jQuery(function () {
    if (jQuery('.sticky-header').first().height()) {
        jQuery('.sticky-header-content').css('min-height', jQuery('.sticky-header').first().height() + 'px');
    }

})
jQuery(window).scroll(function () {
    var sticky = jQuery('.sticky-header');
    var pleft = jQuery('.product-detail-description-left-fixed');
    var scroll = jQuery(window).scrollTop();

    if (scroll >= 10) {
        sticky.addClass('fixed');
        pleft.addClass('sticky');
    }
    else {
        sticky.removeClass('fixed');
        pleft.removeClass('sticky');

    }
})
window.onscroll = function () {
    if (window.scrollX > 0)
        window.scrollTo(0, window.scrollY);

};
jQuery(function () {
    jQuery('.styledSelect').each(function () {
        var styledSelect = jQuery(this);
        setInterval(function () {
            if (styledSelect.parents('.quickbuy-popup').length != 0) {
                var selectedOptions = '';
                var selectedID = '';
                var available = true;

                var so = '';
                styledSelect.parents('.quickbuy-popup').find('form select, .form select').each(function () {
                    if (jQuery(this).val() != '') {
                        selectedOptions += '_' + jQuery(this).val() + '_';
                    }
                    so += jQuery(this).val() + ',';

                });

                styledSelect.parents('.quickbuy-popup').find('.variant .unavailable').each(function () {
                    let name = jQuery(this).attr('data-unavailable-options');
                    if (name == so) {

                        available = false;
                    }
                });
                var selectedPrice = 0;
                styledSelect.parents('.quickbuy-popup').find('form .variants-codes .variant-code, .form .variants-codes .variant-code').each(function () {
                    if (jQuery(this).find('.variant-code-options').text().trim() == selectedOptions) {
                        selectedID = jQuery(this).find('.variant-code-code').text();
                        selectedPrice = parseFloat(jQuery(this).find('.variant-code-price').text()) / 100;
                    }
                });
                if (selectedID != '') {

                    let previousValue = styledSelect.parents('.quickbuy-popup').find('input[name=id]').val();
                    if (previousValue && previousValue != selectedID) {
                        styledSelect.parents('.quickbuy-popup').find('input[name=id]').val(selectedID);

                        if (Extend) {
                            if (styledSelect.parents('form').length > 0) {
                                let formID = styledSelect.parents('form').attr('id');
                                var productForm = document.querySelector('#' + formID);
                                var extendOffer = productForm.querySelector('#extend-offer');
                                variantId = productForm.id.value
                                if (variantId) {
                                    Extend.setActiveProduct(extendOffer, variantId);
                                }
                            }
                        }
                    }
                }
            } else {
                var selectedOptions = '';
                var selectedID = '';
                var available = true;
                var so = '';
                styledSelect.parents('form').find('.product-form-main select').each(function () {
                    if (jQuery(this).val() != '') {
                        selectedOptions += '_' + jQuery(this).val() + '_';
                    }
                    so += jQuery(this).val() + ',';

                });
                styledSelect.parents('form').find('.product-form-main .variant .unavailable').each(function () {
                    let name = jQuery(this).attr('data-unavailable-options');
                    if (name == so) {
                        available = false;
                    }
                });


                styledSelect.parents('form').find('.product-form-main .variants-codes .variant-code').each(function () {
                    if (jQuery(this).find('.variant-code-options').text().trim() == selectedOptions) {
                        selectedID = jQuery(this).find('.variant-code-code').text();
                    }
                });
                if (selectedID != '') {

                    let previousValue = '' + styledSelect.parents('form').find('input[name=id]').val();
                    if (previousValue && previousValue != selectedID) {
                        styledSelect.parents('form').find('input[name=id]').val(selectedID);

                        if (Extend) {
                            if (styledSelect.parents('form').length > 0) {
                                let formID = styledSelect.parents('form').attr('id');
                                var productForm = document.querySelector('#' + formID);
                                var extendOffer = productForm.querySelector('#extend-offer');
                                variantId = productForm.id.value

                                if (variantId) {
                                    Extend.setActiveProduct(extendOffer, variantId);
                                }
                            }
                        }
                    }
                }
            }
        }, 500);
    });
});

jQuery('.bundle-box-product-right .submit-wrapper').click(function (e) {

    e.preventDefault();
    e.stopPropagation();
    if (jQuery(this).parents('.comfort-bundle-product').prev('.quickbuy-modal').length > 0) {
        jQuery(this).parents('.comfort-bundle-product').prev('.quickbuy-modal').show();
        jQuery('html').css('overflow', 'hidden');
        jQuery('html').css('touch-action', 'none');
        jQuery('html').css('-ms-touch-action', 'none');
        //jQuery('.page-container').css('position', 'fixed');
    }

});


jQuery('a').each(function () {
    if (jQuery(this).attr('href') && jQuery(this).attr('href').includes('tel')) {
        if (jQuery(this).attr('href').startsWith('tel:1')
            && !jQuery(this).attr('href').startsWith('tel:+')) {
            jQuery(this).attr('href', jQuery(this).attr('href').replace('tel:1', 'tel:+1'));
        } else
            if (jQuery(this).attr('href').startsWith('tel:+') && !jQuery(this).attr('href').startsWith('tel:+1')) {
                jQuery(this).attr('href', jQuery(this).attr('href').replace('tel:+', 'tel:+1'));
            } else
                if (!jQuery(this).attr('href').startsWith('tel:+1')) {
                    jQuery(this).attr('href', jQuery(this).attr('href').replace('tel:', 'tel:+1'));
                }
    }

});

if (jQuery('.shops').length > 1) {
    jQuery('.shops').last().remove();
}


setInterval(function () {
    jQuery('.newsletter-country-phone select').hide();
    jQuery('.newsletter-country-phone select').val('US');
}, 1000);

setTimeout(function () {
    jQuery('.newsletter-country-phone .phone-field').attr('type', 'text');
    jQuery('.newsletter-country-phone .phone-field').attr('placeholder', 'Phone +1');
    /*
    jQuery('.newsletter-country-phone .phone-field').click(function(){
      if(jQuery('.newsletter-country-phone select').val() == 'US'){
        if(!jQuery('.newsletter-country-phone .phone-field').val().includes('+1')){
          jQuery('.newsletter-country-phone .phone-field').val('+1'
               + jQuery('.newsletter-country-phone .phone-field').val());
        }
      }
    });
    */
    jQuery('.newsletter-country-phone select').hide();
    jQuery('.newsletter-country-phone select').val('US');
}, 1000);


/*
New breakdown section live
 */
setTimeout(function () {
    jQuery('#shopify-section-breakdown-section [data-breakdown-step-index="1"]').addClass('active');
}, 1000);


setTimeout(function () {
    if (jQuery(window).width() >= 950) {

        jQuery('.new-breakdown-section .breakdown-step > h3').each(function () {
            jQuery(this).html(jQuery(this).html() + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
        });

        jQuery('.breakdown-switcher[data-breakdown-index="1"]').addClass('active');
        jQuery('.breakdown-switcher').click(function () {

            let index = jQuery(this).attr('data-breakdown-index');
            //console.log(index);
            jQuery('.breakdown-switcher').removeClass('active');
            jQuery(this).addClass('active');
            jQuery('.breakdown-grid').hide();
            jQuery('.breakdown-grid[data-breakdown-index="' + index + '"]').css('display', 'grid');

            setTimeout(function () {
                jQuery('.breakdown-grid[data-breakdown-index="' + index + '"] .breakdown-step[data-breakdown-step-index="1"]').removeClass('active');
            }, 10);
            breakdownSlide(jQuery('.breakdown-grid[data-breakdown-index="' + index + '"] .breakdown-step-show-initial').attr('data-breakdown-step-index'), 10,
                jQuery('.breakdown-grid[data-breakdown-index="' + index + '"]'));


        });
        if (jQuery('.new-breakdown-section').length > 0) {
            //if(jQuery(window).width() >= 950){
            var height = 0;
            jQuery('.new-breakdown-section img').each(function () {
                if (jQuery(this).height() > height) {
                    height = jQuery(this).height();
                }
            });
            //}
            jQuery('.new-breakdown-section .breakdown-grid').css('height', height + 'px');
        }


        jQuery('.new-breakdown-section .breakdown-grid').css('display', 'grid');
        var maxHeightDefault = 0;
        setTimeout(function () {
            jQuery('.new-breakdown-section .breakdown-left').each(function () {
                var currentHeight = 0;
                var maxIndex = 0;
                var maxHeight = jQuery(this).find('img').first().height();
                if (maxHeight == 0) {
                    maxHeight = maxHeightDefault;
                } else {
                    maxHeightDefault = maxHeight;
                }
                //console.log(maxHeight);
                if (jQuery(window).width() < 950) {
                    maxHeight = parseInt(jQuery('.breakdown-grid').attr('data-mobile-height'));
                }
                jQuery(this).find('img').attr('data-max-height', maxHeight);
                jQuery(this).find('.step-image-area').each(function () {
                    maxIndex++;
                    if (jQuery(this).attr('data-area-index') == 2) {
                        currentHeight = 0;
                    }
                    if (jQuery(this).attr('data-area-index') != 1) {
                        //jQuery(this).css('bottom', currentHeight);
                        let nextHeight = maxHeight * (parseInt(jQuery(this).attr('data-area-position'))) / 100;
                        jQuery(this).css('height', (nextHeight - currentHeight) + 'px');
                        currentHeight = nextHeight;
                    }
                });

                var topValue = 0;
                //console.log(maxIndex);
                for (let i = maxIndex; i > 0; i--) {
                    jQuery(this).find('.step-image-area[data-area-index="' + i + '"]').css('top', topValue);
                    topValue += jQuery(this).find('.step-image-area[data-area-index="' + i + '"]').height();
                    //console.log(topValue);
                }
            });

            jQuery('.new-breakdown-section .breakdown-grid').css('display', 'none');
            jQuery('.new-breakdown-section .breakdown-grid').first().css('display', 'grid');
        }, 1000);

        jQuery('.new-breakdown-section .breakdown-left .step-image-area').click(function (e) {
            breakdownSlide(jQuery(this).attr('data-area-index'), 200, jQuery(this).parents('.breakdown-grid'));
        });
        if (jQuery(window).width() >= 950) {
            jQuery('.new-breakdown-section .breakdown-left .step-image-area').mouseenter(function (e) {
                breakdownChangeImage(jQuery(this).attr('data-area-index'), jQuery(this).parents('.breakdown-grid'));
            });
            jQuery('.new-breakdown-section .breakdown-left .step-image-area').mouseleave(function (e) {
                breakdownChangeImage(-1, jQuery(this).parents('.breakdown-grid'));
            });
        }

        jQuery('.new-breakdown-section .breakdown-grid').css('display', 'grid');
        var k = 0;
        jQuery('.new-breakdown-section .breakdown-grid').each(function () {
            var grid = jQuery(this);
            var lastIndex = parseInt(grid.find('.breakdown-step').last().attr('data-breakdown-step-index'));
            jQuery(this).find('.breakdown-right .breakdown-step-wrapper').each(function () {
                let index = jQuery(this).find('.breakdown-step').attr('data-breakdown-step-index');
                grid.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + index + ']').show();
                //console.log(grid.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + index + '] h3').width());
                let coef = 5.5;/*
        if(lastIndex - index + 1 == 3 && jQuery('.product-template__container > h1').text() == 'Natural Hybrid Latex'){
            coef = 4.5;
        }*/
                var lineLength = jQuery(window).width() / coef + jQuery(this).parents('.breakdown-right').width() / 2 + grid.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + index + '] h3').width() / 2;
                let h0 = parseFloat(grid.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + index + '] h3').height());
                grid.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + index + ']').hide();
                let percentage = parseInt(grid.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + index + ']').attr('data-step-position'));
                h = percentage * grid.height() / 100 - h0;
                if (index != 1) {
                    grid.find('.breakdown-right').append('<svg data-index="' + index + '" class="breakdown-new-number-circle" style="width:70px;height:70px;position:absolute;top:' + (h + 28 + 10 - 20 - 12 + k * 30) + 'px;right:' + (+50 * (2 - 2) + (lineLength + 30)) + 'px;" id="Layer_1circle_' + index + '" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><defs><style>.cls-1c,.cls-3c{fill:#bbc692;}.cls-2c{fill:#384f3b;}.cls-3c{font-size:62px;font-family:NotoSansJP-Medium-83pv-RKSJ-H, Noto Sans JP;}</style></defs><circle class="cls-1c" cx="120" cy="120" r="58.5"/>' +
                        '<circle cx="120" cy="120" fill="none" r="50.88" stroke="#384f3b" stroke-width="2">' +
                        '<animate attributeName="r" from="50" to="120" dur="1.5s" begin="0s" repeatCount="indefinite"/>' +
                        '<animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"/>' +
                        '</circle><circle class="cls-2c" cx="120" cy="120" r="50.88"/><text class="cls-3c" transform="translate(103.21 142.36)">' +
                        (lastIndex - index + 1) + '</text></svg>');
                }
            });
        });
        jQuery('.new-breakdown-section .breakdown-grid').css('display', 'none');
        jQuery('.new-breakdown-section .breakdown-grid').first().css('display', 'grid');

        setTimeout(function () {
            jQuery('.breakdown-step[data-breakdown-step-index="1"]').removeClass('active');
        }, 10);
        breakdownSlide(jQuery('.breakdown-step-show-initial').first().attr('data-breakdown-step-index'),
            10, jQuery('.breakdown-step-show-initial').first().parents('.breakdown-grid'));
        jQuery('.new-breakdown-section .breakdown-grid').each(function () {
            jQuery(this).find('.breakdown-new-number-circle[data-index="'
                + jQuery(this).find('.breakdown-step-show-initial').attr('data-breakdown-step-index')
                + '"]').attr('class', 'breakdown-new-number-circle active');
        });


        jQuery('.breakdown-new-number-circle').click(function () {
            jQuery(this).parents('.breakdown-grid').find('.breakdown-new-number-circle').attr('class', 'breakdown-new-number-circle');
            jQuery(this).attr('class', 'breakdown-new-number-circle active');
            breakdownSlide(jQuery(this).attr('data-index'), 200, jQuery(this).parents('.breakdown-grid'));
        });

        /*
        New breakdown animation
        */
        function breakdownSlide(nextIndex, animationSpeed, grid) {
            grid.find('.breakdown-new-number-circle').attr('class', 'breakdown-new-number-circle');
            grid.find('.breakdown-new-number-circle[data-index="'
                + nextIndex
                + '"]').attr('class', 'breakdown-new-number-circle active');
            var parent = grid;
            var currentIndex = parseInt(parent.attr('data-current-breakdown-step'));
            if (currentIndex != nextIndex && !parent.hasClass('currently-animated')) {
                parent.addClass('currently-animated');
                parent.find('.breakdown-left .breakdown-step[data-breakdown-step-index=' + currentIndex + ']').hide();
                parent.find('.breakdown-left .breakdown-step[data-breakdown-step-index=' + nextIndex + ']').show();
                parent.find('.breakdown-left .breakdown-inactive').show();
                parent.find('.breakdown-left .breakdown-inactive[data-breakdown-step-index="' + nextIndex + '"]').hide();
                parent.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + currentIndex + ']').fadeOut(function () {
                    parent.find('.breakdown-step[data-breakdown-step-index=' + currentIndex + '] svg').remove();
                    parent.find('.breakdown-step[data-breakdown-step-index=' + currentIndex + ']').css('margin-top', '0px');

                    parent.find('.breakdown-step[data-breakdown-step-index=' + nextIndex + ']').show();
                    let h0 = parseFloat(parent.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + nextIndex + '] h3').height());
                    let percentage = parseInt(parent.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + nextIndex + ']').attr('data-step-position'));
                    h = percentage * jQuery('.new-breakdown-section .breakdown-grid').height() / 100 - h0;
                    if (jQuery(window).width() < 950) {
                        h -= h0;
                    }
                    //         if(animationSpeed <= 1){
                    parent.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + nextIndex + ']').css('margin-top', h + 'px');
                    //        }
                    //parent.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + nextIndex + ']').animate({ 'marginTop':
                    //                                                                                                         h + 'px' }, animationSpeed, "linear", function(){
                    var right = parent.find('.breakdown-right .breakdown-step[data-breakdown-step-index=' + nextIndex + ']');
                    let coef = 5.75;
                    /*
                      if(nextIndex == 4 && jQuery('.product-template__container > h1').text() == 'Natural Hybrid Latex'){
                          coef = 4.75;
                      }
                      */
                    var lineLength = jQuery(window).width() / coef;
                    if (nextIndex != 1 && right.find('svg line').length == 0) {
                        //console.log("Animation");
                        if (jQuery(window).width() >= 950) {
                            var line =
                                '' +
                                '<svg style="position:absolute;top:8px;left:-' + (50 * (2 - 2) + lineLength + 20) + 'px;" height="6" width="' + (50 * (2 - 2) + lineLength) + '">' +
                                //'<circle style="visibility:hidden;" cx="5" cy="3" r="2" stroke="#384f3b" stroke-width="1" fill="none" />' +
                                '<line x1="' + (50 * (2 - 2) + lineLength) + '" y1="3" x2="' + (50 * (2 - 2) + lineLength) + '" y2="3" style="stroke:#384f3b;stroke-width:1" />' +
                                '</svg>';
                            right.prepend(line);
                            for (let i = 0; i < (lineLength - 6); i++) {
                                setTimeout(function () {
                                    right.find('svg line').attr('x1', (lineLength - i));
                                }, animationSpeed * i / lineLength);
                            }
                        }
                        setTimeout(function () {
                            right.find('svg circle').css('visibility', 'visible');
                            jQuery('.new-breakdown-section .breakdown-grid').removeClass('currently-animated');
                        }, animationSpeed);

                    }
                    //   });
                });
                parent.attr('data-current-breakdown-step', nextIndex);
            }
        }
        function breakdownChangeImage(nextIndex, grid) {
            var parent = grid;
            var currentIndex = parseInt(parent.attr('data-current-breakdown-step'));
            if (currentIndex != nextIndex) {
                parent.find('.breakdown-left .breakdown-step').hide();
                parent.find('.breakdown-left .breakdown-inactive').show();
                parent.find('.breakdown-left .breakdown-step[data-breakdown-step-index="0"]').show();
                parent.find('.breakdown-left .breakdown-step[data-breakdown-step-index="' + currentIndex + '"]').show();
                parent.find('.breakdown-left .breakdown-step[data-breakdown-step-index="' + nextIndex + '"]').show();
                parent.find('.breakdown-left .breakdown-inactive[data-breakdown-step-index="' + currentIndex + '"]').hide();
                parent.find('.breakdown-left .breakdown-inactive[data-breakdown-step-index="' + nextIndex + '"]').hide();
            }
        }
    } else {

        setTimeout(function () {
            jQuery('.mobile-breakdown-grid[data-breakdown-index="1"] .breakdown-step[data-breakdown-step-index="1"]').removeClass('active');
        }, 10);
        jQuery('.mobile-breakdown-grid[data-breakdown-index="1"] .breakdown-step-show-initial').addClass('active');



        jQuery('.breakdown-switcher[data-breakdown-index="1"]').addClass('active');
        jQuery('.breakdown-switcher').click(function () {

            let index = jQuery(this).attr('data-breakdown-index');
            jQuery('.breakdown-switcher').removeClass('active');
            jQuery(this).addClass('active');
            jQuery('.mobile-breakdown-grid').hide();
            jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"]').css('display', 'grid');

            setTimeout(function () {
                jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"] .breakdown-step').removeClass('active');
                jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"] .breakdown-step-show-initial').addClass('active');
                jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"]').find('.breakdown-new-number-circle').attr('class', 'breakdown-new-number-circle');
                jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"]').find('.breakdown-new-number-circle[data-index="'
                    + jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"] .breakdown-step-show-initial').attr('data-breakdown-step-index')
                    + '"]').attr('class', 'breakdown-new-number-circle active');
            }, 10);
            jQuery('.mobile-breakdown-grid[data-breakdown-index="' + index + '"] .breakdown-step-show-initial').addClass('active');


        });

        setTimeout(function () {

            var first = true;
            jQuery('.new-breakdown-section .mobile-breakdown-grid').each(function () {
                var grid = jQuery(this);
                var lastIndex = parseInt(grid.find('.breakdown-step').last().attr('data-breakdown-step-index'));

                grid.css('display', 'grid');
                jQuery(this).find('.breakdown-text .breakdown-step').each(function () {

                    //console.log(grid.find('.breakdown-image .breakdown-step[data-breakdown-step-index="0"]').height());
                    let index = jQuery(this).attr('data-breakdown-step-index');
                    let percentage = parseInt(jQuery(this).attr('data-step-position'));
                    h = percentage * grid.find('.breakdown-image .breakdown-step[data-breakdown-step-index="0"]').height() / 100;
                    var lineLength = jQuery(window).width() / 4.5;
                    if (index != 1) {
                        grid.find('.breakdown-image').append('<svg data-index="' + index + '" class="breakdown-new-number-circle" style="width:40px;height:40px;position:absolute;top:' + (h - 0) + 'px;right:' + (+20 * (2 - 2) + (lineLength / 2 + 50)) + 'px;" id="Layer_1circle_' + index + '_mob" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><defs><style>.cls-1c,.cls-3c{fill:#bbc692;}.cls-2c{fill:#384f3b;}.cls-3c{font-size:62px;font-family:NotoSansJP-Medium-83pv-RKSJ-H, Noto Sans JP;}</style></defs>'
                            + '<circle class="cls-1c" cx="120" cy="120" r="58.5"/>' +
                            '<circle cx="120" cy="120" fill="none" r="50.88" stroke="#384f3b" stroke-width="2">' +
                            '<animate attributeName="r" from="50" to="120" dur="1.5s" begin="0s" repeatCount="indefinite"/>' +
                            '<animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"/>' +
                            '</circle>'
                            + '<circle class="cls-2c" cx="120" cy="120" r="50.88"/><text class="cls-3c" transform="translate(103.21 142.36)">' +
                            (lastIndex - index + 1) + '</text></svg>');


                    }
                    grid.find('.breakdown-image').css('min-height',
                        grid.find('.breakdown-image .breakdown-step[data-breakdown-step-index="0"]').height() + 'px');
                });
                if (first) {
                    first = false;
                } else {
                    grid.css('display', 'none');
                }
            });

            jQuery('.breakdown-new-number-circle[data-index="'
                + jQuery('.mobile-breakdown-grid .breakdown-step-show-initial').attr('data-breakdown-step-index')
                + '"]').attr('class', 'breakdown-new-number-circle active');
            jQuery('.breakdown-new-number-circle').click(function () {

                let grid = jQuery(this).parents('.mobile-breakdown-grid');
                grid.find('.breakdown-new-number-circle').attr('class', 'breakdown-new-number-circle');
                grid.find('.breakdown-new-number-circle[data-index="' + jQuery(this).attr('data-index') + '"]').attr('class', 'breakdown-new-number-circle active');
                grid.find('.breakdown-step').removeClass('active');
                grid.find('.breakdown-inactive').show();
                grid.find('.breakdown-step[data-breakdown-step-index="' + jQuery(this).attr('data-index') + '"]').addClass('active');
                grid.find('.breakdown-inactive[data-breakdown-step-index="' + jQuery(this).attr('data-index') + '"]').hide();
            });
        }, 1000);
    }
}, 500);


jQuery("img").each(function () {
    if (jQuery(this).attr("src") != '' && !jQuery(this).hasClass("not-lazy-load") &&
        jQuery(this).parents(".template-product").length == 0 && jQuery(this).parents(".real-review-icons").length == 0 && jQuery(this).parents("#shopify-section-new-breakdown-section").length == 0 && jQuery(this).parents(".tile-icon").length == 0) {
        jQuery(this).addClass("lazy-load");
        jQuery(this).attr("data-src", jQuery(this).attr("src"));
        jQuery(this).removeAttr("src");
    }
    if (jQuery(this).attr("srcset") != '' && !jQuery(this).hasClass("not-lazy-load")) {
        jQuery(this).addClass("lazy-load");
        jQuery(this).attr("data-srcset", jQuery(this).attr("srcset"));
        jQuery(this).removeAttr("srcset");
    }
});
var myElements = document.querySelectorAll("img.lazy-load");
lozad(myElements, {
    rootMargin: "30px 0px",
    loaded: function (el) {
        el.classList.add("is-loaded");
    }
}).observe();

url = new URL(window.location.href);
if (url.searchParams.get('customer_posted') && jQuery('.footer-part').length > 0) {
    window.scrollTo(0, jQuery('.footer-part').offset().top);
    setTimeout(function () {
        jQuery('.form-message').hide();
    }, 5000
    );
}
if (url.searchParams.get('irgwc') == '1' && url.searchParams.get('utm_source') == 'Impact' && url.searchParams.get('utm_medium') == '1428968') {
    window.location.replace("/checkout");
}

jQuery('.top-banner-slide').show();
jQuery('.top-banner-slides').slick({
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: false,
    variableWidth: false,
    autoplay: true,
    vertical: false,
    speed: 700,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    swipeToSlide: false,
    fade: true
});
jQuery('.top-banner-slides-prev').click(function () {
    jQuery('.top-banner-slides').slick('slickPrev');
});
jQuery('.top-banner-slides-next').click(function () {
    jQuery('.top-banner-slides').slick('slickNext');
});
if (jQuery('.top-banner-slide').length > 1) {
    jQuery('.top-banner-slides-prev').animate({ left: ((jQuery(window).width() - jQuery('.top-banner-slides .slick-slide[data-slick-index="0"] span').width()) / 2 - 40) + "px" }, 100);
    jQuery('.top-banner-slides-next').animate({ right: ((jQuery(window).width() - jQuery('.top-banner-slides .slick-slide[data-slick-index="0"] span').width()) / 2 - 40) + "px" }, 100);
    jQuery('.top-banner-slides-prev, .top-banner-slides-next').show();
}

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
        'shopify:section:load',
        this._onSectionLoad.bind(this)
    );
    document.addEventListener(
        'shopify:section:unload',
        this._onSectionUnload.bind(this)
    );
    document.addEventListener(
        'shopify:section:select',
        this._onSelect.bind(this)
    );
    document.addEventListener(
        'shopify:section:deselect',
        this._onDeselect.bind(this)
    );
    document.addEventListener(
        'shopify:block:select',
        this._onBlockSelect.bind(this)
    );
    document.addEventListener(
        'shopify:block:deselect',
        this._onBlockDeselect.bind(this)
    );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var id = container.getAttribute('data-section-id');
        var type = container.getAttribute('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = document.querySelector(
            '[data-section-id="' + evt.detail.sectionId + '"]'
        );

        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        this.instances = this.instances.filter(function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (typeof instance.onUnload === 'function') {
                    instance.onUnload(evt);
                }
            }

            return !isEventInstance;
        });
    },

    _onSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onSelect === 'function'
        ) {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onDeselect === 'function'
        ) {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockSelect === 'function'
        ) {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockDeselect === 'function'
        ) {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
            function (container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
    /**
     * Get the query params in a Url
     * Ex
     * https://mysite.com/search?q=noodles&b
     * getParameterByName('q') = "noodles"
     * getParameterByName('b') = "" (empty value)
     * getParameterByName('test') = null (absent)
     */
    getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    resizeSelects: function (selects) {
        selects.forEach(function (select) {
            var arrowWidth = 55;

            var test = document.createElement('span');
            test.innerHTML = select.selectedOptions[0].label;

            document.querySelector('.site-footer').appendChild(test);

            var width = test.offsetWidth + arrowWidth;
            test.remove();

            select.style.width = width + 'px';
        });
    },

    keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39
    }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {NodeList} options.tables - Elements of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function (options) {
        options.tables.forEach(function (table) {
            var wrapper = document.createElement('div');
            wrapper.classList.add(options.tableWrapperClass);

            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function (options) {
        options.iframes.forEach(function (iframe) {
            var wrapper = document.createElement('div');
            wrapper.classList.add(options.iframeWrapperClass);

            iframe.parentNode.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);

            iframe.src = iframe.src;
        });
    }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
    state: {
        firstFocusable: null,
        lastFocusable: null
    },
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects
     *
     * @param {HTMLElement} element - The element to be acted upon
     */
    pageLinkFocus: function (element) {
        if (!element) return;
        var focusClass = 'js-focus-hidden';

        element.setAttribute('tabIndex', '-1');
        element.focus();
        element.classList.add(focusClass);
        element.addEventListener('blur', callback, { once: true });

        function callback() {
            element.classList.remove(focusClass);
            element.removeAttribute('tabindex');
        }
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {HTMLElement} options.container - Container to trap focus within
     * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
     */
    trapFocus: function (options) {
        var focusableElements = Array.from(
            options.container.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            )
        ).filter(function (element) {
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            return (
                width !== 0 &&
                height !== 0 &&
                getComputedStyle(element).getPropertyValue('display') !== 'none'
            );
        });

        this.state.firstFocusable = focusableElements[0];
        this.state.lastFocusable = focusableElements[focusableElements.length - 1];

        if (!options.elementToFocus) {
            options.elementToFocus = options.container;
        }

        options.container.setAttribute('tabindex', '-1');
        options.elementToFocus.focus();

        this._setupHandlers();

        document.addEventListener('focusin', this._onFocusInHandler);
        document.addEventListener('focusout', this._onFocusOutHandler);
    },

    _setupHandlers: function () {
        if (!this._onFocusInHandler) {
            this._onFocusInHandler = this._onFocusIn.bind(this);
        }

        if (!this._onFocusOutHandler) {
            this._onFocusOutHandler = this._onFocusIn.bind(this);
        }

        if (!this._manageFocusHandler) {
            this._manageFocusHandler = this._manageFocus.bind(this);
        }
    },

    _onFocusOut: function () {
        document.removeEventListener('keydown', this._manageFocusHandler);
    },

    _onFocusIn: function (evt) {
        if (
            evt.target !== this.state.lastFocusable &&
            evt.target !== this.state.firstFocusable
        )
            return;

        document.addEventListener('keydown', this._manageFocusHandler);
    },

    _manageFocus: function (evt) {
        if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

        /**
         * On the last focusable element and tab forward,
         * focus the first element.
         */
        if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
            evt.preventDefault();
            this.state.firstFocusable.focus();
        }
        /**
         * On the first focusable element and tab backward,
         * focus the last element.
         */
        if (evt.target === this.state.firstFocusable && evt.shiftKey) {
            evt.preventDefault();
            this.state.lastFocusable.focus();
        }
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {HTMLElement} options.container - Container to trap focus within
     */
    removeTrapFocus: function (options) {
        if (options.container) {
            options.container.removeAttribute('tabindex');
        }
        document.removeEventListener('focusin', this._onFocusInHandler);
    },

    /**
     * Add aria-describedby attribute to external and new window links
     *
     * @param {object} options - Options to be used
     * @param {object} options.messages - Custom messages to be used
     * @param {HTMLElement} options.links - Specific links to be targeted
     */
    //   accessibleLinks: function(options) {
    //     var body = document.querySelector('body');

    //     var idSelectors = {
    //       newWindow: 'a11y-new-window-message',
    //       external: 'a11y-external-message',
    //       newWindowExternal: 'a11y-new-window-external-message'
    //     };

    //     if (options.links === undefined || !options.links.length) {
    //       options.links = document.querySelectorAll(
    //         'a[href]:not([aria-describedby])'
    //       );
    //     }

    //     function generateHTML(customMessages) {
    //       if (typeof customMessages !== 'object') {
    //         customMessages = {};
    //       }

    //       var messages = Object.assign(
    //         {
    //           newWindow: 'Opens in a new window.',
    //           external: 'Opens external website.',
    //           newWindowExternal: 'Opens external website in a new window.'
    //         },
    //         customMessages
    //       );

    //       var container = document.createElement('ul');
    //       var htmlMessages = '';

    //       for (var message in messages) {
    //         htmlMessages +=
    //           '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
    //       }

    //       container.setAttribute('hidden', true);
    //       container.innerHTML = htmlMessages;

    //       body.appendChild(container);
    //     }

    //     function _externalSite(link) {
    //       var hostname = window.location.hostname;

    //       return link.hostname !== hostname;
    //     }

    //     options.links.forEach(function(link) {
    //       var target = link.getAttribute('target');
    //       var rel = link.getAttribute('rel');
    //       var isExternal = _externalSite(link);
    //       var isTargetBlank = target === '_blank';

    //       if (isExternal) {
    //         link.setAttribute('data-aria', idSelectors.external);
    //       }

    //       if (isTargetBlank) {
    //         if (!rel || rel.indexOf('noopener') === -1) {
    //           var relValue = rel === undefined ? '' : rel + ' ';
    //           relValue = relValue + 'noopener';
    //           link.setAttribute('rel', relValue);
    //         }

    //         link.setAttribute('data-aria', idSelectors.newWindow);
    //       }

    //       if (isExternal && isTargetBlank) {
    //         link.setAttribute('data-aria', idSelectors.newWindowExternal);
    //       }
    //     });

    //     generateHTML(options.messages);
    //   }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Swaps the src of an image for another OR returns the imageURL to the callback function
     * @param image
     * @param element
     * @param callback
     */
    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);

        if (callback) {
            callback(imageUrl, image, element); // eslint-disable-line callback-return
        } else {
            element.src = imageUrl;
        }
    }

    /**
     * +++ Useful
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
        );

        if (match !== null) {
            if (match[2] !== undefined) {
                return match[1] + match[2];
            } else {
                return match[1];
            }
        } else {
            return null;
        }
    }

    /**
     * +++ Useful
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match !== null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        }

        return null;
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        switchImage: switchImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number === null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.container = options.container;
        this.product = options.product;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.singleOptions = this.container.querySelectorAll(
            options.singleOptionSelector
        );
        this.currentVariant = this._getVariantFromOptions();

        this.singleOptions.forEach(
            function (option) {
                option.addEventListener('change', this._onSelectChange.bind(this));
            }.bind(this)
        );
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {
            var result = [];

            this.singleOptions.forEach(function (option) {
                var type = option.getAttribute('type');
                var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

                if (!isRadioOrCheckbox || option.checked) {
                    result.push({
                        value: option.value,
                        index: option.getAttribute('data-index')
                    });
                }
            });

            return result;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;

            var found = variants.find(function (variant) {
                return selectedValues.every(function (values) {
                    return variant[values.index] === values.value;
                });
            });

            return found;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();

            this.container.dispatchEvent(
                new CustomEvent('variantChange', {
                    detail: {
                        variant: variant
                    },
                    bubbles: true,
                    cancelable: true
                })
            );

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (
                !variant.featured_image ||
                variantImage.src === currentVariantImage.src
            ) {
                return;
            }

            this.container.dispatchEvent(
                new CustomEvent('variantImageChange', {
                    detail: {
                        variant: variant
                    },
                    bubbles: true,
                    cancelable: true
                })
            );
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {
            if (
                variant.price === this.currentVariant.price &&
                variant.compare_at_price === this.currentVariant.compare_at_price
            ) {
                return;
            }

            this.container.dispatchEvent(
                new CustomEvent('variantPriceChange', {
                    detail: {
                        variant: variant
                    },
                    bubbles: true,
                    cancelable: true
                })
            );
        },

        /**
         * Trigger event when variant sku changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantSKUChange
         */
        _updateSKU: function (variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }

            this.container.dispatchEvent(
                new CustomEvent('variantSKUChange', {
                    detail: {
                        variant: variant
                    },
                    bubbles: true,
                    cancelable: true
                })
            );
        },

        /**
         * Update history state for product deeplinking
         *
         * @param  {variant} variant - Currently selected variant
         * @return {k}         [description]
         */
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?variant=' +
                variant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param  {variant} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            var masterSelect = this.container.querySelector(this.originalSelectorId);

            if (!masterSelect) return;
            masterSelect.value = variant.id;
        }
    });

    return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearch = (function () {
    'use strict';

    function validateQuery(query) {
        var error;

        if (query === null || query === undefined) {
            error = new TypeError("'query' is missing");
            error.type = 'argument';
            throw error;
        }

        if (typeof query !== 'string') {
            error = new TypeError("'query' is not a string");
            error.type = 'argument';
            throw error;
        }
    }

    function GenericError() {
        var error = Error.call(this);

        error.name = 'Server error';
        error.message = 'Something went wrong on the server';
        error.status = 500;

        return error;
    }

    function NotFoundError(status) {
        var error = Error.call(this);

        error.name = 'Not found';
        error.message = 'Not found';
        error.status = status;

        return error;
    }

    function ServerError() {
        var error = Error.call(this);

        error.name = 'Server error';
        error.message = 'Something went wrong on the server';
        error.status = 500;

        return error;
    }

    function ContentTypeError(status) {
        var error = Error.call(this);

        error.name = 'Content-Type error';
        error.message = 'Content-Type was not provided or is of wrong type';
        error.status = status;

        return error;
    }

    function JsonParseError(status) {
        var error = Error.call(this);

        error.name = 'JSON parse error';
        error.message = 'JSON syntax error';
        error.status = status;

        return error;
    }

    function ThrottledError(status, name, message, retryAfter) {
        var error = Error.call(this);

        error.name = name;
        error.message = message;
        error.status = status;
        error.retryAfter = retryAfter;

        return error;
    }

    function InvalidParameterError(status, name, message) {
        var error = Error.call(this);

        error.name = name;
        error.message = message;
        error.status = status;

        return error;
    }

    function ExpectationFailedError(status, name, message) {
        var error = Error.call(this);

        error.name = name;
        error.message = message;
        error.status = status;

        return error;
    }

    function request(configParams, query, onSuccess, onError) {
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) {
                return;
            }

            var contentType = xhr.getResponseHeader('Content-Type');

            if (xhr.status >= 500) {
                onError(new ServerError());

                return;
            }

            if (xhr.status === 404) {
                onError(new NotFoundError(xhr.status));

                return;
            }

            if (
                typeof contentType !== 'string' ||
                contentType.toLowerCase().match('application/json') === null
            ) {
                onError(new ContentTypeError(xhr.status));

                return;
            }

            if (xhr.status === 417) {
                try {
                    var invalidParameterJson = JSON.parse(xhr.responseText);

                    onError(
                        new InvalidParameterError(
                            xhr.status,
                            invalidParameterJson.message,
                            invalidParameterJson.description
                        )
                    );
                } catch (error) {
                    onError(new JsonParseError(xhr.status));
                }

                return;
            }

            if (xhr.status === 422) {
                try {
                    var expectationFailedJson = JSON.parse(xhr.responseText);

                    onError(
                        new ExpectationFailedError(
                            xhr.status,
                            expectationFailedJson.message,
                            expectationFailedJson.description
                        )
                    );
                } catch (error) {
                    onError(new JsonParseError(xhr.status));
                }

                return;
            }

            if (xhr.status === 429) {
                try {
                    var throttledJson = JSON.parse(xhr.responseText);

                    onError(
                        new ThrottledError(
                            xhr.status,
                            throttledJson.message,
                            throttledJson.description,
                            xhr.getResponseHeader('Retry-After')
                        )
                    );
                } catch (error) {
                    onError(new JsonParseError(xhr.status));
                }

                return;
            }

            if (xhr.status === 200) {
                try {
                    var res = JSON.parse(xhr.responseText);
                    res.query = query;
                    onSuccess(res);
                } catch (error) {
                    onError(new JsonParseError(xhr.status));
                }

                return;
            }

            try {
                var genericErrorJson = JSON.parse(xhr.responseText);
                onError(
                    new GenericError(
                        xhr.status,
                        genericErrorJson.message,
                        genericErrorJson.description
                    )
                );
            } catch (error) {
                onError(new JsonParseError(xhr.status));
            }

            return;
        };

        xhr.open(
            'get',
            '/search/suggest.json?q=' + encodeURIComponent(query) + '&' + configParams
        );

        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.send();
    }

    function Cache(config) {
        this._store = {};
        this._keys = [];
        if (config && config.bucketSize) {
            this.bucketSize = config.bucketSize;
        } else {
            this.bucketSize = 20;
        }
    }

    Cache.prototype.set = function (key, value) {
        if (this.count() >= this.bucketSize) {
            var deleteKey = this._keys.splice(0, 1);
            this.delete(deleteKey);
        }

        this._keys.push(key);
        this._store[key] = value;

        return this._store;
    };

    Cache.prototype.get = function (key) {
        return this._store[key];
    };

    Cache.prototype.has = function (key) {
        return Boolean(this._store[key]);
    };

    Cache.prototype.count = function () {
        return Object.keys(this._store).length;
    };

    Cache.prototype.delete = function (key) {
        var exists = Boolean(this._store[key]);
        delete this._store[key];
        return exists && !this._store[key];
    };

    function Dispatcher() {
        this.events = {};
    }

    Dispatcher.prototype.on = function (eventName, callback) {
        var event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        event.registerCallback(callback);
    };

    Dispatcher.prototype.off = function (eventName, callback) {
        var event = this.events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
            event.unregisterCallback(callback);
            if (event.callbacks.length === 0) {
                delete this.events[eventName];
            }
        }
    };

    Dispatcher.prototype.dispatch = function (eventName, payload) {
        var event = this.events[eventName];
        if (event) {
            event.fire(payload);
        }
    };

    function DispatcherEvent(eventName) {
        this.eventName = eventName;
        this.callbacks = [];
    }

    DispatcherEvent.prototype.registerCallback = function (callback) {
        this.callbacks.push(callback);
    };

    DispatcherEvent.prototype.unregisterCallback = function (callback) {
        var index = this.callbacks.indexOf(callback);
        if (index > -1) {
            this.callbacks.splice(index, 1);
        }
    };

    DispatcherEvent.prototype.fire = function (payload) {
        var callbacks = this.callbacks.slice(0);
        callbacks.forEach(function (callback) {
            callback(payload);
        });
    };

    function debounce(func, wait) {
        var timeout = null;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                timeout = null;
                func.apply(context, args);
            }, wait || 0);
        };
    }

    function objectToQueryParams(obj, parentKey) {
        var output = '';
        parentKey = parentKey || null;

        Object.keys(obj).forEach(function (key) {
            var outputKey = key + '=';
            if (parentKey) {
                outputKey = parentKey + '[' + key + ']';
            }

            switch (trueTypeOf(obj[key])) {
                case 'object':
                    output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
                    break;
                case 'array':
                    output += outputKey + '=' + obj[key].join(',') + '&';
                    break;
                default:
                    if (parentKey) {
                        outputKey += '=';
                    }
                    output += outputKey + encodeURIComponent(obj[key]) + '&';
                    break;
            }
        });

        return output;
    }

    function trueTypeOf(obj) {
        return Object.prototype.toString
            .call(obj)
            .slice(8, -1)
            .toLowerCase();
    }

    var DEBOUNCE_RATE = 10;
    var requestDebounced = debounce(request, DEBOUNCE_RATE);

    function PredictiveSearch(config) {
        if (!config) {
            throw new TypeError('No config object was specified');
        }

        this._retryAfter = null;
        this._currentQuery = null;

        this.dispatcher = new Dispatcher();
        this.cache = new Cache({ bucketSize: 40 });
        this.configParams = objectToQueryParams(config);
    }

    PredictiveSearch.TYPES = {
        PRODUCT: 'product',
        PAGE: 'page',
        ARTICLE: 'article'
    };

    PredictiveSearch.FIELDS = {
        AUTHOR: 'author',
        BODY: 'body',
        PRODUCT_TYPE: 'product_type',
        TAG: 'tag',
        TITLE: 'title',
        VARIANTS_BARCODE: 'variants.barcode',
        VARIANTS_SKU: 'variants.sku',
        VARIANTS_TITLE: 'variants.title',
        VENDOR: 'vendor'
    };

    PredictiveSearch.UNAVAILABLE_PRODUCTS = {
        SHOW: 'show',
        HIDE: 'hide',
        LAST: 'last'
    };

    PredictiveSearch.prototype.query = function query(query) {
        try {
            validateQuery(query);
        } catch (error) {
            this.dispatcher.dispatch('error', error);
            return;
        }

        if (query === '') {
            return this;
        }

        this._currentQuery = normalizeQuery(query);
        var cacheResult = this.cache.get(this._currentQuery);
        if (cacheResult) {
            this.dispatcher.dispatch('success', cacheResult);
            return this;
        }

        requestDebounced(
            this.configParams,
            query,
            function (result) {
                this.cache.set(normalizeQuery(result.query), result);
                if (normalizeQuery(result.query) === this._currentQuery) {
                    this._retryAfter = null;
                    this.dispatcher.dispatch('success', result);
                }
            }.bind(this),
            function (error) {
                if (error.retryAfter) {
                    this._retryAfter = error.retryAfter;
                }
                this.dispatcher.dispatch('error', error);
            }.bind(this)
        );

        return this;
    };

    PredictiveSearch.prototype.on = function on(eventName, callback) {
        this.dispatcher.on(eventName, callback);

        return this;
    };

    PredictiveSearch.prototype.off = function on(eventName, callback) {
        this.dispatcher.off(eventName, callback);

        return this;
    };

    function normalizeQuery(query) {
        if (typeof query !== 'string') {
            return null;
        }

        return query
            .trim()
            .replace(' ', '-')
            .toLowerCase();
    }

    return PredictiveSearch;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearchComponent = (function (PredictiveSearch) {
    'use strict';

    PredictiveSearch =
        PredictiveSearch && PredictiveSearch.hasOwnProperty('default')
            ? PredictiveSearch['default']
            : PredictiveSearch;

    var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
        resources: {
            type: [PredictiveSearch.TYPES.PRODUCT],
            options: {
                unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
                fields: [
                    PredictiveSearch.FIELDS.TITLE,
                    PredictiveSearch.FIELDS.VENDOR,
                    PredictiveSearch.FIELDS.PRODUCT_TYPE,
                    PredictiveSearch.FIELDS.VARIANTS_TITLE
                ]
            }
        }
    };

    function PredictiveSearchComponent(config) {
        // validate config
        if (
            !config ||
            !config.selectors ||
            !config.selectors.input ||
            !isString(config.selectors.input) ||
            !config.selectors.result ||
            !isString(config.selectors.result) ||
            !config.resultTemplateFct ||
            !isFunction(config.resultTemplateFct) ||
            !config.numberOfResultsTemplateFct ||
            !isFunction(config.numberOfResultsTemplateFct) ||
            !config.loadingResultsMessageTemplateFct ||
            !isFunction(config.loadingResultsMessageTemplateFct)
        ) {
            var error = new TypeError(
                'PredictiveSearchComponent config is not valid'
            );
            error.type = 'argument';
            throw error;
        }

        // Find nodes
        this.nodes = findNodes(config.selectors);

        // Validate nodes
        if (!isValidNodes(this.nodes)) {
            // eslint-disable-next-line no-console
            console.warn('Could not find valid nodes');
            return;
        }

        // Store the keyword that was used for the search
        this._searchKeyword = '';

        // Assign result template
        this.resultTemplateFct = config.resultTemplateFct;

        // Assign number of results template
        this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

        // Assign loading state template function
        this.loadingResultsMessageTemplateFct =
            config.loadingResultsMessageTemplateFct;

        // Assign number of search results
        this.numberOfResults = config.numberOfResults || 4;

        // Set classes
        this.classes = {
            visibleVariant: config.visibleVariant
                ? config.visibleVariant
                : 'predictive-search-wrapper--visible',
            itemSelected: config.itemSelectedClass
                ? config.itemSelectedClass
                : 'predictive-search-item--selected',
            clearButtonVisible: config.clearButtonVisibleClass
                ? config.clearButtonVisibleClass
                : 'predictive-search__clear-button--visible'
        };

        this.selectors = {
            searchResult: config.searchResult
                ? config.searchResult
                : '[data-search-result]'
        };

        // Assign callbacks
        this.callbacks = assignCallbacks(config);

        // Add input attributes
        addInputAttributes(this.nodes.input);

        // Add input event listeners
        this._addInputEventListeners();

        // Add body listener
        this._addBodyEventListener();

        // Add accessibility announcer
        this._addAccessibilityAnnouncer();

        // Display the reset button if the input is not empty
        this._toggleClearButtonVisibility();

        // Instantiate Predictive Search API
        this.predictiveSearch = new PredictiveSearch(
            config.PredictiveSearchAPIConfig
                ? config.PredictiveSearchAPIConfig
                : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG
        );

        // Add predictive search success event listener
        this.predictiveSearch.on(
            'success',
            this._handlePredictiveSearchSuccess.bind(this)
        );

        // Add predictive search error event listener
        this.predictiveSearch.on(
            'error',
            this._handlePredictiveSearchError.bind(this)
        );
    }

    /**
     * Private methods
     */
    function findNodes(selectors) {
        return {
            input: document.querySelector(selectors.input),
            reset: document.querySelector(selectors.reset),
            result: document.querySelector(selectors.result)
        };
    }

    function isValidNodes(nodes) {
        if (
            !nodes ||
            !nodes.input ||
            !nodes.result ||
            nodes.input.tagName !== 'INPUT'
        ) {
            return false;
        }

        return true;
    }

    function assignCallbacks(config) {
        return {
            onBodyMousedown: config.onBodyMousedown,
            onBeforeOpen: config.onBeforeOpen,
            onOpen: config.onOpen,
            onBeforeClose: config.onBeforeClose,
            onClose: config.onClose,
            onInputFocus: config.onInputFocus,
            onInputKeyup: config.onInputKeyup,
            onInputBlur: config.onInputBlur,
            onInputReset: config.onInputReset,
            onBeforeDestroy: config.onBeforeDestroy,
            onDestroy: config.onDestroy
        };
    }

    function addInputAttributes(input) {
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');
    }

    function removeInputAttributes(input) {
        input.removeAttribute('autocorrect', 'off');
        input.removeAttribute('autocomplete', 'off');
        input.removeAttribute('autocapitalize', 'off');
        input.removeAttribute('spellcheck', 'false');
    }

    /**
     * Public variables
     */
    PredictiveSearchComponent.prototype.isResultVisible = false;
    PredictiveSearchComponent.prototype.results = {};

    /**
     * "Private" variables
     */
    PredictiveSearchComponent.prototype._latencyTimer = null;
    PredictiveSearchComponent.prototype._resultNodeClicked = false;

    /**
     * "Private" instance methods
     */
    PredictiveSearchComponent.prototype._addInputEventListeners = function () {
        var input = this.nodes.input;
        var reset = this.nodes.reset;

        if (!input) {
            return;
        }

        this._handleInputFocus = this._handleInputFocus.bind(this);
        this._handleInputBlur = this._handleInputBlur.bind(this);
        this._handleInputKeyup = this._handleInputKeyup.bind(this);
        this._handleInputKeydown = this._handleInputKeydown.bind(this);

        input.addEventListener('focus', this._handleInputFocus);
        input.addEventListener('blur', this._handleInputBlur);
        input.addEventListener('keyup', this._handleInputKeyup);
        input.addEventListener('keydown', this._handleInputKeydown);

        if (reset) {
            this._handleInputReset = this._handleInputReset.bind(this);
            reset.addEventListener('click', this._handleInputReset);
        }
    };

    PredictiveSearchComponent.prototype._removeInputEventListeners = function () {
        var input = this.nodes.input;

        input.removeEventListener('focus', this._handleInputFocus);
        input.removeEventListener('blur', this._handleInputBlur);
        input.removeEventListener('keyup', this._handleInputKeyup);
        input.removeEventListener('keydown', this._handleInputKeydown);
    };

    PredictiveSearchComponent.prototype._addBodyEventListener = function () {
        this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

        document
            .querySelector('body')
            .addEventListener('mousedown', this._handleBodyMousedown);
    };

    PredictiveSearchComponent.prototype._removeBodyEventListener = function () {
        document
            .querySelector('body')
            .removeEventListener('mousedown', this._handleBodyMousedown);
    };

    PredictiveSearchComponent.prototype._removeClearButtonEventListener = function () {
        var reset = this.nodes.reset;

        if (!reset) {
            return;
        }

        reset.removeEventListener('click', this._handleInputReset);
    };

    /**
     * Event handlers
     */
    PredictiveSearchComponent.prototype._handleBodyMousedown = function (evt) {
        if (this.isResultVisible && this.nodes !== null) {
            if (
                evt.target.isEqualNode(this.nodes.input) ||
                this.nodes.input.contains(evt.target) ||
                evt.target.isEqualNode(this.nodes.result) ||
                this.nodes.result.contains(evt.target)
            ) {
                this._resultNodeClicked = true;
            } else {
                if (isFunction(this.callbacks.onBodyMousedown)) {
                    var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
                    if (isBoolean(returnedValue) && returnedValue) {
                        this.close();
                    }
                } else {
                    this.close();
                }
            }
        }
    };

    PredictiveSearchComponent.prototype._handleInputFocus = function (evt) {
        if (isFunction(this.callbacks.onInputFocus)) {
            var returnedValue = this.callbacks.onInputFocus(this.nodes);
            if (isBoolean(returnedValue) && !returnedValue) {
                return false;
            }
        }

        if (evt.target.value.length > 0) {
            this._search();
        }

        return true;
    };

    PredictiveSearchComponent.prototype._handleInputBlur = function () {
        // This has to be done async, to wait for the focus to be on the next
        // element and avoid closing the results.
        // Example: Going from the input to the reset button.
        setTimeout(
            function () {
                if (isFunction(this.callbacks.onInputBlur)) {
                    var returnedValue = this.callbacks.onInputBlur(this.nodes);
                    if (isBoolean(returnedValue) && !returnedValue) {
                        return false;
                    }
                }

                if (document.activeElement.isEqualNode(this.nodes.reset)) {
                    return false;
                }

                if (this._resultNodeClicked) {
                    this._resultNodeClicked = false;
                    return false;
                }

                this.close();
            }.bind(this)
        );

        return true;
    };

    PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function () {
        this._accessibilityAnnouncerDiv = window.document.createElement('div');

        this._accessibilityAnnouncerDiv.setAttribute(
            'style',
            'position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;'
        );

        this._accessibilityAnnouncerDiv.setAttribute('data-search-announcer', '');
        this._accessibilityAnnouncerDiv.setAttribute('aria-live', 'polite');
        this._accessibilityAnnouncerDiv.setAttribute('aria-atomic', 'true');

        this.nodes.result.parentElement.appendChild(
            this._accessibilityAnnouncerDiv
        );
    };

    PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function () {
        this.nodes.result.parentElement.removeChild(
            this._accessibilityAnnouncerDiv
        );
    };

    PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function (
        previousSelectedElement,
        currentSelectedElement
    ) {
        // Update the active descendant on the search input
        this.nodes.input.setAttribute(
            'aria-activedescendant',
            currentSelectedElement.id
        );

        // Unmark the previousSelected elemented as selected
        if (previousSelectedElement) {
            previousSelectedElement.removeAttribute('aria-selected');
        }

        // Mark the element as selected
        currentSelectedElement.setAttribute('aria-selected', true);
    };

    PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function () {
        this.nodes.input.setAttribute('aria-activedescendant', '');
    };

    PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function (
        results
    ) {
        var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
        var newMessage = this.numberOfResultsTemplateFct(results);

        // If the messages are the same, they won't get announced
        // add white space so it gets announced
        if (currentAnnouncedMessage === newMessage) {
            newMessage = newMessage + '&nbsp;';
        }

        this._accessibilityAnnouncerDiv.innerHTML = newMessage;
    };

    PredictiveSearchComponent.prototype._announceLoadingState = function () {
        this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
    };

    PredictiveSearchComponent.prototype._handleInputKeyup = function (evt) {
        var UP_ARROW_KEY_CODE = 38;
        var DOWN_ARROW_KEY_CODE = 40;
        var RETURN_KEY_CODE = 13;
        var ESCAPE_KEY_CODE = 27;

        if (isFunction(this.callbacks.onInputKeyup)) {
            var returnedValue = this.callbacks.onInputKeyup(this.nodes);
            if (isBoolean(returnedValue) && !returnedValue) {
                return false;
            }
        }

        this._toggleClearButtonVisibility();

        if (this.isResultVisible && this.nodes !== null) {
            if (evt.keyCode === UP_ARROW_KEY_CODE) {
                this._navigateOption(evt, 'UP');
                return true;
            }

            if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
                this._navigateOption(evt, 'DOWN');
                return true;
            }

            if (evt.keyCode === RETURN_KEY_CODE) {
                this._selectOption();
                return true;
            }

            if (evt.keyCode === ESCAPE_KEY_CODE) {
                this.close();
            }
        }

        if (evt.target.value.length <= 0) {
            this.close();
            this._setKeyword('');
        } else if (evt.target.value.length > 0) {
            this._search();
        }

        return true;
    };

    PredictiveSearchComponent.prototype._handleInputKeydown = function (evt) {
        var RETURN_KEY_CODE = 13;
        var UP_ARROW_KEY_CODE = 38;
        var DOWN_ARROW_KEY_CODE = 40;

        // Prevent the form default submission if there is a selected option
        if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
            evt.preventDefault();
        }

        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (
            evt.keyCode === UP_ARROW_KEY_CODE ||
            evt.keyCode === DOWN_ARROW_KEY_CODE
        ) {
            evt.preventDefault();
        }
    };

    PredictiveSearchComponent.prototype._handleInputReset = function (evt) {
        evt.preventDefault();

        if (isFunction(this.callbacks.onInputReset)) {
            var returnedValue = this.callbacks.onInputReset(this.nodes);
            if (isBoolean(returnedValue) && !returnedValue) {
                return false;
            }
        }

        this.nodes.input.value = '';
        this.nodes.input.focus();
        this._toggleClearButtonVisibility();
        this.close();

        return true;
    };

    PredictiveSearchComponent.prototype._navigateOption = function (
        evt,
        direction
    ) {
        var currentOption = this._getSelectedOption();

        if (!currentOption) {
            var firstOption = this.nodes.result.querySelector(
                this.selectors.searchResult
            );
            firstOption.classList.add(this.classes.itemSelected);
            this._updateAccessibilityAttributesAfterSelectingElement(
                null,
                firstOption
            );
        } else {
            if (direction === 'DOWN') {
                var nextOption = currentOption.nextElementSibling;
                if (nextOption) {
                    currentOption.classList.remove(this.classes.itemSelected);
                    nextOption.classList.add(this.classes.itemSelected);
                    this._updateAccessibilityAttributesAfterSelectingElement(
                        currentOption,
                        nextOption
                    );
                }
            } else {
                var previousOption = currentOption.previousElementSibling;
                if (previousOption) {
                    currentOption.classList.remove(this.classes.itemSelected);
                    previousOption.classList.add(this.classes.itemSelected);
                    this._updateAccessibilityAttributesAfterSelectingElement(
                        currentOption,
                        previousOption
                    );
                }
            }
        }
    };

    PredictiveSearchComponent.prototype._getSelectedOption = function () {
        return this.nodes.result.querySelector('.' + this.classes.itemSelected);
    };

    PredictiveSearchComponent.prototype._selectOption = function () {
        var selectedOption = this._getSelectedOption();

        if (selectedOption) {
            selectedOption.querySelector('a, button').click();
        }
    };

    PredictiveSearchComponent.prototype._search = function () {
        var newSearchKeyword = this.nodes.input.value;

        if (this._searchKeyword === newSearchKeyword) {
            return;
        }

        clearTimeout(this._latencyTimer);
        this._latencyTimer = setTimeout(
            function () {
                this.results.isLoading = true;

                // Annonuce that we're loading the results
                this._announceLoadingState();

                this.nodes.result.classList.add(this.classes.visibleVariant);
                // NOTE: We could benifit in using DOMPurify.
                // https://github.com/cure53/DOMPurify
                this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
            }.bind(this),
            500
        );

        this.predictiveSearch.query(newSearchKeyword);
        this._setKeyword(newSearchKeyword);
    };

    PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function (
        json
    ) {
        clearTimeout(this._latencyTimer);
        this.results = json.resources.results;

        this.results.isLoading = false;
        this.results.products = this.results.products.slice(
            0,
            this.numberOfResults
        );
        this.results.canLoadMore =
            this.numberOfResults <= this.results.products.length;
        this.results.searchQuery = this.nodes.input.value;

        if (this.results.products.length > 0 || this.results.searchQuery) {
            this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
            this._announceNumberOfResultsFound(this.results);
            this.open();
        } else {
            this.nodes.result.innerHTML = '';

            this._closeOnNoResults();
        }
    };

    PredictiveSearchComponent.prototype._handlePredictiveSearchError = function () {
        clearTimeout(this._latencyTimer);
        this.nodes.result.innerHTML = '';

        this._closeOnNoResults();
    };

    PredictiveSearchComponent.prototype._closeOnNoResults = function () {
        if (this.nodes) {
            this.nodes.result.classList.remove(this.classes.visibleVariant);
        }

        this.isResultVisible = false;
    };

    PredictiveSearchComponent.prototype._setKeyword = function (keyword) {
        this._searchKeyword = keyword;
    };

    PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function () {
        if (!this.nodes.reset) {
            return;
        }

        if (this.nodes.input.value.length > 0) {
            this.nodes.reset.classList.add(this.classes.clearButtonVisible);
        } else {
            this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
        }
    };

    /**
     * Public methods
     */
    PredictiveSearchComponent.prototype.open = function () {
        if (this.isResultVisible) {
            return;
        }

        if (isFunction(this.callbacks.onBeforeOpen)) {
            var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
            if (isBoolean(returnedValue) && !returnedValue) {
                return false;
            }
        }

        this.nodes.result.classList.add(this.classes.visibleVariant);
        this.nodes.input.setAttribute('aria-expanded', true);
        this.isResultVisible = true;

        if (isFunction(this.callbacks.onOpen)) {
            return this.callbacks.onOpen(this.nodes) || true;
        }

        return true;
    };

    PredictiveSearchComponent.prototype.close = function () {
        if (!this.isResultVisible) {
            return true;
        }

        if (isFunction(this.callbacks.onBeforeClose)) {
            var returnedValue = this.callbacks.onBeforeClose(this.nodes);
            if (isBoolean(returnedValue) && !returnedValue) {
                return false;
            }
        }

        if (this.nodes) {
            this.nodes.result.classList.remove(this.classes.visibleVariant);
        }

        this.nodes.input.setAttribute('aria-expanded', false);
        this._clearAriaActiveDescendant();
        this._setKeyword('');

        if (isFunction(this.callbacks.onClose)) {
            this.callbacks.onClose(this.nodes);
        }

        this.isResultVisible = false;
        this.results = {};

        return true;
    };

    PredictiveSearchComponent.prototype.destroy = function () {
        this.close();

        if (isFunction(this.callbacks.onBeforeDestroy)) {
            var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
            if (isBoolean(returnedValue) && !returnedValue) {
                return false;
            }
        }

        this.nodes.result.classList.remove(this.classes.visibleVariant);
        removeInputAttributes(this.nodes.input);
        this._removeInputEventListeners();
        this._removeBodyEventListener();
        this._removeAccessibilityAnnouncer();
        this._removeClearButtonEventListener();

        if (isFunction(this.callbacks.onDestroy)) {
            this.callbacks.onDestroy(this.nodes);
        }

        return true;
    };

    PredictiveSearchComponent.prototype.clearAndClose = function () {
        this.nodes.input.value = '';
        this.close();
    };

    /**
     * Utilities
     */
    function getTypeOf(value) {
        return Object.prototype.toString.call(value);
    }

    function isString(value) {
        return getTypeOf(value) === '[object String]';
    }

    function isBoolean(value) {
        return getTypeOf(value) === '[object Boolean]';
    }

    function isFunction(value) {
        return getTypeOf(value) === '[object Function]';
    }

    return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);

window.theme = window.theme || {};

theme.TouchEvents = function TouchEvents(element, options) {
    this.axis;
    this.checkEvents = [];
    this.eventHandlers = {};
    this.eventModel = {};
    this.events = [
        ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
        ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
        ['mousedown', 'mousemove', 'mouseup']
    ];
    this.eventType;
    this.difference = {};
    this.direction;
    this.start = {};

    this.element = element;
    this.options = Object.assign(
        {},
        {
            dragThreshold: 10,
            start: function () { }, // eslint-disable-line
            move: function () { }, // eslint-disable-line
            end: function () { } // eslint-disable-line
        },
        options
    );

    this.checkEvents = this._getCheckEvents();
    this.eventModel = this._getEventModel();

    this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
    destroy: function () {
        this.element.removeEventListener(
            'dragstart',
            this.eventHandlers.preventDefault
        );

        this.element.removeEventListener(
            this.events[this.eventModel][0],
            this.eventHandlers.touchStart
        );

        if (!this.eventModel) {
            this.element.removeEventListener(
                this.events[2][0],
                this.eventHandlers.touchStart
            );
        }

        this.element.removeEventListener('click', this.eventHandlers.preventClick);
    },

    _setupEventHandlers: function () {
        this.eventHandlers.preventDefault = this._preventDefault.bind(this);
        this.eventHandlers.preventClick = this._preventClick.bind(this);
        this.eventHandlers.touchStart = this._touchStart.bind(this);
        this.eventHandlers.touchMove = this._touchMove.bind(this);
        this.eventHandlers.touchEnd = this._touchEnd.bind(this);

        // Prevent element from dragging when using mouse
        this.element.addEventListener(
            'dragstart',
            this.eventHandlers.preventDefault
        );

        // Bind the touchstart/pointerdown event
        this.element.addEventListener(
            this.events[this.eventModel][0],
            this.eventHandlers.touchStart
        );

        // Bind mousedown if necessary
        if (!this.eventModel) {
            this.element.addEventListener(
                this.events[2][0],
                this.eventHandlers.touchStart
            );
        }

        // No clicking during touch
        this.element.addEventListener('click', this.eventHandlers.preventClick);
    },

    _touchStart: function (event) {
        this.eventType = this.eventModel;

        if (event.type === 'mousedown' && !this.eventModel) {
            this.eventType = 2;
        }

        if (this.checkEvents[this.eventType](event)) return;
        if (this.eventType) this._preventDefault(event);

        document.addEventListener(
            this.events[this.eventType][1],
            this.eventHandlers.touchMove
        );

        document.addEventListener(
            this.events[this.eventType][2],
            this.eventHandlers.touchEnd
        );

        if (this.eventType < 2) {
            document.addEventListener(
                this.events[this.eventType][3],
                this.eventHandlers.touchEnd
            );
        }

        this.start = {
            xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
            yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
            time: new Date().getTime()
        };

        // Ensure we empty out the this.difference object
        Object.keys(this.difference).forEach(
            function (key) {
                delete this.difference[key];
            }.bind(this)
        );

        this.options.start(event);
    },

    _touchMove: function (event) {
        this.difference = this._getDifference(event);

        // Prevent document from scrolling during swipe gesture
        document['on' + this.events[this.eventType][1]] = function (event) {
            this._preventDefault(event);
        }.bind(this);

        // Get the direction user is dragging
        if (!this.axis) {
            if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
                this.axis = 'xPosition';
            } else if (
                this.options.dragThreshold < Math.abs(this.difference.yPosition)
            ) {
                this.axis = 'yPosition';
            } else {
                this.axis = false;
            }
        } else if (this.axis === 'xPosition') {
            this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
        } else if (this.axis === 'yPosition') {
            this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
        }

        this.options.move(event, this.direction, this.difference);
    },

    _touchEnd: function (event) {
        document.removeEventListener(
            this.events[this.eventType][1],
            this.eventHandlers.touchMove
        );

        document.removeEventListener(
            this.events[this.eventType][2],
            this.eventHandlers.touchEnd
        );

        if (this.eventType < 2) {
            document.removeEventListener(
                this.events[this.eventType][3],
                this.eventHandlers.touchEnd
            );
        }

        // Re-enable document scrolling
        document['on' + this.events[this.eventType][1]] = function () {
            return true;
        };

        this.options.end(event, this.direction, this.difference);
        this.axis = false;
    },

    _getDifference: function (event) {
        return {
            xPosition:
                (this.eventType ? event.clientX : event.touches[0].clientX) -
                this.start.xPosition,
            yPosition:
                (this.eventType ? event.clientY : event.touches[0].clientY) -
                this.start.yPosition,
            time: new Date().getTime() - this.start.time
        };
    },

    _getCheckEvents: function () {
        return [
            // Touch events
            function (event) {
                // Skip the event if it's a multi-touch or pinch move
                return (
                    (event.touches && event.touches.length > 1) ||
                    (event.scale && event.scale !== 1)
                );
            },
            // Pointer events
            function (event) {
                // Skip it, if:
                // 1. The event is not primary (other pointers during multi-touch),
                // 2. Left mouse button is not pressed,
                // 3. Event is not a touch event
                return (
                    !event.isPrimary ||
                    (event.buttons && event.buttons !== 1) ||
                    (event.pointerType !== 'touch' && event.pointerType !== 'pen')
                );
            },
            // Mouse events
            function (event) {
                // Skip the event if left mouse button is not pressed
                return event.buttons && event.buttons !== 1;
            }
        ];
    },

    _getEventModel: function () {
        return window.navigator.pointerEnabled ? 1 : 0;
    },

    _preventDefault: function (event) {
        event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    },

    _preventClick: function (event) {
        if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
            this._preventDefault(event);
        }
    }
});


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
    function Drawer(id, position, options) {
        var DEFAULT_OPEN_CLASS = 'js-drawer-open';
        var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

        var defaults = {
            selectors: {
                openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
                close: '.' + DEFAULT_CLOSE_CLASS
            },
            classes: {
                open: DEFAULT_OPEN_CLASS,
                openVariant: DEFAULT_OPEN_CLASS + '-' + position
            },
            withPredictiveSearch: false
        };

        this.nodes = {
            parents: [document.documentElement, document.body],
            page: document.getElementById('PageContainer')
        };

        this.eventHandlers = {};

        this.config = Object.assign({}, defaults, options);
        this.position = position;
        this.drawer = document.getElementById(id);

        if (!this.drawer) {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    }

    Drawer.prototype.init = function () {
        if (document
            .querySelector(this.config.selectors.openVariant)) {
            document
                .querySelector(this.config.selectors.openVariant)
                .addEventListener('click', this.open.bind(this));
        }
        this.drawer
            .querySelector(this.config.selectors.close)
            .addEventListener('click', this.close.bind(this));
    };

    Drawer.prototype.open = function (evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to nodes.page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.activeSource = evt.currentTarget;
        }

        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        if (!this.config.withPredictiveSearch) {
            theme.Helpers.prepareTransition(this.drawer);
        }

        this.nodes.parents.forEach(
            function (parent) {
                parent.classList.add(
                    this.config.classes.open,
                    this.config.classes.openVariant
                );
            }.bind(this)
        );

        this.drawerIsOpen = true;

        // Run function when draw opens if set
        if (
            this.config.onDrawerOpen &&
            typeof this.config.onDrawerOpen === 'function'
        ) {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }

        if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'true');
        }

        // Set focus on drawer
        var trapFocusConfig = {
            container: this.drawer
        };

        if (this.config.elementToFocusOnOpen) {
            trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
        }

        slate.a11y.trapFocus(trapFocusConfig);

        this.bindEvents();

        return this;
    };

    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) {
            // don't close a closed drawer
            return;
        }

        // deselect any focused form elements
        document.activeElement.dispatchEvent(
            new CustomEvent('blur', { bubbles: true, cancelable: true })
        );

        // Ensure closing transition is applied to moved elements, like the nav
        if (!this.config.withPredictiveSearch) {
            theme.Helpers.prepareTransition(this.drawer);
        }

        this.nodes.parents.forEach(
            function (parent) {
                parent.classList.remove(
                    this.config.classes.open,
                    this.config.classes.openVariant
                );
            }.bind(this)
        );

        if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
        }

        this.drawerIsOpen = false;

        // Remove focus on drawer
        slate.a11y.removeTrapFocus({
            container: this.drawer
        });

        this.unbindEvents();

        // Run function when draw closes if set
        if (
            this.config.onDrawerClose &&
            typeof this.config.onDrawerClose === 'function'
        ) {
            this.config.onDrawerClose();
        }
    };

    Drawer.prototype.bindEvents = function () {
        this.eventHandlers.drawerKeyupHandler = function (evt) {
            // close on 'esc' keypress
            if (evt.keyCode === 27) {
                this.close();
                return false;
            } else {
                return true;
            }
        }.bind(this);

        this.eventHandlers.drawerTouchmoveHandler = function () {
            return false;
        };

        this.eventHandlers.drawerClickHandler = function () {
            this.close();
            return false;
        }.bind(this);

        // Add event listener to document body
        document.body.addEventListener(
            'keyup',
            this.eventHandlers.drawerKeyupHandler
        );

        // Lock scrolling on mobile
        this.nodes.page.addEventListener(
            'touchmove',
            this.eventHandlers.drawerTouchmoveHandler
        );

        this.nodes.page.addEventListener(
            'click',
            this.eventHandlers.drawerClickHandler
        );
    };

    Drawer.prototype.unbindEvents = function () {
        this.nodes.page.removeEventListener(
            'touchmove',
            this.eventHandlers.drawerTouchmoveHandler
        );
        this.nodes.page.removeEventListener(
            'click',
            this.eventHandlers.drawerClickHandler
        );
        document.body.removeEventListener(
            'keyup',
            this.eventHandlers.drawerKeyupHandler
        );
    };

    return Drawer;
})();

theme.Helpers = (function () {
    var touchDevice = false;

    var classes = {
        preventScrolling: 'prevent-scrolling'
    };

    var scrollPosition = window.pageYOffset;

    function setTouch() {
        touchDevice = true;
    }

    function isTouch() {
        return touchDevice;
    }

    function enableScrollLock() {
        scrollPosition = window.pageYOffset;
        document.body.style.top = '-' + scrollPosition + 'px';
        document.body.classList.add(classes.preventScrolling);
    }

    function disableScrollLock() {
        document.body.classList.remove(classes.preventScrolling);
        document.body.style.removeProperty('top');
        window.scrollTo(0, scrollPosition);
    }

    function debounce(func, wait, immediate) {
        var timeout;

        return function () {
            var context = this,
                args = arguments;

            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };

            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function getScript(source, beforeEl) {
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            var prior = beforeEl || document.getElementsByTagName('script')[0];

            script.async = true;
            script.defer = true;

            // eslint-disable-next-line shopify/prefer-early-return
            function onloadHander(_, isAbort) {
                if (
                    isAbort ||
                    !script.readyState ||
                    /loaded|complete/.test(script.readyState)
                ) {
                    script.onload = null;
                    script.onreadystatechange = null;
                    script = undefined;

                    if (isAbort) {
                        reject();
                    } else {
                        resolve();
                    }
                }
            }

            script.onload = onloadHander;
            script.onreadystatechange = onloadHander;

            script.src = source;
            prior.parentNode.insertBefore(script, prior);
        });
    }

    /* Based on the prepareTransition by Jonathan Snook */
    /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
    function prepareTransition(element) {
        if (element) {
            element.addEventListener(
                'transitionend',
                function (event) {
                    event.currentTarget.classList.remove('is-transitioning');
                },
                { once: true }
            );

            var properties = [
                'transition-duration',
                '-moz-transition-duration',
                '-webkit-transition-duration',
                '-o-transition-duration'
            ];

            var duration = 0;

            properties.forEach(function (property) {
                var computedValue = getComputedStyle(element)[property];

                if (computedValue) {
                    computedValue.replace(/\D/g, '');
                    duration || (duration = parseFloat(computedValue));
                }
            });

            if (duration !== 0) {
                element.classList.add('is-transitioning');
                element.offsetWidth;
            }
        }
    }

    /*!
     * Serialize all form data into a SearchParams string
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {String}      The serialized form data
     */
    function serialize(form) {
        var arr = [];
        Array.prototype.slice.call(form.elements).forEach(function (field) {
            if (
                !field.name ||
                field.disabled ||
                ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
            )
                return;
            if (field.type === 'select-multiple') {
                Array.prototype.slice.call(field.options).forEach(function (option) {
                    if (!option.selected) return;
                    arr.push(
                        encodeURIComponent(field.name) +
                        '=' +
                        encodeURIComponent(option.value)
                    );
                });
                return;
            }
            if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
                return;
            arr.push(
                encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
            );
        });
        return arr.join('&');
    }
    function cookiesEnabled() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }

        return cookieEnabled;
    }

    function promiseStylesheet(stylesheet) {
        var stylesheetUrl = stylesheet || theme.stylesheet;

        if (typeof this.stylesheetPromise === 'undefined') {
            this.stylesheetPromise = new Promise(function (resolve) {
                var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

                if (link && link.loaded) resolve();
                if (link)
                    link.addEventListener('load', function () {
                        setTimeout(resolve, 0);
                    });
            });
        }

        return this.stylesheetPromise;
    }

    return {
        setTouch: setTouch,
        isTouch: isTouch,
        enableScrollLock: enableScrollLock,
        disableScrollLock: disableScrollLock,
        debounce: debounce,
        getScript: getScript,
        prepareTransition: prepareTransition,
        serialize: serialize,
        cookiesEnabled: cookiesEnabled,
        promiseStylesheet: promiseStylesheet
    };
})();

theme.LibraryLoader = (function () {
    var types = {
        link: 'link',
        script: 'script'
    };

    var status = {
        requested: 'requested',
        loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
        youtubeSdk: {
            tagId: 'youtube-sdk',
            src: 'https://www.youtube.com/iframe_api',
            type: types.script
        },
        plyrShopifyStyles: {
            tagId: 'plyr-shopify-styles',
            src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
            type: types.link
        },
        modelViewerUiStyles: {
            tagId: 'shopify-model-viewer-ui-styles',
            src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            type: types.link
        }
    };

    function load(libraryName, callback) {
        var library = libraries[libraryName];

        if (!library) return;
        if (library.status === status.requested) return;

        callback = callback || function () { };
        if (library.status === status.loaded) {
            callback();
            return;
        }

        library.status = status.requested;

        var tag;

        switch (library.type) {
            case types.script:
                tag = createScriptTag(library, callback);
                break;
            case types.link:
                tag = createLinkTag(library, callback);
                break;
        }

        tag.id = library.tagId;
        library.element = tag;

        var firstScriptTag = document.getElementsByTagName(library.type)[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
        var tag = document.createElement('script');
        tag.src = library.src;
        tag.addEventListener('load', function () {
            library.status = status.loaded;
            callback();
        });
        return tag;
    }

    function createLinkTag(library, callback) {
        var tag = document.createElement('link');
        tag.href = library.src;
        tag.rel = 'stylesheet';
        tag.type = 'text/css';
        tag.addEventListener('load', function () {
            library.status = status.loaded;
            callback();
        });
        return tag;
    }

    return {
        load: load
    };
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function () {
    var selectors = {
        body: 'body',
        navigation: '#AccessibleNav',
        siteNavHasDropdown: '[data-has-dropdowns]',
        siteNavChildLinks: '.site-nav__child-link',
        siteNavActiveDropdown: '.site-nav--active-dropdown',
        siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
        siteNavCenteredDropdown: '.site-nav__dropdown--centered',
        siteNavLinkMain: '.site-nav__link--main',
        siteNavChildLink: '.site-nav__link--last',
        siteNavDropdown: '.site-nav__dropdown',
        siteHeader: '.site-header'
    };

    var config = {
        activeClass: 'site-nav--active-dropdown',
        childLinkClass: 'site-nav__child-link',
        rightDropdownClass: 'site-nav__dropdown--right',
        leftDropdownClass: 'site-nav__dropdown--left'
    };

    var cache = {};

    function init() {
        cacheSelectors();
        styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();

        /*cache.parents.forEach(function(element) {
          element.addEventListener('click', submenuParentClickHandler);
        });
    */
        // check when we're leaving a dropdown and close the active dropdown
        cache.siteNavChildLink.forEach(function (element) {
            element.addEventListener('focusout', submenuFocusoutHandler);
        });

        cache.topLevel.forEach(function (element) {
            element.addEventListener('focus', hideDropdown);
        });

        cache.subMenuLinks.forEach(function (element) {
            element.addEventListener('click', stopImmediatePropagation);
        });

        window.addEventListener('resize', resizeHandler);
    }

    function stopImmediatePropagation(event) {
        event.stopImmediatePropagation();
    }

    function cacheSelectors() {
        var navigation = document.querySelector(selectors.navigation);

        cache = {
            nav: navigation,
            topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
            subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
            activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
            siteHeader: document.querySelector(selectors.siteHeader),
            siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink)
        };
    }

    function showDropdown(element) {
        element.classList.add(config.activeClass);

        if (cache.activeDropdown) hideDropdown();

        cache.activeDropdown = element;

        element
            .querySelector(selectors.siteNavLinkMain)
            .setAttribute('aria-expanded', 'true');

        setTimeout(function () {
            window.addEventListener('keyup', keyUpHandler);
            document.body.addEventListener('click', hideDropdown);
        }, 250);
    }

    function hideDropdown() {
        if (!cache.activeDropdown) return;

        cache.activeDropdown
            .querySelector(selectors.siteNavLinkMain)
            .setAttribute('aria-expanded', 'false');
        cache.activeDropdown.classList.remove(config.activeClass);

        cache.activeDropdown = document.querySelector(
            selectors.siteNavActiveDropdown
        );

        window.removeEventListener('keyup', keyUpHandler);
        document.body.removeEventListener('click', hideDropdown);
    }

    function styleDropdowns(dropdownListItems) {
        dropdownListItems.forEach(function (item) {
            var dropdownLi = item.querySelector(selectors.siteNavDropdown);

            if (!dropdownLi) return;

            if (isRightOfLogo(item)) {
                dropdownLi.classList.remove(config.leftDropdownClass);
                dropdownLi.classList.add(config.rightDropdownClass);
            } else {
                dropdownLi.classList.remove(config.rightDropdownClass);
                dropdownLi.classList.add(config.leftDropdownClass);
            }
        });
    }

    function isRightOfLogo(item) {
        var rect = item.getBoundingClientRect();
        var win = item.ownerDocument.defaultView;
        var leftOffset = rect.left + win.pageXOffset;

        var headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
        return leftOffset > headerWidth;
    }

    function positionFullWidthDropdowns() {
        document
            .querySelectorAll(selectors.siteNavHasCenteredDropdown)
            .forEach(function (el) {
                var fullWidthDropdown = el.querySelector(
                    selectors.siteNavCenteredDropdown
                );

                var fullWidthDropdownOffset = el.offsetTop + 41;
                fullWidthDropdown.style.top = fullWidthDropdownOffset + 'px';
            });
    }

    function keyUpHandler(event) {
        if (event.keyCode === 27) hideDropdown();
    }

    function resizeHandler() {
        adjustStyleAndPosition();
    }

    function submenuParentClickHandler(event) {
        var element = event.currentTarget;

        element.classList.contains(config.activeClass)
            ? hideDropdown()
            : showDropdown(element);
    }

    function submenuFocusoutHandler() {
        setTimeout(function () {
            if (
                document.activeElement.classList.contains(config.childLinkClass) ||
                !cache.activeDropdown
            ) {
                return;
            }

            hideDropdown();
        });
    }

    var adjustStyleAndPosition = theme.Helpers.debounce(function () {
        styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
    }, 50);

    function unload() {
        cache.topLevel.forEach(function (element) {
            element.removeEventListener('focus', hideDropdown);
        });

        cache.subMenuLinks.forEach(function (element) {
            element.removeEventListener('click', stopImmediatePropagation);
        });

        cache.parents.forEach(function (element) {
            element.removeEventListener('click', submenuParentClickHandler);
        });

        cache.siteNavChildLink.forEach(function (element) {
            element.removeEventListener('focusout', submenuFocusoutHandler);
        });

        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('keyup', keyUpHandler);
        document.body.removeEventListener('click', hideDropdown);
    }

    return {
        init: init,
        unload: unload
    };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
    var classes = {
        mobileNavOpenIcon: 'mobile-nav--open',
        mobileNavCloseIcon: 'mobile-nav--close',
        navLinkWrapper: 'mobile-nav__item',
        navLink: 'mobile-nav__link',
        subNavLink: 'mobile-nav__sublist-link',
        return: 'mobile-nav__return-btn',
        subNavActive: 'is-active',
        subNavClosing: 'is-closing',
        navOpen: 'js-menu--is-open',
        subNavShowing: 'sub-nav--is-open',
        thirdNavShowing: 'third-nav--is-open',
        subNavToggleBtn: 'js-toggle-submenu'
    };

    var cache = {};
    var isTransitioning;
    var activeSubNav;
    var activeTrigger;
    var menuLevel = 1;
    var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
    var mql = window.matchMedia(mediumUpQuery);

    function init() {
        cacheSelectors();

        if (cache.mobileNavToggle) {
            cache.mobileNavToggle.addEventListener('click', toggleMobileNav);
        }

        cache.subNavToggleBtns.forEach(function (element) {
            element.addEventListener('click', toggleSubNav);
        });

        mql.addListener(initBreakpoints);
    }

    function initBreakpoints() {
        /*
        if (
          mql.matches &&
          cache.mobileNavContainer.classList.contains(classes.navOpen)
        ) {
          closeMobileNav();
        }*/
    }

    function toggleMobileNav() {
        var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
            classes.mobileNavCloseIcon
        );

        if (mobileNavIsOpen) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    }

    function cacheSelectors() {
        cache = {
            pageContainer: document.querySelector('#PageContainer'),
            siteHeader: document.querySelector('.site-header'),
            mobileNavToggle: document.querySelector('.js-mobile-nav-toggle'),
            mobileNavContainer: document.querySelector('.mobile-nav-wrapper'),
            mobileNav: document.querySelector('#MobileNav'),
            sectionHeader: document.querySelector('#shopify-section-header'),
            subNavToggleBtns: document.querySelectorAll('.' + classes.subNavToggleBtn)
        };
    }

    function openMobileNav() {
        var translateHeaderHeight = cache.siteHeader.offsetHeight;
        if (cache.mobileNavContainer) {
            theme.Helpers.prepareTransition(cache.mobileNavContainer);
            cache.mobileNavContainer.classList.add(classes.navOpen);

            cache.mobileNavContainer.style.transform =
                'translateY(' + translateHeaderHeight + 'px)';

            cache.pageContainer.style.transform =
                'translate3d(0, ' + cache.mobileNavContainer.scrollHeight + 'px, 0)';

            slate.a11y.trapFocus({
                container: cache.sectionHeader,
                elementToFocus: cache.mobileNavToggle
            });

            cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
            cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
            cache.mobileNavToggle.setAttribute('aria-expanded', true);

            window.addEventListener('keyup', keyUpHandler);
        }
    }

    function keyUpHandler(event) {
        if (event.which === 27) {
            closeMobileNav();
        }
    }

    function closeMobileNav() {
        theme.Helpers.prepareTransition(cache.mobileNavContainer);
        cache.mobileNavContainer.classList.remove(classes.navOpen);
        cache.mobileNavContainer.style.transform = 'translateY(-100%)';
        cache.pageContainer.setAttribute('style', '');

        slate.a11y.trapFocus({
            container: document.querySelector('html'),
            elementToFocus: document.body
        });

        cache.mobileNavContainer.addEventListener(
            'transitionend',
            mobileNavRemoveTrapFocus,
            { once: true }
        );

        cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
        cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
        cache.mobileNavToggle.setAttribute('aria-expanded', false);
        cache.mobileNavToggle.focus();

        window.removeEventListener('keyup', keyUpHandler);
        window.scrollTo(0, 0);
    }

    function mobileNavRemoveTrapFocus() {
        slate.a11y.removeTrapFocus({
            container: cache.mobileNav
        });
    }

    function toggleSubNav(event) {
        if (isTransitioning) return;

        var toggleBtn = event.currentTarget;
        var isReturn = toggleBtn.classList.contains(classes.return);

        isTransitioning = true;

        if (isReturn) {
            var subNavToggleBtn = document.querySelectorAll(
                '.' + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
            );

            subNavToggleBtn.forEach(function (element) {
                element.classList.remove(classes.subNavActive);
            });

            if (activeTrigger) {
                activeTrigger.classList.remove(classes.subNavActive);
            }
        } else {
            toggleBtn.classList.add(classes.subNavActive);
        }

        activeTrigger = toggleBtn;

        goToSubnav(toggleBtn.getAttribute('data-target'));
    }

    function goToSubnav(target) {
        var targetMenu = target
            ? document.querySelector(
                '.mobile-nav__dropdown[data-parent="' + target + '"]'
            )
            : cache.mobileNav;

        menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

        if (activeSubNav) {
            theme.Helpers.prepareTransition(activeSubNav);
            activeSubNav.classList.add(classes.subNavClosing);
        }

        activeSubNav = targetMenu;

        var translateMenuHeight = targetMenu.offsetHeight;

        var openNavClass =
            menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

        cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
        cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
        cache.mobileNavContainer.classList.add(openNavClass);

        if (!target) {
            cache.mobileNavContainer.classList.remove(
                classes.thirdNavShowing,
                classes.subNavShowing
            );
        }

        /* if going back to first subnav, focus is on whole header */
        var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

        cache.mobileNavContainer.addEventListener(
            'transitionend',
            trapMobileNavFocus,
            { once: true }
        );

        function trapMobileNavFocus() {
            slate.a11y.trapFocus({
                container: container
            });

            cache.mobileNavContainer.removeEventListener(
                'transitionend',
                trapMobileNavFocus
            );

            isTransitioning = false;
        }

        // Match height of subnav
        cache.pageContainer.style.transform =
            'translateY(' + translateMenuHeight + 'px)';

        activeSubNav.classList.remove(classes.subNavClosing);
    }

    function unload() {
        mql.removeListener(initBreakpoints);
    }

    return {
        init: init,
        unload: unload,
        closeMobileNav: closeMobileNav
    };
})();

(function () {
    var selectors = {
        backButton: '.return-link'
    };

    var backButton = document.querySelector(selectors.backButton);

    if (!document.referrer || !backButton || !window.history.length) {
        return;
    }

    backButton.addEventListener(
        'click',
        function (evt) {
            evt.preventDefault();

            var referrerDomain = urlDomain(document.referrer);
            var shopDomain = urlDomain(window.location.href);

            if (shopDomain === referrerDomain) {
                history.back();
            }

            return false;
        },
        { once: true }
    );

    function urlDomain(url) {
        var anchor = document.createElement('a');
        anchor.ref = url;

        return anchor.hostname;
    }
})();

theme.Slideshow = (function () {
    var selectors = {
        button: '[data-slider-button]',
        indicator: '[data-slider-indicator]',
        indicators: '[data-slider-indicators]',
        pause: '[data-slider-pause]',
        slider: '[data-slider]',
        sliderItem: '[data-slider-item]',
        sliderItemLink: '[data-slider-item-link]',
        sliderTrack: '[data-slider-track]',
        sliderContainer: '[data-slider-container]'
    };

    var classes = {
        isPaused: 'slideshow__pause--is-paused',
        indicator: 'slider-indicators__item',
        indicatorActive: 'slick-active',
        sliderInitialized: 'slick-initialized',
        slideActive: 'slideshow__slide--active',
        slideClone: 'slick-cloned'
    };

    var attributes = {
        buttonNext: 'data-slider-button-next'
    };

    function Slideshow(container, options) {
        this.container = container;
        this.slider = this.container.querySelector(selectors.slider);

        if (!this.slider) return;

        this.eventHandlers = {};
        this.lastSlide = 0;
        this.slideIndex = 0;
        this.sliderContainer = null;
        this.slides = [];
        this.options = Object.assign(
            {},
            {
                autoplay: false,
                canUseKeyboardArrows: true,
                canUseTouchEvents: false,
                slideActiveClass: classes.slideActive,
                slideInterval: 0,
                slidesToShow: 0,
                slidesToScroll: 1,
                type: 'fade',
                swipeToSlide: false
            },
            options
        );

        this.sliderContainer = this.slider.querySelector(selectors.sliderContainer);
        this.adaptHeight =
            this.sliderContainer.getAttribute('data-adapt-height') === 'true';
        this.slides = Array.from(
            this.sliderContainer.querySelectorAll(selectors.sliderItem)
        );
        // adding -1 to accomodate Array order
        this.lastSlide = this.slides.length - 1;
        this.buttons = this.container.querySelectorAll(selectors.button);
        this.pause = this.container.querySelector(selectors.pause);
        this.indicators = this.container.querySelectorAll(selectors.indicators);

        if (this.slides.length <= 1) return;

        this.timeout = 250;

        if (this.options.autoplay) {
            this.startAutoplay();
        }

        if (this.adaptHeight) {
            this.setSlideshowHeight();
        }

        if (this.options.type === 'slide') {
            this.isFirstSlide = false;
            this.isLastSlide = false;
            this.sliderItemWidthTotal = 0;
            this.sliderTrack = this.slider.querySelector(selectors.sliderTrack);
            // added setTimeout due to matchMedia calling too early
            // which result wrong value when getting dimension from an element
            this.sliderItemWidthTotal = 0;
            theme.Helpers.promiseStylesheet().then(
                function () {
                    this._setupSlideType();
                }.bind(this)
            );
        } else {
            this.setupSlider(0);
        }

        this._setupEventHandlers();
    }

    Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
        /**
         * Moves to the previous slide
         */
        previousSlide: function () {
            this._move();
        },

        /**
         * Moves to the next slide
         */
        nextSlide: function () {
            this._move('next');
        },

        /**
         * Moves to the specified slide
         * @param {Number} index - The index of the slide to move to
         */
        setSlide: function (index) {
            this._setPosition(Number(index));
        },

        /**
         * Starts autoplaying the slider if autoplay is enabled
         */
        startAutoplay: function () {
            this.isAutoPlaying = true;

            window.clearTimeout(this.autoTimeOut);

            this.autoTimeOut = window.setTimeout(
                function () {
                    var nextSlideIndex = this._getNextSlideIndex('next');
                    this._setPosition(nextSlideIndex);
                }.bind(this),
                this.options.slideInterval
            );
        },

        /**
         * Stops autoplaying the slider if autoplay is enabled
         */
        stopAutoplay: function () {
            this.isAutoPlaying = false;

            window.clearTimeout(this.autoTimeOut);
        },

        /**
         * Set active states for sliders and indicators
         * @param {index} integer - Slide index to set up slider from
         */
        setupSlider: function (index) {
            this.slideIndex = index;

            if (this.indicators.length) {
                this._setActiveIndicator(index);
            }

            this._setupActiveSlide(index);
        },

        /**
         * Removes event listeners, among other things when wanting to destroy the
         * slider instance. This method needs to be called manually and will most
         * likely be included in a section's onUnload() method.
         */
        destroy: function () {
            if (this.adaptHeight) {
                window.removeEventListener('resize', this.eventHandlers.debounceResize);
            }

            this.container.removeEventListener(
                'focus',
                this.eventHandlers.focus,
                true
            );
            this.slider.removeEventListener(
                'focusin',
                this.eventHandlers.focusIn,
                true
            );
            this.slider.removeEventListener(
                'focusout',
                this.eventHandlers.focusOut,
                true
            );
            this.container.removeEventListener('blur', this.eventHandlers.blur, true);

            if (this.buttons) {
                this.buttons.forEach(
                    function (button) {
                        button.removeEventListener('click', this.eventHandlers.clickButton);
                    }.bind(this)
                );
            }

            this.indicators.forEach(function (indicatorWrapper) {
                indicatorWrapper.childNodes.forEach(function (indicator) {
                    indicator.firstElementChild.removeEventListener(
                        'click',
                        this.eventHandlers.onClickIndicator
                    );

                    indicator.firstElementChild.removeEventListener(
                        'keydown',
                        this.eventHandlers.onKeydownIndicator
                    );
                }, this);
            }, this);

            if (this.options.type === 'slide') {
                window.removeEventListener(
                    'resize',
                    this.eventHandlers.debounceResizeSlideIn
                );

                if (this.touchEvents && this.options.canUseTouchEvents) {
                    this.touchEvents.destroy();
                    this.touchEvents = null;
                }
            }
        },

        _setupEventHandlers: function () {
            this.eventHandlers.focus = this._onFocus.bind(this);
            this.eventHandlers.focusIn = this._onFocusIn.bind(this);
            this.eventHandlers.focusOut = this._onFocusOut.bind(this);
            this.eventHandlers.blur = this._onBlur.bind(this);
            this.eventHandlers.keyUp = this._onKeyUp.bind(this);
            this.eventHandlers.clickButton = this._onClickButton.bind(this);
            this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this);
            this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(
                this
            );
            this.eventHandlers.onClickPause = this._onClickPause.bind(this);

            if (this.adaptHeight) {
                this.eventHandlers.debounceResize = theme.Helpers.debounce(
                    function () {
                        this.setSlideshowHeight();
                    }.bind(this),
                    50
                );

                window.addEventListener('resize', this.eventHandlers.debounceResize);
            }

            this.container.addEventListener('focus', this.eventHandlers.focus, true);
            this.slider.addEventListener('focusin', this.eventHandlers.focusIn, true);
            this.slider.addEventListener(
                'focusout',
                this.eventHandlers.focusOut,
                true
            );
            this.container.addEventListener('blur', this.eventHandlers.blur, true);

            if (this.buttons) {
                this.buttons.forEach(
                    function (button) {
                        button.addEventListener('click', this.eventHandlers.clickButton);
                    }.bind(this)
                );
            }

            if (this.pause) {
                this.pause.addEventListener('click', this.eventHandlers.onClickPause);
            }

            this.indicators.forEach(function (indicatorWrapper) {
                indicatorWrapper.childNodes.forEach(function (indicator) {
                    indicator.firstElementChild.addEventListener(
                        'click',
                        this.eventHandlers.onClickIndicator
                    );

                    indicator.firstElementChild.addEventListener(
                        'keydown',
                        this.eventHandlers.onKeydownIndicator
                    );
                }, this);
            }, this);

            if (this.options.type === 'slide') {
                this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
                    function () {
                        this.sliderItemWidthTotal = 0;
                        this._setupSlideType(true);
                    }.bind(this),
                    50
                );

                window.addEventListener(
                    'resize',
                    this.eventHandlers.debounceResizeSlideIn
                );

                if (
                    this.options.canUseTouchEvents &&
                    this.options.slidesToScroll < this.slides.length
                ) {
                    this._setupTouchEvents();
                }
            }
        },

        _setupTouchEvents: function () {
            this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
                start: function () {
                    this._onTouchStart();
                }.bind(this),
                move: function (event, direction, difference) {
                    this._onTouchMove(event, direction, difference);
                }.bind(this),
                end: function (event, direction, difference) {
                    this._onTouchEnd(event, direction, difference);
                }.bind(this)
            });
        },

        /**
         * Set slideshop for "slide-in" effect
         * @param {Boolean} onResize if function call came from resize event
         */
        _setupSlideType: function (onResize) {
            this.sliderItemWidth = Math.floor(
                this.sliderContainer.offsetWidth / this.options.slidesToShow
            );
            this.sliderTranslateXMove =
                this.sliderItemWidth * this.options.slidesToScroll;

            if (!onResize) {
                this.sliderContainer.classList.add(classes.sliderInitialized);
            }

            // Loop through all slider items
            // Set width according to the number of items to show in 1 slide
            // Set container width to accomodate all items
            this.slides.forEach(function (sliderItem, index) {
                var sliderItemLink = sliderItem.querySelector(selectors.sliderItemLink);
                sliderItem.style.width = this.sliderItemWidth + 'px';
                sliderItem.setAttribute('aria-hidden', true);
                sliderItem.setAttribute('tabindex', -1);
                this.sliderItemWidthTotal =
                    this.sliderItemWidthTotal + sliderItem.offsetWidth;

                if (sliderItemLink) {
                    sliderItemLink.setAttribute('tabindex', -1);
                }

                if (index < this.options.slidesToShow) {
                    sliderItem.setAttribute('aria-hidden', false);
                    sliderItem.classList.add(this.options.slideActiveClass);

                    if (sliderItemLink) {
                        sliderItemLink.setAttribute('tabindex', 0);
                    }
                }
            }, this);

            this.sliderTrack.style.width =
                Math.floor(this.sliderItemWidthTotal) + 'px';
            this.sliderTrack.style.transform = 'translateX(-0px)';

            // set disabled attribute on Previous button
            if (this.buttons.length) {
                this.buttons[0].setAttribute('aria-disabled', true);
                this.buttons[1].removeAttribute('aria-disabled');
            }

            if (this.indicators.length) {
                this._setActiveIndicator(0);
            }
        },

        _onTouchStart: function () {
            this.touchStartPosition = this._getTranslateXPosition();
        },

        _onTouchMove: function (event, direction, difference) {
            // Fix touch events cause unexpected behaviour
            // when the dragging motion goes beyond the theme editor preview.
            var threshold = 80;
            if (
                Shopify.designMode &&
                (event.clientX <= threshold ||
                    event.clientX >= window.innerWidth - threshold)
            ) {
                event.target.dispatchEvent(
                    new MouseEvent('mouseup', {
                        bubbles: true,
                        cancelable: true
                    })
                );
                return;
            }

            if (direction !== 'left' && direction !== 'right') return;

            this.touchMovePosition = this.touchStartPosition + difference.xPosition;

            this.sliderTrack.style.transform =
                'translateX(' + this.touchMovePosition + 'px';
        },

        _onTouchEnd: function (event, direction, difference) {
            var nextTranslateXPosition = 0;

            if (Object.keys(difference).length === 0) return;

            var slideDirection = direction === 'left' ? 'next' : '';

            if (direction === 'left') {
                if (this._isNextTranslateXLast(this.touchStartPosition)) {
                    nextTranslateXPosition = this.touchStartPosition;
                } else {
                    nextTranslateXPosition =
                        this.touchStartPosition - this.sliderTranslateXMove;
                }
            } else {
                nextTranslateXPosition =
                    this.touchStartPosition + this.sliderTranslateXMove;
                if (this._isNextTranslateXFirst(this.touchStartPosition)) {
                    nextTranslateXPosition = 0;
                }
            }

            this.slideIndex = this._getNextSlideIndex(slideDirection);

            this.sliderTrack.style.transition = 'transform 500ms ease 0s';
            this.sliderTrack.style.transform =
                'translateX(' + nextTranslateXPosition + 'px';

            window.setTimeout(
                function () {
                    this.sliderTrack.style.transition = '';
                }.bind(this),
                500
            );

            this._verifyFirstLastSlideTranslateX(nextTranslateXPosition);

            this._postTransitionEnd();
        },

        /**
         * Events handlers for next and previous button
         * @param {Object} event event handler
         */
        _onClickButton: function (event) {
            // prevent multiple clicks
            if (event.detail > 1) return;

            var button = event.currentTarget;
            var nextButton = button.hasAttribute(attributes.buttonNext);

            if (
                this.options.type === 'slide' &&
                button.getAttribute('aria-disabled') === 'true'
            ) {
                return;
            }

            if (this.options.autoplay && this.isAutoPlaying) {
                this.stopAutoplay();
            }

            if (nextButton) {
                this.nextSlide();
            } else {
                this.previousSlide();
            }
        },

        _onClickIndicator: function (event) {
            event.preventDefault();

            if (event.target.classList.contains(classes.indicatorActive)) return;

            if (this.options.autoplay && this.isAutoPlaying) {
                this.stopAutoplay();
            }

            this.slideIndex = Number(event.target.dataset.slideNumber);
            this.goToSlideByIndex(this.slideIndex);
        },

        goToSlideByIndex: function (index) {
            this._setPosition(index);

            if (this.options.type === 'slide' && this.sliderTrack) {
                this.sliderTrack.style.transition = 'transform 500ms ease 0s';
                var newPosition = index * this.slides[0].offsetWidth;

                this.sliderTrack.style.transform = 'translateX(-' + newPosition + 'px)';

                if (this.options.slidesToShow > 1) {
                    this._verifyFirstLastSlideTranslateX(newPosition);

                    if (this.buttons.length) {
                        this._disableArrows();
                    }

                    this._setupMultipleActiveSlide(
                        index,
                        index + (this.options.slidesToShow - 1)
                    );
                }
            }
        },

        _onKeydownIndicator: function (event) {
            if (event.keyCode !== slate.utils.keyboardKeys.ENTER) return;

            this._onClickIndicator(event);

            this.slider.focus();
        },

        _onClickPause: function (event) {
            if (!event.currentTarget.classList.contains(classes.isPaused)) {
                event.currentTarget.classList.add(classes.isPaused);
                this.stopAutoplay();
            } else {
                event.currentTarget.classList.remove(classes.isPaused);
                this.startAutoplay();
            }
        },

        _onFocus: function () {
            this.container.addEventListener('keyup', this.eventHandlers.keyUp);
        },

        _onFocusIn: function () {
            if (this.slider.hasAttribute('aria-live')) return;

            if (this.options.autoplay && this.isAutoPlaying) {
                this.stopAutoplay();
            }

            this.slider.setAttribute('aria-live', 'polite');
        },

        _onBlur: function () {
            this.container.removeEventListener('keyup', this.eventHandlers.keyUp);
        },

        _onFocusOut: function () {
            this.slider.removeAttribute('aria-live');

            // Adding a setTimeout because everytime we focus out
            // It automatically goes to <body>
            // We want to resume autoplay when focus is outside of the slideshow container
            setTimeout(
                function () {
                    if (
                        !document.activeElement.closest(
                            '#' + this.slider.getAttribute('id')
                        )
                    ) {
                        if (
                            this.options.autoplay &&
                            !this.isAutoPlaying &&
                            !this.pause.classList.contains(classes.isPaused)
                        ) {
                            this.startAutoplay();
                        }
                    }
                }.bind(this),
                this.timeout
            );
        },

        _onKeyUp: function (event) {
            switch (event.keyCode) {
                case slate.utils.keyboardKeys.LEFTARROW:
                    if (!this.options.canUseKeyboardArrows) return;

                    if (this.options.type === 'slide' && this.isFirstSlide) {
                        return;
                    }

                    this.previousSlide();

                    break;
                case slate.utils.keyboardKeys.RIGHTARROW:
                    if (!this.options.canUseKeyboardArrows) return;

                    if (this.options.type === 'slide' && this.isLastSlide) {
                        return;
                    }

                    this.nextSlide();

                    break;
                case slate.utils.keyboardKeys.ESCAPE:
                    this.slider.blur();
                    break;
            }
        },

        _move: function (direction) {
            if (this.options.type === 'slide') {
                this.slideIndex = this._getNextSlideIndex(direction);
                this._moveSlideshow(direction);
            } else {
                var nextSlideIndex = this._getNextSlideIndex(direction);
                this._setPosition(nextSlideIndex);
            }
        },

        _moveSlideshow: function (direction) {
            this.direction = direction;
            var valueXToMove = 0;

            // Get current position of translateX
            var currentTranslateXPosition = this._getTranslateXPosition();
            var currentActiveSlidesIndex = this._getActiveSlidesIndex();

            // In the future, we'll use ES6 deconstructure
            // Math.min(...currentActiveSlidesIndex);
            var currentActiveSlidesMinIndex = Math.min.apply(
                Math,
                currentActiveSlidesIndex
            );
            var currentActiveSlidesMaxIndex = Math.max.apply(
                Math,
                currentActiveSlidesIndex
            );

            // Set the next active state depending on the direction
            // We bump up the index depending on the "slidesToShow" option
            this.nextMinIndex =
                direction === 'next'
                    ? currentActiveSlidesMinIndex + this.options.slidesToShow
                    : currentActiveSlidesMinIndex - this.options.slidesToShow;
            this.nextMaxIndex =
                direction === 'next'
                    ? currentActiveSlidesMaxIndex + this.options.slidesToShow
                    : currentActiveSlidesMinIndex - 1;

            this.sliderTrack.style.transition = 'transform 500ms ease 0s';

            if (direction === 'next') {
                valueXToMove = currentTranslateXPosition - this.sliderTranslateXMove;
                this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
            } else {
                valueXToMove = currentTranslateXPosition + this.sliderTranslateXMove;
                this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
            }

            this._verifyFirstLastSlideTranslateX(valueXToMove);

            this._postTransitionEnd();

            this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
        },

        _setPosition: function (nextSlideIndex) {
            this.slideIndex = nextSlideIndex;

            if (this.indicators.length) {
                this._setActiveIndicator(nextSlideIndex);
            }

            this._setupActiveSlide(nextSlideIndex);

            if (this.options.autoplay && this.isAutoPlaying) {
                this.startAutoplay();
            }

            this.container.dispatchEvent(
                new CustomEvent('slider_slide_changed', {
                    detail: nextSlideIndex
                })
            );
        },

        _setupActiveSlide: function (index) {
            this.slides.forEach(function (slide) {
                slide.setAttribute('aria-hidden', true);
                slide.classList.remove(this.options.slideActiveClass);
            }, this);

            this.slides[index].setAttribute('aria-hidden', false);
            this.slides[index].classList.add(this.options.slideActiveClass);
        },

        /**
         * Loops through all slide items
         * Set the active state depending the direction and slide indexes
         * Because slide-in effect can have multiple items in 1 slide, we need to target multiple active elements
         * @param {String} direction "next" for next slides or empty string for previous
         * @param {*} minIndex the current active minimum index
         * @param {*} maxIndex the current active maximum index
         */
        _setupMultipleActiveSlide: function (minIndex, maxIndex) {
            this.slides.forEach(function (slide) {
                var sliderIndex = Number(slide.getAttribute('data-slider-slide-index'));
                var sliderItemLink = slide.querySelector(selectors.sliderItemLink);

                slide.setAttribute('aria-hidden', true);
                slide.classList.remove(this.options.slideActiveClass);
                if (sliderItemLink) {
                    sliderItemLink.setAttribute('tabindex', -1);
                }

                if (sliderIndex >= minIndex && sliderIndex <= maxIndex) {
                    slide.setAttribute('aria-hidden', false);
                    slide.classList.add(this.options.slideActiveClass);

                    if (sliderItemLink) {
                        sliderItemLink.setAttribute('tabindex', 0);
                    }
                }
            }, this);
        },

        _setActiveIndicator: function (index) {
            this.indicators.forEach(function (indicatorWrapper) {
                var activeIndicator = indicatorWrapper.querySelector(
                    '.' + classes.indicatorActive
                );

                var nextIndicator = indicatorWrapper.childNodes[index];

                if (activeIndicator) {
                    activeIndicator.setAttribute('aria-selected', false);
                    activeIndicator.classList.remove(classes.indicatorActive);
                    activeIndicator.firstElementChild.removeAttribute('aria-current');
                }

                nextIndicator.classList.add(classes.indicatorActive);
                nextIndicator.setAttribute('aria-selected', true);
                nextIndicator.firstElementChild.setAttribute('aria-current', true);
            }, this);
        },

        setSlideshowHeight: function () {
            var minAspectRatio = this.sliderContainer.getAttribute(
                'data-min-aspect-ratio'
            );
            this.sliderContainer.style.height =
                document.documentElement.offsetWidth / minAspectRatio + 'px';
        },

        /**
         * Increase or decrease index position of the slideshow
         * Automatically auto-rotate
         * - Last slide goes to first slide when clicking "next"
         * - First slide goes to last slide when clicking "previous"
         * @param {String} direction "next" as a String, other empty string is previous slide
         */
        _getNextSlideIndex: function (direction) {
            var counter = direction === 'next' ? 1 : -1;

            if (direction === 'next') {
                if (this.slideIndex === this.lastSlide) {
                    return this.options.type === 'slide' ? this.lastSlide : 0;
                }
            } else if (!this.slideIndex) {
                return this.options.type === 'slide' ? 0 : this.lastSlide;
            }

            return this.slideIndex + counter;
        },

        /**
         * In "slide-in" type, multiple items are active in 1 slide
         * This will return an array containing their indexes
         */
        _getActiveSlidesIndex: function () {
            var currentActiveSlides = this.slides.filter(function (sliderItem) {
                if (sliderItem.classList.contains(this.options.slideActiveClass)) {
                    return sliderItem;
                }
            }, this);
            var currentActiveSlidesIndex = currentActiveSlides.map(function (
                sliderItem
            ) {
                return Number(sliderItem.getAttribute('data-slider-slide-index'));
            });

            return currentActiveSlidesIndex;
        },

        /**
         * This checks the next "translateX" value and verifies
         * If it's at the last slide or beginning of the slide
         * So we can disable the arrow buttons
         */
        _disableArrows: function () {
            if (this.buttons.length === 0) return;

            var previousButton = this.buttons[0];
            var nextButton = this.buttons[1];

            // first slide
            if (this.isFirstSlide) {
                previousButton.setAttribute('aria-disabled', true);
            } else {
                previousButton.removeAttribute('aria-disabled');
            }

            // last slide
            if (this.isLastSlide) {
                nextButton.setAttribute('aria-disabled', true);
            } else {
                nextButton.removeAttribute('aria-disabled');
            }
        },

        /**
         * Verify if translateX reaches at first or last slide
         * @param {Number} translateXValue
         */
        _verifyFirstLastSlideTranslateX: function (translateXValue) {
            // first slide
            if (this._isNextTranslateXFirst(translateXValue)) {
                this.isFirstSlide = true;
            } else {
                this.isFirstSlide = false;
            }

            // last slide
            if (this._isNextTranslateXLast(translateXValue)) {
                this.isLastSlide = true;
            } else {
                this.isLastSlide = false;
            }
        },

        _getTranslateXPosition: function () {
            return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
        },

        _isNextTranslateXFirst: function (translateXValue) {
            return translateXValue === 0;
        },

        _isNextTranslateXLast: function (translateXValue) {
            // because translateX values are using negative, I'm converting into positive value
            var translateXValueAbsolute = Math.abs(translateXValue);
            var nextTranslateXValue =
                translateXValueAbsolute + this.sliderTranslateXMove;

            return nextTranslateXValue >= this.sliderItemWidthTotal;
        },

        _postTransitionEnd: function () {
            if (this.buttons.length) {
                this._disableArrows();
            }

            if (this.indicators.length) {
                this._setActiveIndicator(this.slideIndex);
            }
        }
    });

    return Slideshow;
})();

theme.Video = (function () {
    var autoplayCheckComplete = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        scrollAnimationDuration: 400,
        playerVars: {
            // eslint-disable-next-line camelcase
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0,
            controls: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
            rel: 0
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerChange
        }
    };
    var classes = {
        playing: 'video-is-playing',
        paused: 'video-is-paused',
        loading: 'video-is-loading',
        loaded: 'video-is-loaded',
        backgroundVideoWrapper: 'video-background-wrapper',
        videoWithImage: 'video--image_with_play',
        backgroundVideo: 'video--background',
        userPaused: 'is-paused',
        supportsAutoplay: 'autoplay',
        supportsNoAutoplay: 'no-autoplay',
        wrapperMinHeight: 'video-section-wrapper--min-height'
    };

    var selectors = {
        section: '.video-section',
        videoWrapper: '.video-section-wrapper',
        playVideoBtn: '.video-control__play',
        closeVideoBtn: '.video-control__close-wrapper',
        pauseVideoBtn: '.video__pause',
        pauseVideoStop: '.video__pause-stop',
        pauseVideoResume: '.video__pause-resume',
        fallbackText: '.icon__fallback-text'
    };

    /**
     * Public functions
     */
    function init(video) {
        if (!video) return;

        videos[video.id] = {
            id: video.id,
            videoId: video.dataset.id,
            type: video.dataset.type,
            status:
                video.dataset.type === 'image_with_play' ? 'closed' : 'background', // closed, open, background
            video: video,
            videoWrapper: video.closest(selectors.videoWrapper),
            section: video.closest(selectors.section),
            controls: video.dataset.type === 'background' ? 0 : 1
        };

        if (!youtubeLoaded) {
            // This code loads the IFrame Player API code asynchronously.
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        playOnClickCheck();
    }

    function customPlayVideo(playerId) {
        // Make sure we have carried out the playOnClick check first
        if (!playOnClickChecked && !playOnClick) {
            return;
        }

        if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
            privatePlayVideo(playerId);
        }
    }

    function pauseVideo(playerId) {
        if (
            videoPlayers[playerId] &&
            typeof videoPlayers[playerId].pauseVideo === 'function'
        ) {
            videoPlayers[playerId].pauseVideo();
        }
    }

    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                createPlayer(key);
            }
        }

        initEvents();
        youtubeLoaded = true;
    }

    function editorLoadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        createPlayer(key);

        initEvents();
    }

    /**
     * Private functions
     */

    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var videoWrapper = videoData.videoWrapper;

        if (playOnClick) {
            // playOnClick means we are probably on mobile (no autoplay).
            // setAsPlaying will show the iframe, requiring another click
            // to play the video.
            setAsPlaying(videoData);
        } else if (clicked || autoplayCheckComplete) {
            // Play if autoplay is available or clicked to play
            videoWrapper.classList.remove(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        } else {
            player.playVideo();
        }
    }

    function setAutoplaySupport(supported) {
        var supportClass = supported
            ? classes.supportsAutoplay
            : classes.supportsNoAutoplay;
        document.documentElement.classList.remove(
            classes.supportsAutoplay,
            classes.supportsNoAutoplay
        );
        document.documentElement.classList.add(supportClass);

        if (!supported) {
            playOnClick = true;
        }

        autoplayCheckComplete = true;
    }

    function playOnClickCheck() {
        if (playOnClickChecked) {
            return;
        }

        if (isMobile()) {
            playOnClick = true;
        }

        if (playOnClick) {
            // No need to also do the autoplay check
            setAutoplaySupport(false);
        }

        playOnClickChecked = true;
    }

    // The API will call this function when each video player is ready
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality('hd1080');
        var videoData = getVideoOptions(evt);
        var videoTitle = evt.target.getVideoData().title;
        playOnClickCheck();

        // Prevent tabbing through YouTube player controls until visible
        document.getElementById(videoData.id).setAttribute('tabindex', '-1');

        sizeBackgroundVideos();
        setButtonLabels(videoData.videoWrapper, videoTitle);

        // Customize based on options from the video ID
        if (videoData.type === 'background') {
            evt.target.mute();
            privatePlayVideo(videoData.id);
        }

        videoData.videoWrapper.classList.add(classes.loaded);
    }

    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        if (
            videoData.status === 'background' &&
            !isMobile() &&
            !autoplayCheckComplete &&
            (evt.data === YT.PlayerState.PLAYING ||
                evt.data === YT.PlayerState.BUFFERING)
        ) {
            setAutoplaySupport(true);
            autoplayCheckComplete = true;
            videoData.videoWrapper.classList.remove(classes.loading);
        }
        switch (evt.data) {
            case YT.PlayerState.ENDED:
                setAsFinished(videoData);
                break;
            case YT.PlayerState.PAUSED:
                // Seeking on a YouTube video also fires a PAUSED state change,
                // checking the state after a delay prevents us pausing the video when
                // the user is seeking instead of pausing
                setTimeout(function () {
                    if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
                        setAsPaused(videoData);
                    }
                }, 200);
                break;
        }
    }

    function setAsFinished(videoData) {
        switch (videoData.type) {
            case 'background':
                videoPlayers[videoData.id].seekTo(0);
                break;
            case 'image_with_play':
                closeVideo(videoData.id);
                toggleExpandVideo(videoData.id, false);
                break;
        }
    }

    function setAsPlaying(videoData) {
        var videoWrapper = videoData.videoWrapper;
        var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);

        videoWrapper.classList.remove(classes.loading);

        if (pauseButton.classList.contains(classes.userPaused)) {
            pauseButton.classList.remove(classes.userPaused);
        }

        // Do not change element visibility if it is a background video
        if (videoData.status === 'background') {
            return;
        }

        document.getElementById(videoData.id).setAttribute('tabindex', '0');

        if (videoData.type === 'image_with_play') {
            videoWrapper.classList.remove(classes.paused);
            videoWrapper.classList.add(classes.playing);
        }

        // Update focus to the close button so we stay within the video wrapper,
        // allowing time for the scroll animation
        setTimeout(function () {
            videoWrapper.querySelector(selectors.closeVideoBtn).focus();
        }, videoOptions.scrollAnimationDuration);
    }

    function setAsPaused(videoData) {
        var videoWrapper = videoData.videoWrapper;

        // YT's events fire after our click event. This status flag ensures
        // we don't interact with a closed or background video.
        if (videoData.type === 'image_with_play') {
            if (videoData.status === 'closed') {
                videoWrapper.classList.remove(classes.paused);
            } else {
                videoWrapper.classList.add(classes.paused);
            }
        }

        videoWrapper.classList.remove(classes.playing);
    }

    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var videoWrapper = videoData.videoWrapper;

        document.getElementById(videoData.id).setAttribute('tabindex', '-1');

        videoData.status = 'closed';

        switch (videoData.type) {
            case 'image_with_play':
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData); // in case the video is already paused
                break;
            case 'background':
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
        }

        videoWrapper.classList.remove(classes.paused, classes.playing);
    }

    function getVideoOptions(evt) {
        var id = evt.target.getIframe().id;
        return videos[id];
    }

    function toggleExpandVideo(playerId, expand) {
        var video = videos[playerId];
        var elementTop =
            video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
        var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
        var offset = 0;
        var newHeight = 0;

        if (isMobile()) {
            video.videoWrapper.parentElement.classList.toggle('page-width', !expand);
        }

        if (expand) {
            if (isMobile()) {
                newHeight = window.innerWidth / videoOptions.ratio;
            } else {
                newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio;
            }
            offset = (window.innerHeight - newHeight) / 2;

            video.videoWrapper.style.height =
                video.videoWrapper.getBoundingClientRect().height + 'px';
            video.videoWrapper.classList.remove(classes.wrapperMinHeight);
            video.videoWrapper.style.height = newHeight + 'px';

            // Animate doesn't work in mobile editor, so we don't use it
            if (!(isMobile() && Shopify.designMode)) {
                var scrollBehavior = document.documentElement.style.scrollBehavior;
                document.documentElement.style.scrollBehavior = 'smooth';
                window.scrollTo({ top: elementTop - offset });
                document.documentElement.style.scrollBehavior = scrollBehavior;
            }
        } else {
            if (isMobile()) {
                newHeight = video.videoWrapper.dataset.mobileHeight;
            } else {
                newHeight = video.videoWrapper.dataset.desktopHeight;
            }

            video.videoWrapper.style.height = newHeight + 'px';

            setTimeout(function () {
                video.videoWrapper.classList.add(classes.wrapperMinHeight);
            }, 600);
            // Set focus on play button, but don't scroll page
            var x = window.scrollX;
            var y = window.scrollY;
            playButton.focus();
            window.scrollTo(x, y);
        }
    }

    function togglePause(playerId) {
        var pauseButton = videos[playerId].videoWrapper.querySelector(
            selectors.pauseVideoBtn
        );
        var paused = pauseButton.classList.contains(classes.userPaused);
        if (paused) {
            pauseButton.classList.remove(classes.userPaused);
            customPlayVideo(playerId);
        } else {
            pauseButton.classList.add(classes.userPaused);
            pauseVideo(playerId);
        }
        pauseButton.setAttribute('aria-pressed', !paused);
    }

    function startVideoOnClick(playerId) {
        var video = videos[playerId];

        // add loading class to wrapper
        video.videoWrapper.classList.add(classes.loading);

        // Explicity set the video wrapper height (needed for height transition)
        video.videoWrapper.style.height = video.videoWrapper.offsetHeight + 'px';

        video.status = 'open';

        switch (video.type) {
            case 'image_with_play':
                privatePlayVideo(playerId, true);
                break;
            case 'background':
                unsetBackgroundVideo(playerId, video);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
        }

        toggleExpandVideo(playerId, true);

        // esc to close video player
        document.addEventListener('keydown', handleVideoPlayerKeydown);
    }

    var handleVideoPlayerKeydown = function (evt) {
        var playerId = document.activeElement.dataset.controls;
        if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
            return;
        }

        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
    };

    function sizeBackgroundVideos() {
        var backgroundVideos = document.querySelectorAll(
            '.' + classes.backgroundVideo
        );
        backgroundVideos.forEach(function (el) {
            sizeBackgroundVideo(el);
        });
    }

    function sizeBackgroundVideo(videoPlayer) {
        if (!youtubeLoaded) {
            return;
        }

        if (isMobile()) {
            videoPlayer.style.cssText = null;
        } else {
            var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
            var videoWidth = videoWrapper.clientWidth;
            var playerWidth = videoPlayer.clientWidth;
            var desktopHeight = videoWrapper.dataset.desktopHeight;

            // when screen aspect ratio differs from video, video must center and underlay one dimension
            if (videoWidth / videoOptions.ratio < desktopHeight) {
                playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
                var styles =
                    'width: ' +
                    playerWidth +
                    'px; height: ' +
                    desktopHeight +
                    'px; left: ' +
                    (videoWidth - playerWidth) / 2 +
                    'px; top: 0;';
                videoPlayer.style.cssText = styles;
            } else {
                // new video width < window width (gap to right)
                desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
                var styles2 =
                    'width: ' +
                    videoWidth +
                    'px; height: ' +
                    desktopHeight +
                    'px; top: ' +
                    (desktopHeight - desktopHeight) / 2 +
                    'px; left: 0;'; // player height is greater, offset top; reset left
                videoPlayer.style.cssText = styles2;
            }

            theme.Helpers.prepareTransition(videoPlayer);
            videoWrapper.classList.add(classes.loaded);
        }
    }

    function unsetBackgroundVideo(playerId) {
        // Switch the background video to a chrome-only player once played
        var player = document.getElementById(playerId);
        player.classList.remove(classes.backgroundVideo);
        player.classList.add(classes.videoWithImage);

        setTimeout(function () {
            document.getElementById(playerId).style.cssText = null;
        }, 600);

        videos[playerId].videoWrapper.classList.remove(
            classes.backgroundVideoWrapper
        );
        videos[playerId].videoWrapper.classList.add(classes.playing);

        videos[playerId].status = 'open';
    }

    function setBackgroundVideo(playerId) {
        var player = document.getElementById(playerId);
        player.classList.remove(classes.videoWithImage);
        player.classList.add(classes.backgroundVideo);

        videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);

        videos[playerId].status = 'background';
        sizeBackgroundVideo(player);
    }

    function isMobile() {
        return window.innerWidth < theme.breakpoints.medium;
    }

    var handleWindowResize = theme.Helpers.debounce(function () {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;
        sizeBackgroundVideos();

        if (isMobile()) {
            for (key in videos) {
                if (videos.hasOwnProperty(key)) {
                    if (videos[key].videoWrapper.classList.contains(classes.playing)) {
                        if (!fullscreen) {
                            pauseVideo(key);
                            setAsPaused(videos[key]);
                        }
                    }
                    videos[key].videoWrapper.style.height =
                        document.documentElement.clientWidth / videoOptions.ratio + 'px';
                }
            }
            setAutoplaySupport(false);
        } else {
            setAutoplaySupport(true);
            for (key in videos) {
                var videosWithImage = videos[key].videoWrapper.querySelectorAll(
                    '.' + classes.videoWithImage
                );
                if (videosWithImage.length) {
                    continue;
                }
                videoPlayers[key].playVideo();
                setAsPlaying(videos[key]);
            }
        }
    }, 200);

    var handleWindowScroll = theme.Helpers.debounce(function () {
        if (!youtubeLoaded) return;

        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var videoWrapper = videos[key].videoWrapper;
                var condition =
                    videoWrapper.getBoundingClientRect().top +
                    window.pageYOffset +
                    videoWrapper.offsetHeight * 0.75 <
                    window.pageYOffset ||
                    videoWrapper.getBoundingClientRect().top +
                    window.pageYOffset +
                    videoWrapper.offsetHeight * 0.25 >
                    window.pageYOffset + window.innerHeight;

                // Close the video if more than 75% of it is scrolled out of view
                if (videoWrapper.classList.contains(classes.playing)) {
                    if (!condition) return;
                    closeVideo(key);
                    toggleExpandVideo(key, false);
                }
            }
        }
    }, 50);

    function initEvents() {
        var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn);
        var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn);
        var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn);

        playVideoBtns.forEach(function (btn) {
            btn.addEventListener('click', function (evt) {
                var playerId = evt.currentTarget.dataset.controls;
                startVideoOnClick(playerId);
            });
        });

        closeVideoBtns.forEach(function (btn) {
            btn.addEventListener('click', function (evt) {
                var playerId = evt.currentTarget.dataset.controls;

                evt.currentTarget.blur();
                closeVideo(playerId);
                toggleExpandVideo(playerId, false);
            });
        });

        pauseVideoBtns.forEach(function (btn) {
            btn.addEventListener('click', function (evt) {
                var playerId = evt.currentTarget.dataset.controls;
                togglePause(playerId);
            });
        });

        // Listen to resize to keep a background-size:cover-like layout
        window.addEventListener('resize', handleWindowResize);

        window.addEventListener('scroll', handleWindowScroll);
    }

    function createPlayer(key) {
        var args = Object.assign(videoOptions, videos[key]);

        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
    }

    function removeEvents() {
        document.removeEventListener('keydown', handleVideoPlayerKeydown);
        window.removeEventListener('resize', handleWindowResize);
        window.removeEventListener('scroll', handleWindowScroll);
    }

    function setButtonLabels(videoWrapper, title) {
        var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
        var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
        var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
        var closeButtonText = closeButton.querySelector(selectors.fallbackText);

        var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
        var pauseButtonStopText = pauseButtonStop.querySelector(
            selectors.fallbackText
        );

        var pauseButtonResume = pauseButton.querySelector(
            selectors.pauseVideoResume
        );
        var pauseButtonResumeText = pauseButtonResume.querySelector(
            selectors.fallbackText
        );

        // Insert the video title retrieved from YouTube into the instructional text
        // for each button
        playButtons.forEach(function (playButton) {
            var playButtonText = playButton.querySelector(selectors.fallbackText);

            playButtonText.textContent = playButtonText.textContent.replace(
                '[video_title]',
                title
            );
        });
        closeButtonText.textContent = closeButtonText.textContent.replace(
            '[video_title]',
            title
        );
        pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace(
            '[video_title]',
            title
        );
        pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace(
            '[video_title]',
            title
        );
    }

    return {
        init: init,
        editorLoadVideo: editorLoadVideo,
        loadVideos: loadVideos,
        playVideo: customPlayVideo,
        pauseVideo: pauseVideo,
        removeEvents: removeEvents
    };
})();

theme.ProductVideo = (function () {
    var videos = {};

    var hosts = {
        html5: 'html5',
        youtube: 'youtube'
    };

    var selectors = {
        productMediaWrapper: '[data-product-single-media-wrapper]'
    };

    var attributes = {
        enableVideoLooping: 'enable-video-looping',
        videoId: 'video-id'
    };

    function init(videoContainer, sectionId) {
        if (!videoContainer) {
            return;
        }

        var videoElement = videoContainer.querySelector('iframe, video');

        if (!videoElement) {
            return;
        }

        var mediaId = videoContainer.getAttribute('data-media-id');

        videos[mediaId] = {
            mediaId: mediaId,
            sectionId: sectionId,
            host: hostFromVideoElement(videoElement),
            container: videoContainer,
            element: videoElement,
            ready: function () {
                createPlayer(this);
            }
        };

        var video = videos[mediaId];

        switch (video.host) {
            case hosts.html5:
                window.Shopify.loadFeatures([
                    {
                        name: 'video-ui',
                        version: '1.0',
                        onLoad: setupPlyrVideos
                    }
                ]);
                theme.LibraryLoader.load('plyrShopifyStyles');
                break;
            case hosts.youtube:
                theme.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
                break;
        }
    }

    function setupPlyrVideos(errors) {
        if (errors) {
            fallbackToNativeVideo();
            return;
        }

        loadVideos(hosts.html5);
    }

    function setupYouTubeVideos() {
        if (!window.YT.Player) return;

        loadVideos(hosts.youtube);
    }

    function createPlayer(video) {
        if (video.player) {
            return;
        }

        var productMediaWrapper = video.container.closest(
            selectors.productMediaWrapper
        );

        var enableLooping = productMediaWrapper.getAttribute(
            'data-' + attributes.enableVideoLooping
        );

        switch (video.host) {
            case hosts.html5:
                // eslint-disable-next-line no-undef
                video.player = new Shopify.Plyr(video.element, {
                    loop: { active: enableLooping }
                });
                break;
            case hosts.youtube:
                var videoId = productMediaWrapper.getAttribute(
                    'data-' + attributes.videoId
                );

                video.player = new YT.Player(video.element, {
                    videoId: videoId,
                    events: {
                        onStateChange: function (event) {
                            if (event.data === 0 && enableLooping) event.target.seekTo(0);
                        }
                    }
                });
                break;
        }

        var pauseVideo = function () {
            if (!video.player) return;

            if (video.host === hosts.html5) {
                video.player.pause();
            }

            if (video.host === hosts.youtube && video.player.pauseVideo) {
                video.player.pauseVideo();
            }
        };

        productMediaWrapper.addEventListener('mediaHidden', pauseVideo);
        productMediaWrapper.addEventListener('xrLaunch', pauseVideo);

        productMediaWrapper.addEventListener('mediaVisible', function () {
            if (theme.Helpers.isTouch()) return;
            if (!video.player) return;

            if (video.host === hosts.html5) {
                video.player.play();
            }

            if (video.host === hosts.youtube && video.player.playVideo) {
                video.player.playVideo();
            }
        });
    }

    function hostFromVideoElement(video) {
        if (video.tagName === 'VIDEO') {
            return hosts.html5;
        }

        if (video.tagName === 'IFRAME') {
            if (
                /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                    video.src
                )
            ) {
                return hosts.youtube;
            }
        }
        return null;
    }

    function loadVideos(host) {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                if (video.host === host) {
                    video.ready();
                }
            }
        }
    }

    function fallbackToNativeVideo() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];

                if (video.nativeVideo) continue;

                if (video.host === hosts.html5) {
                    video.element.setAttribute('controls', 'controls');
                    video.nativeVideo = true;
                }
            }
        }
    }

    function removeSectionVideos(sectionId) {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];

                if (video.sectionId === sectionId) {
                    if (video.player) video.player.destroy();
                    delete videos[key];
                }
            }
        }
    }

    return {
        init: init,
        hosts: hosts,
        loadVideos: loadVideos,
        removeSectionVideos: removeSectionVideos
    };
})();

theme.ProductModel = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
        mediaGroup: '[data-product-single-media-group]',
        xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
        modelJsonSections[sectionId] = {
            loaded: false
        };

        modelViewerContainers.forEach(function (modelViewerContainer, index) {
            var mediaId = modelViewerContainer.getAttribute('data-media-id');
            var modelViewerElement = modelViewerContainer.querySelector(
                'model-viewer'
            );
            var modelId = modelViewerElement.getAttribute('data-model-id');

            if (index === 0) {
                var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
                var xrButton = mediaGroup.querySelector(selectors.xrButton);
                xrButtons[sectionId] = {
                    element: xrButton,
                    defaultId: modelId
                };
            }

            models[mediaId] = {
                modelId: modelId,
                sectionId: sectionId,
                container: modelViewerContainer,
                element: modelViewerElement
            };
        });

        window.Shopify.loadFeatures([
            {
                name: 'shopify-xr',
                version: '1.0',
                onLoad: setupShopifyXr
            },
            {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: setupModelViewerUi
            }
        ]);
        theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
        if (errors) return;

        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', function () {
                setupShopifyXr();
            });
            return;
        }

        for (var sectionId in modelJsonSections) {
            if (modelJsonSections.hasOwnProperty(sectionId)) {
                var modelSection = modelJsonSections[sectionId];

                if (modelSection.loaded) continue;
                var modelJson = document.querySelector('#ModelJson-' + sectionId);

                window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
                modelSection.loaded = true;
            }
        }
        window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
        if (errors) return;

        for (var key in models) {
            if (models.hasOwnProperty(key)) {
                var model = models[key];
                if (!model.modelViewerUi) {
                    model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
                }
                setupModelViewerListeners(model);
            }
        }
    }

    function setupModelViewerListeners(model) {
        var xrButton = xrButtons[model.sectionId];

        model.container.addEventListener('mediaVisible', function () {
            xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
            if (theme.Helpers.isTouch()) return;
            model.modelViewerUi.play();
        });

        model.container.addEventListener('mediaHidden', function () {
            xrButton.element.setAttribute(
                'data-shopify-model3d-id',
                xrButton.defaultId
            );
            model.modelViewerUi.pause();
        });

        model.container.addEventListener('xrLaunch', function () {
            model.modelViewerUi.pause();
        });
    }

    function removeSectionModels(sectionId) {
        for (var key in models) {
            if (models.hasOwnProperty(key)) {
                var model = models[key];
                if (model.sectionId === sectionId) {
                    models[key].modelViewerUi.destroy();
                    delete models[key];
                }
            }
        }
        delete modelJsonSections[sectionId];
    }

    return {
        init: init,
        removeSectionModels: removeSectionModels
    };
})();

window.theme = window.theme || {};

theme.FormStatus = (function () {
    var selectors = {
        statusMessage: '[data-form-status]'
    };

    function init() {
        var statusMessages = document.querySelectorAll(selectors.statusMessage);

        statusMessages.forEach(function (statusMessage) {
            statusMessage.setAttribute('tabindex', -1);
            statusMessage.focus();

            statusMessage.addEventListener(
                'blur',
                function (evt) {
                    evt.target.removeAttribute('tabindex');
                },
                { once: true }
            );
        });
    }

    return {
        init: init
    };
})();

theme.Hero = (function () {
    var classes = {
        indexSectionFlush: 'index-section--flush'
    };

    var selectors = {
        heroFixedWidthContent: '.hero-fixed-width__content',
        heroFixedWidthImage: '.hero-fixed-width__image'
    };

    function hero(el, sectionId) {
        var hero = document.querySelector(el);
        var layout = hero.getAttribute('data-layout');
        var parentSection = document.querySelector('#shopify-section-' + sectionId);
        var heroContent = parentSection.querySelector(
            selectors.heroFixedWidthContent
        );
        var heroImage = parentSection.querySelector(selectors.heroFixedWidthImage);

        if (layout !== 'fixed_width') {
            return;
        }

        parentSection.classList.remove(classes.indexSectionFlush);
        heroFixedHeight();

        window.addEventListener('resize', function () {
            theme.Helpers.debounce(function () {
                heroFixedHeight();
            }, 50);
        });

        function heroFixedHeight() {
            var contentHeight;
            var imageHeight;

            if (heroContent) {
                contentHeight = heroContent.offsetHeight + 50;
            }

            if (heroImage) {
                imageHeight = heroImage.offsetHeight;
            }

            if (contentHeight > imageHeight) {
                heroImage.style.minHeight = contentHeight + 'px';
            }
        }
    }

    return hero;
})();

// prettier-ignore
window.theme = window.theme || {};

theme.SearchResultsTemplate = (function () {
    function renderResults(products, isLoading, searchQuery) {
        return [
            '<div class="predictive-search">',
            renderHeader(products, isLoading),
            renderProducts(products, searchQuery),
            '</div>'
        ].join('');
    }

    function renderHeader(products, isLoading) {
        if (products.length === 0) {
            return '';
        }

        return [
            '<div class="predictive-search-title">',
            '<h3 id="predictive-search" class="predictive-search-title__content">' +
            theme.strings.products +
            '</h3>',
            '<span class="predictive-search-title__loading-spinner">' +
            (isLoading
                ? '<span class= "icon-predictive-search-spinner" ></span >'
                : '') +
            '</span>',
            '</div>'
        ].join('');
    }

    function loadingState() {
        return [
            '<div class="predictive-search">',
            '<div class="predictive-search-loading">',
            '<span class="visually-hidden">' + theme.strings.loading + '</span>',
            '<span class="predictive-search-loading__icon">',
            '<span class="icon-predictive-search-spinner"></span>',
            '</span>',
            '</div>',
            '</div>'
        ].join('');
    }

    function renderViewAll(searchQuery) {
        return [
            '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
            theme.strings.searchFor +
            '<span class="predictive-search-view-all__query"> &ldquo;' +
            _htmlEscape(searchQuery) +
            '&rdquo;</span>',
            '</button>'
        ].join('');
    }

    function renderProducts(products, searchQuery) {
        var resultsCount = products.length;

        return [
            '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
            products
                .map(function (product, index) {
                    return renderProduct(normalizeProduct(product), index, resultsCount);
                })
                .join(''),
            '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
            renderViewAll(searchQuery) +
            '</li>',
            '</ul>'
        ].join('');
    }

    function renderProduct(product, index, resultsCount) {
        return [
            '<li id="search-result-' +
            index +
            '" class="predictive-search-item" role="option" data-search-result>',
            '<a class="predictive-search-item__link" href="' +
            product.url +
            '" tabindex="-1">',
            '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
            renderProductImage(product),
            '</div>',
            '<div class="predictive-search__column predictive-search__column--content ' +
            (getDetailsCount() ? '' : 'predictive-search__column--center') +
            '">',
            '<span class="predictive-search-item__title">',
            '<span class="predictive-search-item__title-text">' +
            product.title +
            '</span>',
            '</span>' + (getDetailsCount() ? renderProductDetails(product) : ''),
            '<span class="visually-hidden">, </span>',
            '<span class="visually-hidden">' +
            getNumberOfResultsString(index + 1, resultsCount) +
            '</span>',
            '</div>',
            '</a>',
            '</li>'
        ].join('');
    }

    function renderProductImage(product) {
        if (product.image === null) {
            return '';
        }

        return (
            '<img class="predictive-search-item__image lazyload" src="' +
            product.image.url +
            '" data-src="' +
            product.image.url +
            '" data-image alt="' +
            product.image.alt +
            '" />'
        );
    }

    function renderProductDetails(product) {
        return [
            '<dl class="predictive-search-item__details price' +
            (product.isOnSale ? ' price--on-sale' : '') +
            (!product.available ? ' price--sold-out' : '') +
            (!product.isPriceVaries && product.isCompareVaries
                ? ' price--compare-price-hidden'
                : '') +
            '">',
            '<div class="predictive-search-item__detail">',
            renderVendor(product),
            '</div>',
            '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
            renderProductPrice(product),
            '</div>',
            '</dl>'
        ].join('');
    }
    function renderProductPrice(product) {
        if (!theme.settings.predictiveSearchShowPrice) {
            return '';
        }

        var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

        var priceMarkup =
            '<div class="price__regular">' + renderPrice(product) + '</div>';

        var salePriceMarkup =
            '<div class="price__sale">' + renderSalePrice(product) + '</div>';

        return (
            accessibilityAnnounceComma +
            '<div class="price__pricing-group">' +
            (product.isOnSale ? salePriceMarkup : priceMarkup) +
            '</div>'
        );
    }

    function renderSalePrice(product) {
        return [
            '<dt>',
            '<span class="visually-hidden">' + theme.strings.salePrice + '</span>',
            '</dt>',
            '<dd>',
            '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
            (product.isPriceVaries
                ? theme.strings.fromLowestPrice.replace('[price]', product.price)
                : product.price) +
            '</span>',
            '</dd>',
            '<div class="price__compare">' + renderCompareAtPrice(product) + '</div>'
        ].join('');
    }

    function renderCompareAtPrice(product) {
        return [
            '<dt>',
            '<span class="visually-hidden">' +
            theme.strings.regularPrice +
            '</span> ',
            '</dt>',
            '<dd>',
            '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
            product.compareAtPrice +
            '</span>',
            '</dd>'
        ].join('');
    }

    function renderPrice(product) {
        return [
            '<dt>',
            '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>',
            '</dt>',
            '<dd>',
            '<span class="predictive-search-item__price">' +
            (product.isPriceVaries
                ? theme.strings.fromLowestPrice.replace('[price]', product.price)
                : product.price) +
            '</span>',
            '</dd>'
        ].join('');
    }

    function renderVendor(product) {
        if (!theme.settings.predictiveSearchShowVendor || product.vendor === '') {
            return '';
        }

        return [
            '<dt>',
            '<span class="visually-hidden">' + theme.strings.vendor + '</span>',
            '</dt>',
            '<dd class="predictive-search-item__vendor">' + product.vendor + '</dd>'
        ].join('');
    }

    function normalizeProduct(product) {
        var productOrVariant =
            product.variants.length > 0 ? product.variants[0] : product;

        return {
            url: productOrVariant.url,
            image: getProductImage(product),
            title: product.title,
            vendor: product.vendor || '',
            price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
            compareAtPrice: theme.Currency.formatMoney(
                product.compare_at_price_min,
                theme.moneyFormat
            ),
            available: product.available,
            isOnSale: isOnSale(product),
            isPriceVaries: isPriceVaries(product),
            isCompareVaries: isCompareVaries(product)
        };
    }

    function getProductImage(product) {
        var image;
        var featuredImage;

        if (product.variants.length > 0 && product.variants[0].image !== null) {
            featuredImage = product.variants[0].featured_image;
        } else if (product.image) {
            featuredImage = product.featured_image;
        } else {
            image = null;
        }

        if (image !== null) {
            image = {
                url: theme.Images.getSizedImageUrl(featuredImage.url, '100x'),
                alt: featuredImage.alt
            };
        }

        return image;
    }

    function isOnSale(product) {
        return (
            product.compare_at_price_min !== null &&
            parseInt(product.compare_at_price_min, 10) >
            parseInt(product.price_min, 10)
        );
    }

    function isPriceVaries(product) {
        return product.price_max !== product.price_min;
    }

    function isCompareVaries(product) {
        return product.compare_at_price_max !== product.compare_at_price_min;
    }

    // Returns the number of optional product details to be shown,
    // values of the detailsList need to be boolean.
    function getDetailsCount() {
        var detailsList = [
            theme.settings.predictiveSearchShowPrice,
            theme.settings.predictiveSearchShowVendor
        ];

        var detailsCount = detailsList.reduce(function (acc, detail) {
            return acc + (detail ? 1 : 0);
        }, 0);

        return detailsCount;
    }

    function getNumberOfResultsString(resultNumber, resultsCount) {
        return theme.strings.number_of_results
            .replace('[result_number]', resultNumber)
            .replace('[results_count]', resultsCount);
    }

    function _htmlEscape(input) {
        return input
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    return function (data) {
        var products = data.products || [];
        var isLoading = data.isLoading;
        var searchQuery = data.searchQuery || '';

        if (isLoading && products.length === 0) {
            return loadingState();
        }

        return renderResults(products, isLoading, searchQuery);
    };
})();

window.theme = window.theme || {};

(function () {
    // (a11y) This function will be used by the Predictive Search Component
    // to announce the number of search results
    function numberOfResultsTemplateFct(data) {
        if (data.products.length === 1) {
            return theme.strings.one_result_found;
        } else {
            return theme.strings.number_of_results_found.replace(
                '[results_count]',
                data.products.length
            );
        }
    }

    // (a11y) This function will be used by the Predictive Search Component
    // to announce that it's loading results
    function loadingResultsMessageTemplateFct() {
        return theme.strings.loading;
    }

    function isPredictiveSearchSupported() {
        var shopifyFeatures = JSON.parse(
            document.getElementById('shopify-features').textContent
        );

        return shopifyFeatures.predictiveSearch;
    }

    function isPredictiveSearchEnabled() {
        return window.theme.settings.predictiveSearchEnabled;
    }

    function canInitializePredictiveSearch() {
        return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
    }

    // listen for search submits and validate query
    function validateSearchHandler(searchEl, submitEl) {
        submitEl.addEventListener(
            'click',
            validateSearchInput.bind(this, searchEl)
        );
    }

    // if there is nothing in the search field, prevent submit
    function validateSearchInput(searchEl, evt) {
        var isInputValueEmpty = searchEl.value.trim().length === 0;
        if (!isInputValueEmpty) {
            return;
        }

        if (typeof evt !== 'undefined') {
            evt.preventDefault();
        }

        searchEl.focus();
    }

    window.theme.SearchPage = (function () {
        var selectors = {
            searchReset: '[data-search-page-predictive-search-clear]',
            searchInput: '[data-search-page-predictive-search-input]',
            searchSubmit: '[data-search-page-predictive-search-submit]',
            searchResults: '[data-predictive-search-mount="default"]'
        };

        var componentInstance;
        var searchInput = document.querySelector(selectors.searchInput);
        var searchSubmit = document.querySelector(selectors.searchSubmit);

        function init(config) {
            componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
                selectors: {
                    input: selectors.searchInput,
                    reset: selectors.searchReset,
                    result: selectors.searchResults
                },
                resultTemplateFct: window.theme.SearchResultsTemplate,
                numberOfResultsTemplateFct: numberOfResultsTemplateFct,
                loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
                onOpen: function (nodes) {
                    if (config.isTabletAndUp) {
                        return;
                    }

                    var searchInputBoundingRect = searchInput.getBoundingClientRect();
                    var bodyHeight = document.body.offsetHeight;
                    var offset = 50;
                    var resultsMaxHeight =
                        bodyHeight - searchInputBoundingRect.bottom - offset;

                    nodes.result.style.maxHeight = resultsMaxHeight + 'px';
                },
                onBeforeDestroy: function (nodes) {
                    // If the viewport width changes from mobile to tablet
                    // reset the top position of the results
                    nodes.result.style.maxHeight = '';
                }
            });

            validateSearchHandler(searchInput, searchSubmit);
        }

        function unload() {
            if (!componentInstance) {
                return;
            }
            componentInstance.destroy();
            componentInstance = null;
        }

        return {
            init: init,
            unload: unload
        };
    })();

    window.theme.SearchHeader = (function () {
        var selectors = {
            searchInput: '[data-predictive-search-drawer-input]',
            searchResults: '[data-predictive-search-mount="drawer"]',
            searchFormContainer: '[data-search-form-container]',
            searchSubmit: '[data-search-form-submit]'
        };

        var componentInstance;
        var searchInput = document.querySelector(selectors.searchInput);
        var searchSubmit = document.querySelector(selectors.searchSubmit);

        function init(config) {
            componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
                selectors: {
                    input: selectors.searchInput,
                    result: selectors.searchResults
                },
                resultTemplateFct: window.theme.SearchResultsTemplate,
                numberOfResultsTemplateFct: numberOfResultsTemplateFct,
                numberOfResults: config.numberOfResults,
                loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
                onInputBlur: function () {
                    return false;
                },
                onOpen: function (nodes) {
                    var searchInputBoundingRect = searchInput.getBoundingClientRect();

                    // For tablet screens and up, stop the scroll area from extending past
                    // the bottom of the screen because we're locking the body scroll
                    var maxHeight =
                        window.innerHeight -
                        searchInputBoundingRect.bottom -
                        (config.isTabletAndUp ? 20 : 0);

                    nodes.result.style.top = config.isTabletAndUp
                        ? ''
                        : searchInputBoundingRect.bottom + 'px';
                    nodes.result.style.maxHeight = maxHeight + 'px';
                },
                onClose: function (nodes) {
                    nodes.result.style.maxHeight = '';
                },
                onBeforeDestroy: function (nodes) {
                    // If the viewport width changes from mobile to tablet
                    // reset the top position of the results
                    nodes.result.style.top = '';
                }
            });

            validateSearchHandler(searchInput, searchSubmit);
        }

        function unload() {
            if (!componentInstance) {
                return;
            }

            componentInstance.destroy();
            componentInstance = null;
        }

        function clearAndClose() {
            if (!componentInstance) {
                return;
            }

            componentInstance.clearAndClose();
        }

        return {
            init: init,
            unload: unload,
            clearAndClose: clearAndClose
        };
    })();

    window.theme.Search = (function () {
        var classes = {
            searchTemplate: 'template-search'
        };
        var selectors = {
            siteHeader: '.site-header'
        };
        var mediaQueryList = {
            mobile: window.matchMedia('(max-width: 749px)'),
            tabletAndUp: window.matchMedia('(min-width: 750px)')
        };

        function init() {
            if (!document.querySelector(selectors.siteHeader)) {
                return;
            }

            if (!canInitializePredictiveSearch()) {
                return;
            }

            Object.keys(mediaQueryList).forEach(function (device) {
                mediaQueryList[device].addListener(initSearchAccordingToViewport);
            });

            initSearchAccordingToViewport();
        }

        function initSearchAccordingToViewport() {
            theme.SearchDrawer.close();
            theme.SearchHeader.unload();
            theme.SearchPage.unload();

            if (mediaQueryList.mobile.matches) {
                theme.SearchHeader.init({
                    numberOfResults: 4,
                    isTabletAndUp: false
                });

                if (isSearchPage()) {
                    theme.SearchPage.init({ isTabletAndUp: false });
                }
            } else {
                // Tablet and up
                theme.SearchHeader.init({
                    numberOfResults: 4,
                    isTabletAndUp: true
                });

                if (isSearchPage()) {
                    theme.SearchPage.init({ isTabletAndUp: true });
                }
            }
        }

        function isSearchPage() {
            return document.body.classList.contains(classes.searchTemplate);
        }

        function unload() {
            theme.SearchHeader.unload();
            theme.SearchPage.unload();
        }

        return {
            init: init,
            unload: unload
        };
    })();
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function () {
    var selectors = {
        headerSection: '[data-header-section]',
        drawer: '[data-predictive-search-drawer]',
        drawerOpenButton: '[data-predictive-search-open-drawer]',
        headerSearchInput: '[data-predictive-search-drawer-input]',
        predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
    };

    var drawerInstance;

    function init() {
        setAccessibilityProps();

        drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
            onDrawerOpen: function () {
                setHeight();
                theme.MobileNav.closeMobileNav();
                lockBodyScroll();
            },
            onDrawerClose: function () {
                theme.SearchHeader.clearAndClose();
                var drawerOpenButton = document.querySelector(
                    selectors.drawerOpenButton
                );

                if (drawerOpenButton) drawerOpenButton.focus();

                unlockBodyScroll();
            },
            withPredictiveSearch: true,
            elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput)
        });
    }

    function setAccessibilityProps() {
        var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

        if (drawerOpenButton) {
            drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
            drawerOpenButton.setAttribute('aria-expanded', 'false');
            drawerOpenButton.setAttribute('aria-controls', 'dialog');
        }
    }

    function setHeight() {
        var searchDrawer = document.querySelector(selectors.drawer);
        var headerHeight = document.querySelector(selectors.headerSection)
            .offsetHeight;

        searchDrawer.style.height = headerHeight + 'px';
    }

    function close() {
        drawerInstance.close();
    }

    function lockBodyScroll() {
        theme.Helpers.enableScrollLock();
    }

    function unlockBodyScroll() {
        theme.Helpers.disableScrollLock();
    }

    return {
        init: init,
        close: close
    };
})();

theme.Disclosure = (function () {
    var selectors = {
        disclosureForm: '[data-disclosure-form]',
        disclosureList: '[data-disclosure-list]',
        disclosureToggle: '[data-disclosure-toggle]',
        disclosureInput: '[data-disclosure-input]',
        disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
        listVisible: 'disclosure-list--visible'
    };

    function Disclosure(disclosure) {
        this.container = disclosure;
        this._cacheSelectors();
        this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
        _cacheSelectors: function () {
            this.cache = {
                disclosureForm: this.container.closest(selectors.disclosureForm),
                disclosureList: this.container.querySelector(selectors.disclosureList),
                disclosureToggle: this.container.querySelector(
                    selectors.disclosureToggle
                ),
                disclosureInput: this.container.querySelector(
                    selectors.disclosureInput
                ),
                disclosureOptions: this.container.querySelectorAll(
                    selectors.disclosureOptions
                )
            };
        },

        _setupListeners: function () {
            this.eventHandlers = this._setupEventHandlers();

            this.cache.disclosureToggle.addEventListener(
                'click',
                this.eventHandlers.toggleList
            );

            this.cache.disclosureOptions.forEach(function (disclosureOption) {
                disclosureOption.addEventListener(
                    'click',
                    this.eventHandlers.connectOptions
                );
            }, this);

            this.container.addEventListener(
                'keyup',
                this.eventHandlers.onDisclosureKeyUp
            );

            this.cache.disclosureList.addEventListener(
                'focusout',
                this.eventHandlers.onDisclosureListFocusOut
            );

            this.cache.disclosureToggle.addEventListener(
                'focusout',
                this.eventHandlers.onDisclosureToggleFocusOut
            );

            document.body.addEventListener('click', this.eventHandlers.onBodyClick);
        },

        _setupEventHandlers: function () {
            return {
                connectOptions: this._connectOptions.bind(this),
                toggleList: this._toggleList.bind(this),
                onBodyClick: this._onBodyClick.bind(this),
                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
            };
        },

        _connectOptions: function (event) {
            event.preventDefault();

            this._submitForm(event.currentTarget.dataset.value);
        },

        _onDisclosureToggleFocusOut: function (event) {
            var disclosureLostFocus =
                this.container.contains(event.relatedTarget) === false;

            if (disclosureLostFocus) {
                this._hideList();
            }
        },

        _onDisclosureListFocusOut: function (event) {
            var childInFocus = event.currentTarget.contains(event.relatedTarget);

            var isVisible = this.cache.disclosureList.classList.contains(
                classes.listVisible
            );

            if (isVisible && !childInFocus) {
                this._hideList();
            }
        },

        _onDisclosureKeyUp: function (event) {
            if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
            this._hideList();
            this.cache.disclosureToggle.focus();
        },

        _onBodyClick: function (event) {
            var isOption = this.container.contains(event.target);
            var isVisible = this.cache.disclosureList.classList.contains(
                classes.listVisible
            );

            if (isVisible && !isOption) {
                this._hideList();
            }
        },

        _submitForm: function (value) {
            this.cache.disclosureInput.value = value;
            this.cache.disclosureForm.submit();
        },

        _hideList: function () {
            this.cache.disclosureList.classList.remove(classes.listVisible);
            this.cache.disclosureToggle.setAttribute('aria-expanded', false);
        },

        _toggleList: function () {
            var ariaExpanded =
                this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
            this.cache.disclosureList.classList.toggle(classes.listVisible);
            this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
        },

        destroy: function () {
            this.cache.disclosureToggle.removeEventListener(
                'click',
                this.eventHandlers.toggleList
            );

            this.cache.disclosureOptions.forEach(function (disclosureOption) {
                disclosureOption.removeEventListener(
                    'click',
                    this.eventHandlers.connectOptions
                );
            }, this);

            this.container.removeEventListener(
                'keyup',
                this.eventHandlers.onDisclosureKeyUp
            );

            this.cache.disclosureList.removeEventListener(
                'focusout',
                this.eventHandlers.onDisclosureListFocusOut
            );

            this.cache.disclosureToggle.removeEventListener(
                'focusout',
                this.eventHandlers.onDisclosureToggleFocusOut
            );

            document.body.removeEventListener(
                'click',
                this.eventHandlers.onBodyClick
            );
        }
    });

    return Disclosure;
})();

theme.Zoom = (function () {
    var selectors = {
        imageZoom: '[data-image-zoom]'
    };

    var classes = {
        zoomImg: 'zoomImg'
    };

    var attributes = {
        imageZoomTarget: 'data-image-zoom-target'
    };

    function Zoom(container) {
        this.container = container;
        this.cache = {};
        this.url = container.dataset.zoom;

        this._cacheSelectors();

        if (!this.cache.sourceImage) return;

        this._duplicateImage();
    }

    Zoom.prototype = Object.assign({}, Zoom.prototype, {
        _cacheSelectors: function () {
            this.cache = {
                sourceImage: this.container.querySelector(selectors.imageZoom)
            };
        },

        _init: function () {
            var targetWidth = this.cache.targetImage.width;
            var targetHeight = this.cache.targetImage.height;

            if (this.cache.sourceImage === this.cache.targetImage) {
                this.sourceWidth = targetWidth;
                this.sourceHeight = targetHeight;
            } else {
                this.sourceWidth = this.cache.sourceImage.width;
                this.sourceHeight = this.cache.sourceImage.height;
            }

            this.xRatio =
                (this.cache.sourceImage.width - targetWidth) / this.sourceWidth;
            this.yRatio =
                (this.cache.sourceImage.height - targetHeight) / this.sourceHeight;
        },

        _start: function (e) {
            this._init();
            this._move(e);
        },

        _stop: function () {
            this.cache.targetImage.style.opacity = 0;
        },

        /**
         * Sets the correct coordinates top and left position in px
         * It sets a limit within between 0 and the max height of the image
         * So when the mouse leaves the target image, it could
         * never go above or beyond the target image zone
         */
        _setTopLeftMaxValues: function (top, left) {
            return {
                left: Math.max(Math.min(left, this.sourceWidth), 0),
                top: Math.max(Math.min(top, this.sourceHeight), 0)
            };
        },

        _move: function (e) {
            // get left and top position within the "source image" zone
            var left =
                e.pageX -
                (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX);
            var top =
                e.pageY -
                (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY);
            // make sure the left and top position don't go
            // above or beyond the target image zone
            var position = this._setTopLeftMaxValues(top, left);

            top = position.top;
            left = position.left;

            this.cache.targetImage.style.left = -(left * -this.xRatio) + 'px';
            this.cache.targetImage.style.top = -(top * -this.yRatio) + 'px';
            this.cache.targetImage.style.opacity = 1;
        },

        /**
         * This loads a high resolution image
         * via the data attributes url
         * It adds all necessary CSS styles and adds to the container
         */
        _duplicateImage: function () {
            this._loadImage()
                .then(
                    function (image) {
                        this.cache.targetImage = image;
                        image.style.width = image.width + 'px';
                        image.style.height = image.height + 'px';
                        image.style.position = 'absolute';
                        image.style.maxWidth = 'none';
                        image.style.maxHeight = 'none';
                        image.style.opacity = 0;
                        image.style.border = 'none';
                        image.style.left = 0;
                        image.style.top = 0;

                        this.container.appendChild(image);

                        this._init();

                        this._start = this._start.bind(this);
                        this._stop = this._stop.bind(this);
                        this._move = this._move.bind(this);

                        this.container.addEventListener('mouseenter', this._start);
                        this.container.addEventListener('mouseleave', this._stop);
                        this.container.addEventListener('mousemove', this._move);

                        this.container.style.position = 'relative';
                        this.container.style.overflow = 'hidden';
                    }.bind(this)
                )
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error fetching image', error);
                });
        },

        _loadImage: function () {
            // eslint-disable-next-line
            return new Promise(function (resolve, reject) {
                var image = new Image();
                image.setAttribute('role', 'presentation');
                image.setAttribute(attributes.imageZoomTarget, true);
                image.classList.add(classes.zoomImg);
                image.src = this.url;

                image.addEventListener('load', function () {
                    resolve(image);
                });

                image.addEventListener('error', function (error) {
                    reject(error);
                });
            }.bind(this)
            );
        },

        unload: function () {
            var targetImage = this.container.querySelector(
                '[' + attributes.imageZoomTarget + ']'
            );
            if (targetImage) {
                targetImage.remove();
            }

            this.container.removeEventListener('mouseenter', this._start);
            this.container.removeEventListener('mouseleave', this._stop);
            this.container.removeEventListener('mousemove', this._move);
        }
    });

    return Zoom;
})();


/* ================ TEMPLATES ================ */
(function () {
    var filterBys = document.querySelectorAll('[data-blog-tag-filter]');

    if (!filterBys.length) return;

    slate.utils.resizeSelects(filterBys);

    filterBys.forEach(function (filterBy) {
        filterBy.addEventListener('change', function (evt) {
            location.href = evt.target.value;
        });
    });
})();

window.theme = theme || {};

theme.customerTemplates = (function () {
    var selectors = {
        RecoverHeading: '#RecoverHeading',
        RecoverEmail: '#RecoverEmail',
        LoginHeading: '#LoginHeading'
    };

    function initEventListeners() {
        this.recoverHeading = document.querySelector(selectors.RecoverHeading);
        this.recoverEmail = document.querySelector(selectors.RecoverEmail);
        this.loginHeading = document.querySelector(selectors.LoginHeading);
        var recoverPassword = document.getElementById('RecoverPassword');
        var hideRecoverPasswordLink = document.getElementById(
            'HideRecoverPasswordLink'
        );

        // Show reset password form
        if (recoverPassword) {
            recoverPassword.addEventListener(
                'click',
                function (evt) {
                    evt.preventDefault();
                    showRecoverPasswordForm();
                    this.recoverHeading.setAttribute('tabindex', '-1');
                    this.recoverHeading.focus();
                }.bind(this)
            );
        }

        // Hide reset password form
        if (hideRecoverPasswordLink) {
            hideRecoverPasswordLink.addEventListener(
                'click',
                function (evt) {
                    evt.preventDefault();
                    hideRecoverPasswordForm();
                    this.loginHeading.setAttribute('tabindex', '-1');
                    this.loginHeading.focus();
                }.bind(this)
            );
        }

        if (this.recoverHeading) {
            this.recoverHeading.addEventListener('blur', function (evt) {
                evt.target.removeAttribute('tabindex');
            });
        }

        if (this.loginHeading) {
            this.loginHeading.addEventListener('blur', function (evt) {
                evt.target.removeAttribute('tabindex');
            });
        }
    }

    /**
     *
     *  Show/Hide recover password form
     *
     */

    function showRecoverPasswordForm() {
        document.getElementById('RecoverPasswordForm').classList.remove('hide');
        document.getElementById('CustomerLoginForm').classList.add('hide');

        if (this.recoverEmail.getAttribute('aria-invalid') === 'true') {
            this.recoverEmail.focus();
        }
    }

    function hideRecoverPasswordForm() {
        document.getElementById('RecoverPasswordForm').classList.add('hide');
        document.getElementById('CustomerLoginForm').classList.remove('hide');
    }

    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
        var formState = document.querySelector('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!formState) {
            return;
        }

        // show success message
        var resetSuccess = document.getElementById('ResetSuccess');
        resetSuccess.classList.remove('hide');
        resetSuccess.focus();
    }

    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
        var newAddressForm = document.getElementById('AddressNewForm');
        var newAddressFormButton = document.getElementById('AddressNewButton');

        if (!newAddressForm) {
            return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector(
                'AddressCountryNew',
                'AddressProvinceNew',
                {
                    hideElement: 'AddressProvinceContainerNew'
                }
            );
        }

        // Initialize each edit form's country/province selector
        document
            .querySelectorAll('.address-country-option')
            .forEach(function (option) {
                var formId = option.dataset.formId;
                var countrySelector = 'AddressCountry_' + formId;
                var provinceSelector = 'AddressProvince_' + formId;
                var containerSelector = 'AddressProvinceContainer_' + formId;

                // eslint-disable-next-line no-new
                new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                    hideElement: containerSelector
                });
            });

        // Toggle new/edit address forms
        document.querySelectorAll('.address-new-toggle').forEach(function (button) {
            button.addEventListener('click', function () {
                var isExpanded =
                    newAddressFormButton.getAttribute('aria-expanded') === 'true';

                newAddressForm.classList.toggle('hide');
                newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
                newAddressFormButton.focus();
            });
        });

        document.querySelectorAll('.address-edit-toggle').forEach(function (button) {
            button.addEventListener('click', function (evt) {
                var formId = evt.target.dataset.formId;
                var editButton = document.getElementById('EditFormButton_' + formId);
                var editAddress = document.getElementById('EditAddress_' + formId);
                var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

                editAddress.classList.toggle('hide');
                editButton.setAttribute('aria-expanded', !isExpanded);
                editButton.focus();
            });
        });

        document.querySelectorAll('.address-delete').forEach(function (button) {
            button.addEventListener('click', function (evt) {
                var target = evt.target.dataset.target;
                var confirmMessage = evt.target.dataset.confirmMessage;

                // eslint-disable-next-line no-alert
                if (
                    confirm(
                        confirmMessage || 'Are you sure you wish to delete this address?'
                    )
                ) {
                    Shopify.postLink(target, {
                        parameters: { _method: 'delete' }
                    });
                }
            });
        });
    }

    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            showRecoverPasswordForm.bind(this)();
        }
    }

    return {
        init: function () {
            initEventListeners();
            checkUrlHash();
            resetPasswordSuccess();
            customerAddressForm();
        }
    };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
    var selectors = {
        cartCount: '[data-cart-count]',
        cartCountBubble: '[data-cart-count-bubble]',
        cartDiscount: '[data-cart-discount]',
        cartDiscountTitle: '[data-cart-discount-title]',
        cartDiscountAmount: '[data-cart-discount-amount]',
        cartDiscountWrapper: '[data-cart-discount-wrapper]',
        cartErrorMessage: '[data-cart-error-message]',
        cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
        cartItem: '[data-cart-item]',
        cartItemDetails: '[data-cart-item-details]',
        cartItemDiscount: '[data-cart-item-discount]',
        cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
        cartItemDiscountTitle: '[data-cart-item-discount-title]',
        cartItemDiscountAmount: '[data-cart-item-discount-amount]',
        cartItemDiscountList: '[data-cart-item-discount-list]',
        cartItemFinalPrice: '[data-cart-item-final-price]',
        cartItemImage: '[data-cart-item-image]',
        cartItemLinePrice: '[data-cart-item-line-price]',
        cartItemOriginalPrice: '[data-cart-item-original-price]',
        cartItemPrice: '[data-cart-item-price]',
        cartItemPriceList: '[data-cart-item-price-list]',
        cartItemProperty: '[data-cart-item-property]',
        cartItemPropertyName: '[data-cart-item-property-name]',
        cartItemPropertyValue: '[data-cart-item-property-value]',
        cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
        cartItemRegularPrice: '[data-cart-item-regular-price]',
        cartItemTitle: '[data-cart-item-title]',
        cartItemOption: '[data-cart-item-option]',
        cartLineItems: '[data-cart-line-items]',
        cartNote: '[data-cart-notes]',
        cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
        cartQuantityErrorMessageWrapper:
            '[data-cart-quantity-error-message-wrapper]',
        cartRemove: '[data-cart-remove]',
        cartStatus: '[data-cart-status]',
        cartSubtotal: '[data-cart-subtotal]',
        cartTableCell: '[data-cart-table-cell]',
        cartWrapper: '[data-cart-wrapper]',
        emptyPageContent: '[data-empty-page-content]',
        quantityInput: '[data-quantity-input]',
        quantityInputMobile: '[data-quantity-input-mobile]',
        quantityInputDesktop: '[data-quantity-input-desktop]',
        quantityLabelMobile: '[data-quantity-label-mobile]',
        quantityLabelDesktop: '[data-quantity-label-desktop]',
        inputQty: '[data-quantity-input]',
        thumbnails: '.cart__image',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        unitPriceGroup: '[data-unit-price-group]'
    };

    var classes = {
        cartNoCookies: 'cart--no-cookies',
        cartRemovedProduct: 'cart__removed-product',
        thumbnails: 'cart__image',
        hide: 'hide',
        inputError: 'input--error'
    };

    var attributes = {
        cartItemIndex: 'data-cart-item-index',
        cartItemKey: 'data-cart-item-key',
        cartItemQuantity: 'data-cart-item-quantity',
        cartItemTitle: 'data-cart-item-title',
        cartItemUrl: 'data-cart-item-url',
        quantityItem: 'data-quantity-item'
    };

    var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

    function Cart(container) {
        this.container = container;
        this.thumbnails = this.container.querySelectorAll(selectors.thumbnails);
        this.quantityInputs = this.container.querySelectorAll(selectors.inputQty);

        this.ajaxEnabled = true;

        this._handleInputQty = theme.Helpers.debounce(
            this._handleInputQty.bind(this),
            500
        );
        this.setQuantityFormControllers = this.setQuantityFormControllers.bind(
            this
        );
        this._onNoteChange = this._onNoteChange.bind(this);
        this._onRemoveItem = this._onRemoveItem.bind(this);

        if (!theme.Helpers.cookiesEnabled()) {
            this.container.classList.add(classes.cartNoCookies);
        }

        this.thumbnails.forEach(function (element) {
            element.style.cursor = 'pointer';
        });

        this.container.addEventListener('click', this._handleThumbnailClick);
        this.container.addEventListener('change', this._handleInputQty);

        this.mql = window.matchMedia(mediumUpQuery);
        this.mql.addListener(this.setQuantityFormControllers);

        this.setQuantityFormControllers();

        /**
         * Because the entire cart is recreated when a cart item is updated,
         * we cannot cache the elements in the cart. Instead, we add the event
         * listeners on the cart's container to allow us to retain the event
         * listeners after rebuilding the cart when an item is updated.
         */
        this.container.addEventListener('click', this._onRemoveItem);
        this.container.addEventListener('change', this._onNoteChange);

        this._setupCartTemplates();

    }

    Cart.prototype = Object.assign({}, Cart.prototype, {
        _setupCartTemplates: function () {
            var cartItem = this.container.querySelector(selectors.cartItem);
            if (!cartItem) return;

            this.itemTemplate = this.container
                .querySelector(selectors.cartItem)
                .cloneNode(true);

            this.itemDiscountTemplate = this.itemTemplate
                .querySelector(selectors.cartItemDiscount)
                .cloneNode(true);

            this.cartDiscountTemplate = this.container
                .querySelector(selectors.cartDiscount)
                .cloneNode(true);

            this.itemPriceListTemplate = this.itemTemplate
                .querySelector(selectors.cartItemPriceList)
                .cloneNode(true);

            this.itemOptionTemplate = this.itemTemplate
                .querySelector(selectors.cartItemOption)
                .cloneNode(true);

            this.itemPropertyTemplate = this.itemTemplate
                .querySelector(selectors.cartItemProperty)
                .cloneNode(true);
        },

        _handleInputQty: function (evt) {
            if (!evt.target.hasAttribute('data-quantity-input')) return;

            var input = evt.target;
            var itemElement = input.closest(selectors.cartItem);

            var itemIndex = Number(input.getAttribute('data-quantity-item'));

            var itemQtyInputs = this.container.querySelectorAll(
                "[data-quantity-item='" + itemIndex + "']"
            );

            var value = parseInt(input.value);

            var isValidValue = !(value < 0 || isNaN(value));

            itemQtyInputs.forEach(function (element) {
                element.value = value;
            });

            this._hideCartError();
            this._hideQuantityErrorMessage();

            if (!isValidValue) {
                this._showQuantityErrorMessages(itemElement);
                return;
            }

            this._updateItemQuantity(itemIndex, itemElement, itemQtyInputs, value);

        },

        _updateItemQuantity: function (
            itemIndex,
            itemElement,
            itemQtyInputs,
            value
        ) {
            var key = itemElement.getAttribute(attributes.cartItemKey);
            var index = Number(itemElement.getAttribute(attributes.cartItemIndex));

            var request = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;'
                },
                body: JSON.stringify({
                    line: index,
                    quantity: value
                })
            };

            fetch('/cart/change.js', request)
                .then(function (response) {
                    return response.json();
                })
                .then(
                    function (state) {
                        this._setCartCountBubble(state.item_count);

                        if (!state.item_count) {
                            this._emptyCart();
                            return;
                        }

                        this._createCart(state);

                        //Extend - Dispatch refreshCart event
                        window.dispatchEvent(Extend.CustomEvent('refreshCart', { detail: { cart: state } }));
                        //Extend - End Extend Code

                        if (!value) {
                            this._showRemoveMessage(itemElement.cloneNode(true));
                            return;
                        }

                        var lineItem = document.querySelector(
                            "[data-cart-item-key='" + key + "']"
                        );

                        var item = this.getItem(key, state);

                        var inputSelector = this.mql.matches
                            ? selectors.quantityInputDesktop
                            : selectors.quantityInputMobile;

                        this._updateLiveRegion(item);

                        if (!lineItem) return;
                        lineItem.querySelector(inputSelector).focus();
                    }.bind(this)
                )
                .catch(
                    function () {
                        this._showCartError(null);
                    }.bind(this)
                );
        },

        getItem: function (key, state) {
            return state.items.find(function (item) {
                return item.key === key;
            });
        },

        _liveRegionText: function (item) {
            // Dummy content for live region
            var liveRegionText =
                theme.strings.update +
                ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

            // Update Quantity
            liveRegionText = liveRegionText
                .replace('[QuantityLabel]', theme.strings.quantity)
                .replace('[Quantity]', item.quantity);

            // Update pricing information
            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(
                item.original_line_price,
                theme.moneyFormat
            );
            var discountLabel = '';
            var discountPrice = '';
            var discountInformation = '';

            if (item.original_line_price > item.final_line_price) {
                regularLabel = theme.strings.regularTotal;

                discountLabel = theme.strings.discountedTotal;
                discountPrice = theme.Currency.formatMoney(
                    item.final_line_price,
                    theme.moneyFormat
                );

                discountInformation = theme.strings.priceColumn;
            }

            liveRegionText = liveRegionText
                .replace('[Regular]', regularLabel)
                .replace('[$$]', regularPrice)
                .replace('[DiscountedPrice]', discountLabel)
                .replace('[$]', discountPrice)
                .replace('[PriceInformation]', discountInformation)
                .trim();

            return liveRegionText;
        },

        _updateLiveRegion: function (item) {
            if (!item) return;

            var liveRegion = this.container.querySelector(selectors.cartStatus);

            liveRegion.textContent = this._liveRegionText(item);
            liveRegion.setAttribute('aria-hidden', false);

            setTimeout(function () {
                liveRegion.setAttribute('aria-hidden', true);
            }, 1000);
        },

        _createCart: function (state) {
            var cartDiscountList = this._createCartDiscountList(state);

            var cartTable = this.container.querySelector(selectors.cartLineItems);
            cartTable.innerHTML = '';

            this._createLineItemList(state).forEach(function (lineItem) {
                cartTable.appendChild(lineItem);
            });

            this.setQuantityFormControllers();

            this.cartNotes =
                this.cartNotes || this.container.querySelector(selectors.cartNote);

            if (this.cartNotes) {
                this.cartNotes.value = state.note;
            }

            var discountWrapper = this.container.querySelector(
                selectors.cartDiscountWrapper
            );

            if (cartDiscountList.length === 0) {
                discountWrapper.innerHTML = '';
                discountWrapper.classList.add(classes.hide);
            } else {
                discountWrapper.innerHTML = '';

                cartDiscountList.forEach(function (discountItem) {
                    discountWrapper.appendChild(discountItem);
                });

                discountWrapper.classList.remove(classes.hide);
            }

            this.container.querySelector(
                selectors.cartSubtotal
            ).textContent = theme.Currency.formatMoney(
                state.total_price,
                theme.moneyFormatWithCurrency
            );

        },

        _createCartDiscountList: function (cart) {
            return cart.cart_level_discount_applications.map(
                function (discount) {
                    var discountNode = this.cartDiscountTemplate.cloneNode(true);

                    discountNode.querySelector(selectors.cartDiscountTitle).textContent =
                        discount.title;

                    discountNode.querySelector(
                        selectors.cartDiscountAmount
                    ).textContent = theme.Currency.formatMoney(
                        discount.total_allocated_amount,
                        theme.moneyFormat
                    );

                    return discountNode;
                }.bind(this)
            );
        },

        _createLineItemList: function (state) {
            return state.items.map(
                function (item, index) {
                    var itemNode = this.itemTemplate.cloneNode(true);

                    var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

                    this._setLineItemAttributes(itemNode, item, index);
                    this._setLineItemImage(itemNode, item.featured_image);

                    var cartItemTitle = itemNode.querySelector(selectors.cartItemTitle);
                    cartItemTitle.textContent = item.product_title;
                    cartItemTitle.setAttribute('href', item.url);

                    var productDetailsList = this._createProductDetailsList(
                        item.product_has_only_default_variant,
                        item.options_with_values,
                        item.properties
                    );

                    this._setProductDetailsList(itemNode, productDetailsList);

                    this._setItemRemove(itemNode, item.title);

                    itemPriceList.innerHTML = this._createItemPrice(
                        item.original_price,
                        item.final_price
                    ).outerHTML;

                    if (item.unit_price_measurement) {
                        itemPriceList.appendChild(
                            this._createUnitPrice(
                                item.unit_price,
                                item.unit_price_measurement
                            )
                        );
                    }

                    this._setItemPrice(itemNode, itemPriceList);

                    var itemDiscountList = this._createItemDiscountList(item);
                    this._setItemDiscountList(itemNode, itemDiscountList);
                    this._setQuantityInputs(itemNode, item, index);

                    var itemLinePrice = this._createItemPrice(
                        item.original_line_price,
                        item.final_line_price
                    );

                    this._setItemLinePrice(itemNode, itemLinePrice);

                    return itemNode;
                }.bind(this)
            );
        },

        _setLineItemAttributes: function (itemNode, item, index) {
            itemNode.setAttribute(attributes.cartItemKey, item.key);
            itemNode.setAttribute(attributes.cartItemUrl, item.url);
            itemNode.setAttribute(attributes.cartItemTitle, item.title);
            itemNode.setAttribute(attributes.cartItemIndex, index + 1);
            itemNode.setAttribute(attributes.cartItemQuantity, item.quantity);
        },

        _setLineItemImage: function (itemNode, featuredImage) {
            var image = itemNode.querySelector(selectors.cartItemImage);

            var sizedImageUrl =
                featuredImage.url !== null
                    ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
                    : null;

            if (sizedImageUrl) {
                image.setAttribute('alt', featuredImage.alt);
                image.setAttribute('src', sizedImageUrl);
                image.classList.remove(classes.hide);
            } else {
                image.parentNode.removeChild(image);
            }
        },

        _setProductDetailsList: function (item, productDetailsList) {
            var itemDetails = item.querySelector(selectors.cartItemDetails);

            if (productDetailsList.length) {
                itemDetails.classList.remove(classes.hide);
                itemDetails.innerHTML = productDetailsList.reduce(function (
                    result,
                    element
                ) {
                    return result + element.outerHTML;
                },
                    '');

                return;
            }

            itemDetails.classList.add(classes.hide);
            itemDetails.textContent = '';
        },

        _setItemPrice: function (item, price) {
            item.querySelector(selectors.cartItemPrice).innerHTML = price.outerHTML;
        },

        _setItemDiscountList: function (item, discountList) {
            var itemDiscountList = item.querySelector(selectors.cartItemDiscountList);

            if (discountList.length === 0) {
                itemDiscountList.innerHTML = '';
                itemDiscountList.classList.add(classes.hide);
            } else {
                itemDiscountList.innerHTML = discountList.reduce(function (
                    result,
                    element
                ) {
                    return result + element.outerHTML;
                },
                    '');

                itemDiscountList.classList.remove(classes.hide);
            }
        },

        _setItemRemove: function (item, title) {
            item
                .querySelector(selectors.cartRemove)
                .setAttribute(
                    'aria-label',
                    theme.strings.removeLabel.replace('[product]', title)
                );
        },

        _setQuantityInputs: function (itemNode, item, index) {
            var mobileInput = itemNode.querySelector(selectors.quantityInputMobile);
            var desktopInput = itemNode.querySelector(selectors.quantityInputDesktop);

            mobileInput.setAttribute('id', 'updates_' + item.key);
            desktopInput.setAttribute('id', 'updates_large_' + item.key);

            [mobileInput, desktopInput].forEach(function (element) {
                element.setAttribute(attributes.quantityItem, index + 1);
                element.value = item.quantity;
            });

            itemNode
                .querySelector(selectors.quantityLabelMobile)
                .setAttribute('for', 'updates_' + item.key);

            itemNode
                .querySelector(selectors.quantityLabelDesktop)
                .setAttribute('for', 'updates_large_' + item.key);
        },

        setQuantityFormControllers: function () {
            var desktopQuantityInputs = document.querySelectorAll(
                selectors.quantityInputDesktop
            );

            var mobileQuantityInputs = document.querySelectorAll(
                selectors.quantityInputMobile
            );

            if (this.mql.matches) {
                addNameAttribute(desktopQuantityInputs);
                removeNameAttribute(mobileQuantityInputs);
            } else {
                addNameAttribute(mobileQuantityInputs);
                removeNameAttribute(desktopQuantityInputs);
            }

            function addNameAttribute(inputs) {
                inputs.forEach(function (element) {
                    element.setAttribute('name', 'updates[]');
                });
            }

            function removeNameAttribute(inputs) {
                inputs.forEach(function (element) {
                    element.removeAttribute('name');
                });
            }
        },

        _setItemLinePrice: function (item, price) {
            item.querySelector(selectors.cartItemLinePrice).innerHTML =
                price.outerHTML;
        },

        _createProductDetailsList: function (
            product_has_only_default_variant,
            options,
            properties
        ) {
            var optionsPropertiesHTML = [];

            if (!product_has_only_default_variant) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(
                    this._getOptionList(options)
                );
            }

            if (properties !== null && Object.keys(properties).length !== 0) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(
                    this._getPropertyList(properties)
                );
            }

            return optionsPropertiesHTML;
        },

        _getOptionList: function (options) {
            return options.map(
                function (option) {
                    var optionElement = this.itemOptionTemplate.cloneNode(true);

                    optionElement.textContent = option.name + ': ' + option.value;
                    optionElement.classList.remove(classes.hide);

                    return optionElement;
                }.bind(this)
            );
        },

        _getPropertyList: function (properties) {
            var propertiesArray =
                properties !== null ? Object.entries(properties) : [];

            return propertiesArray.map(
                function (property) {
                    var propertyElement = this.itemPropertyTemplate.cloneNode(true);

                    // Line item properties prefixed with an underscore are not to be displayed
                    if (property[0].charAt(0) === '_') return;

                    // if the property value has a length of 0 (empty), don't display it
                    if (property[1].length === 0) return;

                    propertyElement.querySelector(
                        selectors.cartItemPropertyName
                    ).textContent = property[0];

                    if (property[0].indexOf('/uploads/') === -1) {
                        propertyElement.querySelector(
                            selectors.cartItemPropertyValue
                        ).textContent = ': ' + property[1];
                    } else {
                        propertyElement.querySelector(
                            selectors.cartItemPropertyValue
                        ).innerHTML =
                            ': <a href="' +
                            property[1] +
                            '"> ' +
                            property[1].split('/').pop() +
                            '</a>';
                    }

                    propertyElement.classList.remove(classes.hide);

                    return propertyElement;
                }.bind(this)
            );
        },

        _createItemPrice: function (original_price, final_price) {
            var originalPriceHTML = theme.Currency.formatMoney(
                original_price,
                theme.moneyFormat
            );

            var resultHTML;

            if (original_price !== final_price) {
                resultHTML = this.itemPriceListTemplate
                    .querySelector(selectors.cartItemDiscountedPriceGroup)
                    .cloneNode(true);

                resultHTML.querySelector(
                    selectors.cartItemOriginalPrice
                ).innerHTML = originalPriceHTML;

                resultHTML.querySelector(
                    selectors.cartItemFinalPrice
                ).innerHTML = theme.Currency.formatMoney(
                    final_price,
                    theme.moneyFormat
                );
            } else {
                resultHTML = this.itemPriceListTemplate
                    .querySelector(selectors.cartItemRegularPriceGroup)
                    .cloneNode(true);

                resultHTML.querySelector(
                    selectors.cartItemRegularPrice
                ).innerHTML = originalPriceHTML;
            }

            resultHTML.classList.remove(classes.hide);
            return resultHTML;
        },

        _createUnitPrice: function (unitPrice, unitPriceMeasurement) {
            var unitPriceGroup = this.itemPriceListTemplate
                .querySelector(selectors.unitPriceGroup)
                .cloneNode(true);

            var unitPriceBaseUnit =
                (unitPriceMeasurement.reference_value !== 1
                    ? unitPriceMeasurement.reference_value
                    : '') + unitPriceMeasurement.reference_unit;

            unitPriceGroup.querySelector(
                selectors.unitPriceBaseUnit
            ).textContent = unitPriceBaseUnit;

            unitPriceGroup.querySelector(
                selectors.unitPrice
            ).innerHTML = theme.Currency.formatMoney(unitPrice, theme.moneyFormat);

            unitPriceGroup.classList.remove(classes.hide);

            return unitPriceGroup;
        },

        _createItemDiscountList: function (item) {
            return item.line_level_discount_allocations.map(
                function (discount) {
                    var discountNode = this.itemDiscountTemplate.cloneNode(true);

                    discountNode.querySelector(
                        selectors.cartItemDiscountTitle
                    ).textContent = discount.discount_application.title;

                    discountNode.querySelector(
                        selectors.cartItemDiscountAmount
                    ).textContent = theme.Currency.formatMoney(
                        discount.amount,
                        theme.moneyFormat
                    );

                    return discountNode;
                }.bind(this)
            );
        },

        _showQuantityErrorMessages: function (itemElement) {
            itemElement
                .querySelectorAll(selectors.cartQuantityErrorMessage)
                .forEach(function (element) {
                    element.textContent = theme.strings.quantityMinimumMessage;
                });

            itemElement
                .querySelectorAll(selectors.cartQuantityErrorMessageWrapper)
                .forEach(function (element) {
                    element.classList.remove(classes.hide);
                });

            itemElement
                .querySelectorAll(selectors.inputQty)
                .forEach(function (element) {
                    element.classList.add(classes.inputError);
                    element.focus();
                });
        },

        _hideQuantityErrorMessage: function () {
            var errorMessages = document.querySelectorAll(
                selectors.cartQuantityErrorMessageWrapper
            );

            errorMessages.forEach(function (element) {
                element.classList.add(classes.hide);

                element.querySelector(selectors.cartQuantityErrorMessage).textContent =
                    '';
            });

            this.container
                .querySelectorAll(selectors.inputQty)
                .forEach(function (element) {
                    element.classList.remove(classes.inputError);
                });
        },

        _handleThumbnailClick: function (evt) {
            if (!evt.target.classList.contains(classes.thumbnails)) return;

            window.location.href = evt.target
                .closest(selectors.cartItem)
                .getAttribute('data-cart-item-url');
        },

        _onNoteChange: function (evt) {
            if (!evt.target.hasAttribute('data-cart-notes')) return;

            var note = evt.target.value;
            this._hideCartError();
            this._hideQuantityErrorMessage();

            var headers = new Headers({ 'Content-Type': 'application/json' });

            var request = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ note: note })
            };

            fetch('/cart/update.js', request).catch(
                function () {
                    this._showCartError(evt.target);
                }.bind(this)
            );
        },

        _showCartError: function (elementToFocus) {
            document.querySelector(selectors.cartErrorMessage).textContent =
                theme.strings.cartError;

            document
                .querySelector(selectors.cartErrorMessageWrapper)
                .classList.remove(classes.hide);

            if (!elementToFocus) return;
            elementToFocus.focus();
        },

        _hideCartError: function () {
            document
                .querySelector(selectors.cartErrorMessageWrapper)
                .classList.add(classes.hide);
            document.querySelector(selectors.cartErrorMessage).textContent = '';
        },

        _onRemoveItem: function (evt) {
            if (!evt.target.hasAttribute('data-cart-remove')) return;

            evt.preventDefault();
            var lineItem = evt.target.closest(selectors.cartItem);
            var index = Number(lineItem.getAttribute(attributes.cartItemIndex));

            this._hideCartError();

            var request = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;'
                },
                body: JSON.stringify({
                    line: index,
                    quantity: 0
                })
            };

            fetch('/cart/change.js', request)
                .then(function (response) {
                    return response.json();
                })
                .then(
                    function (state) {
                        if (state.item_count === 0) {
                            this._emptyCart();
                        } else {
                            this._createCart(state);
                            this._showRemoveMessage(lineItem.cloneNode(true));

                            //Extend - Dispatch refreshCart event
                            window.dispatchEvent(Extend.CustomEvent('refreshCart', { detail: { cart: state } }));
                            //Extend - End Extend Code

                        }

                        this._setCartCountBubble(state.item_count);
                    }.bind(this)
                )
                .catch(
                    function () {
                        this._showCartError(null);
                    }.bind(this)
                );
        },

        _showRemoveMessage: function (lineItem) {
            var index = lineItem.getAttribute('data-cart-item-index');
            var removeMessage = this._getRemoveMessage(lineItem);

            if (index - 1 === 0) {
                this.container
                    .querySelector('[data-cart-item-index="1"]')
                    .insertAdjacentHTML('beforebegin', removeMessage.outerHTML);
            } else {
                this.container
                    .querySelector("[data-cart-item-index='" + (index - 1) + "']")
                    .insertAdjacentHTML('afterend', removeMessage.outerHTML);
            }

            this.container.querySelector('[data-removed-item-row]').focus();
        },

        _getRemoveMessage: function (lineItem) {
            var formattedMessage = this._formatRemoveMessage(lineItem);

            var tableCell = lineItem
                .querySelector(selectors.cartTableCell)
                .cloneNode(true);

            tableCell.removeAttribute('class');
            tableCell.classList.add(classes.cartRemovedProduct);
            tableCell.setAttribute('colspan', '4');
            tableCell.innerHTML = formattedMessage;

            lineItem.setAttribute('role', 'alert');
            lineItem.setAttribute('tabindex', '-1');
            lineItem.setAttribute('data-removed-item-row', true);
            lineItem.innerHTML = tableCell.outerHTML;

            return lineItem;
        },

        _formatRemoveMessage: function (lineItem) {
            var quantity = lineItem.getAttribute('data-cart-item-quantity');
            var url = lineItem.getAttribute(attributes.cartItemUrl);
            var title = lineItem.getAttribute(attributes.cartItemTitle);

            return theme.strings.removedItemMessage
                .replace('[quantity]', quantity)
                .replace(
                    '[link]',
                    '<a ' +
                    'href="' +
                    url +
                    '" class="text-link text-link--accent">' +
                    title +
                    '</a>'
                );
        },

        _setCartCountBubble: function (quantity) {
            this.cartCountBubble =
                this.cartCountBubble ||
                document.querySelector(selectors.cartCountBubble);

            this.cartCount =
                this.cartCount || document.querySelector(selectors.cartCount);

            if (quantity > 0) {
                this.cartCountBubble.classList.remove(classes.hide);
                this.cartCount.textContent = quantity;
            } else {
                this.cartCountBubble.classList.add(classes.hide);
                this.cartCount.textContent = '';
            }
        },

        _emptyCart: function () {
            this.emptyPageContent =
                this.emptyPageContent ||
                this.container.querySelector(selectors.emptyPageContent);

            this.cartWrapper =
                this.cartWrapper || this.container.querySelector(selectors.cartWrapper);

            this.emptyPageContent.classList.remove(classes.hide);
            this.cartWrapper.classList.add(classes.hide);
        }
    });

    return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
    var settings = {
        mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
    };

    var selectors = {
        filterSelection: '#FilterTags',
        sortSelection: '#SortBy',
        selectInput: '[data-select-input]'
    };

    function Filters(container) {
        this.filterSelect = container.querySelector(selectors.filterSelection);
        this.sortSelect = container.querySelector(selectors.sortSelection);

        this.selects = document.querySelectorAll(selectors.selectInput);

        if (this.sortSelect) {
            this.defaultSort = this._getDefaultSortValue();
        }

        if (this.selects.length) {
            this.selects.forEach(function (select) {
                select.classList.remove('hidden');
            });
        }

        this.initBreakpoints = this._initBreakpoints.bind(this);

        this.mql = window.matchMedia(settings.mediaQueryMediumUp);
        this.mql.addListener(this.initBreakpoints);

        if (this.filterSelect) {
            this.filterSelect.addEventListener(
                'change',
                this._onFilterChange.bind(this)
            );
        }

        if (this.sortSelect) {
            this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
        }

        theme.Helpers.promiseStylesheet().then(
            function () {
                this._initBreakpoints();
            }.bind(this)
        );
        this._initParams();
    }

    Filters.prototype = Object.assign({}, Filters.prototype, {
        _initBreakpoints: function () {
            if (this.mql.matches) {
                slate.utils.resizeSelects(this.selects);
            }
        },

        _initParams: function () {
            this.queryParams = {};
            if (location.search.length) {
                var aKeyValue;
                var aCouples = location.search.substr(1).split('&');
                for (var i = 0; i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        this.queryParams[
                            decodeURIComponent(aKeyValue[0])
                        ] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },

        _onSortChange: function () {
            this.queryParams.sort_by = this._getSortValue();

            if (this.queryParams.page) {
                delete this.queryParams.page;
            }

            window.location.search = decodeURIComponent(
                new URLSearchParams(Object.entries(this.queryParams)).toString()
            );
        },

        _onFilterChange: function () {
            document.location.href = this._getFilterValue();
        },

        _getFilterValue: function () {
            return this.filterSelect.value;
        },

        _getSortValue: function () {
            return this.sortSelect.value || this.defaultSort;
        },

        _getDefaultSortValue: function () {
            return this.sortSelect.dataset.defaultSortby;
        },

        onUnload: function () {
            if (this.filterSelect) {
                this.filterSelect.removeEventListener('change', this._onFilterChange);
            }

            if (this.sortSelect) {
                this.sortSelect.removeEventListener('change', this._onSortChange);
            }

            this.mql.removeListener(this.initBreakpoints);
        }
    });

    return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
    function Header() {
        theme.Header.init();
        theme.MobileNav.init();
        theme.SearchDrawer.init();
        theme.Search.init();
    }

    Header.prototype = Object.assign({}, Header.prototype, {
        onUnload: function () {
            theme.Header.unload();
            theme.Search.unload();
            theme.MobileNav.unload();
        }
    });

    return Header;
})();

theme.Maps = (function () {
    var config = {
        zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
    };

    var selectors = {
        section: '[data-section-type="map"]',
        map: '[data-map]',
        mapOverlay: '[data-map-overlay]'
    };

    var classes = {
        mapError: 'map-section--load-error',
        errorMsg: 'map-section__error errors text-center'
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    // eslint-disable-next-line camelcase, no-unused-vars
    window.gm_authFailure = function () {
        if (!Shopify.designMode) {
            return;
        }

        document.querySelector(selectors.section).classList.add(classes.mapError);
        document.querySelector(selectors.map).remove();
        document
            .querySelector(selectors.mapOverlay)
            .insertAdjacentHTML(
                'afterend',
                '<div class="' +
                classes.errorMsg +
                '">' +
                theme.strings.authError +
                '</div>'
            );
    };

    function Map(container) {
        this.map = container.querySelector(selectors.map);
        if (!this.map) return;
        this.key = this.map.dataset.apiKey;

        if (typeof this.key === 'undefined') {
            return;
        }

        if (apiStatus === 'loaded') {
            this.createMap();
        } else {
            mapsToLoad.push(this);

            if (apiStatus !== 'loading') {
                apiStatus = 'loading';
                if (typeof window.google === 'undefined') {
                    theme.Helpers.getScript(
                        'https://maps.googleapis.com/maps/api/js?key=' + this.key
                    ).then(function () {
                        apiStatus = 'loaded';
                        initAllMaps();
                    });
                }
            }
        }
    }

    function initAllMaps() {
        // API has loaded, load all Map instances in queue
        mapsToLoad.forEach(function (map) {
            map.createMap();
        });
    }

    function geolocate(map) {
        return new Promise(function (resolve, reject) {
            var geocoder = new google.maps.Geocoder();
            var address = map.dataset.addressSetting;

            geocoder.geocode({ address: address }, function (results, status) {
                if (status !== google.maps.GeocoderStatus.OK) {
                    reject(status);
                }

                resolve(results);
            });
        });
    }

    Map.prototype = Object.assign({}, Map.prototype, {
        createMap: function () {
            return geolocate(this.map)
                .then(
                    function (results) {
                        var mapOptions = {
                            zoom: config.zoom,
                            center: results[0].geometry.location,
                            draggable: false,
                            clickableIcons: false,
                            scrollwheel: false,
                            disableDoubleClickZoom: true,
                            disableDefaultUI: true
                        };

                        var map = (this.map = new google.maps.Map(this.map, mapOptions));
                        var center = (this.center = map.getCenter());

                        //eslint-disable-next-line no-unused-vars
                        var marker = new google.maps.Marker({
                            map: map,
                            position: map.getCenter()
                        });

                        google.maps.event.addDomListener(
                            window,
                            'resize',
                            theme.Helpers.debounce(
                                function () {
                                    google.maps.event.trigger(map, 'resize');
                                    map.setCenter(center);
                                    this.map.removeAttribute('style');
                                }.bind(this),
                                250
                            )
                        );
                    }.bind(this)
                )
                .catch(
                    function () {
                        var errorMessage;

                        switch (status) {
                            case 'ZERO_RESULTS':
                                errorMessage = errors.addressNoResults;
                                break;
                            case 'OVER_QUERY_LIMIT':
                                errorMessage = errors.addressQueryLimit;
                                break;
                            case 'REQUEST_DENIED':
                                errorMessage = errors.authError;
                                break;
                            default:
                                errorMessage = errors.addressError;
                                break;
                        }

                        // Show errors only to merchant in the editor.
                        if (Shopify.designMode) {
                            this.map.parentNode.classList.add(classes.mapError);
                            this.map.parentNode.innerHTML =
                                '<div class="' +
                                classes.errorMsg +
                                '">' +
                                errorMessage +
                                '</div>';
                        }
                    }.bind(this)
                );
        },

        onUnload: function () {
            if (this.map) {
                google.maps.event.clearListeners(this.map, 'resize');
            }
        }
    });

    return Map;
})();

/* eslint-disable no-new */
theme.Product = (function () {
    function Product(container) {
        this.container = container;
        var sectionId = container.getAttribute('data-section-id');
        this.zoomPictures = [];
        this.ajaxEnabled = true;

        this.settings = {
            // Breakpoints from src/stylesheets/global/variables.scss.liquid
            mediaQueryMediumUp: 'screen and (min-width: 750px)',
            mediaQuerySmall: 'screen and (max-width: 749px)',
            bpSmall: false,
            enableHistoryState:
                container.getAttribute('data-enable-history-state') || false,
            namespace: '.slideshow-' + sectionId,
            sectionId: sectionId,
            sliderActive: false,
            zoomEnabled: false
        };

        this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            cartCount: '[data-cart-count]',
            cartCountBubble: '[data-cart-count-bubble]',
            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupClose: '[data-cart-popup-close]',
            cartPopupDismiss: '[data-cart-popup-dismiss]',
            cartPopupImage: '[data-cart-popup-image]',
            cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
            cartPopupImagePlaceholder: '[data-image-loading-animation]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',
            loader: '[data-loader]',
            loaderStatus: '[data-loader-status]',
            quantity: '[data-quantity-input]',
            SKU: '.variant-sku',
            productStatus: '[data-product-status]',
            originalSelectorId: '#ProductSelect-' + sectionId,
            productForm: '[data-product-form]',
            errorMessage: '[data-error-message]',
            errorMessageWrapper: '[data-error-message-wrapper]',
            imageZoomWrapper: '[data-image-zoom-wrapper]',
            productMediaWrapper: '[data-product-single-media-wrapper]',
            productThumbImages: '.product-single__thumbnail--' + sectionId,
            productThumbs: '.product-single__thumbnails-' + sectionId,
            productThumbListItem: '.product-single__thumbnails-item',
            productThumbsWrapper: '.thumbnails-wrapper',
            saleLabel: '.product-price__sale-label-' + sectionId,
            singleOptionSelector: '.single-option-selector-' + sectionId,
            shopifyPaymentButton: '.shopify-payment-button',
            productMediaTypeVideo: '[data-product-media-type-video]',
            productMediaTypeModel: '[data-product-media-type-model]',
            priceContainer: '[data-price]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-price-base-unit]',
            productPolicies: '[data-product-policies]'
        };

        this.classes = {
            cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
            hidden: 'hide',
            visibilityHidden: 'visibility-hidden',
            inputError: 'input--error',
            jsZoomEnabled: 'js-zoom-enabled',
            productOnSale: 'price--on-sale',
            productUnitAvailable: 'price--unit-available',
            productUnavailable: 'price--unavailable',
            productSoldOut: 'price--sold-out',
            cartImage: 'cart-popup-item__image',
            productFormErrorMessageWrapperHidden:
                'product-form__error-message-wrapper--hidden',
            activeClass: 'active-thumb',
            variantSoldOut: 'product-form--variant-sold-out'
        };

        this.eventHandlers = {};

        this.quantityInput = container.querySelector(this.selectors.quantity);
        this.errorMessageWrapper = container.querySelector(
            this.selectors.errorMessageWrapper
        );
        this.addToCart = container.querySelector(this.selectors.addToCart);
        this.addToCartText = this.addToCart.querySelector(
            this.selectors.addToCartText
        );
        this.shopifyPaymentButton = container.querySelector(
            this.selectors.shopifyPaymentButton
        );
        this.productPolicies = container.querySelector(
            this.selectors.productPolicies
        );

        this.loader = this.addToCart.querySelector(this.selectors.loader);
        this.loaderStatus = container.querySelector(this.selectors.loaderStatus);

        this.imageZoomWrapper = container.querySelectorAll(
            this.selectors.imageZoomWrapper
        );

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        var productJson = document.getElementById('ProductJson-' + sectionId);
        if (!productJson || !productJson.innerHTML.length) {
            return;
        }

        this.productSingleObject = JSON.parse(productJson.innerHTML);

        this.settings.zoomEnabled =
            this.imageZoomWrapper.length > 0
                ? this.imageZoomWrapper[0].classList.contains(
                    this.classes.jsZoomEnabled
                )
                : false;

        this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this);
        this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this);

        this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall);
        this.mqlSmall.addListener(this.initMobileBreakpoint);

        this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp);
        this.mqlMediumUp.addListener(this.initDesktopBreakpoint);

        this.initMobileBreakpoint();
        this.initDesktopBreakpoint();
        this._stringOverrides();
        this._initVariants();
        this._initMediaSwitch();
        this._initAddToCart();
        this._setActiveThumbnail();
        this._initProductVideo();
        this._initModelViewerLibraries();
        this._initShopifyXrLaunch();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {};
            theme.strings = Object.assign({}, theme.strings, theme.productStrings);
        },

        _initMobileBreakpoint: function () {
            if (this.mqlSmall.matches) {
                // initialize thumbnail slider on mobile if more than four thumbnails
                if (
                    this.container.querySelectorAll(this.selectors.productThumbImages)
                        .length > 4
                ) {
                    this._initThumbnailSlider();
                }

                // destroy image zooming if enabled
                if (this.settings.zoomEnabled) {
                    this.imageZoomWrapper.forEach(
                        function (element, index) {
                            this._destroyZoom(index);
                        }.bind(this)
                    );
                }

                this.settings.bpSmall = true;
            } else {
                if (this.settings.sliderActive) {
                    this._destroyThumbnailSlider();
                }

                this.settings.bpSmall = false;
            }
        },

        _initDesktopBreakpoint: function () {
            if (this.mqlMediumUp.matches && this.settings.zoomEnabled) {
                this.imageZoomWrapper.forEach(
                    function (element, index) {
                        this._enableZoom(element, index);
                    }.bind(this)
                );
            }
        },

        _initVariants: function () {
            var options = {
                container: this.container,
                enableHistoryState:
                    this.container.getAttribute('data-enable-history-state') || false,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };

            this.variants = new slate.Variants(options);

            this.eventHandlers.updateAvailability = this._updateAvailability.bind(
                this
            );
            this.eventHandlers.updateMedia = this._updateMedia.bind(this);
            this.eventHandlers.updatePrice = this._updatePrice.bind(this);
            this.eventHandlers.updateSKU = this._updateSKU.bind(this);

            this.container.addEventListener(
                'variantChange',
                this.eventHandlers.updateAvailability
            );
            this.container.addEventListener(
                'variantImageChange',
                this.eventHandlers.updateMedia
            );
            this.container.addEventListener(
                'variantPriceChange',
                this.eventHandlers.updatePrice
            );
            this.container.addEventListener(
                'variantSKUChange',
                this.eventHandlers.updateSKU
            );
        },

        _initMediaSwitch: function () {
            if (!document.querySelector(this.selectors.productThumbImages)) {
                return;
            }

            var self = this;

            var productThumbImages = document.querySelectorAll(
                this.selectors.productThumbImages
            );

            this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this);

            productThumbImages.forEach(function (el) {
                el.addEventListener('click', function (evt) {
                    evt.preventDefault();
                    var mediaId = el.getAttribute('data-thumbnail-id');

                    self._switchMedia(mediaId);
                    self._setActiveThumbnail(mediaId);
                });
                el.addEventListener('keyup', self.eventHandlers.handleMediaFocus);
            });
        },

        _initAddToCart: function () {
            var productForm = this.container.querySelector(
                this.selectors.productForm
            );
            productForm.addEventListener(
                'submit',
                function (evt) {
                    if (this.addToCart.getAttribute('aria-disabled') === 'true') {
                        evt.preventDefault();
                        return;
                    }



                    evt.preventDefault();

                    this.previouslyFocusedElement = document.activeElement;

                    var isInvalidQuantity =
                        !!this.quantityInput && this.quantityInput.value <= 0;

                    if (isInvalidQuantity) {
                        this._showErrorMessage(theme.strings.quantityMinimumMessage);
                        return;
                    }

                    // disable the addToCart and dynamic checkout button while
                    // request/cart popup is loading and handle loading state
                    this._handleButtonLoadingState(true);
                    var form = this.container.querySelector(this.selectors.productForm);
                    this._addItemToCart(form);
                    return;

                }.bind(this)
            );
        },

        _initProductVideo: function () {
            var sectionId = this.settings.sectionId;

            var productMediaTypeVideo = this.container.querySelectorAll(
                this.selectors.productMediaTypeVideo
            );
            productMediaTypeVideo.forEach(function (el) {
                theme.ProductVideo.init(el, sectionId);
            });
        },

        _initModelViewerLibraries: function () {
            var modelViewerElements = this.container.querySelectorAll(
                this.selectors.productMediaTypeModel
            );
            if (modelViewerElements.length < 1) return;
            theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
        },

        _initShopifyXrLaunch: function () {
            this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(
                this
            );
            document.addEventListener(
                'shopify_xr_launch',
                this.eventHandlers.initShopifyXrLaunchHandler
            );
        },

        _initShopifyXrLaunchHandler: function () {
            var currentMedia = this.container.querySelector(
                this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
                new CustomEvent('xrLaunch', {
                    bubbles: true,
                    cancelable: true
                })
            );
        },

        _addItemToCart: function (form) {
            var self = this;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: theme.Helpers.serialize(form)
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    if (json.status && json.status !== 200) {
                        var error = new Error(json.description);
                        error.isFromServer = true;
                        throw error;
                    }
                    self._hideErrorMessage();
                    self._setupCartPopup(json);
                })
                .catch(function (error) {
                    self.previouslyFocusedElement.focus();
                    self._showErrorMessage(
                        error.isFromServer && error.message.length
                            ? error.message
                            : theme.strings.cartError
                    );
                    self._handleButtonLoadingState(false);
                    // eslint-disable-next-line no-console
                    //console.log(error);
                });
        },

        _handleButtonLoadingState: function (isLoading) {
            if (isLoading) {
                this.addToCart.setAttribute('aria-disabled', true);
                this.addToCartText.classList.add(this.classes.hidden);
                this.loader.classList.remove(this.classes.hidden);

                if (this.shopifyPaymentButton) {
                    this.shopifyPaymentButton.setAttribute('disabled', true);
                }

                this.loaderStatus.setAttribute('aria-hidden', false);
            } else {
                this.addToCart.removeAttribute('aria-disabled');
                this.addToCartText.classList.remove(this.classes.hidden);
                this.loader.classList.add(this.classes.hidden);

                if (this.shopifyPaymentButton) {
                    this.shopifyPaymentButton.removeAttribute('disabled');
                }

                this.loaderStatus.setAttribute('aria-hidden', true);
            }
        },

        _showErrorMessage: function (errorMessage) {
            var errorMessageContainer = this.container.querySelector(
                this.selectors.errorMessage
            );
            errorMessageContainer.innerHTML = errorMessage;

            if (this.quantityInput) {
                this.quantityInput.classList.add(this.classes.inputError);
            }

            this.errorMessageWrapper.classList.remove(
                this.classes.productFormErrorMessageWrapperHidden
            );
            this.errorMessageWrapper.setAttribute('aria-hidden', true);
            this.errorMessageWrapper.removeAttribute('aria-hidden');
        },

        _hideErrorMessage: function () {
            this.errorMessageWrapper.classList.add(
                this.classes.productFormErrorMessageWrapperHidden
            );

            if (this.quantityInput) {
                this.quantityInput.classList.remove(this.classes.inputError);
            }
        },

        _setupCartPopup: function (item) {
            this.cartPopup =
                this.cartPopup || document.querySelector(this.selectors.cartPopup);
            this.cartPopupWrapper =
                this.cartPopupWrapper ||
                document.querySelector(this.selectors.cartPopupWrapper);
            this.cartPopupTitle =
                this.cartPopupTitle ||
                document.querySelector(this.selectors.cartPopupTitle);
            this.cartPopupQuantity =
                this.cartPopupQuantity ||
                document.querySelector(this.selectors.cartPopupQuantity);
            this.cartPopupQuantityLabel =
                this.cartPopupQuantityLabel ||
                document.querySelector(this.selectors.cartPopupQuantityLabel);
            this.cartPopupClose =
                this.cartPopupClose ||
                document.querySelector(this.selectors.cartPopupClose);
            this.cartPopupDismiss =
                this.cartPopupDismiss ||
                document.querySelector(this.selectors.cartPopupDismiss);
            this.cartPopupImagePlaceholder =
                this.cartPopupImagePlaceholder ||
                document.querySelector(this.selectors.cartPopupImagePlaceholder);

            this._setupCartPopupEventListeners();

            this._updateCartPopupContent(item);
        },

        _updateCartPopupContent: function (item) {
            var self = this;

            var quantity = this.quantityInput ? this.quantityInput.value : 1;

            this.cartPopupTitle.textContent = item.product_title;
            this.cartPopupQuantity.textContent = quantity;
            this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
                '[count]',
                quantity
            );

            this._setCartPopupPlaceholder(item.featured_image.url);
            this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
            this._setCartPopupProductDetails(
                item.product_has_only_default_variant,
                item.options_with_values,
                item.properties
            );

            fetch('/cart.js')
                .then(function (response) {
                    return response.json();
                })
                .then(function (cart) {
                    self._setCartQuantity(cart.item_count);
                    self._setCartCountBubble(cart.item_count);
                    self._showCartPopup();
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    //console.log(error);
                });
        },

        _setupCartPopupEventListeners: function () {
            this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(
                this
            );
            this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this);
            this.eventHandlers.onBodyClick = this._onBodyClick.bind(this);

            this.cartPopupWrapper.addEventListener(
                'keyup',
                this.eventHandlers.cartPopupWrapperKeyupHandler
            );
            this.cartPopupClose.addEventListener(
                'click',
                this.eventHandlers.hideCartPopup
            );
            this.cartPopupDismiss.addEventListener(
                'click',
                this.eventHandlers.hideCartPopup
            );
            document.body.addEventListener('click', this.eventHandlers.onBodyClick);
        },

        _cartPopupWrapperKeyupHandler: function (event) {
            if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                this._hideCartPopup(event);
            }
        },

        _setCartPopupPlaceholder: function (imageUrl) {
            this.cartPopupImageWrapper =
                this.cartPopupImageWrapper ||
                document.querySelector(this.selectors.cartPopupImageWrapper);

            if (imageUrl === null) {
                this.cartPopupImageWrapper.classList.add(this.classes.hidden);
                return;
            }
        },

        _setCartPopupImage: function (imageUrl, imageAlt) {
            if (imageUrl === null) return;

            this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
            var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
            var image = document.createElement('img');
            image.src = sizedImageUrl;
            image.alt = imageAlt;
            image.classList.add(this.classes.cartImage);
            image.setAttribute('data-cart-popup-image', '');

            image.onload = function () {
                this.cartPopupImagePlaceholder.removeAttribute(
                    'data-image-loading-animation'
                );
                this.cartPopupImageWrapper.append(image);
            }.bind(this);
        },

        _setCartPopupProductDetails: function (
            product_has_only_default_variant,
            options,
            properties
        ) {
            this.cartPopupProductDetails =
                this.cartPopupProductDetails ||
                document.querySelector(this.selectors.cartPopupProductDetails);
            var variantPropertiesHTML = '';

            if (!product_has_only_default_variant) {
                variantPropertiesHTML =
                    variantPropertiesHTML + this._getVariantOptionList(options);
            }

            if (properties !== null && Object.keys(properties).length !== 0) {
                variantPropertiesHTML =
                    variantPropertiesHTML + this._getPropertyList(properties);
            }

            if (variantPropertiesHTML.length === 0) {
                this.cartPopupProductDetails.innerHTML = '';
                this.cartPopupProductDetails.setAttribute('hidden', '');
            } else {
                this.cartPopupProductDetails.innerHTML = variantPropertiesHTML;
                this.cartPopupProductDetails.removeAttribute('hidden');
            }
        },

        _getVariantOptionList: function (variantOptions) {
            var variantOptionListHTML = '';

            variantOptions.forEach(function (variantOption) {
                variantOptionListHTML =
                    variantOptionListHTML +
                    '<li class="product-details__item product-details__item--variant-option">' +
                    variantOption.name +
                    ': ' +
                    variantOption.value +
                    '</li>';
            });

            return variantOptionListHTML;
        },

        _getPropertyList: function (properties) {
            var propertyListHTML = '';
            var propertiesArray = Object.entries(properties);

            propertiesArray.forEach(function (property) {
                // Line item properties prefixed with an underscore are not to be displayed
                if (property[0].charAt(0) === '_') return;

                // if the property value has a length of 0 (empty), don't display it
                if (property[1].length === 0) return;

                propertyListHTML =
                    propertyListHTML +
                    '<li class="product-details__item product-details__item--property">' +
                    '<span class="product-details__property-label">' +
                    property[0] +
                    ': </span>' +
                    property[1];
                ': ' + '</li>';
            });

            return propertyListHTML;
        },

        _setCartQuantity: function (quantity) {
            this.cartPopupCartQuantity =
                this.cartPopupCartQuantity ||
                document.querySelector(this.selectors.cartPopupCartQuantity);
            var ariaLabel;

            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
            }

            this.cartPopupCartQuantity.textContent = quantity;
            this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
        },

        _setCartCountBubble: function (quantity) {
            this.cartCountBubble =
                this.cartCountBubble ||
                document.querySelector(this.selectors.cartCountBubble);
            this.cartCount =
                this.cartCount || document.querySelector(this.selectors.cartCount);

            this.cartCountBubble.classList.remove(this.classes.hidden);
            this.cartCount.textContent = quantity;
        },

        _showCartPopup: function () {
            theme.Helpers.prepareTransition(this.cartPopupWrapper);

            this.cartPopupWrapper.classList.remove(
                this.classes.cartPopupWrapperHidden
            );
            this._handleButtonLoadingState(false);

            slate.a11y.trapFocus({
                container: this.cartPopupWrapper,
                elementToFocus: this.cartPopup,
                namespace: 'cartPopupFocus'
            });
        },

        _hideCartPopup: function (event) {
            var setFocus = event.detail === 0 ? true : false;
            theme.Helpers.prepareTransition(this.cartPopupWrapper);
            this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);

            var cartPopupImage = document.querySelector(
                this.selectors.cartPopupImage
            );
            if (cartPopupImage) {
                cartPopupImage.remove();
            }
            this.cartPopupImagePlaceholder.setAttribute(
                'data-image-loading-animation',
                ''
            );

            slate.a11y.removeTrapFocus({
                container: this.cartPopupWrapper,
                namespace: 'cartPopupFocus'
            });

            if (setFocus) this.previouslyFocusedElement.focus();

            this.cartPopupWrapper.removeEventListener(
                'keyup',
                this.eventHandlers.cartPopupWrapperKeyupHandler
            );
            this.cartPopupClose.removeEventListener(
                'click',
                this.eventHandlers.hideCartPopup
            );
            this.cartPopupDismiss.removeEventListener(
                'click',
                this.eventHandlers.hideCartPopup
            );
            document.body.removeEventListener(
                'click',
                this.eventHandlers.onBodyClick
            );
        },

        _onBodyClick: function (event) {
            var target = event.target;

            if (
                target !== this.cartPopupWrapper &&
                !target.closest(this.selectors.cartPopup)
            ) {
                this._hideCartPopup(event);
            }
        },

        _setActiveThumbnail: function (mediaId) {
            // If there is no element passed, find it by the current product image
            if (typeof mediaId === 'undefined') {
                var productMediaWrapper = this.container.querySelector(
                    this.selectors.productMediaWrapper + ':not(.hide)'
                );

                if (!productMediaWrapper) return;
                mediaId = productMediaWrapper.getAttribute('data-media-id');
            }

            var thumbnailWrappers = this.container.querySelectorAll(
                this.selectors.productThumbListItem + ':not(.slick-cloned)'
            );

            var activeThumbnail;
            thumbnailWrappers.forEach(
                function (el) {
                    var current = el.querySelector(
                        this.selectors.productThumbImages +
                        "[data-thumbnail-id='" +
                        mediaId +
                        "']"
                    );
                    if (current) {
                        activeThumbnail = current;
                    }
                }.bind(this)
            );

            var productThumbImages = document.querySelectorAll(
                this.selectors.productThumbImages
            );
            productThumbImages.forEach(
                function (el) {
                    el.classList.remove(this.classes.activeClass);
                    el.removeAttribute('aria-current');
                }.bind(this)
            );

            if (activeThumbnail) {
                activeThumbnail.classList.add(this.classes.activeClass);
                activeThumbnail.setAttribute('aria-current', true);
                this._adjustThumbnailSlider(activeThumbnail);
            }
        },

        _adjustThumbnailSlider: function (activeThumbnail) {
            var sliderItem = activeThumbnail.closest('[data-slider-item]');
            if (!sliderItem) return;

            var slideGroupLeaderIndex =
                Math.floor(
                    Number(sliderItem.getAttribute('data-slider-slide-index')) / 3
                ) * 3;

            window.setTimeout(
                function () {
                    if (!this.slideshow) return;
                    this.slideshow.goToSlideByIndex(slideGroupLeaderIndex);
                }.bind(this),
                251
            );
        },

        _switchMedia: function (mediaId) {
            var currentMedia = this.container.querySelector(
                this.selectors.productMediaWrapper +
                ':not(.' +
                this.classes.hidden +
                ')'
            );

            var newMedia = this.container.querySelector(
                this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
            );

            var otherMedia = this.container.querySelectorAll(
                this.selectors.productMediaWrapper +
                ":not([data-media-id='" +
                mediaId +
                "'])"
            );

            currentMedia.dispatchEvent(
                new CustomEvent('mediaHidden', {
                    bubbles: true,
                    cancelable: true
                })
            );
            newMedia.classList.remove(this.classes.hidden);
            newMedia.dispatchEvent(
                new CustomEvent('mediaVisible', {
                    bubbles: true,
                    cancelable: true
                })
            );
            otherMedia.forEach(
                function (el) {
                    el.classList.add(this.classes.hidden);
                }.bind(this)
            );
        },

        _handleMediaFocus: function (evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

            var mediaId = evt.currentTarget.getAttribute('data-thumbnail-id');

            var productMediaWrapper = this.container.querySelector(
                this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
            );
            productMediaWrapper.focus();
        },

        _initThumbnailSlider: function () {
            setTimeout(
                function () {
                    this.slideshow = new theme.Slideshow(
                        this.container.querySelector('[data-thumbnail-slider]'),
                        {
                            canUseTouchEvents: true,
                            type: 'slide',
                            slideActiveClass: 'slick-active',
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    );

                    this.settings.sliderActive = true;
                }.bind(this),
                250
            );
        },

        _destroyThumbnailSlider: function () {
            var sliderButtons = this.container.querySelectorAll(
                '[data-slider-button]'
            );
            var sliderTrack = this.container.querySelector('[data-slider-track]');
            var sliderItems = sliderTrack.querySelectorAll('[data-slider-item');
            this.settings.sliderActive = false;

            if (sliderTrack) {
                sliderTrack.removeAttribute('style');
                sliderItems.forEach(function (sliderItem) {
                    var sliderItemLink = sliderItem.querySelector(
                        '[data-slider-item-link]'
                    );
                    sliderItem.classList.remove('slick-active');
                    sliderItem.removeAttribute('style');
                    sliderItem.removeAttribute('tabindex');
                    sliderItem.removeAttribute('aria-hidden');
                    sliderItemLink.removeAttribute('tabindex');
                });
            }

            sliderButtons.forEach(function (sliderButton) {
                sliderButton.removeAttribute('aria-disabled');
            });

            this.slideshow.destroy();
            this.slideshow = null;
        },

        _liveRegionText: function (variant) {
            // Dummy content for live region
            var liveRegionText =
                '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

            if (!variant) {
                liveRegionText = theme.strings.unavailable;
                return liveRegionText;
            }

            // Update availability
            var availability = variant.available ? '' : theme.strings.soldOut + ',';
            liveRegionText = liveRegionText.replace('[Availability]', availability);

            // Update pricing information
            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(
                variant.price,
                theme.moneyFormat
            );
            var saleLabel = '';
            var salePrice = '';
            var unitLabel = '';
            var unitPrice = '';

            if (variant.compare_at_price > variant.price) {
                regularLabel = theme.strings.regularPrice;
                regularPrice =
                    theme.Currency.formatMoney(
                        variant.compare_at_price,
                        theme.moneyFormat
                    ) + ',';
                saleLabel = theme.strings.sale;
                salePrice = theme.Currency.formatMoney(
                    variant.price,
                    theme.moneyFormat
                );
            }

            if (variant.unit_price) {
                unitLabel = theme.strings.unitPrice;
                unitPrice =
                    theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
                    ' ' +
                    theme.strings.unitPriceSeparator +
                    ' ' +
                    this._getBaseUnit(variant);
            }

            liveRegionText = liveRegionText
                .replace('[Regular]', regularLabel)
                .replace('[$$]', regularPrice)
                .replace('[Sale]', saleLabel)
                .replace('[$]', salePrice)
                .replace('[UnitPrice]', unitLabel)
                .replace('[$$$]', unitPrice)
                .trim();

            return liveRegionText;
        },

        _updateLiveRegion: function (evt) {
            var variant = evt.detail.variant;
            var liveRegion = this.container.querySelector(
                this.selectors.productStatus
            );
            liveRegion.innerHTML = this._liveRegionText(variant);
            liveRegion.setAttribute('aria-hidden', false);
            // hide content from accessibility tree after announcement
            setTimeout(function () {
                liveRegion.setAttribute('aria-hidden', true);
            }, 1000);
        },

        _updateAddToCart: function (evt) {
            var variant = evt.detail.variant;
            var addToCartText = this.container.querySelector(
                this.selectors.addToCartText
            );
            var productForm = this.container.querySelector(
                this.selectors.productForm
            );

            if (variant) {
                if (variant.available) {
                    this.addToCart.removeAttribute('aria-disabled');
                    this.addToCart.setAttribute('aria-label', theme.strings.addToCart);
                    addToCartText.innerHTML = theme.strings.addToCart;
                    productForm.classList.remove(this.classes.variantSoldOut);
                } else {
                    // Variant is sold out, disable submit button and change the text.
                    this.addToCart.setAttribute('aria-disabled', true);
                    this.addToCart.setAttribute('aria-label', theme.strings.soldOut);
                    addToCartText.innerHTML = theme.strings.soldOut;
                    productForm.classList.add(this.classes.variantSoldOut);
                }
            } else {
                // The variant doesn't exist, disable submit button and change the text.
                this.addToCart.setAttribute('aria-disabled', true);
                this.addToCart.setAttribute('aria-label', theme.strings.unavailable);
                addToCartText.innerHTML = theme.strings.unavailable;
                productForm.classList.add(this.classes.variantSoldOut);
            }
        },

        _updateAvailability: function (evt) {
            // remove error message if one is showing
            this._hideErrorMessage();

            // update form submit
            this._updateAddToCart(evt);
            // update live region
            this._updateLiveRegion(evt);

            this._updatePrice(evt);
        },

        _updateMedia: function (evt) {
            var variant = evt.detail.variant;
            var mediaId = variant.featured_media.id;
            var sectionMediaId = this.settings.sectionId + '-' + mediaId;

            this._switchMedia(sectionMediaId);
            this._setActiveThumbnail(sectionMediaId);
        },

        _updatePrice: function (evt) {
            var variant = evt.detail.variant;

            var priceContainer = this.container.querySelector(
                this.selectors.priceContainer
            );
            var regularPrice = priceContainer.querySelector(
                this.selectors.regularPrice
            );
            var salePrice = priceContainer.querySelector(this.selectors.salePrice);
            var unitPrice = priceContainer.querySelector(this.selectors.unitPrice);
            var unitPriceBaseUnit = priceContainer.querySelector(
                this.selectors.unitPriceBaseUnit
            );

            // Reset product price state

            priceContainer.classList.remove(
                this.classes.productUnavailable,
                this.classes.productOnSale,
                this.classes.productUnitAvailable,
                this.classes.productSoldOut
            );
            priceContainer.removeAttribute('aria-hidden');

            if (this.productPolicies) {
                this.productPolicies.classList.remove(this.classes.visibilityHidden);
            }

            // Unavailable
            if (!variant) {
                priceContainer.classList.add(this.classes.productUnavailable);
                priceContainer.setAttribute('aria-hidden', true);

                if (this.productPolicies) {
                    this.productPolicies.classList.add(this.classes.visibilityHidden);
                }
                return;
            }

            // Sold out
            if (!variant.available) {
                priceContainer.classList.add(this.classes.productSoldOut);
            }

            // On sale
            if (variant.compare_at_price > variant.price) {
                regularPrice.innerHTML = theme.Currency.formatMoney(
                    variant.compare_at_price,
                    theme.moneyFormat
                );
                salePrice.innerHTML = theme.Currency.formatMoney(
                    variant.price,
                    theme.moneyFormat
                );
                priceContainer.classList.add(this.classes.productOnSale);
            } else {
                // Regular price
                regularPrice.innerHTML = theme.Currency.formatMoney(
                    variant.price,
                    theme.moneyFormat
                );
            }

            // Unit price
            if (variant.unit_price) {
                unitPrice.innerHTML = theme.Currency.formatMoney(
                    variant.unit_price,
                    theme.moneyFormat
                );
                unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
                priceContainer.classList.add(this.classes.productUnitAvailable);
            }
        },

        _getBaseUnit: function (variant) {
            return variant.unit_price_measurement.reference_value === 1
                ? variant.unit_price_measurement.reference_unit
                : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        },

        _updateSKU: function (evt) {
            var variant = evt.detail.variant;

            // Update the sku
            var sku = document.querySelector(this.selectors.SKU);
            if (!sku) return;
            sku.innerHTML = variant.sku;
        },

        _enableZoom: function (el, index) {
            this.zoomPictures[index] = new theme.Zoom(el);
        },

        _destroyZoom: function (index) {
            if (this.zoomPictures.length === 0) return;
            this.zoomPictures[index].unload();
        },

        onUnload: function () {
            this.container.removeEventListener(
                'variantChange',
                this.eventHandlers.updateAvailability
            );
            this.container.removeEventListener(
                'variantImageChange',
                this.eventHandlers.updateMedia
            );
            this.container.removeEventListener(
                'variantPriceChange',
                this.eventHandlers.updatePrice
            );
            this.container.removeEventListener(
                'variantSKUChange',
                this.eventHandlers.updateSKU
            );
            theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
            theme.ProductModel.removeSectionModels(this.settings.sectionId);

            if (this.mqlSmall) {
                this.mqlSmall.removeListener(this.initMobileBreakpoint);
            }

            if (this.mqlMediumUp) {
                this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
            }
        }
    });

    return Product;
})();

theme.ProductRecommendations = (function () {
    function ProductRecommendations(container) {
        var baseUrl = container.dataset.baseUrl;
        var productId = container.dataset.productId;
        var recommendationsSectionUrl =
            baseUrl +
            '?section_id=product-recommendations&product_id=' +
            productId +
            '&limit=4';

        window.performance.mark(
            'debut:product:fetch_product_recommendations.start'
        );

        fetch(recommendationsSectionUrl)
            .then(function (response) {
                return response.text();
            })
            .then(function (productHtml) {
                if (productHtml.trim() === '') return;

                container.innerHTML = productHtml;
                container.innerHTML = container.firstElementChild.innerHTML;

                window.performance.mark(
                    'debut:product:fetch_product_recommendations.end'
                );

                performance.measure(
                    'debut:product:fetch_product_recommendations',
                    'debut:product:fetch_product_recommendations.start',
                    'debut:product:fetch_product_recommendations.end'
                );
            });
    }

    return ProductRecommendations;
})();

theme.Quotes = (function () {
    var config = {
        mediaQuerySmall: 'screen and (max-width: 749px)',
        mediaQueryMediumUp: 'screen and (min-width: 750px)',
        slideCount: 0
    };

    var defaults = {
        canUseKeyboardArrows: false,
        type: 'slide',
        slidesToShow: 3,
        swipeToSlide: false
    };

    function Quotes(container) {
        this.container = container;
        var sectionId = container.getAttribute('data-section-id');
        this.slider = document.getElementById('Quotes-' + sectionId);

        this.sliderActive = false;

        this.mobileOptions = Object.assign({}, defaults, {
            canUseTouchEvents: false,
            slidesToShow: 1

        });

        this.desktopOptions = Object.assign({}, defaults, {
            slidesToShow: Math.min(
                defaults.slidesToShow,
                this.slider.getAttribute('data-count')
            )
        });

        this.initMobileSlider = this._initMobileSlider.bind(this);
        this.initDesktopSlider = this._initDesktopSlider.bind(this);

        this.mqlSmall = window.matchMedia(config.mediaQuerySmall);
        this.mqlSmall.addListener(this.initMobileSlider);

        this.mqlMediumUp = window.matchMedia(config.mediaQueryMediumUp);
        this.mqlMediumUp.addListener(this.initDesktopSlider);

        this.initMobileSlider();
        this.initDesktopSlider();
    }

    Quotes.prototype = Object.assign({}, Quotes.prototype, {
        onUnload: function () {
            this.mqlSmall.removeListener(this.initMobileSlider);
            this.mqlMediumUp.removeListener(this.initDesktopSlider);
            this.slideshow.destroy();
        },

        // eslint-disable-next-line no-unused-vars
        onBlockSelect: function (evt) {
            var slide = document.querySelector(
                '.quotes-slide--' + evt.detail.blockId
            );
            var slideIndex = Number(slide.getAttribute('data-slider-slide-index'));

            if (this.mqlMediumUp.matches) {
                slideIndex = Math.max(
                    0,
                    Math.min(slideIndex, this.slideshow.slides.length - 3)
                );
            }

            this.slideshow.goToSlideByIndex(slideIndex);
        },

        _initMobileSlider: function () {
            if (this.mqlSmall.matches) {
                this._initSlider(this.mobileOptions);
            }
        },

        _initDesktopSlider: function () {
            if (this.mqlMediumUp.matches) {
                this._initSlider(this.desktopOptions);
            }
        },

        // eslint-disable-next-line no-unused-vars
        _initSlider: function (args) {
            if (this.sliderActive) {
                this.slideshow.destroy();
                this.sliderActive = false;
            }

            this.slideshow = new theme.Slideshow(this.container, args);
            this.sliderActive = true;
        }
    });

    return Quotes;
})();

theme.SlideshowSection = (function () {
    var selectors = {
        sliderMobileContentIndex: '[data-slider-mobile-content-index]'
    };

    function SlideshowSection(container) {
        var sectionId = container.dataset.sectionId;

        this.container = container;
        this.eventHandlers = {};
        this.slideshowDom = container.querySelector('#Slideshow-' + sectionId);
        this.sliderMobileContentIndex = container.querySelectorAll(
            selectors.sliderMobileContentIndex
        );

        this.slideshow = new theme.Slideshow(container, {
            autoplay: this.slideshowDom.getAttribute('data-autorotate') === 'true',
            slideInterval: this.slideshowDom.getAttribute('data-speed')
        });
        this._setupEventListeners();
    }

    return SlideshowSection;
})();

theme.SlideshowSection.prototype = Object.assign(
    {},
    theme.SlideshowSection.prototype,
    {
        _setupEventListeners: function () {
            this.eventHandlers.onSliderSlideChanged = function (event) {
                this._onSliderSlideChanged(event.detail);
            }.bind(this);

            this.container.addEventListener(
                'slider_slide_changed',
                this.eventHandlers.onSliderSlideChanged
            );
        },

        _onSliderSlideChanged: function (slideIndex) {
            var activeClass = 'slideshow__text-content--mobile-active';

            this.sliderMobileContentIndex.forEach(function (element) {
                if (
                    Number(element.getAttribute('data-slider-mobile-content-index')) ===
                    slideIndex
                ) {
                    element.classList.add(activeClass);
                } else {
                    element.classList.remove(activeClass);
                }
            });
        },

        onUnload: function () {
            this.slideshow.destroy();
        },

        onBlockSelect: function (evt) {
            if (this.slideshow.adaptHeight) {
                this.slideshow.setSlideshowHeight();
            }

            // Get slide's index using theme editor's id
            var slide = this.container.querySelector(
                '.slideshow__slide--' + evt.detail.blockId
            );
            var slideIndex = slide.getAttribute('data-slider-slide-index');

            // Go to selected slide, pause auto-rotate
            this.slideshow.setSlide(slideIndex);
            this.slideshow.stopAutoplay();
        },

        onBlockDeselect: function () {
            // Resume auto-rotate
            this.slideshow.startAutoplay();
        }
    }
);

theme.VideoSection = (function () {
    function VideoSection(container) {
        container.querySelectorAll('.video').forEach(function (el) {
            theme.Video.init(el);
            theme.Video.editorLoadVideo(el.id);
        });
    }

    return VideoSection;
})();

theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
    onUnload: function () {
        theme.Video.removeEvents();
    }
});

theme.heros = {};

theme.HeroSection = (function () {
    function HeroSection(container) {
        var sectionId = container.getAttribute('data-section-id');
        var hero = '#Hero-' + sectionId;
        theme.heros[hero] = new theme.Hero(hero, sectionId);
    }

    return HeroSection;
})();

window.theme = window.theme || {};

var selectors = {
    disclosureLocale: '[data-disclosure-locale]',
    disclosureCurrency: '[data-disclosure-currency]'
};

theme.FooterSection = (function () {
    function Footer(container) {
        this.container = container;
        this.cache = {};
        this.cacheSelectors();

        if (this.cache.localeDisclosure) {
            this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
        }

        if (this.cache.currencyDisclosure) {
            this.currencyDisclosure = new theme.Disclosure(
                this.cache.currencyDisclosure
            );
        }
    }

    Footer.prototype = Object.assign({}, Footer.prototype, {
        cacheSelectors: function () {
            this.cache = {
                localeDisclosure: this.container.querySelector(
                    selectors.disclosureLocale
                ),
                currencyDisclosure: this.container.querySelector(
                    selectors.disclosureCurrency
                )
            };
        },

        onUnload: function () {
            if (this.cache.localeDisclosure) {
                this.localeDisclosure.destroy();
            }

            if (this.cache.currencyDisclosure) {
                this.currencyDisclosure.destroy();
            }
        }
    });

    return Footer;
})();


document.addEventListener('DOMContentLoaded', function () {
    var sections = new theme.Sections();

    sections.register('cart-template', theme.Cart);
    sections.register('product', theme.Product);
    sections.register('collection-template', theme.Filters);
    sections.register('product-template', theme.Product);
    sections.register('header-section', theme.HeaderSection);
    sections.register('map', theme.Maps);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('quotes', theme.Quotes);
    sections.register('hero-section', theme.HeroSection);
    sections.register('product-recommendations', theme.ProductRecommendations);
    sections.register('footer-section', theme.FooterSection);

    theme.customerTemplates.init();

    // Theme-specific selectors to make tables scrollable
    var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

    slate.rte.wrapTable({
        tables: document.querySelectorAll(tableSelectors),
        tableWrapperClass: 'scrollable-wrapper'
    });

    // Theme-specific selectors to make iframes responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"],' +
        '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
        '.custom__item-inner--html iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: 'video-wrapper'
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus(
        document.getElementById(window.location.hash.substr(1))
    );

    var inPageLink = document.querySelector('.in-page-link');
    if (inPageLink) {
        inPageLink.addEventListener('click', function (evt) {
            slate.a11y.pageLinkFocus(
                document.getElementById(evt.currentTarget.hash.substr(1))
            );
        });
    }

    document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (evt) {
            evt.preventDefault();
        });
    });
    if (slate.a11y.accessibleLinks)
        slate.a11y.accessibleLinks({
            messages: {
                newWindow: theme.strings.newWindow,
                external: theme.strings.external,
                newWindowExternal: theme.strings.newWindowExternal
            },
            links: document.querySelectorAll(
                'a[href]:not([aria-describedby]), .product-single__thumbnail'
            )
        });

    theme.FormStatus.init();

    var selectors = {
        image: '[data-image]',
        lazyloaded: '.lazyloaded'
    };

    document.addEventListener('lazyloaded', function (evt) {
        var image = evt.target;

        removeImageLoadingAnimation(image);

        if (document.body.classList.contains('template-index')) {
            var mainContent = document.getElementById('MainContent');

            if (mainContent && mainContent.children && mainContent.children.length) {
                var firstSection = document.getElementsByClassName('index-section')[0];

                if (!firstSection.contains(image)) return;

                window.performance.mark('debut:index:first_image_visible');
            }
        }

        if (image.hasAttribute('data-bgset')) {
            var innerImage = image.querySelector(selectors.lazyloaded);

            if (innerImage) {
                var alt = image.getAttribute('data-alt');
                var src = innerImage.hasAttribute('data-src')
                    ? innerImage.getAttribute('data-src')
                    : image.getAttribute('data-bg');

                image.setAttribute('alt', alt ? alt : '');
                image.setAttribute('src', src ? src : '');
            }
        }

        if (!image.hasAttribute('data-image')) {
            return;
        }
    });

    // When the theme loads, lazysizes might load images before the "lazyloaded"
    // event listener has been attached. When this happens, the following function
    // hides the loading placeholders.
    function onLoadHideLazysizesAnimation() {
        var alreadyLazyloaded = document.querySelectorAll('.lazyloaded');
        alreadyLazyloaded.forEach(function (image) {
            removeImageLoadingAnimation(image);
        });
    }

    onLoadHideLazysizesAnimation();

    document.addEventListener(
        'touchstart',
        function () {
            theme.Helpers.setTouch();
        },
        { once: true }
    );

    if (document.fonts) {
        document.fonts.ready.then(function () {
            window.performance.mark('debut:fonts_loaded');
        });
    }
});

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos();
    theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

function removeImageLoadingAnimation(image) {
    // Remove loading animation
    var imageWrapper = image.hasAttribute('data-image-loading-animation')
        ? image
        : image.closest('[data-image-loading-animation]');

    if (imageWrapper) {
        imageWrapper.removeAttribute('data-image-loading-animation');
    }
}
if (jQuery(window).width() < 998) {
    jQuery('.quotes-wrapper').each(function () {
        jQuery(this).find('.quotes-slide').addClass('hidden-slide');
        jQuery(this).find('.quotes-slide').first().removeClass('hidden-slide');

    });
}
if (jQuery(window).width() >= 998) {
    jQuery('.quotes-wrapper').each(function () {
        if (jQuery(this).find('.quotes-slide').length < 4) {
            jQuery(this).find('.slider-prev').hide();
            jQuery(this).find('.slider-next').hide();
        }
    });
}

jQuery('.slider-prev, .compact-slider-prev').click(function () {
    let slider = jQuery(this).parents('.quotes-wrapper');
    let firstSlide = slider.find('.quotes-slide:not(.hidden-slide)').first().attr('data-slider-slide-index');
    //console.log(firstSlide);
    if (firstSlide > 0) {
        slider.find('.quotes-slide[data-slider-slide-index="' + (parseInt(firstSlide) - 1) + '"]').removeClass('hidden-slide');
        slider.find('.quotes-slide:not(.hidden-slide)').last().addClass('hidden-slide');
    } else {
        slider.find('.quotes-slide[data-slider-slide-index="' + slider.find('.quotes-slide').last().attr('data-slider-slide-index') + '"]').removeClass('hidden-slide');
        slider.find('.quotes-slide:not(.hidden-slide)').first().addClass('hidden-slide');
    }
    slider.find('.quotes-slide.hidden-slide iframe').each(function () {
        var src = jQuery(this).attr('src');
        if (src != '') {
            jQuery(this).attr('data-src', src);
            jQuery(this).attr('src', '');
        }
    });
    var src = slider.find('.quotes-slide:not(.hidden-slide)').find('iframe').attr('data-src');
    if (src != '') {
        slider.find('.quotes-slide:not(.hidden-slide)').find('iframe').attr('src', src);
    }
});
jQuery('.slider-next, .compact-slider-next').click(function () {
    let slider = jQuery(this).parents('.quotes-wrapper');
    let lastSlide = slider.find('.quotes-slide:not(.hidden-slide)').last().attr('data-slider-slide-index');
    //console.log(lastSlide);
    if (lastSlide < slider.find('.quotes-slide').length - 1) {
        //console.log('.quotes-slide[data-slider-slide-index="[' + (parseInt(lastSlide)+1) + ']"');
        slider.find('.quotes-slide[data-slider-slide-index="' + (parseInt(lastSlide) + 1) + '"]').removeClass('hidden-slide');
        slider.find('.quotes-slide:not(.hidden-slide)').first().addClass('hidden-slide');
    } else {
        slider.find('.quotes-slide[data-slider-slide-index="0"]').removeClass('hidden-slide');
        slider.find('.quotes-slide:not(.hidden-slide)').last().addClass('hidden-slide');
    }
    slider.find('.quotes-slide.hidden-slide iframe').each(function () {
        var src = jQuery(this).attr('src');
        if (src != '') {
            jQuery(this).attr('data-src', src);
            jQuery(this).attr('src', '');
        }
    });
    var src = slider.find('.quotes-slide:not(.hidden-slide)').find('iframe').attr('data-src');
    if (src != '') {
        slider.find('.quotes-slide:not(.hidden-slide)').find('iframe').attr('src', src);
    }
});

jQuery('.slider-button:first-child()').addClass('active');
setInterval(function () {
    let currentActive = parseInt(jQuery('.slideshow__slide--active').attr('data-slider-slide-index'));
    let total = jQuery('.slideshow__slide').length;
    let next = currentActive + 1;
    if (next == total) {
        next = 0;
    }
    jQuery('.slideshow__slide[data-slider-slide-index="' + currentActive + '"]').removeClass('slideshow__slide--active');
    jQuery('.slider-button').removeClass('active');
    jQuery('.slideshow__slide[data-slider-slide-index="' + next + '"]').addClass('slideshow__slide--active');
    if (next)
        jQuery('.slider-button:nth-child(' + (next + 1) + ')').addClass('active');
}, 10000);

jQuery('.announcement-bar svg:last-child').click(function () {

    jQuery('.site-header').css('position', 'absolute');
    jQuery('.site-header').css('top', jQuery(this).parents('.announcement-bar').height() + 'px');
    jQuery('.site-header').css('transition', 'top 2s ease 0s');
    jQuery(this).parents('.announcement-bar').addClass('hidden');
    jQuery('.site-header').animate({ top: 0 }, 10, 'linear');
    jQuery('.sticky-header-content').css('transition', 'height 2s ease 0s');
    jQuery('.sticky-header-content').css('min-height', '67px');
    jQuery(this).parents('.announcement-bar').addClass('hidden');
    jQuery('main.main-content').css("padding-top", "0px");
    try {
        let popupSeen = localStorage.getItem('popupSeen');
        if (jQuery('#ouibounce-popup').length > 0) {
            if (!popupSeen || -(new Date(popupSeen) - new Date()) / (1000 * 60 * 60 * 24) >= parseInt(jQuery('#ouibounce-popup').attr('data-frequency'))) {

                jQuery('#ouibounce-popup').css('opacity', '0');
                jQuery('#ouibounce-modal').show();
                jQuery('html').css('position', 'fixed');
                jQuery('html').css('overflow', 'hidden');
                jQuery('html').css('touch-action', 'none');
                jQuery('html').css('-ms-touch-action', 'none');
                jQuery('#ouibounce-popup').animate({ opacity: 1 }, 1000);

                localStorage.setItem('popupSeen', new Date());
            }
        }
    } catch (e) {

    }
});

jQuery('.announcement-bar, #ouibounce-popup').each(function () {
    let year = jQuery(this).attr('data-endyear');
    let month = jQuery(this).attr('data-endmonth');
    if (month.length == 1) {
        month = '0' + month;
    }
    let day = jQuery(this).attr('data-endday');
    if (day.length == 1) {
        day = '0' + day;
    }
    let hour = jQuery(this).attr('data-endhour');
    if (hour.length == 1) {
        hour = '0' + hour;
    }
    let minute = jQuery(this).attr('data-endminute');
    if (minute.length == 1) {
        minute = '0' + minute;
    }
    let second = jQuery(this).attr('data-endsecond');
    if (second.length == 1) {
        second = '0' + second;
    }
    let enddate = new Date(year + '-' + month + '-' + day + 'T' + hour + ':' + minute + ':' + second);
    let today = new Date();
    var diff = enddate - today;
    let s = 0, m = 0, h = 0, d = 0;
    if (diff > 0) {

        s = '' + Math.floor(diff / 1000 % 60);
        m = '' + Math.floor(diff / 60000 % 60);
        h = '' + Math.floor(diff / 3600000 % 24);
        d = '' + Math.floor(diff / 86400000);

    } else {
        jQuery(this).find('.enddate').hide();
    }
    console.log("diff:" + diff);
    console.log(d + '-' + h + '-' + m + '-' + s);
    jQuery(this).find('.enddate').attr('data-time', diff);
    jQuery(this).find('.enddate .days').text(d);
    jQuery(this).find('.enddate .hours').text(h);
    jQuery(this).find('.enddate .minutes').text(m);
    jQuery(this).find('.enddate .seconds').text(s);


});

setInterval(function () {
    jQuery('.announcement-bar, #ouibounce-popup').each(function () {
        let year = jQuery(this).attr('data-endyear');
        let month = jQuery(this).attr('data-endmonth');
        if (month.length == 1) {
            month = '0' + month;
        }
        let day = jQuery(this).attr('data-endday');
        if (day.length == 1) {
            day = '0' + day;
        }
        let hour = jQuery(this).attr('data-endhour');
        if (hour.length == 1) {
            hour = '0' + hour;
        }
        let minute = jQuery(this).attr('data-endminute');
        if (minute.length == 1) {
            minute = '0' + minute;
        }
        let second = jQuery(this).attr('data-endsecond');
        if (second.length == 1) {
            second = '0' + second;
        }
        let enddate = new Date(year + '-' + month + '-' + day + 'T' + hour + ':' + minute + ':' + second);
        let today = new Date();
        var diff = enddate - today;
        if (diff > 0) {

            s = '' + Math.floor(diff / 1000 % 60);
            if (s.length == 1) {
                s = '0' + s;
            }
            m = '' + Math.floor(diff / 60000 % 60);
            if (m.length == 1) {
                m = '0' + m;
            }
            h = '' + Math.floor(diff / 3600000 % 24);
            if (h.length == 1) {
                h = '0' + h;
            }
            d = '' + Math.floor(diff / 86400000);
            jQuery(this).find('.enddate').attr('data-time', diff);
            jQuery(this).find('.enddate .days').text(d);
            jQuery(this).find('.enddate .hours').text(h);
            jQuery(this).find('.enddate .minutes').text(m);
            jQuery(this).find('.enddate .seconds').text(s);
        } else {
            jQuery(this).find('.enddate').hide();
        }
        if (diff < 1000 && jQuery(this).hasClass('announcement-bar') && !jQuery(this).hasClass('hidden')) {
            jQuery('.site-header').css('position', 'absolute');
            jQuery('.site-header').css('top', jQuery(this).parents('.announcement-bar').height() + 'px');
            jQuery('.site-header').css('transition', 'top 2s ease 0s');
            jQuery(this).addClass('hidden');
            jQuery('.site-header').animate({ top: 0 }, 10, 'linear');
            jQuery('.sticky-header-content').css('transition', 'height 2s ease 0s');
            jQuery('.sticky-header-content').css('min-height', '67px');
        }

    });
}, 1000);

/*
    Popup scripts
*/

jQuery('.popup').each(function () {

    jQuery(this).parent().show();
    jQuery(this).parent().css('visibility', 'hidden');
    offsetFromTop = (jQuery(window).height() - parseInt(jQuery(this).css('height').replace('px', ''))) / 2;

    if (offsetFromTop < 0) {
        offsetFromTop = 0;
    }
    //jQuery('.popup').animate({top:  jQuery(document).scrollTop() + offsetFromTop}, 1, 'linear');
    jQuery(this).offset({ top: jQuery(document).scrollTop() + offsetFromTop });
    var that = jQuery(this);
    that.parent().css('visibility', 'visible');
    that.parent().hide();
    jQuery(document).scroll(function () {

        var isVisible = that.parent().css('display');
        that.parent().show();
        that.parent().css('visibility', 'hidden');
        //jQuery('.popup-container').height(jQuery(document).scrollTop() + jQuery(window).height());


        let offsetFromTop = (jQuery(window).height() - parseInt(that.css('height').replace('px', ''))) / 2;




        if (offsetFromTop < 0) {
            if (jQuery(document).scrollTop() + jQuery(window).height() > that.offset().top + that.height()) {
                that.offset({ top: jQuery(document).scrollTop() + jQuery(window).height() - that.height() });
            } else if (jQuery(document).scrollTop() < that.offset().top) {
                that.offset({ top: jQuery(document).scrollTop() });
            }
        } else {
            //jQuery('.popup').animate({top: jQuery(document).scrollTop() + offsetFromTop}, 1, 'linear');
            that.offset({ top: jQuery(document).scrollTop() + offsetFromTop });
        }




        that.parent().css('visibility', 'visible');
        if (isVisible != 'block') {
            that.parent().hide();
        }
    });
});

/*
    Email popup scripts
*/
let popupSeen = localStorage.getItem('popupSeen');
if (jQuery('#ouibounce-popup').length > 0) {
    if (!popupSeen || -(new Date(popupSeen) - new Date()) / (1000 * 60 * 60 * 24) >= parseInt(jQuery('#ouibounce-popup').attr('data-frequency'))) {
        if (window.ouibounce) {
            var _ouibounce = ouibounce(document.getElementById('ouibounce-modal'), {
                sitewide: true,
                cookieExpire: parseInt(jQuery('#ouibounce-popup').attr('data-frequency')),
                aggressive: false,//true for testing
                callback: function () {
                    console.log(jQuery('#ouibounce-popup').length);
                    if (jQuery('#ouibounce-popup').length > 0) {
                        localStorage.setItem('popupSeen', new Date());
                        jQuery('#search-modal').css('display', 'none');
                        jQuery('#q-field').val('');
                        jQuery('#ouibounce-modal').show();
                        jQuery('html').css('position', 'fixed');
                        jQuery('html').css('overflow', 'hidden');
                        jQuery('html').css('touch-action', 'none');
                        jQuery('html').css('-ms-touch-action', 'none');
                        jQuery('#ouibounce-popup').css('opacity', 1);
                    }
                    //hide if any other popup is active
                }
            });
        }
    }
    jQuery('#ouibounce-popup-close-icon, .reject_link').click(function (e) {
        var count = 0;
        jQuery('.popup-container').each(function () {
            if (jQuery(this).css('display') == 'block') {
                count++;
            }
        });

        jQuery('#ouibounce-popup').animate({ opacity: 0 }, 1000, function () {
            jQuery('#ouibounce-modal').hide();
            jQuery('#ouibounce-modal').css('opacity', '1');
            if (count < 2) {
                jQuery('.page-container').css('position', 'inherit');
                jQuery('html').css('overflow-y', 'auto');
                jQuery('html').css('position', 'unset');
                jQuery('html').css('touch-action', 'auto');
                jQuery('html').css('-ms-touch-action', 'auto');
                jQuery('.sticky-header').css('position', 'fixed');

            }
            jQuery('#ouibounce-modal').remove();
        });
        e.preventDefault();
    });

    try {
        //mobile touch implementation
        var ts;
        var exitIntentShown = localStorage.getItem('exitIntentShown');
        now = new Date().getTime();
        if ((now - exitIntentShown) / (1000 * 3600 * 24) > 1) {
            jQuery(document).bind('touchstart', function (e) {
                ts = e.originalEvent.touches[0].clientY;
            });

            jQuery(document).bind('touchend', function (e) {
                var te = e.originalEvent.changedTouches[0].clientY;
                if (ts < te - 200) {
                    var exitIntentShown = localStorage.getItem('exitIntentShown');
                    now = new Date().getTime();
                    if (!exitIntentShown || (now - exitIntentShown) / (1000 * 3600 * 24) > 1) {
                        jQuery('#ouibounce-modal').css('display', 'block');
                        jQuery('html').css('position', 'fixed');
                        jQuery('html').css('overflow', 'hidden');
                        jQuery('html').css('touch-action', 'none');
                        jQuery('html').css('-ms-touch-action', 'none');
                        localStorage.setItem('exitIntentShown', new Date().getTime());
                    }
                }
            });
        }

    } catch (e) { }
}

jQuery('.subheader-links a').click(function (e) {
    if (jQuery(this).parents('.modal-small').length == 0) {
        e.preventDefault();
    }
});
jQuery('.modal-small').each(function () {
    //console.log(jQuery(this).parents('.rich-text').find('.h3').offset().top);
    jQuery(this).css('visibility', 'hidden');
    jQuery(this).css('display', 'block');
});

jQuery('.subheader-links a').hover(function () {
    if (jQuery(this).parents('.modal-small').length == 0) {
        jQuery('.modal-small').css('visibility', 'hidden');
        jQuery(this).next().css('visibility', 'visible');
        jQuery(this).next().offset({ left: jQuery(this).offset().left - 130 });
    }
}, function () { }
);
jQuery('.modal-small').hover(function () {
    jQuery(this).css('visibility', 'visible');
}, function () {
    jQuery(this).css('visibility', 'hidden');
}
);
jQuery('.modal-small svg:first-child').click(function () {
    jQuery(this).parents('.modal-small').css('visibility', 'hidden');
});

jQuery('.site-header__account.logged').click(function (e) {
    e.preventDefault();
    jQuery('.simple-dropdown.logged').css('display', 'block');
    jQuery('.dropdown-arrow.logged').css('display', 'block');
});
jQuery('.site-header__account.logged').hover(function (e) {
    jQuery('.simple-dropdown.logged').css('display', 'block');
    jQuery('.dropdown-arrow.logged').css('display', 'block');
}, function () {
    jQuery('.simple-dropdown.logged').css('display', 'none');
    jQuery('.dropdown-arrow.logged').css('display', 'none');
});
jQuery('.simple-dropdown.logged').hover(function (e) {
    jQuery('.simple-dropdown.logged').css('display', 'block');
    jQuery('.dropdown-arrow.logged').css('display', 'block');
}, function () {
    jQuery('.simple-dropdown.logged').css('display', 'none');
    jQuery('.dropdown-arrow.logged').css('display', 'none');
});
jQuery('.dropdown-arrow.logged').hover(function (e) {
    jQuery('.simple-dropdown.logged').css('display', 'block');
    jQuery('.dropdown-arrow.logged').css('display', 'block');
}, function () {
    jQuery('.simple-dropdown.logged').css('display', 'none');
    jQuery('.dropdown-arrow.logged').css('display', 'none');
});


jQuery('.login-link').click(function (e) {
    e.preventDefault();
    jQuery('#account-modal').show();
    //jQuery('.page-container').css('position', 'fixed');
    jQuery('html').css('overflow', 'hidden');
    jQuery('html').css('touch-action', 'none');
    jQuery('html').css('-ms-touch-action', 'none');
});

jQuery('.login-part-switcher').click(function () {
    jQuery('.signup-part').hide();
    jQuery('.signup-part-switcher').removeClass('active-switcher');
    jQuery('.login-part').show();
    jQuery('.login-part-switcher').addClass('active-switcher');////
});
jQuery('.signup-part-switcher').click(function () {
    jQuery('.login-part').hide();
    jQuery('.login-part-switcher').removeClass('active-switcher');
    jQuery('.signup-part').show();
    jQuery('.signup-part-switcher').addClass('active-switcher');
});

if (jQuery(window).width() > 1020) {




    jQuery('.help-menu').click(function (e) {
        //e.preventDefault();
        jQuery('.help-dropdown').css('display', 'grid');
        jQuery('.help-dropdown-arrow').css('display', 'block');
    });
    jQuery('.help-menu').hover(function (e) {
        jQuery('.help-dropdown').css('display', 'grid');
        jQuery('.help-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.help-dropdown').css('display', 'none');
        jQuery('.help-dropdown-arrow').css('display', 'none');
    });
    jQuery('.help-dropdown').hover(function (e) {
        jQuery('.help-dropdown').css('display', 'grid');
        jQuery('.help-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.help-dropdown').css('display', 'none');
        jQuery('.help-dropdown-arrow').css('display', 'none');
    });
    jQuery('.help-dropdown-arrow').hover(function (e) {
        jQuery('.help-dropdown').css('display', 'grid');
        jQuery('.help-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.help-dropdown').css('display', 'none');
        jQuery('.help-dropdown-arrow').css('display', 'none');
    });


    jQuery('.reviews-menu').click(function (e) {
        //e.preventDefault();
        jQuery('.reviews-dropdown').css('display', 'grid');
        jQuery('.reviews-dropdown-arrow').css('display', 'block');
    });
    jQuery('.reviews-menu').hover(function (e) {
        jQuery('.reviews-dropdown').css('display', 'grid');
        jQuery('.reviews-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.reviews-dropdown').css('display', 'none');
        jQuery('.reviews-dropdown-arrow').css('display', 'none');
    });
    jQuery('.reviews-dropdown').hover(function (e) {
        jQuery('.reviews-dropdown').css('display', 'grid');
        jQuery('.reviews-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.reviews-dropdown').css('display', 'none');
        jQuery('.reviews-dropdown-arrow').css('display', 'none');
    });
    jQuery('.reviews-dropdown-arrow').hover(function (e) {
        jQuery('.reviews-dropdown').css('display', 'grid');
        jQuery('.reviews-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.reviews-dropdown').css('display', 'none');
        jQuery('.reviews-dropdown-arrow').css('display', 'none');
    });


    jQuery('.stores-menu').click(function (e) {
        //e.preventDefault();
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    });
    jQuery('.stores-menu').hover(function (e) {
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.stores-dropdown').css('display', 'none');
        jQuery('.stores-dropdown-arrow').css('display', 'none');
    });
    jQuery('.stores-dropdown').hover(function (e) {
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.stores-dropdown').css('display', 'none');
        jQuery('.stores-dropdown-arrow').css('display', 'none');
    });
    jQuery('.stores-dropdown-arrow').hover(function (e) {
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.stores-dropdown').css('display', 'none');
        jQuery('.stores-dropdown-arrow').css('display', 'none');
    });

    jQuery('#mattresses-menu-opener').hover(function (e) {
        setTimeout(function () {
            if (!jQuery('.mattresses-megamenu').hasClass('opened') && jQuery('#mattresses-menu-opener').is(":hover")) {
                jQuery('.mattresses-megamenu').css('opacity', '0');
                jQuery('#mattresses-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#mattresses-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.mattresses-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.mattresses-megamenu').addClass('opened');
                jQuery('#mattresses-menu-opener').addClass('opened');
            }
        }, 10);
    }, function () {
        jQuery('#mattresses-menu-opener').removeClass('opened');
        jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.mattresses-megamenu').removeClass('opened');
        });

    });

    setInterval(function () {
        setTimeout(function () {
            if (!jQuery('.mattresses-megamenu').hasClass('opened') && jQuery('#mattresses-menu-opener').is(":hover")) {
                jQuery('.mattresses-megamenu').css('opacity', '0');
                jQuery('#mattresses-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#mattresses-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.mattresses-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.mattresses-megamenu').addClass('opened');
                jQuery('#mattresses-menu-opener').addClass('opened');
            }
        }, 10);
    }, 200);

    jQuery('#bedding-menu-opener').hover(function (e) {
        setTimeout(function () {
            if (!jQuery('.bedding-megamenu').hasClass('opened') && jQuery('#bedding-menu-opener').is(":hover")) {
                jQuery('.bedding-megamenu').css('opacity', '0');
                jQuery('#bedding-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#bedding-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.bedding-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.bedding-megamenu').addClass('opened');
                jQuery('#bedding-menu-opener').addClass('opened');
            }
        }, 10);
    }, function () {

        jQuery('#bedding-menu-opener').removeClass('opened');
        jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.bedding-megamenu').removeClass('opened');
        });
    });

    setInterval(function () {
        setTimeout(function () {
            if (!jQuery('.bedding-megamenu').hasClass('opened') && jQuery('#bedding-menu-opener').is(":hover")) {
                jQuery('.bedding-megamenu').css('opacity', '0');
                jQuery('#bedding-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#bedding-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.bedding-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.bedding-megamenu').addClass('opened');
                jQuery('#bedding-menu-opener').addClass('opened');
            }
        }, 10);
    }, 200);

    jQuery('#furniture-menu-opener').hover(function (e) {
        setTimeout(function () {
            if (!jQuery('.furniture-megamenu').hasClass('opened') && jQuery('#furniture-menu-opener').is(":hover")) {
                jQuery('.furniture-megamenu').css('opacity', '0');
                jQuery('#furniture-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#furniture-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.furniture-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.furniture-megamenu').addClass('opened');
                jQuery('#furniture-menu-opener').addClass('opened');
            }
        }, 10);
    }, function () {
        jQuery('#furniture-menu-opener').removeClass('opened');
        jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.furniture-megamenu').removeClass('opened');
        });
    });

    setInterval(function () {
        setTimeout(function () {
            if (!jQuery('.furniture-megamenu').hasClass('opened') && jQuery('#furniture-menu-opener').is(":hover")) {
                jQuery('.furniture-megamenu').css('opacity', '0');
                jQuery('#furniture-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#furniture-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.furniture-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.furniture-megamenu').addClass('opened');
                jQuery('#furniture-menu-opener').addClass('opened');
            }
        }, 10);
    }, 200);

    jQuery('#home-menu-opener').hover(function (e) {
        setTimeout(function () {
            if (!jQuery('.home-megamenu').hasClass('opened') && jQuery('#home-menu-opener').is(":hover")) {
                jQuery('.home-megamenu').css('opacity', '0');
                jQuery('#home-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#home-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.home-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.home-megamenu').addClass('opened');
                jQuery('#home-menu-opener').addClass('opened');
            }
        }, 10);
    }, function () {
        jQuery('#home-menu-opener').removeClass('opened');
        jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.home-megamenu').removeClass('opened');
        });
    });

    setInterval(function () {
        setTimeout(function () {
            if (!jQuery('.home-megamenu').hasClass('opened') && jQuery('#home-menu-opener').is(":hover")) {
                jQuery('.home-megamenu').css('opacity', '0');
                jQuery('#home-menu-opener .megamenu-opened-icon').css('opacity', '0');
                jQuery('#home-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
                jQuery('.home-megamenu').animate({ opacity: 1 }, 200);
                jQuery('.home-megamenu').addClass('opened');
                jQuery('#home-menu-opener').addClass('opened');
            }
        }, 10);
    }, 200);


}

jQuery('.mobile-nav--open').click(function () {
    jQuery('.mobile-menu-wrapper').show();
    jQuery('.site-header__mobile-nav').hide();
    jQuery('.page-container').hide();
    jQuery('.sticky-header').css('position', 'absolute');

});
jQuery('.mobile-menu-close').click(function () {
    jQuery('.mobile-menu-wrapper').hide();
    jQuery('.site-header__mobile-nav').css('display', 'flex');
    jQuery('.page-container').show();
    jQuery('.sticky-header').css('position', 'fixed');

});

jQuery('.faq-menu-title').click(function () {
    if (!jQuery(this).hasClass('active')) {
        jQuery('.faq-menu-title.active').removeClass('active');
        jQuery(this).addClass('active');
        let faqMenuIndex = jQuery(this).attr('data-faqindex');
        jQuery('.faq-menu.active').removeClass('active');
        jQuery('.faq-menu[data-faqindex="' + faqMenuIndex + '"]').addClass('active');
    }
});

jQuery('.comparison-competitors table td').each(function () {
    if (jQuery(this).text() == '+') {
        jQuery(this).text('');
        jQuery(this).append(jQuery('.table-icons svg').first().clone());
        jQuery(this).css('text-align', 'center');
    } else if (jQuery(this).text() == '-') {
        jQuery(this).text('');
        jQuery(this).append(jQuery('.table-icons svg').last().clone());
        jQuery(this).css('text-align', 'center');
    }
});

jQuery('.industry-reviews-bottom-left .iframe-hover-icon').click(function () {
    jQuery('.industry-reviews-bottom-left .iframe-hover-icon').hide();
    jQuery('.industry-reviews-bottom-left > svg').hide();
    jQuery('.industry-reviews-bottom-left h2').hide();
    jQuery('.industry-reviews-bottom-left .video-module-player').css('opacity', '1');
    jQuery('.industry-reviews-bottom-left .video-module-player iframe').css('pointer-events', 'all');
    jQuery('.industry-reviews-bottom-left .video-module-player .iframe-wrapper').css('background-image', 'none');
    jQuery('.industry-reviews-bottom-left .video-module-player .iframe-wrapper iframe').css('opacity', '1');
    jQuery('.industry-reviews-bottom-left .video-module-player .iframe-wrapper').click();
    setTimeout(function () {
        jQuery('.industry-reviews-bottom-left .video-module-player .iframe-wrapper iframe').attr('src',
            jQuery('.industry-reviews-bottom-left .video-module-player .iframe-wrapper iframe').attr('src') + '?autoplay=1');
        //console.log(jQuery('.industry-reviews-bottom-left .video-module-player .iframe-wrapper iframe').attr('src'));
    }, 1);

});

jQuery('.quotes-slide-inner .quotes-slider__video .playbutton, .quotes-slide-inner .quotes-slider__video iframe').click(function () {
    jQuery(this).parents('.quotes-slide-inner').find('.playbutton').hide();
    jQuery(this).parents('.quotes-slide-inner').find('.quotes-slider__video > svg').hide();
    jQuery(this).parents('.quotes-slide-inner').find('h2').hide();
    jQuery(this).parents('.quotes-slide-inner').find('.video-module-player').css('opacity', '1');
    jQuery(this).parents('.quotes-slide-inner').find('.video-module-player').click();
});


var previousOption;
$('#shops-state option').each(function () {
    if (this.text == previousOption) $(this).remove();
    previousOption = this.text;
});
previousOption = '';
$('#shops-city option').each(function () {
    if (this.text == previousOption) $(this).remove();
    previousOption = this.text;
});

jQuery('.shop:first-child').addClass('chosen');
$('#shops-state, #shops-city').on('change', function () {
    let state = jQuery('#shops-state').val();
    var city = jQuery('#shops-city').val();
    if (state && city) {
        jQuery('.shop').removeClass('chosen');
        jQuery('.shop[data-state="' + state + '"][data-city="' + city + '"]').addClass('chosen');

        var container = jQuery('.shops-container-bottom[data-city="' + city + '"]');
        if (container.find('.yelp-review').length == 0) {
            jQuery('.shop.chosen .map').each(function () {

                city = jQuery(this).parents('.shop').attr('data-city');

                //var request = {
                //placeId: container.find('.yelp-wrapper').attr('data-google-place-id'),
                //};

                //service = new google.maps.places.PlacesService(map);
                //service.getDetails(request, callback);

                //function callback(place, status) {
                //if (status == google.maps.places.PlacesServiceStatus.OK) {
                ////console.log(place);
                //container.find('.view-map-link').attr('href', place.url);
                //container.find('.shops-container-bottom-right-inner-bottom a').text(place.user_ratings_total + " reviews");
                var ii = 0;
                if (container.find('.yelp-wrapper').attr('data-google-place-id') != '') {
                    jQuery.ajax({
                        url: 'https://nestbedding.pythonanywhere.com/ptimes/reviews?placeid=' + container.find('.yelp-wrapper').attr('data-google-place-id'), success: function (data) {

                            jQuery.each(data, function (i, f) {
                                try {
                                    f = JSON.parse(f);
                                    if (f.rating >= 3 && f.snippet != '') {
                                        let stars = '<div class="yelp-stars">';
                                        for (let j = 1; j <= f.rating; j++) {
                                            stars += jQuery('.yelp-star').first().html();
                                        }
                                        stars += '</div>';
                                        var text = '<div data-index="' + ii + '" class="yelp-review">' +
                                            '<h4>' + f.user.name + '</h4>' +
                                            '<div class="rating">' + stars + '</div>' +
                                            '<div class="yelp-review-text" style="padding-bottom:10px;">' + f.date + '</div>' +
                                            '<div class="yelp-review-text">';
                                        if (f.snippet.length > 100) {
                                            text += f.snippet.substring(0, 100) + '<a class="hidden-review-link" style="color:inherit;cursor:pointer;">... Read more </a>'
                                                + '<span class="hidden-review" style="display:none;">' + f.snippet.substring(100)
                                                + '<a class="opened-review-link" style="color:inherit;cursor:pointer;"> Read less </a>' + '</span>';
                                        }
                                        else {
                                            text += f.snippet;
                                        }
                                        text += '</div></div>';
                                        if (ii < 5) {
                                            container.find('.yelp-wrapper').append(
                                                text
                                            );
                                        } else {
                                            container.find('.yelp-wrapper').attr('data-slide' + ii, text);
                                        }
                                        ii++;
                                    }
                                } catch (e) { }

                            });


                            container.find('.shops-container-bottom-right-inner-bottom a').text(ii + " reviews");
                            container.find('.yelp-review').first().addClass('active');
                            if (container.find('.yelp-review').length > 0) {
                                container.find('.yelp-wrapper > svg').show();
                            }
                            else {
                                container.find('.yelp-wrapper > svg').hide();
                            }
                        }
                    });
                }

                //}
            });
        }
        jQuery('.shops-container-bottom').removeClass('chosen');
        jQuery('.shops-container-bottom[data-state="' + state + '"][data-city="' + city + '"]').addClass('chosen');
    }
});


function initMap() {
    jQuery('.map').each(function () {
        const uluru = { lat: parseFloat(jQuery(this).attr('data-lat')), lng: parseFloat(jQuery(this).attr('data-long')) };
        const map = new google.maps.Map(document.getElementById(jQuery(this).attr('id')), {
            zoom: 14,
            center: uluru,
            disableDefaultUI: true,
            scrollwheel: false,
            zoomControl: true
        });
        const marker = new google.maps.Marker({
            position: uluru,
            map: map
        });
    });
}

setTimeout(function () {
    jQuery('.shop.chosen .map').each(function () {


        var city = jQuery(this).parents('.shop').attr('data-city');
        var container = jQuery('.shops-container-bottom[data-city="' + city + '"]');

        //var request = {
        //placeId: container.find('.yelp-wrapper').attr('data-google-place-id'),
        //};

        //service = new google.maps.places.PlacesService(map);
        //service.getDetails(request, callback);

        //function callback(place, status) {
        //if (status == google.maps.places.PlacesServiceStatus.OK) {
        ////console.log(place);
        //container.find('.view-map-link').attr('href', place.url);
        //container.find('.shops-container-bottom-right-inner-bottom a').text(place.user_ratings_total + " reviews");
        var ii = 0;
        if (container.find('.yelp-wrapper').attr('data-google-place-id') != '') {
            jQuery.ajax({
                url: 'https://nestbedding.pythonanywhere.com/ptimes/reviews?placeid=' + container.find('.yelp-wrapper').attr('data-google-place-id'), success: function (data) {

                    jQuery.each(data, function (i, f) {
                        try {
                            f = JSON.parse(f);
                            if (f.rating >= 3 && f.snippet != '') {
                                let stars = '<div class="yelp-stars">';
                                for (let j = 1; j <= f.rating; j++) {
                                    stars += jQuery('.yelp-star').first().html();
                                }
                                stars += '</div>';
                                var text = '<div data-index="' + ii + '" class="yelp-review">' +
                                    '<h4>' + f.user.name + '</h4>' +
                                    '<div class="rating">' + stars + '</div>' +
                                    '<div class="yelp-review-text" style="padding-bottom:10px;">' + f.date + '</div>' +
                                    '<div class="yelp-review-text">';
                                if (f.snippet.length > 100) {
                                    text += f.snippet.substring(0, 100) + '<a class="hidden-review-link" style="color:inherit;cursor:pointer;">... Read more </a>'
                                        + '<span class="hidden-review" style="display:none;">' + f.snippet.substring(100)
                                        + '<a class="opened-review-link" style="color:inherit;cursor:pointer;"> Read less </a>' + '</span>';
                                }
                                else {
                                    text += f.snippet;
                                }
                                text += '</div></div>';
                                if (ii < 5) {
                                    container.find('.yelp-wrapper').append(
                                        text
                                    );
                                } else {
                                    container.find('.yelp-wrapper').attr('data-slide' + ii, text);
                                }
                                ii++;
                            }
                        } catch (e) { }

                    });


                    container.find('.shops-container-bottom-right-inner-bottom a').text(ii + " reviews");
                    container.find('.yelp-review').first().addClass('active');
                    if (container.find('.yelp-review').length > 0) {
                        container.find('.yelp-wrapper > svg').show();
                    }
                    else {
                        container.find('.yelp-wrapper > svg').hide();
                    }
                }
            });
        }

        //}
    });
}, 100);
jQuery(document).on("click", ".hidden-review-link", function () {

    jQuery(this).hide();
    jQuery(this).parents('.yelp-review-text').find('.hidden-review').show();
});
jQuery(document).on("click", ".opened-review-link", function () {

    jQuery(this).parents('.yelp-review-text').find('.hidden-review').hide();
    jQuery(this).parents('.yelp-review-text').find('.hidden-review-link').show();
});
jQuery('.yelp-wrapper svg:first-child').click(function () {
    let actual = parseInt(jQuery(this).parents('.yelp-wrapper').find('.yelp-review.active').attr('data-index'));
    jQuery(this).parents('.yelp-wrapper').find('.yelp-review.active').removeClass('active');
    if (actual != 0) {
        jQuery(this).parents('.yelp-wrapper').find('.yelp-review[data-index="' + (actual - 1) + '"]').addClass('active');
    } else {
        jQuery(this).parents('.yelp-wrapper').find('.yelp-review[data-index="' + (parseInt(jQuery(this).parents('.yelp-wrapper').find('.yelp-review').length) - 1) + '"]').addClass('active');
    }
});

jQuery('.yelp-wrapper svg:nth-child(2)').click(function () {
    let actual = parseInt(jQuery(this).parents('.yelp-wrapper').find('.yelp-review.active').attr('data-index'));
    jQuery(this).parents('.yelp-wrapper').find('.yelp-review.active').removeClass('active');
    if (actual != (parseInt(jQuery(this).parents('.yelp-wrapper').find('.yelp-review').length) - 1)) {
        jQuery(this).parents('.yelp-wrapper').find('.yelp-review[data-index="' + (actual + 1) + '"]').addClass('active');
    } else {
        var wrapper = jQuery(this).parents('.yelp-wrapper');
        if (wrapper.attr('data-slide' + (actual + 1))) {
            wrapper.append(
                wrapper.attr('data-slide' + (actual + 1))
            );
            jQuery(this).parents('.yelp-wrapper').find('.yelp-review[data-index="' + (actual + 1) + '"]').addClass('active');
        } else {
            jQuery(this).parents('.yelp-wrapper').find('.yelp-review[data-index="0"]').addClass('active');
        }

    }
});

if (jQuery(window).width() < 800) {
    jQuery('.shop').each(function () {
        jQuery(this).find('.shop-info').after(jQuery(this).find('.map-wrapper'));
    });
    jQuery('.shops-container-bottom').each(function () {
        jQuery(this).find('.shops-container-bottom-left img').before(jQuery(this).find('.shops-container-bottom-right-inner > h3'));
        jQuery(this).find('.shops-container-bottom-left img').before(jQuery(this).find('.shops-container-bottom-right-inner > h4'));
    });
}


jQuery('.review-types span').click(function () {
    jQuery('.real-product-reviews').hide();
    jQuery('.' + jQuery(this).attr('data-review-type')).show();
    jQuery('.review-types span').removeClass('active');
    jQuery(this).addClass('active');
});



setInterval(function () {
    if (jQuery('.spr-review-header').length > 0 && jQuery('.review-customization:visible').length == 0 && jQuery('.filtered-out').length == 0) {
        jQuery('.real-product-reviews').each(function () {
            var i = 0;
            jQuery(this).find('.spr-review').each(function () {
                jQuery(this).append('<div class="review-customization">' +
                    jQuery('#icon-real-review-' + (i % 5 + 1)).html() +
                    '<div class="review-customization-col1">' +
                    '<h4>' + jQuery(this).find('.spr-review-header-byline strong:first-child').html() + '</h4>'
                    + '<span class="review-location">' + jQuery(this).find('.spr-review-header-byline strong:nth-child(2)').html() + '</span>'
                    + '</div>' +
                    '<div class="review-customization-col2">' +
                    '<div class="rating">' + jQuery(this).find('.spr-review-header-starratings').html() + '</div>'
                    + '<div class="review-date">' + jQuery(this).find('.spr-review-header-byline strong:last-child').html() + '</div>'
                    + '<h5 class="review-header">' + jQuery(this).find('.spr-review-header-title').html() + '</h5>'
                    + '<div class="review-body">' + jQuery(this).find('.spr-review-content-body').html() + '</div>'
                    + '<div class="report">'
                    + '<span>was this helpful?</span>' + '<a href="#">YES (15)</a>' + '<a href="#">NO (0)</a>'
                    + jQuery(this).find('.spr-review-footer').html() + '</div>'
                    + '</div>' + '</div>'
                );
                i++;
            });
        });
        if (jQuery('.spr-summary-actions .filters').length == 0) {
            var toAppend = '';
            if (jQuery('#all-real-reviews').length == 0) {
                var search =
                    jQuery('.free-text-search');
                jQuery('.yotpo-messages').first().prepend('<div class="search-container"></div>');
                if (jQuery(window).width() < 768) {
                    jQuery('.yotpo-messages').first().find('.search-container').prepend(search);
                } else {
                    jQuery('.yotpo-messages').first().find('.search-container').prepend(search);
                }

                toAppend = '<div><span class="filter-additional" ' +
                    'data-filter-option="Back Sleeper">Back Sleeper</span>'

                    + '<span class="filter-additional" ' +
                    'data-filter-option="Stomach Sleeper">Stomach Sleeper</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Side Sleeper">Side Sleeper</span>'
                    + '<span class="filter-additional hide-mobile" ' +
                    'data-filter-option="Combination Sleeper">Combination</span></div>'
                    + '<div><span class="filter-additional" ' +
                    'data-filter-option="Plush">Soft/Plush</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Normal">Medium</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Firm">Firm</span>'
                    + '<span class="filter-additional hide-mobile" ' +
                    'data-filter-option="Very Firm">Very Firm</span></div>';
            }
            jQuery('.spr-summary-actions').prepend('<span class="filters-heading hide-desktop">filter:</span>' + '<div class="filters">' +
                '<span class="filters-heading hide-mobile">filter:</span>'
                + toAppend
                + '<div><span class="filters-1">Most Helpful</span><span class="filters-2">Most Recent</span><span class="filters-3">Highest Rated</span><span class="filters-4">Lowest Rated</span></div>'

                + '</div>');

            if (jQuery(window).width() >= 768) {

                jQuery('.filters').append(jQuery('.yotpo-messages').first().find('.search-container'));
            }

            jQuery('.filters-1').click(function () {
                //TODO
            });


        }

    }
}, 1000);


jQuery('.breakdown-circle[data-breakdown-step-index="1"]').addClass('active');
jQuery('.breakdown-step[data-breakdown-step-index="1"]').addClass('active');
jQuery('.breakdown-circle').click(function () {
    let index = jQuery(this).attr('data-breakdown-step-index');
    jQuery(this).parents('.breakdown-grid').find('.breakdown-circle').removeClass('active');
    jQuery(this).parents('.breakdown-grid').find('.breakdown-step').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).parents('.breakdown-grid').find('.breakdown-step[data-breakdown-step-index="' + index + '"]').css('opacity', 0);
    jQuery(this).parents('.breakdown-grid').find('.breakdown-step[data-breakdown-step-index="' + index + '"]').addClass('active');
    jQuery(this).parents('.breakdown-grid').find('.breakdown-step[data-breakdown-step-index="' + index + '"]').animate({ opacity: 1 }, 500);
});

jQuery('.nest-builder-section-title > svg, .product-detail-description-right .product-detail-description-right-section-title svg, .quickbuy-popup-content-right .product-detail-description-right-section-title svg').click(function () {
    if (jQuery(this).parent().attr('data-product-id')) {
        jQuery('.' + jQuery(this).parent().attr('data-popup') + '-modal[data-product-id="' + jQuery(this).parent().attr('data-product-id') + '"]').show();
    } else {
        jQuery('.' + jQuery(this).parent().attr('data-popup') + '-modal').show();
        jQuery('#' + jQuery(this).parent().attr('data-popup') + '-modal').show();
    }

    jQuery('html').css('overflow', 'hidden');
    jQuery('html').css('touch-action', 'none');
    jQuery('html').css('-ms-touch-action', 'none');
    //jQuery('.page-container').css('position', 'fixed');
});

jQuery('.firmness-labels .first, .firmness-point.first').click(function () {
    jQuery('.firmness-switcher').addClass('first');
    jQuery('.firmness-switcher').removeClass('third');

});
jQuery('.firmness-labels .second, .firmness-point.second').click(function () {
    jQuery('.firmness-switcher').removeClass('first');
    jQuery('.firmness-switcher').removeClass('third');

});
jQuery('.firmness-labels .third, .firmness-point.third').click(function () {
    jQuery('.firmness-switcher').removeClass('first');
    jQuery('.firmness-switcher').addClass('third');

});

jQuery('.nest-builder-mobile-opener').click(function () {
    if (jQuery('.nest-builder-mobile-box').hasClass('opened')) {
        jQuery('.nest-builder-mobile-box').removeClass('opened');
    } else {
        jQuery('.nest-builder-mobile-box').addClass('opened');
    }
});

jQuery('.nest-builder-clear-filter').click(function () {
    jQuery('.nest-builder-mobile-filter.active').removeClass('active');
    jQuery('.nest-builder-mobile-box').removeClass('opened');
});
jQuery('.nest-builder-do-filter').click(function () {
    jQuery('.nest-builder-mobile-box').removeClass('opened');
});
jQuery('.nest-builder-mobile-filter').click(function () {
    if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
    } else {
        jQuery(this).addClass('active');
    }
});


jQuery('.product-specs-section-header').click(function () {
    if (jQuery(this).find('.specs-plus:visible').length > 0) {
        jQuery('.product-specs-section-header').find('.specs-minus').hide();
        jQuery('.product-specs-section-header').find('.specs-plus').show();
        jQuery('.product-specs-section').find('.product-specs-section-content').hide();
        jQuery(this).find('.specs-plus').hide();
        jQuery(this).find('.specs-plus').parents('.product-specs-section-header').find('.specs-minus').show();
        jQuery(this).find('.specs-plus').parents('.product-specs-section').find('.product-specs-section-content').show();
    } else {
        jQuery(this).find('.specs-minus').hide();
        jQuery(this).find('.specs-minus').parents('.product-specs-section-header').find('.specs-plus').show();
        jQuery(this).find('.specs-minus').parents('.product-specs-section').find('.product-specs-section-content').hide();
    }
});

jQuery('.product-detail-description-left-small:first-child').addClass('active');
jQuery('.product-detail-description-left-small').hover(function () {
    jQuery('.product-detail-description-left-small.active').removeClass('active');
    jQuery(this).addClass('active');
    jQuery('.product-detail-description-left-large').css('background-image', 'url(' + jQuery(this).attr('data-large-src') + ')');
});
var limit = 7;
if (jQuery('.product-detail-description-left-small').length > limit) {
    jQuery('.product-detail-description-slider-arrow').show();
    jQuery('.product-detail-description-left-small').hide();
    for (let i = 1; i <= limit; i++) {
        jQuery('.product-detail-description-left-small:nth-child(' + i + ')').css('display', 'inline-block');
    }
    jQuery('.product-detail-description-slider-right-arrow').attr('data-last-active', limit);
    jQuery('.product-detail-description-slider-left-arrow').attr('data-first-active', 1);

}
jQuery('.product-detail-description-slider-right-arrow').click(function () {
    if (jQuery(this).attr('data-last-active') <= limit) {
        let first = parseInt(jQuery('.product-detail-description-slider-left-arrow').attr('data-first-active'));
        let last = parseInt(jQuery('.product-detail-description-slider-right-arrow').attr('data-last-active'));
        jQuery('.product-detail-description-left-small:nth-child(' + first + ')').hide();
        jQuery('.product-detail-description-left-small:nth-child(' + (last + 1) + ')').css('display', 'inline-block');
        jQuery('.product-detail-description-slider-right-arrow').attr('data-last-active', last + 1);
        jQuery('.product-detail-description-slider-left-arrow').attr('data-first-active', first + 1);
    }
});
jQuery('.product-detail-description-slider-left-arrow').click(function () {
    if (jQuery(this).attr('data-first-active') > 1) {
        let first = parseInt(jQuery('.product-detail-description-slider-left-arrow').attr('data-first-active'));
        let last = parseInt(jQuery('.product-detail-description-slider-right-arrow').attr('data-last-active'));
        jQuery('.product-detail-description-left-small:nth-child(' + last + ')').hide();
        jQuery('.product-detail-description-left-small:nth-child(' + (first - 1) + ')').css('display', 'inline-block');
        jQuery('.product-detail-description-slider-right-arrow').attr('data-last-active', last - 1);
        jQuery('.product-detail-description-slider-left-arrow').attr('data-first-active', first - 1);
    }
});
if (jQuery('.template-product .spr-header-title').length > 0) {
    jQuery('.template-product .spr-header-title').append('<div class="product-reviews-header-middle"></div>');
    jQuery('.product-reviews-header-middle').append(jQuery('.spr-summary-actions-newreview').clone(true, true));
}


jQuery('.bed-feel').hover(function () {
    jQuery(this).find('.bed-feel-popup').css('visibility', 'visible');
}, function () {
    jQuery(this).find('.bed-feel-popup').css('visibility', 'hidden');
});

jQuery('.bed-feel-popup svg').click(function () {
    jQuery(this).parents('.bed-feel-popup').css('visibility', 'hidden');
});

jQuery('.truncated a').click(function () {
    jQuery(this).parents('.quotes-slider__text').find('.truncated').hide();
    jQuery(this).parents('.quotes-slider__text').find('.full').show();

});
jQuery('.cart-item-info-quantity-value input').change(function (e) {
    //console.log(jQuery('.cart__qty-input').val());
    jQuert('#variant-quantity').val(jQuery('.cart-item-info-quantity-value input').val());
});

jQuery('.slideshow-slides').slick({
    centerPadding: '90px',
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    adaptiveHeight: false,
    autoplay: true,
    vertical: false,
    rows: 1,
    autoplaySpeed: 10000,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    prevArrow: false,
    nextArrow: false
});



setInterval(function () {
    let current = parseInt(jQuery('.slick-current').attr('data-slidenumber'));
    if (current) {
        jQuery('.slider-button').removeClass('active');
        jQuery('.slider-button:nth-child(' + current + ')').addClass('active');
    }
}, 1000);
jQuery('.slider-button').click(function () {
    jQuery('.slideshow-slides')[0].slick.slickGoTo(parseInt(jQuery(this).attr('data-slide')) - 1);
});
jQuery('.product-card__image-wrapper, .price__vendor').click(function () {
    window.location = jQuery(this).parents('.product-card').find('.product_permalink').text();
});
jQuery('.product-link').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    //jQuery('.page-container').css('position', 'fixed');
    let productID = jQuery(this).attr('data-product-id');
    jQuery('.quickbuy-popup[data-product-id="' + productID + '"]').parents('.quickbuy-modal').show();
    //jQuery('.sticky-header-content').hide();
    //jQuery('.page-container').css('position', 'fixed');
    jQuery('html').css('overflow', 'hidden');
    jQuery('html').css('touch-action', 'none');
    jQuery('html').css('-ms-touch-action', 'none');
    /*
    //Extend - Trigger resize event when modal is opened
    var event;
    if(typeof(Event) === 'function') {
      event = new Event('resize');
    }else{
      // for IE and other old browsers
      // causes deprecation warning on modern browsers
      event = window.document.createEvent('UIEvents');
      event.initUIEvent('resize', true, false, window, 0);
    }

    window.dispatchEvent(event);
    //Extend - End Extend Code
    */
});

jQuery('.quickbuy-wrapper .quickbuy-modal').each(function () {
    jQuery('body').prepend(jQuery(this));
});


jQuery('.nest-builder-section-options span.label, .nest-builder-section-options .checkmark').click(function (e) {
    if (jQuery(this).parent().find('.checkmark').hasClass('checked')) {
        jQuery(this).parent().find('input').prop('checked', false).removeAttr('checked');
        jQuery(this).parent().find('.checkmark').removeClass('checked');
    } else {
        jQuery(this).parent().find('input').prop('checked', true);
        jQuery(this).parent().find('.checkmark').addClass('checked');
    }


});
if (jQuery('.collection-detail-product-card').length > 0) {
    jQuery('.collection-detail-product-card').each(function () {
        let chosen = [];
        chosen.push('Medium');
        chosen.push('Medium/Firm');
        let available = (jQuery(this).attr('data-filters'));
        if (available) {
            available = available.split(';');
            for (let i = 0; i < available.length; i++) {
                available[i] = available[i].trim();
            }
            let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
            if (intersection.length == 0) {
                jQuery(this).hide();
            }
        }
    });
}
if (jQuery('.collection-detail-product-card:visible').length == 0) {
    jQuery('.no-items').show();
    jQuery('.collection-detail-product-cards').css('display', 'none');
}
if (jQuery(window).width() <= 1020) {
    jQuery('#firmnessSliderMobile').change(function () {
        //console.log("clicked");
        var chosen = [];
        jQuery('.collection-detail-product-card').show();
        jQuery('.collection-detail-product-card').removeClass('hidden');
        jQuery('.no-items').hide();
        jQuery('.collection-detail-product-cards').css('display', 'grid');

        var firmness = "Medium";
        if (jQuery('#firmnessSliderMobile').val() > 30 && jQuery('#firmnessSliderMobile').val() <= 70) {
            firmness = "Medium";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        } else if (jQuery('#firmnessSliderMobile').val() >= 0 && jQuery('#firmnessSliderMobile').val() <= 30) {
            firmness = "Plush";
        } else if (jQuery('#firmnessSliderMobile').val() > 70 && jQuery('#firmnessSliderMobile').val() <= 100) {
            firmness = "Firm";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        }
        //console.log(firmness);

        chosen.push(firmness);

        jQuery('.collection-detail-product-card').each(function () {
            let available = (jQuery(this).attr('data-filters'));
            available = available.split(';');
            for (let i = 0; i < available.length; i++) {
                available[i] = available[i].trim();
            }
            let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
            if (intersection.length == 0) {
                jQuery(this).hide();
                jQuery(this).addClass('hidden');
            }
        });

        jQuery('.nest-builder-section').each(function () {
            var chosen = [];

            jQuery(this).find('.nest-builder-mobile-filter.active').each(function () {
                chosen.push(jQuery(this).text());

            });
            if (chosen.length > 0) {
                //console.log(chosen);
                jQuery('.collection-detail-product-card').each(function () {
                    let available = (jQuery(this).attr('data-filters'));
                    available = available.split(';');
                    for (let i = 0; i < available.length; i++) {
                        available[i] = available[i].trim();
                    }
                    let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                    if (intersection.length == 0) {
                        jQuery(this).hide();
                        jQuery(this).addClass('hidden');
                    }
                });
            }
        });



        jQuery('.active-filter-tile').hide();
        jQuery('.active-filter-tile').removeClass('inline-flex-important');
        var found = false;
        jQuery('.nest-builder-section').each(function () {
            if (jQuery(this).find('.nest-builder-mobile-filter.active').length > 0) {
                found = true;

                jQuery('.active-filter-tile[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section')
                    + '"]').addClass('inline-flex-important');

            }
        });
        if (jQuery('#firmnessSliderMobile').val() <= 40 || jQuery('#firmnessSliderMobile').val() > 70) {
            found = true;
            jQuery('.active-filter-tile[data-nest-builder-section="1"]').addClass('inline-flex-important');
        }
        if (found) {
            jQuery('.filters-active').addClass('visible-important');
            jQuery('.filters-active').show();
        } else {
            jQuery('.filters-active').css('visibility', 'hidden');
            jQuery('.filters-active').hide();
        }

        if (jQuery('.collection-detail-product-card:visible').length == 0) {
            jQuery('.no-items').show();
            jQuery('.collection-detail-product-cards').css('display', 'none');
        }
    });
}
if (jQuery(window).width() > 1020) {
    jQuery('.nest-builder-section-options').click(function () {
        jQuery('.collection-detail-product-card').show();
        jQuery('.no-items').hide();
        jQuery('.collection-detail-product-cards').css('display', 'grid');

        var chosen = [];

        var firmness = "Medium";
        if (jQuery('#firmnessSlider').val() > 30 && jQuery('#firmnessSlider').val() <= 70) {
            firmness = "Medium";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        } else if (jQuery('#firmnessSlider').val() >= 0 && jQuery('#firmnessSlider').val() <= 30) {
            firmness = "Plush";
        } else if (jQuery('#firmnessSlider').val() > 70 && jQuery('#firmnessSlider').val() <= 100) {
            firmness = "Firm";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        }


        chosen.push(firmness);

        jQuery('.collection-detail-product-card').each(function () {
            let available = (jQuery(this).attr('data-filters'));
            available = available.split(';');
            for (let i = 0; i < available.length; i++) {
                available[i] = available[i].trim();
            }
            let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
            if (intersection.length == 0) {
                jQuery(this).hide();
            }
        });
        jQuery('.nest-builder-section-options').each(function () {
            var chosen = [];

            jQuery(this).find('input').each(function () {
                if (jQuery(this).parent().find('.checkmark').hasClass('checked')) {
                    chosen.push(jQuery(this).val());
                }
            });
            if (chosen.length > 0) {
                jQuery('.collection-detail-product-card').each(function () {
                    let available = (jQuery(this).attr('data-filters'));
                    available = available.split(';');
                    for (let i = 0; i < available.length; i++) {
                        available[i] = available[i].trim();
                    }
                    let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                    if (intersection.length == 0) {
                        jQuery(this).hide();
                    }
                });
            }
        });
        if (jQuery('.collection-detail-product-card:visible').length == 0) {
            jQuery('.no-items').show();
            jQuery('.collection-detail-product-cards').css('display', 'none');
        }

        jQuery('.active-filter-tile').hide();
        jQuery('.active-filter-tile').removeClass('inline-flex-important');

        var found = false;
        jQuery('.nest-builder-section').each(function () {
            if (jQuery(this).find('.checked').length > 0) {
                found = true;
                jQuery('.active-filter-tile[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section')
                    + '"]').show();
            }
        });
        if (jQuery('#firmnessSlider').val() <= 40 || jQuery('#firmnessSlider').val() > 70) {
            found = true;
            jQuery('.active-filter-tile[data-nest-builder-section="1"]').show();
        }
        if (found) {
            jQuery('.filters-active').css('visibility', 'visible');
        } else {
            jQuery('.filters-active').css('visibility', 'hidden');
        }

    });
}
jQuery('.active-filter-tile').click(function () {
    if (jQuery(this).attr('data-nest-builder-section') == 1) {
        jQuery('#firmnessSlider').val(50);
        jQuery('#firmnessSliderMobile').val(50);
    }
    if (jQuery(window).width() > 1020) {
        jQuery('.nest-builder-section[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section') + '"]').find('.checked').removeClass('checked');
        jQuery('.collection-detail-product-card').show();
        jQuery('.no-items').hide();
        jQuery('.collection-detail-product-cards').css('display', 'grid');
        var chosen = [];
        var firmness = "Medium";
        if (jQuery('#firmnessSlider').val() > 30 && jQuery('#firmnessSlider').val() <= 70) {
            firmness = "Medium";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        } else if (jQuery('#firmnessSlider').val() >= 0 && jQuery('#firmnessSlider').val() <= 30) {
            firmness = "Plush";
        } else if (jQuery('#firmnessSlider').val() > 70 && jQuery('#firmnessSlider').val() <= 100) {
            firmness = "Firm";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        }



        chosen.push(firmness);

        jQuery('.collection-detail-product-card').each(function () {
            let available = (jQuery(this).attr('data-filters'));
            available = available.split(';');
            for (let i = 0; i < available.length; i++) {
                available[i] = available[i].trim();
            }
            let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
            if (intersection.length == 0) {
                jQuery(this).hide();
            }
        });

        jQuery('.nest-builder-section-options').each(function () {
            var chosen = [];

            jQuery(this).find('input').each(function () {
                if (jQuery(this).parent().find('.checkmark').hasClass('checked')) {
                    chosen.push(jQuery(this).val());
                }
            });
            if (chosen.length > 0) {
                jQuery('.collection-detail-product-card').each(function () {
                    let available = (jQuery(this).attr('data-filters'));
                    available = available.split(';');
                    for (let i = 0; i < available.length; i++) {
                        available[i] = available[i].trim();
                    }
                    let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                    //console.log(intersection);
                    if (intersection.length == 0) {
                        jQuery(this).hide();
                    }
                });
            }
        });

        if (jQuery('.collection-detail-product-card:visible').length == 0) {
            jQuery('.no-items').show();
            jQuery('.collection-detail-product-cards').css('display', 'none');
        }

        jQuery('.active-filter-tile').hide();
        var found = false;
        jQuery('.nest-builder-section').each(function () {
            if (jQuery(this).find('.checked').length > 0) {
                found = true;
                jQuery('.active-filter-tile[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section')
                    + '"]').show();
            }
        });
        if (jQuery('#firmnessSlider').val() <= 40 || jQuery('#firmnessSlider').val() > 70) {
            found = true;
            jQuery('.active-filter-tile[data-nest-builder-section="1"]').show();
        }
        if (found) {
            jQuery('.filters-active').css('visibility', 'visible');
        } else {
            jQuery('.filters-active').css('visibility', 'hidden');
        }
    }
    else {
        jQuery('.nest-builder-section[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section') + '"]').find('.nest-builder-mobile-filter.active').removeClass('active');
        var chosen = [];
        jQuery('.collection-detail-product-card').show();
        jQuery('.collection-detail-product-card').removeClass('hidden');
        jQuery('.no-items').hide();
        jQuery('.collection-detail-product-cards').css('display', 'grid');

        var firmness = "Medium";
        if (jQuery('#firmnessSliderMobile').val() > 30 && jQuery('#firmnessSliderMobile').val() <= 70) {
            firmness = "Medium";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        } else if (jQuery('#firmnessSliderMobile').val() >= 0 && jQuery('#firmnessSliderMobile').val() <= 30) {
            firmness = "Plush";
        } else if (jQuery('#firmnessSliderMobile').val() > 70 && jQuery('#firmnessSliderMobile').val() <= 100) {
            firmness = "Firm";
            chosen.push("Medium/Firm"); //Alexander Signature Flippable case
        }


        chosen.push(firmness);

        jQuery('.collection-detail-product-card').each(function () {
            let available = (jQuery(this).attr('data-filters'));
            available = available.split(';');
            for (let i = 0; i < available.length; i++) {
                available[i] = available[i].trim();
            }
            let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
            if (intersection.length == 0) {
                jQuery(this).hide();
                jQuery(this).addClass('hidden');
            }
        });

        jQuery('.nest-builder-section').each(function () {
            var chosen = [];

            jQuery(this).find('.nest-builder-mobile-filter.active').each(function () {
                chosen.push(jQuery(this).text());

            });
            if (chosen.length > 0) {
                //console.log(chosen);
                jQuery('.collection-detail-product-card').each(function () {
                    let available = (jQuery(this).attr('data-filters'));
                    available = available.split(';');
                    for (let i = 0; i < available.length; i++) {
                        available[i] = available[i].trim();
                    }
                    let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                    if (intersection.length == 0) {
                        jQuery(this).hide();
                        jQuery(this).addClass('hidden');
                    }
                });
            }
        });



        jQuery('.active-filter-tile').hide();
        jQuery('.active-filter-tile').removeClass('inline-flex-important');
        var found = false;
        jQuery('.nest-builder-section').each(function () {
            if (jQuery(this).find('.nest-builder-mobile-filter.active').length > 0) {
                found = true;

                jQuery('.active-filter-tile[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section')
                    + '"]').addClass('inline-flex-important');

            }
        });
        if (jQuery('#firmnessSliderMobile').val() <= 40 || jQuery('#firmnessSliderMobile').val() > 70) {
            found = true;
            jQuery('.active-filter-tile[data-nest-builder-section="1"]').addClass('inline-flex-important');
        }

        if (found) {
            jQuery('.filters-active').addClass('visible-important');
            jQuery('.filters-active').show();
        } else {
            jQuery('.filters-active').css('visibility', 'hidden');
            jQuery('.filters-active').hide();
        }

        if (jQuery('.collection-detail-product-card:visible').length == 0) {
            jQuery('.no-items').show();
            jQuery('.collection-detail-product-cards').css('display', 'none');
        }
    }
});

jQuery('.nest-builder-mobile-filter').click(function () {
    var chosen = [];
    jQuery('.collection-detail-product-card').show();
    jQuery('.collection-detail-product-card').removeClass('hidden');
    jQuery('.no-items').hide();
    jQuery('.collection-detail-product-cards').css('display', 'grid');

    var firmness = "Medium";
    if (jQuery('#firmnessSliderMobile').val() > 30 && jQuery('#firmnessSliderMobile').val() <= 70) {
        firmness = "Medium";
        chosen.push("Medium/Firm"); //Alexander Signature Flippable case
    } else if (jQuery('#firmnessSliderMobile').val() >= 0 && jQuery('#firmnessSliderMobile').val() <= 30) {
        firmness = "Plush";
    } else if (jQuery('#firmnessSliderMobile').val() > 70 && jQuery('#firmnessSliderMobile').val() <= 100) {
        firmness = "Firm";
        chosen.push("Medium/Firm"); //Alexander Signature Flippable case
    }


    chosen.push(firmness);

    jQuery('.collection-detail-product-card').each(function () {
        let available = (jQuery(this).attr('data-filters'));
        available = available.split(';');
        for (let i = 0; i < available.length; i++) {
            available[i] = available[i].trim();
        }
        let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
        if (intersection.length == 0) {
            jQuery(this).hide();
            jQuery(this).addClass('hidden');
        }
    });

    jQuery('.nest-builder-section').each(function () {
        var chosen = [];

        jQuery(this).find('.nest-builder-mobile-filter.active').each(function () {
            chosen.push(jQuery(this).text());

        });
        if (chosen.length > 0) {
            //console.log(chosen);
            jQuery('.collection-detail-product-card').each(function () {
                let available = (jQuery(this).attr('data-filters'));
                available = available.split(';');
                for (let i = 0; i < available.length; i++) {
                    available[i] = available[i].trim();
                }
                let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                if (intersection.length == 0) {
                    jQuery(this).hide();
                    jQuery(this).addClass('hidden');
                }
            });
        }
    });



    jQuery('.active-filter-tile').hide();
    jQuery('.active-filter-tile').removeClass('inline-flex-important');
    var found = false;
    jQuery('.nest-builder-section').each(function () {
        if (jQuery(this).find('.nest-builder-mobile-filter.active').length > 0) {
            found = true;

            jQuery('.active-filter-tile[data-nest-builder-section="' + jQuery(this).attr('data-nest-builder-section')
                + '"]').addClass('inline-flex-important');

        }
    });
    if (jQuery('#firmnessSliderMobile').val() <= 40 || jQuery('#firmnessSliderMobile').val() > 70) {
        found = true;
        jQuery('.active-filter-tile[data-nest-builder-section="1"]').addClass('inline-flex-important');
    }
    if (found) {
        jQuery('.filters-active').addClass('visible-important');
        jQuery('.filters-active').show();
    } else {
        jQuery('.filters-active').css('visibility', 'hidden');
        jQuery('.filters-active').hide();
    }

    if (jQuery('.collection-detail-product-card:visible').length == 0) {
        jQuery('.no-items').show();
        jQuery('.collection-detail-product-cards').css('display', 'none');
    }
});


jQuery('.nest-builder-left .nest-builder-section').each(function () {
    if (!jQuery(this).hasClass('show-always') && jQuery(this).find('input').length == 0) {
        jQuery(this).hide();
    }
});
jQuery('.nest-builder-mobile .nest-builder-section').each(function () {
    if (!jQuery(this).hasClass('show-always') && jQuery(this).find('.nest-builder-mobile-filter').length == 0) {
        jQuery(this).hide();
    }
});
if (jQuery(window).width() > 1020) {

    jQuery(document).scroll(function () {

        if (jQuery(document).scrollTop() + jQuery(window).height() > 110 + jQuery('.last-footer').height() + jQuery('.last-footer').offset().top) {
            // window.scrollTo(0, 60 + jQuery('.last-footer').height() + jQuery('.last-footer').offset().top - jQuery(window).height());
        }

    });
}

jQuery('.quick-buy-hover').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    let productID = jQuery(this).attr('data-product-id');
    jQuery('.quickbuy-popup[data-product-id="' + productID + '"]').parents('.quickbuy-modal').show();
    //jQuery('.sticky-header-content').hide();
    //jQuery('.page-container').css('position', 'fixed');
    jQuery('html').css('overflow', 'hidden');
    jQuery('html').css('touch-action', 'none');
    jQuery('html').css('-ms-touch-action', 'none');
    //Extend - Trigger resize event when modal is opened
    var event;
    if (typeof (Event) === 'function') {
        event = new Event('resize');
    } else {
        // for IE and other old browsers
        // causes deprecation warning on modern browsers
        event = window.document.createEvent('UIEvents');
        event.initUIEvent('resize', true, false, window, 0);
    }

    window.dispatchEvent(event);
    //Extend - End Extend Code
});
jQuery('#back-to-top').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.scrollTo({ top: 0, behavior: 'smooth' });
});
jQuery('.return-to-top-inner').hover(function () {
    jQuery('.z-icons').css('display', 'flex');
}, function () {
    jQuery('.z-icons').css('display', 'none');
});

function geotargetly_loaded() {

    let country = geotargetly_country_code();
    var user_region = geotargetly_region_code();
    var user_city = geotargetly_city_name();


    console.log("Region: " + user_region);
    console.log("City: " + user_city);

    let regions = ['CA', 'AZ', 'WA', 'NY', 'TX', 'IL', 'OH', 'MN'];
    let cities = ['Albany', 'Berkeley', 'Santa Monica', 'New York', 'Glendale',
        'Agoura Hills', 'Alhambra', 'Arcadia', 'Artesia', 'Avalon', 'Azusa', 'Baldwin Park',
        'Bell', 'Bell Gardens', 'Bellflower', 'Beverly Hills', 'Bradbury', 'Burbank',
        'Calabasas', 'Carson', 'Cerritos', 'Claremont', 'Commerce', 'Compton',
        'Covina', 'Cudahy', 'Culver City', 'Diamond Bar', 'Downey', 'Duarte', 'El Monte',
        'El Segundo', 'Gardena', 'Glendora', 'Hawaiian Gardens', 'Hawthorne', 'Hermosa Beach',
        'Hidden Hills', 'Huntington Park', 'Industry', 'Inglewood', 'Irwindale', 'La Cañada Flintridge',
        'La Habra Heights', 'La Mirada', 'La Puente', 'La Verne', 'Lakewood', 'Lancaster', 'Lawndale',
        'Lomita', 'Long Beach', 'Lynwood', 'Malibu', 'Manhattan Beach', 'Maywood',
        'Monrovia', 'Montebello', 'Monterey Park', 'Norwalk', 'Palmdale', 'Palos Verdes Estates',
        'Paramount', 'Pasadena', 'Pico Rivera', 'Pomona', 'Rancho Palos Verdes', 'Redondo Beach',
        'Rolling Hills', 'Rolling Hills Estates', 'Rosemead', 'San Dimas', 'San Fernando',
        'San Gabriel', 'San Marino', 'Santa Clarita', 'Santa Fe Springs', 'Santa Monica',
        'Sierra Madre', 'Signal Hill', 'South El Monte', 'South Gate', 'South Pasadena',
        'Temple City', 'Torrance', 'Vernon', 'Walnut', 'West Covina', 'West Hollywood',
        'Westlake Village', 'Whittier',
        'Apache Junction', 'Avondale', 'Buckeye', 'Carefree', 'Cave Creek',
        'Chandler', 'El Mirage', 'Fountain Hills', 'Gila Bend', 'Gilbert',
        'Glendale', 'Goodyear', 'Guadalupe', 'Litchfield Park', 'Mesa',
        'Paradise Valley', 'Peoria', 'Queen Creek', 'Scottsdale', 'Sun City',
        'Sun City West', 'Surprise', 'Tempe', 'Tolleson', 'Wickenburg', 'Youngtown',
        'Austin', 'Round Rock', 'Cedar Park', 'Georgetown', 'Pflugerville',
        'San Marcos', 'Leander', 'Kyle', 'Hutto', 'Brushy Creek', 'Chico',
        'San Diego', 'Austin', 'Houston', 'Chicago', 'Columbus', 'Minnetonka', 'Minneapolis', 'Tempe'];

    var lat = geotargetly_lat();
    var lng = geotargetly_lng();

    //console.log("Lat: " + lat);
    //console.log("Lng: " + lng);

    var visited = Cookies.get('shops-visit');
    var zip = Cookies.get('zip for ' + lat + ',' + lng);
    var clicked = Cookies.get('shops-click');
    console.log('ZIP:' + zip);

    if (jQuery('.shops-container-center').length > 0
        && (country == 'US' || country == 'SK')
        && (regions.includes(user_region) || country == 'SK')
        && (cities.includes(user_city) || country == 'SK')
    ) {
        try {


            if (visited != 'true') {

                Cookies.set('shops-visit', 'true', { expires: 1 });
            }
            else if (clicked != 'true') {

                let url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=AIzaSyA12ZKkbaXGPOjd9sGVvGfajI2693X2EsE';
                //    //console.log(url);
                if (!zip) {


                    jQuery.ajax({
                        url: url,
                        dataType: 'json',
                        success: function (result) {
                            var zipcode = '';
                            jQuery.each(result['results'], function (i, address) {
                                jQuery.each(address['address_components'], function (j, component) {
                                    if (component['types'].includes('postal_code')) {
                                        zipcode = component['short_name'].replaceAll(' ', '');
                                    }
                                });
                            });
                            console.log('ZIP:' + zipcode);

                            Cookies.set('zip for ' + lat + ',' + lng, "" + zipcode, { expires: 365 });
                            zipcode = "" + zipcode;

                            ga('send', 'event', 'Geolocation popup', 'Geolocation popup shown', 'GEO pop - ' + zipcode);
                            //For test
                            //zipcode = "10116";
                            jQuery('.shops-container-center > .shop').each(function () {
                                var zips = jQuery(this).attr('data-zip').split(', ');
                                if (zips.includes(zipcode)) {
                                    if (jQuery('.geolocation-popup-links a[data-city="' +
                                        jQuery(this).attr('data-city')
                                        + '"]').length == 0) {
                                        jQuery('.geolocation-popup-links').append('<a data-city="' +
                                            jQuery(this).attr('data-city')
                                            + '" href="'
                                            + jQuery(this).attr('data-detail') + '">' +
                                            jQuery(this).attr('data-city')
                                            + '</a>');
                                    }

                                }
                            });
                            if (jQuery('.geolocation-popup-links a').length != 0) {
                                setInterval(function () {
                                    if (jQuery('.cc-window').length > 0
                                        && !jQuery('.geolocation-popup').attr('data-position-changed')) {
                                        jQuery('.geolocation-popup').css('bottom', (30 + jQuery('.cc-window').outerHeight()) + 'px');
                                        jQuery('.geolocation-popup').attr('data-position-changed', true);
                                    }
                                }, 1000);
                                jQuery('.geolocation-popup').css('display', 'flex');
                            }
                            if (jQuery('.geolocation-popup-links a').length == 1) {
                                jQuery('.geolocation-popup-links a').text('See my store');
                            }
                            jQuery('.geolocation-popup-links a').click(function (e) {
                                e.preventDefault();
                                jQuery('.geolocation-popup').hide();
                                Cookies.set('shops-click', 'true', { expires: 1 });
                                window.location.href = jQuery(this).attr('href');
                            });
                        },
                        error: function (result) {
                            //console.log(result);
                        }
                    });
                } else {
                    zipcode = zip;
                    //zipcode = "10116";

                    ga('send', 'event', 'Geolocation popup', 'Geolocation popup shown', 'GEO pop - ' + zipcode);

                    jQuery('.shops-container-center > .shop').each(function () {
                        var zips = jQuery(this).attr('data-zip').split(', ');
                        if (zips.includes(zipcode)) {
                            if (jQuery('.geolocation-popup-links a[data-city="' +
                                jQuery(this).attr('data-city')
                                + '"]').length == 0) {
                                jQuery('.geolocation-popup-links').append('<a data-city="' +
                                    jQuery(this).attr('data-city')
                                    + '" href="'
                                    + jQuery(this).attr('data-detail') + '">' +
                                    jQuery(this).attr('data-city')
                                    + '</a>');
                            }

                        }
                    });
                    if (jQuery('.geolocation-popup-links a').length != 0) {
                        setInterval(function () {
                            if (jQuery('.cc-window').length > 0
                                && !jQuery('.geolocation-popup').attr('data-position-changed')) {
                                jQuery('.geolocation-popup').css('bottom', (30 + jQuery('.cc-window').outerHeight()) + 'px');
                                jQuery('.geolocation-popup').attr('data-position-changed', true);
                            }
                        }, 1000);
                        jQuery('.geolocation-popup').css('display', 'flex');
                    }
                    if (jQuery('.geolocation-popup-links a').length == 1) {
                        jQuery('.geolocation-popup-links a').text('See my store');
                    }
                    jQuery('.geolocation-popup-links a').click(function (e) {
                        e.preventDefault();
                        jQuery('.geolocation-popup').hide();
                        Cookies.set('shops-click', 'true', { expires: 1 });
                        window.location.href = jQuery(this).attr('href');
                    });
                }
            }
        } catch (e) {

        }
    }


    console.log('geotargetly loaded');


    if (jQuery('.cart-subtotal.recycling-fee').length == 0 && (country == 'US')) {
        jQuery('.recycling-fees .recycling-fee').each(function () {

            if (jQuery(this).find('.recycling-fee-code').text().trim() == user_region) {
                console.log("region :" + user_region)
                var fee = jQuery(this).find('.recycling-fee-value').text().trim();
                var feeID = jQuery(this).find('.recycling-fee-details').text().trim();


                jQuery.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    success: function (result) {
                        var feeAdded = false;
                        var feeNeeded = false;
                        var feeCount = 0;
                        var feeAddedCount = 0;
                        for (let i = 0; i < result['items'].length; i++) {

                            if (result['items'][i]['properties'] && result['items'][i]['properties']['type'] && result['items'][i]['properties']['type'] == 'fee') {
                                feeAddedCount += result['items'][i]['quantity'];
                                console.log("feeAddedCount + :" + result['items'][i]['quantity']);
                            }
                            jQuery('.recycling-fee-product').each(function () {

                                if (result['items'][i]['handle'] == jQuery(this).text().trim()) {
                                    //console.log(jQuery(this).text().trim());
                                    feeNeeded = true;
                                    feeCount += result['items'][i]['quantity'];
                                    console.log("feeCount + :" + result['items'][i]['quantity']);
                                }
                            });
                        }
                        fee = (feeCount * parseFloat(fee)).toFixed(2);
                        if (feeNeeded) {
                            var feeDiv = jQuery('.recycling-fee[data-region-code="' + user_region + '"]');
                            var feeIcon = '';
                            var feePopup = '';
                            if (feeDiv.find('.recycling-fee-text').length > 0) {
                                feeIcon = '<svg style="margin-left:15px;position:relative;top:3px;" class="fee-popup-icon" data-name="recycle fee" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">' +
                                    '<g fill="none" stroke="#384f3b" stroke-width="1">' +
                                    '<circle cx="10" cy="10" r="10" stroke="none"></circle>' +
                                    '<circle cx="10" cy="10" r="9.5" fill="none"></circle>' +
                                    '</g>' +
                                    '<text data-name="?" transform="translate(10 16)" fill="#384f3b" font-size="14" font-family="SegoeUI, Segoe UI" letter-spacing="0.05em"><tspan x="-3.138" y="0">?</tspan></text>' +
                                    '</svg>';
                                feePopup = '<div id="fee-popup"><svg class="fee-popup-close" xmlns="http://www.w3.org/2000/svg" width="14.031" height="14.031" viewBox="0 0 14.031 14.031">' +
                                    '<g transform="translate(-7670.155 3310.214)">' +
                                    '<line x1="0.812" y2="14.817" transform="translate(7682.122 -3308.724) rotate(45)" fill="none" stroke="#384f3b" stroke-linecap="round" stroke-width="2"/>' +
                                    '<line x1="0.812" y1="14.817" transform="translate(7682.696 -3298.247) rotate(135)" fill="none" stroke="#384f3b" stroke-linecap="round" stroke-width="2"/>' +
                                    '</g>' +
                                    '</svg>' +
                                    '<div class="fee-popup-title">Mattress Recycling Fee</div>' +
                                    '<div class="fee-popup-content">' + feeDiv.find('.recycling-fee-text').html() + '</div></div>';

                            }
                            jQuery('<div class="cart-subtotal recycling-fee" style="position: relative;">' + feePopup +
                                '<span class="cart-subtotal__title" data-open-accessibility-text-original="18px" style="font-size: 18px;">MRC Fee' + feeIcon + '</span>' +
                                '<span class="cart-subtotal__price" data-cart-subtotal="" data-open-accessibility-text-original="18px" style="font-size: 18px;"><b>$' + fee + '</b></span>' +
                                '</div>').insertBefore('.cart-subtotal.total');
                            if (feeDiv.find('.recycling-fee-text').length > 0) {
                                jQuery('.fee-popup-icon').click(function () {
                                    jQuery('#fee-popup').show();
                                });
                                jQuery('.fee-popup-close').click(function () {
                                    jQuery('#fee-popup').hide();
                                });
                            }
                        }
                        console.log(fee);
                        console.log(feeAddedCount);
                        console.log(feeCount);
                        console.log(feeNeeded);
                        if (feeAddedCount != feeCount && feeNeeded) {

                            console.log('Fee needed');
                            var updated_total = result['total_price'] + parseInt(fee.replace('.', '').replace(',', ''));
                            jQuery.ajax({
                                url: '/cart/update.js',
                                data: { note: 'Recycling Fee: $' + fee },
                                dataType: 'json',
                                success: function (complete_result) {
                                    console.log("note added to customer");
                                    console.log(complete_result);
                                }
                            });

                            if (feeCount > feeAddedCount) {
                                console.log("feeCount larger");
                                jQuery.ajax({
                                    url: '/cart/add.js',
                                    data: {
                                        items: [
                                            {
                                                quantity: feeCount - feeAddedCount,
                                                id: feeID,
                                                properties: {
                                                    type: 'fee'
                                                }
                                            }
                                        ]
                                    },
                                    dataType: 'json',
                                    success: function (complete_result) {

                                        console.log("cart added with fee item");
                                        console.log(complete_result);
                                        UpdateCart();
                                    }
                                });
                            } else {
                                console.log("feeAddedCount larger");
                                jQuery.ajax({
                                    method: "POST",
                                    url: '/cart/change.js',
                                    data:
                                    {
                                        quantity: feeCount,
                                        id: feeID

                                    }
                                    ,
                                    dataType: 'json',
                                    success: function (complete_result) {
                                        console.log("cart changed");
                                        console.log(complete_result);
                                        UpdateCart();
                                    }
                                });
                            }

                        }
                    }
                });
            }
        });
    }
}
function checkDiscount(variantID, variantPrice, result, i) {
    var result_ = result;
    jQuery.ajax({
        url: '/products/' + result['items'][i]['handle'] + '.js',
        dataType: 'json',
        success: function (result) {
            var comparePrice = null;
            for (let j = 0; j < result['variants'].length; j++) {
                if (variantID == result['variants'][j]['id']) {
                    comparePrice = result['variants'][j]['compare_at_price'];
                }
            }
            if (comparePrice && comparePrice > variantPrice) {
                comparePrice *= result_['items'][i]['quantity'];
                variantPrice *= result_['items'][i]['quantity'];
                let discount = comparePrice - variantPrice;
                let savings = 0;
                if (jQuery('.cart-modal').attr('data-savings')) {
                    savings = parseInt(jQuery('.cart-modal').attr('data-savings'));
                }
                jQuery('.cart-modal').attr('data-savings', savings + discount);
                //console.log(jQuery('.order-discount-card-wrapper').length);
                if (jQuery('.order-discount-card-wrapper').length == 0) {

                    let html = '<div data-cart-discount-wrapper="">' +
                        '<div class="order-discount-card-wrapper" data-cart-discount=""><span class="order-discount order-discount--title order-discount--cart" data-open-accessibility-text-original="18px" style="font-size: 18px;">' +
                        '<span class="visually-hidden" data-open-accessibility-text-original="18px" style="font-size: 18px;"></span><span data-cart-discount-title="" data-open-accessibility-text-original="18px" style="font-size: 18px;">Total Savings:' +
                        '</span>' +
                        '</span>' +
                        '<span class="order-discount order-discount--cart order-discount--cart-total" data-open-accessibility-text-original="18px" style="font-size: 18px;">' +
                        '-<span data-cart-discount-amount="" data-open-accessibility-text-original="18px" style="font-size: 18px;">' +
                        '$' + parseFloat((savings + discount) / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + '</span>' +
                        '</span></div>' +
                        '</div>';
                    jQuery(html).insertBefore(jQuery('.subtotal').first());
                } else {
                    jQuery('.order-discount--cart-total').html(
                        '$' + parseFloat((savings + discount) / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    );
                }

                jQuery('.cart-item[data-product-id="' + variantID
                    + '"][data-line="' + (i + 1)
                    + '"]').addClass('discounted');
                jQuery('.cart-item[data-product-id="' + variantID
                    + '"][data-line="' + (i + 1)
                    + '"] .cart-item-info-price').html('<span style="color:#E26F37;">' +
                        '$' + parseFloat(variantPrice / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) +
                        '</span>&nbsp;<s>' +
                        '$' + parseFloat(comparePrice / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) +
                        '</s>');
            }
        }
    });
}
setInterval(function () {
    jQuery('.cart-item').each(function () {
        if (jQuery(this).find('.cart-item-info-price s').length > 0) {
            jQuery(this).addClass('discounted');
        }
    });
}, 1000);
function UpdateCart() {
    if (document.getElementById('alertContainer') != null)
        document.getElementById("alertContainer").innerHTML = "Added to Cart";
    jQuery('.cart-modal').attr('data-savings', '');
    var item_count = 0;
    var productsWithRenewals = [];
    var renewalIndeces = [];
    var renewals = [];
    var renewalSize = [];
    var renewalQty = [];

    jQuery('.cart-spinner').removeClass('hide');
    jQuery.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function (result) {
            jQuery('.cart-modal').attr('data-cart', JSON.stringify(result));
            item_count = 0;
            var fee = 0;
            var singleFee = 0;
            var feeNeeded = false;
            var feeCount = 0;
            var feeAddedCount = 0;
            var fee_variant_id = 0;
            var fee_variant_found = false;
            for (let i = 0; i < result['items'].length; i++) {
                if (result['items'][i]['properties'] &&
                    result['items'][i]['properties']['type'] == 'fee') {
                    fee += result['items'][i]['final_price'];
                    singleFee = result['items'][i]['final_price'];
                    feeAddedCount += result['items'][i]['quantity'];
                    fee_variant_found = true;
                    fee_variant_id = result['items'][i]['variant_id'];
                }
                else if (result['items'][i]['product_type'] == 'Renewal Exchange') {
                    for (let k = 0; k < result['items'][i]['quantity']; k++) {
                        renewals.push(
                            jQuery('.renewal-exchange-product[data-renewal="' + result['items'][i]['handle'] + '"]').first().html()
                        );
                        renewalSize.push(
                            jQuery('.renewal-exchange-product[data-renewal="' + result['items'][i]['handle'] + '"]').first().attr('data-size')
                        );
                        renewalIndeces.push(i);
                        renewalQty.push(result['items'][i]['quantity']);
                        let productWithRenewal =
                            jQuery('.renewal-exchange-product[data-renewal="' + result['items'][i]['handle'] + '"]').first().attr('data-product');
                        productsWithRenewals.push(productWithRenewal);
                    }
                } else {
                    item_count += result['items'][i]['quantity'];
                }
                //if(!feeNeeded){

                jQuery('.recycling-fee-product').each(function () {
                    if (result['items'][i]['handle'] == jQuery(this).text().trim()) {
                        //console.log(result['items'][i]['handle']);
                        feeNeeded = true;
                        feeCount += result['items'][i]['quantity'];
                    }
                });
                //}
            }
            fee = fee * feeCount;
            if (feeCount == 0) {
                jQuery('.cart-subtotal.recycling-fee').remove();
            } else {
                jQuery('.cart-subtotal.recycling-fee .cart-subtotal__price b').text('$' + parseFloat(fee / 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }));

            }
            if (fee_variant_found == true) {
                jQuery('.cart__row[data-variant-id="' + fee_variant_id + '"]').find('.cart__final-price > div > span').text('$' + parseFloat(fee / 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }));
            }
            console.log("update cart feecount")
            console.log(feeCount);
            console.log(feeAddedCount);
            console.log(fee);
            if ((feeCount != feeAddedCount && fee > 0) || (feeCount < feeAddedCount && fee == 0)) {
                console.log('Fee not needed');


                for (let i = 0; i < result['items'].length; i++) {
                    if (result['items'][i]['properties'] &&
                        result['items'][i]['properties']['type'] == 'fee') {
                        //console.log(result['items'][i]);
                        var feeId = result['items'][i]['id'];
                        //console.log("fee id: " + feeId);
                        //console.log("count: " + feeCount);
                        /*
                        jQuery.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        data: {
                            updates: {
                                feeId: feeCount
                            }
                        },
                        dataType: 'json',
                            success: function (complete_result) {
                            //console.log(complete_result);
                            }
                        });
                        */
                        /*
                        jQuery.ajax({
                        url: '/cart/change?line=' + (i + 1) + '&quantity=' + feeCount,
                        type: "POST",
                        data: {"id": result['items'][i]['id'], "quantity": feeCount },
                        success: function(result_deletion){
                            //console.log(result_deletion);
                            }
                        }).always(function() {
                        jQuery('.cart-modal').removeClass('ajax-active');
                        });
                        */
                        jQuery.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: { quantity: feeCount, id: feeId },
                            dataType: 'json',
                            success: function (result) {
                                //console.log(result);
                            }
                        });
                    }
                }

            }

            if (feeCount == 0) {
                fee = 0;
                jQuery.ajax({
                    url: '/cart/update.js',
                    data: { note: '' },
                    dataType: 'json',
                    success: function (complete_result) {
                        //console.log(complete_result);
                    }
                });
            }

            let totalPrice = result['total_price'] - (feeAddedCount - feeCount) * singleFee;

            jQuery('.cart-modal').attr('itemsCount', item_count);
            jQuery('.cart-modal').attr('itemsTotalPrice', result['original_total_price']);
            jQuery('.site-header__cart-count').removeClass('hide');
            jQuery('#CartCount span').text(item_count);
            jQuery('.subtotal .cart-total__price').text('$' + parseFloat(totalPrice / 100).toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
            var subtotal = result['original_total_price'];
            if (fee > 0) {
                subtotal -= fee;
            }
            jQuery('.subtotal .cart-subtotal__price').text('$' + parseFloat(subtotal / 100).toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));

            jQuery('#shopify-section-cart-template .cart-subtotal .cart-subtotal__price').text('$' + parseFloat(totalPrice / 100).toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + ' USD');
            jQuery('.cart-modal .cart-items-grid').remove();
            if (result['total_discount'] && result['total_discount'] > 0) {

                jQuery('.order-discount-card-wrapper').remove();

                if (result['total_discount'] && result['total_discount'] > 0) {
                    var discountNames = [];
                    for (let i = 0; i < result['items'].length; i++) {
                        if (result['items'][i]['discounts'].length > 0) {
                            for (let j = 0; j < result['items'][i]['discounts'].length; j++) {
                                if (!discountNames.includes(result['items'][i]['discounts'][j]['title'])) {
                                    discountNames.push(result['items'][i]['discounts'][j]['title']);
                                }
                            }
                        }
                    }
                    let discount = result['total_discount'];
                    let savings = 0;
                    if (jQuery('.cart-modal').attr('data-savings')) {
                        savings = parseInt(jQuery('.cart-modal').attr('data-savings'));
                    }
                    /*
                    jQuery('.cart-modal').attr('data-savings', savings + discount);

                  let html = '<div data-cart-discount-wrapper="">' +
                          '<div class="order-discount-card-wrapper" data-cart-discount=""><span class="order-discount order-discount--title order-discount--cart" data-open-accessibility-text-original="18px" style="font-size: 18px;">' +
                          '<span class="visually-hidden" data-open-accessibility-text-original="18px" style="font-size: 18px;"></span><span data-cart-discount-title="" data-open-accessibility-text-original="18px" style="font-size: 18px;">Total Savings:' +
                          '</span>' +
                                '</span>' +
                                '<span class="order-discount order-discount--cart order-discount--cart-total" data-open-accessibility-text-original="18px" style="font-size: 18px;">' +
                                '-<span data-cart-discount-amount="" data-open-accessibility-text-original="18px" style="font-size: 18px;">' +
                                '$' + parseFloat(result['total_discount']/100).toLocaleString("en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + '</span>' +
                                '</span></div>' +
                          '</div>';
                  jQuery(html).insertBefore( jQuery('.subtotal').first() );*/

                }
            }

            if (item_count == 0) {
                jQuery('.cart-modal .empty-page-content').removeClass('hide');
                jQuery('.cart-modal form').addClass('hide');
                jQuery('.cart-modal .cart-pay-options-infos').addClass('hide');
                jQuery('.cart-modal .cart-pay-options-buttons').addClass('hide');
                jQuery('.cart-modal .cart-modal-bottom').addClass('hide');
            }
            if (item_count > 0) {
                jQuery('.cart-modal .empty-page-content').addClass('hide');
                jQuery('.cart-modal form').removeClass('hide');
                jQuery('.cart-modal .cart-pay-options-infos').removeClass('hide');
                jQuery('.cart-modal .cart-pay-options-buttons').removeClass('hide');
                jQuery('.cart-modal .cart-modal-bottom').removeClass('hide');
                jQuery('.cart-modal form').prepend(
                    '<div class="cart-items-grid"></div>'
                );
            }
            for (let i = 0; i < result['items'].length; i++) {
                if (result['items'][i]['properties'] &&
                    result['items'][i]['properties']['type'] == 'fee') {
                    continue;
                }
                let renewalHtml = '';
                let renewalDeletionUrl = '';
                let renewalQtySingle = '';
                for (let j = 0; j < productsWithRenewals.length; j++) {

                    if (jQuery(".renewal-exchange-product[data-size='" + result['items'][i]['variant_options'][0] + "'][data-product='" + result['items'][i]['handle'] + "']").length > 0) {
                        jQuery(".renewal-exchange-product[data-size='" + result['items'][i]['variant_options'][0] + "'][data-product='" + result['items'][i]['handle'] + "']").first().find('.cart-item-qty').text(result['items'][i]['quantity']);
                        renewalHtml = jQuery(".renewal-exchange-product[data-size='" + result['items'][i]['variant_options'][0] + "'][data-product='" + result['items'][i]['handle'] + "']").first().html()
                            + jQuery('.renewal-popup-container').first().html();
                        renewalDeletionUrl = ' data-renewal-remove-url="/cart/change?line=' + (renewalIndeces[j] + 1) + '&amp;quantity="';
                        renewalQtySingle = ' data-renewal-qty="' + renewalQty[j] + '"';

                    }
                }

                var variantID = result['items'][i]['id'];
                var variantPrice = result['items'][i]['final_price'];
                checkDiscount(variantID, variantPrice, result, i);
                let variants = '';
                for (let j = 0; j < result['items'][i]['options_with_values'].length; j++) {
                    if (result['items'][i]['options_with_values'][j]['name'] != 'Title') {
                        variants += '<li>' + result['items'][i]['options_with_values'][j]['name']
                            + ': ' + result['items'][i]['options_with_values'][j]['value'] + '</li>';
                    }
                }
                if (result['items'][i]['product_title'].includes('Extend Protection Plan')
                    && result['items'][i]['properties']['Term']) {
                    variants += '<li>' +
                        result['items'][i]['properties']['Term'].substr(0, result['items'][i]['properties']['Term'].indexOf('-'))
                        + '</li>';
                }
                console.log(result['items'][i]);
                var priceI = '<div class="cart-item-info-price">' +
                    '$' + parseFloat(result['items'][i]['price'] / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) +
                    '</div>';

                if (result['items'][i]['discounted_price'] < result['items'][i]['original_price']) {
                    priceI = '<div class="cart-item-info-price">' +
                        '<span style="color:#E26F37;">' +
                        '$' + parseFloat(result['items'][i]['discounted_price'] / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) +
                        '</span>&nbsp;<s>' +
                        '$' + parseFloat(result['items'][i]['original_price'] / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) +
                        '</s>' +
                        '</div>';


                }


                if (result['items'][i]['product_type'] == 'Renewal Exchange') {
                    continue;
                }
                jQuery('.cart__row[data-variant-id="' + result['items'][i]['variant_id'] + '"]').find('.cart__final-price > div > span').text('$' + parseFloat(result['items'][i]['final_line_price'] / 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }));
                var productID = result['items'][i]['product_id'];
                var datasize = '';
                if (result['items'][i]['variant_options'].length > 0) {
                    datasize = 'data-size="' + result['items'][i]['variant_options'][0] + '"';
                }
                jQuery('.cart-modal .cart-items-grid').append(
                    '<div class="cart-item" '
                    + datasize
                    + 'data-line="' + (i + 1) + '" data-true-product-id="' + result['items'][i]['product_id'] + '" data-product-id="' + result['items'][i]['id'] + '"><div class="cart__image" style="background-image:url(' + result['items'][i]['image']
                    + ')" alt="Cart image" data-cart-item-image=""></div>'
                    + '<div class="cart-item-info">'
                    + '<a href="' + document.location.origin + result['items'][i]['url'] + '" class="cart__product-title" data-cart-item-title="">'
                    + result['items'][i]['product_title'] +
                    '</a>' +
                    '<ul>' +
                    variants +

                    '</ul>' +

                    '<div class="cart-item-info-bottom">' +

                    '<div class="cart-item-info-quantity" data-remove-url="/cart/change?line=' + (i + 1) + '&amp;quantity="' + renewalDeletionUrl + renewalQtySingle + '>' +

                    '<svg class="cart-item-trash" style="cursor:pointer;" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712z"/></svg>' +
                    '<span class="cart-item-info-quantity-plus">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">' +
                    '<g transform="translate(-1711 -240)">' +
                    '<g transform="translate(1711 240)" fill="none" stroke="#384f3b" stroke-width="1">' +
                    '<circle cx="10" cy="10" r="10" stroke="none"></circle>' +
                    '<circle cx="10" cy="10" r="9.5" fill="none"></circle>' +
                    '</g>' +
                    '<g transform="translate(-0.5 -1)">' +
                    '<line x2="10" transform="translate(1716.5 251)" fill="none" stroke="#384f3b" stroke-linecap="round" stroke-width="1"></line>' +
                    '<line x2="10" transform="translate(1721.5 246) rotate(90)" fill="none" stroke="#384f3b" stroke-linecap="round" stroke-width="1"></line>' +
                    '</g>' +
                    '</g>' +
                    '</svg>' +

                    '</span>' +

                    '<span class="cart-item-info-quantity-value">' +
                    '<input id="updates_' + result['items'][i]['key'] + '" class="cart__qty-input" type="text" value="' +
                    result['items'][i]['quantity'] +
                    '" data-quantity-input="" data-quantity-item="' + result['items'][i]['quantity'] +
                    '" data-quantity-input-mobile="">' +
                    '</span>' +
                    '<span class="cart-item-info-quantity-minus">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">' +
                    '<g transform="translate(-1642 -240)">' +
                    '<g transform="translate(1642 240)" fill="none" stroke="#384f3b" stroke-width="1">' +
                    '<circle cx="10" cy="10" r="10" stroke="none"></circle>' +
                    '<circle cx="10" cy="10" r="9.5" fill="none"></circle>' +
                    '</g>' +
                    '<line x2="9" transform="translate(1647.5 250.5)" fill="none" stroke="#384f3b" stroke-linecap="round" stroke-width="1"></line>' +
                    '</g>' +
                    '</svg>' +

                    '</span>' +
                    '</div>' +
                    priceI +
                    '</div>' + renewalHtml +
                    '</div>' +

                    '</div>'
                );
            }
            jQuery('.renewal-popup-icon').click(function () {
                jQuery(this).parents('.renewal-exchange-card-line-item').find('.renewal-popup').show();
            });
            jQuery('.renewal-popup-close').click(function () {
                jQuery(this).parents('.renewal-popup').hide();
            });



            jQuery('.cart-item-info-quantity-plus').click(function () {
                if (!jQuery('.cart-modal').hasClass('ajax-active')) {
                    jQuery('.cart-modal').addClass('ajax-active');
                    jQuery('.cart-spinner').removeClass('hide');

                    var updates = new Object();
                    var variantid = jQuery(this).parents('.cart-item').attr('data-product-id');
                    var productid = jQuery(this).parents('.cart-item').attr('data-true-product-id');
                    var variantsize = jQuery(this).parents('.cart-item').attr('data-size');
                    var quantity = parseInt(jQuery(this).parents('.cart-item-info-quantity').find('.cart-item-info-quantity-value input').val());
                    updates[variantid] = quantity + 1;
                    jQuery(this).parents('.cart-item-info-quantity').find('.cart-item-info-quantity-value input').val(quantity + 1);


                    if (jQuery(this).parents('.cart-item-info-quantity').attr('data-renewal-remove-url')) {
                        // add renewal pair
                        jQuery('.renewal-exchange-product').each(function () {
                            console.log(jQuery(this).attr('data-product-id'));
                            console.log(jQuery(this).attr('data-size'));
                            if (jQuery(this).attr('data-product-id') == productid
                                && jQuery(this).attr('data-size') == variantsize) {
                                updates[jQuery(this).attr('data-renewal-variant-id')] = quantity + 1;
                            }
                        });
                    }
                    // add protection pair
                    if (jQuery(this).parents('.cart-item').next()
                        && jQuery(this).parents('.cart-item').next().hasClass('indented')) {
                        variantid = jQuery(this).parents('.cart-item').next().attr('data-product-id');
                        quantity = parseInt(jQuery(this).parents('.cart-item').next().find('.cart-item-info-quantity-value input').val());
                        updates[variantid] = quantity + 1;
                        jQuery(this).parents('.cart-item').next().find('.cart-item-info-quantity-value input').val(quantity + 1);

                    }
                    jQuery.ajax({
                        url: '/cart/update.js',
                        data: { updates: updates },
                        dataType: 'json',
                        success: function () { UpdateCart(); geotargetly_loaded(); }
                    }).always(function () {
                        jQuery('.cart-modal').removeClass('ajax-active');
                    });
                    jQuery('.cart-modal').removeClass('lre-checked');
                }
            });

            /*
                      jQuery('.cart-item-info-quantity-plus').click(function(){
                        if(!jQuery('.cart-modal').hasClass('ajax-active')){
                            jQuery('.cart-modal').addClass('ajax-active');
                            jQuery('.cart-spinner').removeClass('hide');
                            let quantity = jQuery(this).parents('.cart-item-info-quantity').find('.cart-item-info-quantity-value input');
                            quantity.val(parseInt(quantity.val()) + 1);


                           var removeUrl = jQuery(this).parents('.cart-item').find('.cart-item-info-quantity').attr('data-remove-url');
                            if(jQuery(this).parents('.cart-item-info-quantity').attr('data-renewal-remove-url')){
                                var dataRenewalQty = parseInt(jQuery(this).parents('.cart-item').find('.cart-item-info-quantity').attr('data-renewal-qty'));
                                jQuery.ajax({
                                    url: jQuery(this).parents('.cart-item-info-quantity').attr('data-renewal-remove-url') + (dataRenewalQty+1),
                                    success: function(result){
                                        jQuery.ajax({
                                            url: removeUrl + quantity.val(),
                                            success: function(){ UpdateCart(); geotargetly_loaded(); }
                                        }).always(function() {
                                            jQuery('.cart-modal').removeClass('ajax-active');
                                        });
                                    }, error: function(){
                                    jQuery('.cart-modal').removeClass('ajax-active');

                                    }
                                });
                            } else{
                                jQuery.ajax({
                                    url: removeUrl + quantity.val(),
                                    success: function(){ UpdateCart(); geotargetly_loaded(); }
                                }).always(function() {
                                    jQuery('.cart-modal').removeClass('ajax-active');
                                });
                            }






                          jQuery('.cart-modal').removeClass('lre-checked');
                        }
                      });
            */
            jQuery('.cart-item').each(function () {
                if (jQuery(this).find('.cart-item-info > a').text().includes('Extend Protection')) {
                    //console.log(jQuery(this).find('.cart-item-info > a').text());

                    jQuery(this).addClass('indented');
                    jQuery(this).prev().addClass('before-indented');
                    jQuery(this).next().addClass('after-indented');
                }
            });
            jQuery('.cart-item-trash').click(function () {
                if (!jQuery('.cart-modal').hasClass('ajax-active')) {
                    jQuery('.cart-modal').addClass('ajax-active');
                    jQuery('.cart-spinner').removeClass('hide');


                    var updates = new Object();
                    var variantid = jQuery(this).parents('.cart-item').attr('data-product-id');
                    var productid = jQuery(this).parents('.cart-item').attr('data-true-product-id');
                    var variantsize = jQuery(this).parents('.cart-item').attr('data-size');
                    let quantity = parseInt(jQuery(this).parents('.cart-item-info-quantity').find('.cart-item-info-quantity-value input').val());
                    updates[variantid] = 0;
                    if (jQuery(this).parents('.cart-item-info-quantity').attr('data-renewal-remove-url')) {
                        // add renewal pair
                        jQuery('.renewal-exchange-product').each(function () {
                            if (jQuery(this).attr('data-product-id') == productid
                                && jQuery(this).attr('data-size') == variantsize) {
                                updates[jQuery(this).attr('data-renewal-variant-id')] = 0;
                            }
                        });
                    }
                    // add protection pair
                    if (jQuery(this).parents('.cart-item').next()
                        && jQuery(this).parents('.cart-item').next().hasClass('indented')) {
                        variantid = jQuery(this).parents('.cart-item').next().attr('data-product-id');
                        updates[variantid] = 0;
                    }
                    jQuery.ajax({
                        url: '/cart/update.js',
                        data: { updates: updates },
                        dataType: 'json',
                        success: function () { UpdateCart(); geotargetly_loaded(); }
                    }).always(function () {
                        jQuery('.cart-modal').removeClass('ajax-active');
                    });

                    jQuery('.cart-modal').removeClass('lre-checked');
                }
            });
            jQuery('.cart-item-info-quantity-minus').click(function () {
                if (!jQuery('.cart-modal').hasClass('ajax-active')) {
                    jQuery('.cart-modal').addClass('ajax-active');
                    jQuery('.cart-spinner').removeClass('hide');

                    var updates = new Object();
                    var variantid = jQuery(this).parents('.cart-item').attr('data-product-id');
                    var productid = jQuery(this).parents('.cart-item').attr('data-true-product-id');
                    var variantsize = jQuery(this).parents('.cart-item').attr('data-size');
                    var quantity = parseInt(jQuery(this).parents('.cart-item-info-quantity').find('.cart-item-info-quantity-value input').val());
                    updates[variantid] = quantity - 1;
                    if (quantity > 0) {
                        jQuery(this).parents('.cart-item-info-quantity').find('.cart-item-info-quantity-value input').val(quantity - 1);
                    }
                    if (quantity == 0) {
                        jQuery(this).parents('.cart-item').hide();
                    }

                    if (jQuery(this).parents('.cart-item-info-quantity').attr('data-renewal-remove-url')) {
                        // add renewal pair
                        jQuery('.renewal-exchange-product').each(function () {
                            console.log(jQuery(this).attr('data-product-id'));
                            console.log(jQuery(this).attr('data-size'));
                            if (jQuery(this).attr('data-product-id') == productid
                                && jQuery(this).attr('data-size') == variantsize) {
                                updates[jQuery(this).attr('data-renewal-variant-id')] = quantity - 1;
                            }
                        });
                    }
                    // add protection pair
                    if (jQuery(this).parents('.cart-item').next()
                        && jQuery(this).parents('.cart-item').next().hasClass('indented')) {
                        variantid = jQuery(this).parents('.cart-item').next().attr('data-product-id');
                        quantity = parseInt(jQuery(this).parents('.cart-item').next().find('.cart-item-info-quantity-value input').val());
                        updates[variantid] = quantity - 1;
                        if (quantity > 0) {
                            jQuery(this).parents('.cart-item').next().find('.cart-item-info-quantity-value input').val(quantity - 1);
                        }
                        if (quantity == 0) {
                            jQuery(this).parents('.cart-item').next().hide();
                        }
                    }
                    jQuery.ajax({
                        url: '/cart/update.js',
                        data: { updates: updates },
                        dataType: 'json',
                        success: function () { UpdateCart(); geotargetly_loaded(); }
                    }).always(function () {
                        jQuery('.cart-modal').removeClass('ajax-active');
                    });
                    jQuery('.cart-modal').removeClass('lre-checked');
                }
            });

            jQuery('.cart-spinner').addClass('hide');
        }

    });



}
UpdateCart();

jQuery('.quickbuy-popup .fake-submit').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    jQuery('.cart-spinner').removeClass('hide');
    var selectedOptions = '';
    var selectedID = '';
    var available = true;

    var so = '';
    jQuery(this).parents('.quickbuy-popup').find('form select, .form select').each(function () {
        if (jQuery(this).val() != '') {
            selectedOptions += '_' + jQuery(this).val() + '_';
        }
        so += jQuery(this).val() + ',';

    });

    jQuery(this).parents('.quickbuy-popup').find('.variant .unavailable').each(function () {
        let name = jQuery(this).attr('data-unavailable-options');
        if (name == so) {

            available = false;
        }
    });
    console.log(selectedOptions);
    var selectedPrice = 0;
    jQuery(this).parents('.quickbuy-popup').find('form .variants-codes .variant-code, .form .variants-codes .variant-code').each(function () {
        console.log(jQuery(this).find('.variant-code-options').text().trim());
        if (jQuery(this).find('.variant-code-options').text().trim() == selectedOptions) {
            selectedID = jQuery(this).find('.variant-code-code').text();
            selectedPrice = parseFloat(jQuery(this).find('.variant-code-price').text()) / 100;
        }
    });
    jQuery('.cart-spinner').removeClass('hide');
    if (selectedID == '') {
        selectedID = jQuery(this).parents('.quickbuy-popup').find('form input[name="id"], .form input[name="id"]').val();
    }

    //Extend - handleAddToCart for modal Page
    var quantity = jQuery(this).parents('.quickbuy-popup').find('input[name="quantity"]').val();
    var extendOffer = jQuery(this).parents('.quickbuy-popup').find('#extend-offer')[0];

    var selectedRenewalLength = 0;
    var selectedRenewal = '';
    jQuery(this).parents('.quickbuy-popup').find('.renewal').each(function () {
        if (selectedOptions.includes(jQuery(this).attr('data-size')) &&
            jQuery(this).attr('data-size').length > selectedRenewalLength) {
            selectedRenewal = jQuery(this).attr('data-renewal');
            selectedRenewalLength = jQuery(this).attr('data-size').length;
        }
    });
    if (available && selectedRenewal != '') {
        jQuery.ajax({
            url: '/cart/add?id=' + selectedRenewal + '&quantity=' + quantity,
            dataType: 'json',
            success: function (result) {
                ExtendShopify.handleAddToCart(extendOffer, {
                    quantity: quantity,
                    modal: true,
                    done: function () {
                        jQuery.ajax({
                            url: '/cart/add?id=' + selectedID + '&quantity=' + quantity,
                            dataType: 'json',
                            success: function (result) {
                                UpdateCart();
                                geotargetly_loaded();
                            }
                        });
                    },
                });
                //Extend - End Extend Code
            }
        });
    } else if (available) {
        ExtendShopify.handleAddToCart(extendOffer, {
            quantity: quantity,
            modal: true,
            done: function () {
                jQuery.ajax({
                    url: '/cart/add?id=' + selectedID + '&quantity=' + quantity,
                    dataType: 'json',
                    success: function (result) {
                        UpdateCart();
                        geotargetly_loaded();
                    }
                });
            },
        });
        //Extend - End Extend Code
    }


    if (available) {
        selectedPrice *= jQuery(this).parents('.quickbuy-popup').find('form .variant-quantity, .form .variant-quantity').val();

        jQuery('body').append(
            '<noscript>' +
            '<img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?tid=2612612057241&event=AddToCart&ed[value]=' +
            selectedPrice +
            '&ed[order_quantity]=' + jQuery(this).parents('.quickbuy-popup').find('form .variant-quantity, .form .variant-quantity').val() +
            '&noscript=1" />' +
            '</noscript>'
        );
        jQuery('body').append(
            '<img class="not-lazy-load" src=\'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=signup&value={"af_revenue":"' + selectedPrice
            + '"}&pixid=2a021f25-740e-4b3c-966b-61fa86219a3c\' width="1" height="1" border="0">'
        );
        jQuery(this).addClass('animate__animated');
        jQuery(this).addClass('animate__zoomIn');
        var originalText = jQuery(this).text();
        var originalElem = jQuery(this);
        jQuery(this).text('ADDED');
        setTimeout(function () {
            originalElem.text(originalText);
        }, 3000);
        jQuery(this).parents('.quickbuy-modal').hide();
        jQuery('.sticky-header').css('visibility', 'visible');
        jQuery('.sticky-header-content').show();
        jQuery('.page-container').css('position', 'inherit');
        jQuery('html').css('overflow-y', 'auto');
        jQuery('html').css('touch-action', 'auto');
        jQuery('html').css('-ms-touch-action', 'auto');
        jQuery('.sticky-header').css('position', 'fixed');

    } else {
        jQuery('.cart-spinner').removeClass('hide');
    }
});

jQuery('.product-detail-description-right .product-form-inner button').click(function (e) {
    if (jQuery(this).parents('.related-product-outer').length == 0 && jQuery(this).parents('.popup.quickbuy-popup').length == 0) {
        e.preventDefault();
        e.stopPropagation();
        var selectedOptions = '';
        var selectedID = '';
        var available = true;
        var so = '';
        jQuery(this).parents('form').find('.product-form-main select').each(function () {
            if (jQuery(this).val() != '') {
                selectedOptions += '_' + jQuery(this).val() + '_';
            }
            so += jQuery(this).val() + ',';

        });

        jQuery(this).parents('form').find('.product-form-main .variant .unavailable').each(function () {
            let name = jQuery(this).attr('data-unavailable-options');
            if (name == so) {
                available = false;
            }
        });

        //console.log(selectedOptions);
        //console.log(available);


        var selectedPrice = 0;

        jQuery(this).parents('form').find('.product-form-main .variants-codes .variant-code').each(function () {
            if (jQuery(this).find('.variant-code-options').text().trim() == selectedOptions) {
                selectedID = jQuery(this).find('.variant-code-code').text();
                selectedPrice = parseFloat(jQuery(this).find('.variant-code-price').text()) / 100;
            }
        });
        jQuery('.cart-spinner').removeClass('hide');
        if (selectedID == '') {
            selectedID = jQuery(this).parents('form').find('.product-form-main input[name="id"]').val();
        }
        selectedPrice *= jQuery(this).parents('form').find('.product-form-main input[name="quantity"]').val();

        jQuery('body').append(
            '<noscript>' +
            '<img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?tid=2612612057241&event=AddToCart&ed[value]=' +
            selectedPrice +
            '&ed[order_quantity]=' + jQuery(this).parents('form').find('.product-form-main input[name="quantity"]').val() +
            '&noscript=1" />' +
            '</noscript>'
        );
        jQuery('body').append(
            '<img class="not-lazy-load" src=\'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=signup&value={"af_revenue":"' + selectedPrice
            + '"}&pixid=2a021f25-740e-4b3c-966b-61fa86219a3c\' width="1" height="1" border="0">'
        );
        var selectedRenewalLength = 0;
        var selectedRenewal = '';
        jQuery(this).parents('form').find('.product-form-main .renewal').each(function () {
            if (selectedOptions.includes(jQuery(this).attr('data-size')) &&
                jQuery(this).attr('data-size').length > selectedRenewalLength) {
                selectedRenewal = jQuery(this).attr('data-renewal');
                selectedRenewalLength = jQuery(this).attr('data-size').length;
            }
        });
        var extendOffer = jQuery(this).parents('form').find('#extend-offer')[0];
        //console.log(available);
        if (available && selectedRenewal != '') {
            var quantity = jQuery(this).parents('form').find('.product-form-main input[name="quantity"]').val();

            jQuery.ajax({
                url: '/cart/add?id=' + selectedRenewal + '&quantity=' + quantity,
                dataType: 'json',
                success: function (result) {

                    //Extend - handleAddToCart for PDP Page
                    ExtendShopify.handleAddToCart(extendOffer, {
                        quantity: quantity,
                        modal: true,
                        done: function () {
                            jQuery.ajax({
                                url: '/cart/add?id=' + selectedID + '&quantity=' + quantity,
                                dataType: 'json',
                                success: function (result) {
                                    UpdateCart();
                                    geotargetly_loaded();
                                }
                            });
                        },
                    });
                    //Extend - End Extend Code
                }
            });
        } else if (available) {

            //Extend - handleAddToCart for PDP Page
            var quantity = jQuery(this).parents('form').find('.product-form-main input[name="quantity"]').val();
            ExtendShopify.handleAddToCart(extendOffer, {
                quantity: quantity,
                modal: true,
                done: function () {
                    jQuery.ajax({
                        url: '/cart/add?id=' + selectedID + '&quantity=' + quantity,
                        dataType: 'json',
                        success: function (result) {
                            UpdateCart();
                            geotargetly_loaded();
                        }
                    });
                },
            });
            //Extend - End Extend Code
        }


        if (available) {
            jQuery(this).addClass('animate__animated');
            jQuery(this).addClass('animate__zoomIn');
            var originalText = jQuery(this).find('span:first-child()').text();
            var originalElem = jQuery(this).find('span:first-child()');
            jQuery(this).find('span:first-child()').text('ADDED');
            setTimeout(function () {
                originalElem.text(originalText);
            }, 3000);
        } else {
            jQuery('.cart-spinner').addClass('hide');

        }
    }
});
jQuery('.related-product-right button').click(function (e) {

    e.preventDefault();
    e.stopPropagation();
    if (jQuery(this).parents('.related-product-outer').find('.quickbuy-modal').length > 0) {

        jQuery(this).parents('.related-product-outer').find('.quickbuy-modal').show();
        //jQuery('.sticky-header-content').hide();
        //jQuery('.page-container').css('position', 'fixed');
        jQuery('html').css('overflow', 'hidden');
        jQuery('html').css('touch-action', 'none');
        jQuery('html').css('-ms-touch-action', 'none');
    }
    else {
        jQuery('.cart-spinner').removeClass('hide');
        pintrk('track', 'AddToCart', {
            value: jQuery(this).parents('form').find('.related-product-price').text().substring(1),
            order_quantity: 1,
            currency: 'USD'
        });
        jQuery('body').append(
            '<noscript>' +
            '<img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?tid=2612612057241&event=AddToCart&ed[value]=' +
            jQuery(this).parents('form').find('.related-product-price').text().substring(1) +
            '&ed[order_quantity]=1&noscript=1" />' +
            '</noscript>'
        );
        jQuery('body').append(
            '<img class="not-lazy-load" src=\'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=signup&value={"af_revenue":"' + jQuery(this).parents('form').find('.related-product-price').text().substring(1)
            + '"}&pixid=2a021f25-740e-4b3c-966b-61fa86219a3c\' width="1" height="1" border="0">'
        );
        var selectedRenewalLength = 0;
        var selectedRenewal = '';
        jQuery(this).parents('form').find('.renewal').each(function () {
            if (selectedOptions.includes(jQuery(this).attr('data-size') + '_') &&
                jQuery(this).attr('data-size').length > selectedRenewalLength) {
                selectedRenewal = jQuery(this).attr('data-renewal');
                selectedRenewalLength = jQuery(this).attr('data-size').length;
            }
        });

        if (selectedRenewal != '') {
            jQuery.ajax({
                url: '/cart/add?id=' + selectedRenewal + '&quantity=1',
                dataType: 'json',
                success: function (result) {
                    jQuery.ajax({
                        url: '/cart/add?id=' + jQuery(this).parents('form').find('input[name="id"]').val() + '&quantity=1',
                        dataType: 'json',
                        success: function (result) {
                            UpdateCart();
                            jQuery('.cart-modal').removeClass('lre-checked');
                            geotargetly_loaded();
                        }
                    });
                }
            });
        } else {
            jQuery.ajax({
                url: '/cart/add?id=' + jQuery(this).parents('form').find('input[name="id"]').val() + '&quantity=1',
                dataType: 'json',
                success: function (result) {
                    UpdateCart();
                    jQuery('.cart-modal').removeClass('lre-checked');
                    geotargetly_loaded();
                }
            });
        }
        jQuery(this).addClass('animate__animated');
        jQuery(this).addClass('animate__zoomIn');
        var originalText = jQuery(this).text();
        var originalElem = jQuery(this);
        jQuery(this).text('ADDED');
        setTimeout(function () {
            originalElem.text(originalText);
        }, 3000);
    }
});
jQuery('.cart__submit').click(function (e) {
    var cartTotalValue = parseInt(jQuery('.cart-modal').attr('itemsTotalPrice')) / 100;
    var cartQuantity = jQuery('.cart-modal').attr('itemsCount');
    var cartProductIDs = [];
    jQuery('.cart-modal .cart-item').each(function () {
        cartProductIDs.push(jQuery(this).attr('data-product-id'));
    })

    pintrk('track', 'checkout', {
        value: cartTotalValue,
        order_quantity: cartQuantity,
        currency: 'USD',
        product_ids: cartProductIDs
    }
    );
    jQuery('body').append(
        '<noscript>' +
        '<img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?tid=2612612057241&event=checkout&ed[value]=' +
        cartTotalValue +
        '&ed[order_quantity]=' + cartQuantity +
        '&noscript=1" />' +
        '</noscript>'
    );
    gtag('event', 'conversion', {
        'send_to': 'AW-995145454/NeYBCOz4o-oBEO7twtoD',
        'value': cartTotalValue,
        'currency': 'USD',
        'transaction_id': ''
    });
});

jQuery(document).click(function (event) {
    var $target = jQuery(event.target);
    if ($target.hasClass('popup-container')) {
        $target.hide();
        jQuery('.page-container').css('position', 'inherit');
        jQuery('html').css('overflow-y', 'auto');
        jQuery('html').css('touch-action', 'auto');
        jQuery('html').css('-ms-touch-action', 'auto');
        jQuery('.sticky-header').css('position', 'fixed');

    }
});



// Iterate over each select element
$('.product-detail-description-right .product-form-inner select').each(function () {
    if (jQuery(this).parents('.quickbuy-popup').length == 0) {

        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        // Hides the select element
        $this.addClass('s-hidden');

        // Wrap the select element in a div
        $this.wrap('<div class="select"></div>');

        // If select has only one option add class to disable it
        var addClass = '';
        if (numberOfOptions == 1) { addClass = " singleOption"; }

        // Insert a styled div to sit over the top of the hidden select element
        $this.after('<div tabindex="0" class="styledSelect' + addClass + '"></div>');

        // Cache the styled div
        var $styledSelect = $this.next('div.styledSelect');

        // Show the first select option in the styled div
        var price = '';
        var compare = '';
        jQuery(this).parents('form').find('.product-form-main .variants .variant').each(function () {
            if (jQuery(this).find('.variant-option').text() == $this.children('option').eq(0).text()) {
                price = jQuery(this).find('.variant-price').text();
                compare = jQuery(this).find('.variant-compare').text();
                return false;
            }
        });
        let html = '';
        if (compare == '') {
            html = '<span class="option-flex"><span>' + $this.children('option').eq(0).text() + '</span>' +
                '<span class="option-price option-second">' + price + '</span></span>';
        } else {
            html = '<span class="option-flex"><span>' + $this.children('option').eq(0).text() + '</span>' +
                '<span class="option-second"><s style="margin-right:15px">' + compare + '</s><span class="option-sale">' + price + '</span>' +
                '</span></span>';
        }
        $styledSelect.append(html);

        // Insert an unordered list after the styled div and also cache the list
        var $list = $('<ul />', {
            'class': 'options'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            var price = '';
            var compare = '';
            jQuery(this).parents('form').find('.product-form-main .variants .variant').each(function () {
                if (jQuery(this).find('.variant-option').text() == $this.children('option').eq(i).text() && !jQuery(this).find('.variant-price').hasClass("unavailable")) {
                    price = jQuery(this).find('.variant-price').text();
                    compare = jQuery(this).find('.variant-compare').text();
                    return false;
                }
            });
            let html = '';
            if (compare == '') {
                html = '<li tabindex="0" class="option-flex" rel="' + $this.children('option').eq(i).text() + '">' +
                    '<span class="option-size">' + $this.children('option').eq(i).text() + '</span>' +
                    '<span class="option-price option-second">' + price + '</span>' +
                    '</li>';
            } else {
                html = '<li tabindex="0" class="option-flex" rel="' + $this.children('option').eq(i).text() + '">' +
                    '<span class="option-size">' + $this.children('option').eq(i).text() + '</span>' +
                    '<span class="option-second"><s style="margin-right:15px">' + compare + '</s><span class="option-sale">' + price + '</span>' +
                    '</span></li>';
            }
            $list.append(html);

        }

        // Cache the list items
        var $listItems = $list.children('li');

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.click(function (e) {

            if ($(e.target).hasClass('unavailable-link')) {
                return;
            }
            console.log("test");
            e.stopPropagation();
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active').next('ul.options').hide();
            });
            $(this).toggleClass('active').next('ul.options').toggle();
        });
        $styledSelect.keypress(function (e) {
            if ($(e.target).hasClass('unavailable-link')) {
                return;
            }
            if (e.which == '13') {
                e.stopPropagation();
                $('div.styledSelect.active').each(function () {
                    $(this).removeClass('active').next('ul.options').hide();
                });
                $(this).toggleClass('active').next('ul.options').toggle();
            }
        });
        var clickedByCode = false;
        const hideShowOnVariantChange = function () {
            // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
            // Updates the select element to have the value of the equivalent option
            var thisSelect = jQuery('.product-detail-description-right .product-form-inner .product-form-main .select').first();
            var thisValue = thisSelect.find('select').val();
            var imageChange = false;
            jQuery('.product-detail-description-right .product-form-inner .product-form-main .select').each(function () {
                var toHide = !jQuery(this).is(thisSelect);
                jQuery(this).find('.option-flex').each(function () {
                    var thisOption = jQuery(this);
                    if (toHide) {
                        thisOption.hide();
                    }

                    jQuery(this).parents('form').find('.product-form-main .variants-codes .variant-code').each(function () {

                        if (jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisOption.find('.option-size').text() + '_')
                            && jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisValue + '_')) {
                            thisOption.show();
                            var selectedOptions = 0;
                            var compared = jQuery(this).find('.variant-code-options').text().trim();
                            if (compared.includes('_' + thisValue + '_')) {
                                selectedOptions++;
                                jQuery(this).parents('form').find('.product-form-main .styledSelect').each(function () {
                                    if (!jQuery(this).is(thisSelect.find('.styledSelect'))) {
                                        if (compared.includes('_' + jQuery(this).find('.option-flex span:first-child()').text() + '_'))
                                            selectedOptions++;
                                    }
                                });
                            }


                            if (selectedOptions == jQuery(this).parents('form').find('.product-form-main .styledSelect').length
                                && jQuery(this).find('.variant-code-image').text() != '') {
                                //alert("line 13109 image change triggered");
                                //  jQuery('.product-detail-description-left-large').css('background-image',
                                // 'url(' + jQuery(this).find('.variant-code-image').text() + ')');
                                imageChange = true;
                            } else if (!imageChange) {
                                // alert("line 13115 image change triggered");
                                //   jQuery('.product-detail-description-left-large').css('background-image',
                                //'url(' + jQuery('.product-detail-description-left-slider-slider .product-detail-description-left-small:first').attr('data-large-src') + ')');
                            }

                            if (thisOption.find('.option-sale').text() != '' &&
                                selectedOptions == jQuery(this).parents('form').find('.product-form-main .styledSelect').length) {
                                thisOption.find('.option-sale').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }));
                                thisOption.find('s').text('$' + parseFloat(jQuery(this).find('.variant-code-oldprice').text() / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }));
                            }

                            if (thisOption.find('.option-price').text() != '' &&
                                selectedOptions == jQuery(this).parents('form').find('.product-form-main .styledSelect').length) {
                                //console.log(jQuery(this).find('.variant-code-options').text());
                                thisOption.find('.option-price').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }));


                                if (thisOption.parents('.select').find('.styledSelect .option-flex span:first-child()').text() == thisOption.find('.option-size').text()) {
                                    thisOption.parents('.select').find('.styledSelect .option-flex .option-price').text(thisOption.find('.option-price').text());
                                }
                            }
                        }
                    });
                });
                // Original logic for adjusting displayed option
                var found = false;
                var firstToSelect = null;
                var $currentSelect = jQuery(this);
                var text = $currentSelect.find('.styledSelect .option-flex > span:first-child').text();
                $currentSelect.find('.options .option-flex').each(function () {
                    if(jQuery(this).css('display') != 'none' && !firstToSelect) {
                        firstToSelect = jQuery(this)
                    }
                    if (jQuery(this).find('.option-size').text() == text && jQuery(this).css('display') != 'none') {
                        found = true;
                    }
                });
                if(clickedByCode) {
                    clickedByCode = false;
                } else if (!found) {
                    $currentSelect.find('.styledSelect .option-flex').remove();
                    clickedByCode = true;
                    firstToSelect.click();
                }               

            });
        };

        var handleVariantChange = function () {
            hideShowOnVariantChange();

            if (jQuery('.variant .unavailable').length > 0) {
                jQuery('.variant .unavailable').each(function () {
                    var name = jQuery(this).parent().find('.variant-option').text();
                    var removeItems = [name, ''];
                    var options = jQuery(this).attr('data-unavailable-options').split(',').filter(item => !removeItems.includes(item));

                    jQuery(this).parents('.product-detail-description-right, .quickbuy-popup-content-right')
                        .find('.option-flex').each(function () {
                            var container = jQuery(this).parents('.product-detail-description-right, .quickbuy-popup-content-right');
                            if (jQuery(this).find('.unavailable-link').length == 0
                                && jQuery(this).find('span').first().text() == name) {
                                var valid = true;
                                var first = true;
                                container.find('.styledSelect .option-flex').each(function () {
                                    if (!first) {
                                        if (!options.includes(jQuery(this).find('span').first().text())
                                            &&
                                            !(container.hasClass('product-detail-description-right')
                                                && jQuery(this).parents('.quickbuy-popup-content-right').length > 0)
                                        ) {
                                            valid = false;
                                        }
                                    } else {
                                        first = false;
                                    }

                                });


                                if (valid) {
                                    console.log(valid);
                                    if (jQuery(this).find('.option-sale:visible').length == 0
                                        || jQuery(this).find('.option-sale').text() == '$0.00'
                                    ) {
                                        jQuery(this).parents('.styledSelect').css('pointer-events', 'all');
                                        jQuery(this).find('.option-second').html('<a href="#" class="unavailable-link">Notify Me</a><s style="margin-right:15px;display:none;">$0.00</s><span style="display:none;" class="option-sale">$0.00</span>');
                                        jQuery(this).addClass('klaviyo-bis-trigger');
                                    }
                                }

                            }
                        });
                });


                jQuery('.unavailable-link').click(function (e) {
                    console.log('clack')
                    /*
                    e.preventDefault();
                    e.stopPropagation();*/
                    let rel = jQuery(this).parents('.option-flex').attr('rel');

                    if (!rel) {

                        rel = jQuery(this).parents('.option-flex').find('span:first-child()').text().trim();

                    }
                    e.preventDefault();
                    e.stopPropagation();

                    jQuery('html').attr('data-klaviyo', rel);


                    jQuery('.options li[rel="' + rel + '"]').click();


                    if (jQuery('.btn.klaviyo-bis-trigger').length)
                        jQuery('.btn.klaviyo-bis-trigger')[0].click();
                    if (jQuery(this).closest('li').length) {
                        jQuery(this).closest('li').click();
                    }

                    jQuery('html').css('overflow', 'hidden');
                    jQuery('html').css('touch-action', 'none');
                    jQuery('html').css('-ms-touch-action', 'none');
                    jQuery('html').css('-webkit-touch-action', 'none');
                    jQuery('html').addClass('klaviyo-shown');
                    jQuery('#klaviyo-bis-iframe').css('visibility', 'hidden');
                    console.log('click')
                    setTimeout(function () {
                        jQuery('#klaviyo-bis-iframe').css('visibility', 'visible');
                    }, 1000);

                });
                jQuery('.quickbuy-popup-content-right').each(function () {
                    if (jQuery(this).find('.styledSelect .option-flex .unavailable-link').length > 0) {
                        jQuery(this).find('.product-form__cart-submit').attr('aria-disabled', 'true');
                        jQuery(this).find('.product-form__cart-submit').attr('aria-label', 'Sold out');
                        jQuery(this).find('.addtocart-text').text(' Sold out ');
                    }

                    else
                        if (jQuery(this).find('.styledSelect .option-flex').length > 0
                            && jQuery(this).find('.product-form__cart-submit[aria-disabled="true"]').length > 0) {
                            jQuery(this).find('.product-form__cart-submit').removeAttr('aria-disabled');
                            jQuery(this).find('.product-form__cart-submit').attr('aria-label', 'Add to cart');
                            jQuery(this).find('.addtocart-text').text(' Add to cart ');
                        }

                });
                jQuery('.product-detail-description-right .product-form-main').each(function () {
                    if (jQuery(this).find('.styledSelect .option-flex .unavailable-link').length > 0) {
                        jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').attr('aria-disabled', 'true');
                        jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').attr('aria-label', 'Sold out');
                        jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-text').text(' Sold out ');
                        jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-subtext').hide();
                    }

                    else

                        if (jQuery(this).find('.styledSelect .option-flex').length > 0
                            && jQuery(this).parents('.product-detail-description-right').find('.main-product-btn[aria-disabled="true"]').length > 0) {
                            jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').removeAttr('aria-disabled');
                            jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').attr('aria-label', 'Add to cart');
                            jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-text').text(' Add to cart ');
                            jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-subtext').show();
                        }

                });
            }
        }

        setInterval(function () {
            if (jQuery('#klaviyo-bis-iframe').css('display') == 'none' && jQuery('html').hasClass('klaviyo-shown')) {
                jQuery('html').removeClass('klaviyo-shown');
                jQuery('html').css('overflow-y', 'auto');
                jQuery('html').css('touch-action', 'auto');
                jQuery('html').css('-webkit-touch-action', 'auto');
                jQuery('html').css('-ms-touch-action', 'auto');
            }
        }, 500);

        // TODO change to trigger after stuff was loaded once we figure out when
        setTimeout(handleVariantChange, 1000);

        // ---------------------------------------------------------------------------
        // Function to update the UL pricing/availability based on variant codes
        // ---------------------------------------------------------------------------
        function updateVariantPricingInUL() {
            // Get the currently selected color from the color select's styled display
            var selectedColor = jQuery('select#product-detail-feel-chooser-1')
                .siblings('.styledSelect')
                .find('.option-flex span:first-child')
                .text()
                .trim();

            // Process the size select options (assumed id "product-detail-size-chooser-0")
            jQuery('select#product-detail-size-chooser-0').each(function () {
                var $select = jQuery(this);
                var $styledSelect = $select.siblings('.styledSelect');

                // Loop through each list item (the options in the UL)
                $styledSelect
                    .siblings('ul.options')
                    .find('li.option-flex')
                    .each(function () {
                        var $option = jQuery(this);
                        var optionText = $option.find('.option-size').text().trim();
                        var $optionSecond = $option.find('.option-second');

                        // Loop through variant codes to find a match for this size and the current color
                        var matchedVariant = null;
                        $select
                            .closest('form')
                            .find('.product-form-main .variants-codes .variant-code')
                            .each(function () {
                                var variantCode = jQuery(this);
                                var variantText = variantCode.find('.variant-code-options').text().trim();
                                if (
                                    variantText.indexOf('_' + optionText + '_') > -1 &&
                                    variantText.indexOf('_' + selectedColor + '_') > -1
                                ) {
                                    matchedVariant = variantCode;
                                    return false;
                                }
                            });

                        // If a matching variant is found, update the pricing/availability for this UL option.
                        if (matchedVariant) {
                            var inventory =
                                parseInt(
                                    matchedVariant.find('.variant-code-code').attr('data-inventory-quantity'),
                                    10
                                ) || 0;
                            var inventoryPolicy = matchedVariant
                                .find('.variant-code-code')
                                .attr('data-inventory-policy');
                            var price = parseFloat(matchedVariant.find('.variant-code-price').text()) / 100;
                            var oldPrice = parseFloat(matchedVariant.find('.variant-code-oldprice').text()) / 100;

                            // Build the pricing HTML
                            var pricingHtml = "";
                            if (inventory > 0 || inventoryPolicy === "continue") {
                                if (!isNaN(oldPrice) && oldPrice > 0) {
                                    pricingHtml =
                                        `<s style="margin-right:15px">$${oldPrice.toFixed(2)}</s>` +
                                        `<span class="option-sale">$${price.toFixed(2)}</span>`;
                                } else {
                                    pricingHtml = `<span class="option-price">$${price.toFixed(2)}</span>`;
                                }
                                $option.removeClass("klaviyo-bis-trigger");
                            } else {
                                pricingHtml = `<a href="#" class="unavailable-link">Notify Me</a>`;
                                $option.addClass("klaviyo-bis-trigger");
                            }
                            $optionSecond.html(pricingHtml);
                        }
                    });
            });
        }

        // ---------------------------------------------------------------------------
        // Function to update the styledSelect display based on the currently selected UL option
        // ---------------------------------------------------------------------------
        function updateStyledSelectDisplay() {
            var $sizeSelect = jQuery('select#product-detail-size-chooser-0');
            var $styledSelect = $sizeSelect.siblings('.styledSelect');

            // Use the value from the hidden select to determine the selected option.
            var selectedValue = $sizeSelect.val();
            // Find the matching list item in the UL
            var $li = $styledSelect.siblings('ul.options').find('li.option-flex[rel="' + selectedValue + '"]');

            if ($li.length > 0) {
                // Check if the li has the "klaviyo-bis-trigger" class.
                var isKlaviyo = $li.hasClass("klaviyo-bis-trigger");

                // Build the span element, adding the class and rel attribute if needed.
                var html = '<span class="option-flex' + (isKlaviyo ? ' klaviyo-bis-trigger' : '') + '"'
                    + (isKlaviyo ? ' rel="' + selectedValue + '"' : '') + '>'
                    + $li.html() + '</span>';

                // Replace any existing option-flex span.
                $styledSelect.find('.option-flex').remove();
                $styledSelect.append(html);
            }
        }

        // ---------------------------------------------------------------------------
        // Main click/keypress event handler for the option list ($listItems)
        // ---------------------------------------------------------------------------
        $listItems.on('click keypress', function (e) {
            if (e.type === 'keypress' && e.which !== 13) {
                return;
            }
            if ($(e.target).hasClass('unavailable-link')) {
                return;
            }
            var thisSelect = jQuery(this).parents('.select');
            var thisValue = jQuery(this).find('.option-size').text();
            var imageChange = false;

            // Process each select container in the form
            jQuery(this)
                .parents('form')
                .find('.product-form-main .select')
                .each(function () {
                    var $currentSelect = jQuery(this);
                    $currentSelect.find('.option-flex').each(function () {
                        var thisOption = jQuery(this);
                        // -------------------------------------------------------------------
                        // Variant-code loop: update pricing/availability for the current option
                        // -------------------------------------------------------------------
                        jQuery(this)
                            .parents('form')
                            .find('.product-form-main .variants-codes .variant-code')
                            .each(function () {
                                var variantCode = jQuery(this);
                                var variantText = variantCode.find('.variant-code-options').text().trim();
                                var optionSizeText = thisOption.find('.option-size').text().trim();

                                // Proceed only if optionSizeText exists and the variant text contains both the current option text and the clicked value.
                                if (
                                    optionSizeText &&
                                    variantText.indexOf('_' + optionSizeText + '_') > -1 &&
                                    variantText.indexOf('_' + thisValue + '_') > -1
                                ) {
                                    var inventory =
                                        parseInt(
                                            variantCode.find('.variant-code-code').attr('data-inventory-quantity'),
                                            10
                                        ) || 0;
                                    var inventoryPolicy = variantCode
                                        .find('.variant-code-code')
                                        .attr('data-inventory-policy');
                                    var price = parseFloat(variantCode.find('.variant-code-price').text()) / 100;
                                    var oldPrice = parseFloat(variantCode.find('.variant-code-oldprice').text()) / 100;
                                    var optionSecond = thisOption.find('.option-second');
                                    // Remove any lingering "Notify Me" link and pricing elements
                                    optionSecond.find('a.unavailable-link, .option-sale, s, .option-price').remove();

                                    // Determine the select id of the current option
                                    var selectId = thisOption
                                        .parents('.select')
                                        .find('.product-detail-option-select')
                                        .attr('id');

                                    // Process for the size select only
                                    if (selectId === 'product-detail-size-chooser-0') {
                                        var isSelectedSize =
                                            thisOption.hasClass('selected') ||
                                            thisOption
                                                .closest('.styledSelect')
                                                .find('.option-flex span:first-child')
                                                .text()
                                                .trim() === optionSizeText;

                                        if (isSelectedSize || !thisOption.hasClass('color-options')) {
                                            var pricingHtml = "";
                                            if (inventory > 0 || inventoryPolicy === "continue") {
                                                if (!isNaN(oldPrice) && oldPrice > 0) {
                                                    pricingHtml =
                                                        `<s style="margin-right:15px">$${oldPrice.toFixed(2)}</s>` +
                                                        `<span class="option-sale">$${price.toFixed(2)}</span>`;
                                                } else {
                                                    pricingHtml = `<span class="option-price">$${price.toFixed(2)}</span>`;
                                                }
                                                thisOption.removeClass('klaviyo-bis-trigger');
                                            } else {
                                                pricingHtml = `<a href="#" class="unavailable-link">Notify Me</a>`;
                                                e.preventDefault();
                                                e.stopPropagation();
                                                thisOption.addClass('klaviyo-bis-trigger');
                                            }
                                            optionSecond.html(pricingHtml);
                                        }
                                    }

                                    // -------------------------------------------------------------------
                                    // Background image update logic
                                    // -------------------------------------------------------------------
                                    var selectedOptions = 0;
                                    if (variantText.indexOf('_' + thisValue + '_') > -1) {
                                        selectedOptions++;
                                        jQuery(this)
                                            .parents('form')
                                            .find('.product-form-main .styledSelect')
                                            .each(function () {
                                                if (!jQuery(this).is(thisSelect.find('.styledSelect'))) {
                                                    if (
                                                        variantText.indexOf(
                                                            '_' + jQuery(this).find('.option-flex span:first-child').text() + '_'
                                                        ) > -1
                                                    ) {
                                                        selectedOptions++;
                                                    }
                                                }
                                            });
                                    }
                                    if (
                                        selectedOptions ==
                                        jQuery(this)
                                            .parents('form')
                                            .find('.product-form-main .styledSelect').length &&
                                        variantCode.find('.variant-code-image').text() !== ''
                                    ) {
                                        jQuery('.product-detail-description-left-large').css(
                                            'background-image',
                                            'url(' + variantCode.find('.variant-code-image').text() + ')'
                                        );
                                        imageChange = true;
                                    } else if (!imageChange) {
                                        jQuery('.product-detail-description-left-large').css(
                                            'background-image',
                                            'url(' +
                                            jQuery('.product-detail-description-left-slider-slider .product-detail-description-left-small:first').attr('data-large-src') +
                                            ')'
                                        );
                                    }
                                }
                            });
                    });
                });

            // Update the styledSelect display for the clicked option.
            var compare = jQuery(this).find('s').text();
            var price = compare
                ? jQuery(this).find('.option-sale').text()
                : jQuery(this).find('.option-price').text();
            let html = '';
            if (compare === '') {
                html =
                    '<span class="option-flex"><span>' +
                    jQuery(this).find('.option-size').text() +
                    '</span>' +
                    '<span class="option-price option-second">' +
                    price +
                    '</span></span>';
            } else {
                html =
                    '<span class="option-flex"><span>' +
                    jQuery(this).find('.option-size').text() +
                    '</span>' +
                    '<span class="option-second"><s style="margin-right:15px">' +
                    compare +
                    '</s><span class="option-sale">' +
                    price +
                    '</span></span></span>';
            }
            $styledSelect.find('.option-flex').remove();
            $styledSelect.append(html);
            $styledSelect.removeClass('active');

            // Set the hidden select's value based on the clicked option.
            $this.val(jQuery(this).attr('rel'));
            $list.hide();

            // Call variant change handler, update the UL pricing/availability and styledSelect display.
            handleVariantChange();
            updateVariantPricingInUL();
            updateStyledSelectDisplay();
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

        setInterval(function () {
            jQuery('.product-detail-description-right .product-form-inner .product-form-main .styledSelect').width(jQuery('.product-detail-description-right .product-form-inner .product-form__cart-submit').last().width() + 10);
            jQuery('.product-detail-description-right .product-form-inner .product-form-main .options').width(jQuery('.product-detail-description-right .product-form-inner .product-form__cart-submit').last().width() + 32);


        }, 200);
    }
});


// Iterate over each select element
$('.quickbuy-popup').each(function () {

    var popup = jQuery(this);
    popup.find('select').each(function () {
        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        // Hides the select element
        $this.addClass('s-hidden');

        // Wrap the select element in a div
        $this.wrap('<div class="select"></div>');

        // If select has only one option add class to disable it
        var addClass = '';
        if (numberOfOptions == 1) { addClass = " singleOption"; }

        // Insert a styled div to sit over the top of the hidden select element
        $this.after('<div tabindex="0" class="styledSelect' + addClass + '"></div>');

        // Cache the styled div
        var $styledSelect = $this.next('div.styledSelect');

        // Show the first select option in the styled div
        var price = '';
        var compare = '';
        popup.find('.variants .variant').each(function () {
            if (jQuery(this).find('.variant-option').text() == $this.children('option').eq(0).text()) {
                price = jQuery(this).find('.variant-price').text();
                compare = jQuery(this).find('.variant-compare').text();
                return false;
            }
        });
        let html = '';
        if (compare == '') {
            html = '<span class="option-flex"><span>' + $this.children('option').eq(0).text() + '</span>' +
                '<span class="option-price option-second">' + price + '</span></span>';
        } else {
            html = '<span class="option-flex"><span>' + $this.children('option').eq(0).text() + '</span>' +
                '<span class="option-second"><s style="margin-right:15px">' + compare + '</s><span class="option-sale">' + price + '</span>' +
                '</span></span>';
        }
        $styledSelect.append(html);

        // Insert an unordered list after the styled div and also cache the list
        var $list = $('<ul />', {
            'class': 'options'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            var price = '';
            var compare = '';
            popup.find('.variants .variant').each(function () {
                if (jQuery(this).find('.variant-option').text() == $this.children('option').eq(i).text()) {
                    price = jQuery(this).find('.variant-price').text();
                    compare = jQuery(this).find('.variant-compare').text();
                    return false;
                }
            });
            let html = '';
            if (compare == '') {
                html = '<li tabindex="0" class="option-flex" rel="' + $this.children('option').eq(i).text() + '">' +
                    '<span class="option-size">' + $this.children('option').eq(i).text() + '</span>' +
                    '<span class="option-price option-second">' + price + '</span>' +
                    '</li>';
            } else {
                html = '<li tabindex="0" class="option-flex" rel="' + $this.children('option').eq(i).text() + '">' +
                    '<span class="option-size">' + $this.children('option').eq(i).text() + '</span>' +
                    '<span class="option-second"><s style="margin-right:15px">' + compare + '</s><span class="option-sale">' + price + '</span>' +
                    '</span></li>';
            }
            $list.append(html);

        }

        // Cache the list items
        var $listItems = $list.children('li');

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active').next('ul.options').hide();
            });
            $(this).toggleClass('active').next('ul.options').toggle();
        });
        $styledSelect.keypress(function (e) {
            if (e.which == '13') {
                e.stopPropagation();
                $('div.styledSelect.active').each(function () {
                    $(this).removeClass('active').next('ul.options').hide();
                });
                $(this).toggleClass('active').next('ul.options').toggle();
            }
        });

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        var thisSelect = popup.find('.select').first();
        var thisValue = thisSelect.find('select').val();
        var imageChange = false;
        popup.find('.select').each(function () {
            var toHide = !jQuery(this).is(thisSelect);
            jQuery(this).find('.option-flex').each(function () {
                var thisOption = jQuery(this);
                if (toHide) {
                    thisOption.hide();
                }
                jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.variants-codes .variant-code').each(function () {

                    if (jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisOption.find('.option-size').text() + '_')
                        && jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisValue + '_')) {
                        thisOption.show();
                        var selectedOptions = 0;
                        var compared = jQuery(this).find('.variant-code-options').text().trim();
                        if (compared.includes('_' + thisValue + '_')) {
                            selectedOptions++;
                            jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').each(function () {
                                if (!jQuery(this).is(thisSelect.find('.styledSelect'))) {
                                    if (compared.includes('_' + jQuery(this).find('.option-flex span:first-child()').text() + '_'))
                                        selectedOptions++;
                                }
                            });
                        }

                        if (selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length
                            && jQuery(this).find('.variant-code-image').text() != '') {
                            //alert("13608 image change");
                            // jQuery('.product-detail-description-left-large').css('background-image',
                            //'url(' + jQuery(this).find('.variant-code-image').text() + ')');
                            imageChange = true
                        } else if (!imageChange) {
                            //alert("13613 image change");
                            // jQuery('.product-detail-description-left-large').css('background-image',
                            //'url(' + jQuery('.product-detail-description-left-slider-slider .product-detail-description-left-small:first').attr('data-large-src') + ')');
                        }
                        if (thisOption.find('.option-sale').text() != '' &&
                            selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length) {
                            thisOption.find('.option-sale').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }));
                            thisOption.find('s').text('$' + parseFloat(jQuery(this).find('.variant-code-oldprice').text() / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }));
                        }

                        if (thisOption.find('.option-price').text() != '' &&
                            selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length) {
                            //console.log(jQuery(this).find('.variant-code-options').text());
                            thisOption.find('.option-price').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }));
                            if (thisOption.parents('.select').find('.styledSelect .option-flex span:first-child()').text() == thisOption.find('.option-size').text()) {
                                thisOption.parents('.select').find('.styledSelect .option-flex .option-price').text(thisOption.find('.option-price').text());
                            }
                        }
                    }
                });

            });


        });

        $listItems.keypress(function (e) {
            if (e.which == 13) {
                e.stopPropagation();
                var thisSelect = jQuery(this).parents('.select');
                var thisValue = jQuery(this).find('.option-size').text();
                var imageChange = false;
                jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.select').each(function () {
                    var toHide = !jQuery(this).is(thisSelect);
                    jQuery(this).find('.option-flex').each(function () {
                        var thisOption = jQuery(this);
                        if (toHide) {
                            thisOption.hide();
                        }
                        jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.variants-codes .variant-code').each(function () {

                            if (jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisOption.find('.option-size').text() + '_')
                                && jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisValue + '_')) {
                                thisOption.show();
                                var selectedOptions = 0;
                                var compared = jQuery(this).find('.variant-code-options').text().trim();
                                if (compared.includes('_' + thisValue + '_')) {
                                    selectedOptions++;
                                    jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').each(function () {
                                        if (!jQuery(this).is(thisSelect.find('.styledSelect'))) {
                                            if (compared.includes('_' + jQuery(this).find('.option-flex span:first-child()').text() + '_'))
                                                selectedOptions++;
                                        }
                                    });
                                }

                                if (selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length
                                    && jQuery(this).find('.variant-code-image').text() != '') {
                                    //console.log(compared);
                                    //console.log(selectedOptions);
                                    jQuery('.product-detail-description-left-large').css('background-image',
                                        'url(' + jQuery(this).find('.variant-code-image').text() + ')');
                                    imageChange = true;
                                } else if (!imageChange) {
                                    jQuery('.product-detail-description-left-large').css('background-image',
                                        'url(' + jQuery('.product-detail-description-left-slider-slider .product-detail-description-left-small:first').attr('data-large-src') + ')');
                                }
                                if (thisOption.find('.option-sale').text() != '' &&
                                    selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length) {
                                    thisOption.find('.option-sale').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }));
                                    thisOption.find('s').text('$' + parseFloat(jQuery(this).find('.variant-code-oldprice').text() / 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }));
                                }

                                if (thisOption.find('.option-price').text() != '' &&
                                    selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length) {
                                    //console.log(jQuery(this).find('.variant-code-options').text());
                                    thisOption.find('.option-price').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }));
                                    if (thisOption.parents('.select').find('.styledSelect .option-flex span:first-child()').text() == thisOption.find('.option-size').text()) {
                                        thisOption.parents('.select').find('.styledSelect .option-flex .option-price').text(thisOption.find('.option-price').text());
                                    }
                                }
                            }
                        });

                    });
                    if (toHide) {
                        var found = false;
                        var text = jQuery(this).find('.styledSelect .option-flex > span:first-child()').text();
                        jQuery(this).find('.options .option-flex').each(function () {
                            if (jQuery(this).find('.option-size').text() == text && jQuery(this).css('display') != 'none') {
                                found = true;
                            }
                        });

                        if (!found) {
                            jQuery(this).find('.styledSelect .option-flex').remove();
                            var clicked = jQuery(this).find('.options .option-flex').first();
                            if (clicked.css('display') == 'none') {
                                jQuery(this).find('.options .option-flex').each(function () {
                                    if (clicked.css('display') == 'none' && jQuery(this).css('display') != 'none') {
                                        clicked = jQuery(this);
                                    }
                                });
                            }
                            setTimeout(function () {
                                clicked.click();
                                //console.log(clicked.html());
                            }, 500);

                        }
                    }

                });


                var price = '';
                var compare = '';
                compare = jQuery(this).find('s').text();
                if (!compare) {
                    price = jQuery(this).find('.option-price').text();
                } else {
                    price = jQuery(this).find('.option-sale').text();
                }

                let html = '';
                if (compare == '') {
                    html = '<span class="option-flex"><span>' + jQuery(this).find('.option-size').text() + '</span>' +
                        '<span class="option-price option-second">' + price + '</span></span>';
                } else {
                    html = '<span class="option-flex"><span>' + jQuery(this).find('.option-size').text() + '</span>' +
                        '<span class="option-second"><s style="margin-right:15px">' + compare + '</s><span class="option-sale">' + price + '</span>' +
                        '</span></span>';
                }
                $styledSelect.find('.option-flex').remove();
                $styledSelect.append(html);
                $styledSelect.removeClass('active');

                $this.val($(this).attr('rel'));
                $list.hide();
                /* alert($this.val()); Uncomment this for demonstration! */
            }
        });
        $listItems.click(function (e) {

            e.stopPropagation();
            var thisSelect = jQuery(this).parents('.select');
            var thisValue = jQuery(this).find('.option-size').text();
            var imageChange = false;
            jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.select').each(function () {
                var toHide = !jQuery(this).is(thisSelect);
                jQuery(this).find('.option-flex').each(function () {
                    var thisOption = jQuery(this);
                    if (toHide) {
                        thisOption.hide();
                    }
                    jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.variants-codes .variant-code').each(function () {

                        if (jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisOption.find('.option-size').text() + '_')
                            && jQuery(this).find('.variant-code-options').text().trim().includes('_' + thisValue + '_')) {
                            thisOption.show();
                            var selectedOptions = 0;
                            var compared = jQuery(this).find('.variant-code-options').text().trim();
                            if (compared.includes('_' + thisValue + '_')) {
                                selectedOptions++;
                                jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').each(function () {
                                    if (!jQuery(this).is(thisSelect.find('.styledSelect'))) {
                                        if (compared.includes('_' + jQuery(this).find('.option-flex span:first-child()').text() + '_'))
                                            selectedOptions++;
                                    }
                                });
                            }

                            if (selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length
                                && jQuery(this).find('.variant-code-image').text() != '') {
                                //console.log(compared);
                                //console.log(selectedOptions);
                                jQuery('.product-detail-description-left-large').css('background-image',
                                    'url(' + jQuery(this).find('.variant-code-image').text() + ')');
                                imageChange = true;
                            } else if (!imageChange) {
                                jQuery('.product-detail-description-left-large').css('background-image',
                                    'url(' + jQuery('.product-detail-description-left-slider-slider .product-detail-description-left-small:first').attr('data-large-src') + ')');
                            }
                            if (thisOption.find('.option-sale').text() != '' &&
                                selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length) {
                                thisOption.find('.option-sale').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }));
                                thisOption.find('s').text('$' + parseFloat(jQuery(this).find('.variant-code-oldprice').text() / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }));
                            }

                            if (thisOption.find('.option-price').text() != '' &&
                                selectedOptions == jQuery(this).parents('.quickbuy-popup .form, .quickbuy-popup form').find('.styledSelect').length) {
                                //console.log(jQuery(this).find('.variant-code-options').text());
                                thisOption.find('.option-price').text('$' + parseFloat(jQuery(this).find('.variant-code-price').text() / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }));
                                if (thisOption.parents('.select').find('.styledSelect .option-flex span:first-child()').text() == thisOption.find('.option-size').text()) {
                                    thisOption.parents('.select').find('.styledSelect .option-flex .option-price').text(thisOption.find('.option-price').text());
                                }
                            }
                        }
                    });

                });
                if (toHide) {
                    var found = false;
                    var text = jQuery(this).find('.styledSelect .option-flex > span:first-child()').text();
                    jQuery(this).find('.options .option-flex').each(function () {
                        if (jQuery(this).find('.option-size').text() == text && jQuery(this).css('display') != 'none') {
                            found = true;
                        }
                    });

                    if (!found) {
                        jQuery(this).find('.styledSelect .option-flex').remove();
                        var clicked = jQuery(this).find('.options .option-flex').first();
                        if (clicked.css('display') == 'none') {
                            jQuery(this).find('.options .option-flex').each(function () {
                                if (clicked.css('display') == 'none' && jQuery(this).css('display') != 'none') {
                                    clicked = jQuery(this);
                                }
                            });
                        }
                        setTimeout(function () {
                            clicked.click();
                            //console.log(clicked.html());
                        }, 500);

                    }
                }

            });





            var price = '';
            var compare = '';
            compare = jQuery(this).find('s').text();
            if (!compare) {
                price = jQuery(this).find('.option-price').text();
            } else {
                price = jQuery(this).find('.option-sale').text();
            }

            let html = '';
            if (compare == '') {
                html = '<span class="option-flex"><span>' + jQuery(this).find('.option-size').text() + '</span>' +
                    '<span class="option-price option-second">' + price + '</span></span>';
            } else {
                html = '<span class="option-flex"><span>' + jQuery(this).find('.option-size').text() + '</span>' +
                    '<span class="option-second"><s style="margin-right:15px">' + compare + '</s><span class="option-sale">' + price + '</span>' +
                    '</span></span>';
            }
            $styledSelect.find('.option-flex').remove();
            $styledSelect.append(html);
            $styledSelect.removeClass('active');

            $this.val($(this).attr('rel'));
            $list.hide();
            /* alert($this.val()); Uncomment this for demonstration! */
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

        setInterval(function () {
            if (popup.find('.fake-submit').first().width()) {
                popup.find('.styledSelect').width(popup.find('.fake-submit').first().width());
                popup.find('.options').width(popup.find('.fake-submit').first().width() + 22);
            }

        }, 200);

    });

});


//if(jQuery(window).width() <= 1020){

//}

jQuery('.template-search .list-view-item').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    location.href = jQuery(this).attr('data-url');
});
/*
if(jQuery('.featured-collection-wrapper-mobile').length > 0 && jQuery(window).width() < 1020){
  jQuery(document).scroll(function(){
    if(jQuery(document).scrollTop() + jQuery(window).height()/2 < jQuery('.featured-collection-wrapper-mobile .product-slider').offset().top){
    } else{
        jQuery('.site-header').css('position', 'absolute');
        jQuery('.site-header').css('top', jQuery(this).parents('.announcement-bar').height() + 'px');
        jQuery('.announcement-bar').addClass('hidden');
        jQuery('.sticky-header-content').css('min-height', '94px');
    }
  });
}
*/
if (jQuery('.template-product').length > 0) {
    var lastScrollPosition = 0;
    var heightPlus = jQuery('.sticky-header').outerHeight();
    jQuery(document).scroll(function () {
        let criticalPoint = 0;
        if (jQuery(window).width() <= 1020) {
            criticalPoint = jQuery('.related-products-container').offset().top + jQuery('.related-products-container').height() - jQuery('.sticky-header').height();
        } else {
            criticalPoint = jQuery('.product-specs .product-specs-main-right').offset().top + jQuery('.product-specs .product-specs-main-right').height();

        }
        if (criticalPoint > 0) {
            let height = jQuery('.sticky-product-specs-footer').outerHeight();

            if (jQuery(document).scrollTop() >= criticalPoint) {
                jQuery('.sticky-product-specs-footer').css('position', 'fixed');
                jQuery('.sticky-product-specs-footer').show();
                jQuery('.sticky-product-specs-footer').css('transition', 'transform 1s ease');
                jQuery('#shopify-section-header').css('transition', 'transform 1s ease');
                jQuery('#shopify-section-header').css('position', 'fixed');
                jQuery('#shopify-section-header').css('z-index', '2');
                jQuery('#shopify-section-header').css('width', '100vw');
                if (!lastScrollPosition || lastScrollPosition < jQuery(document).scrollTop()) {
                    jQuery('#shopify-section-header').css('transform', 'translateY(-' + heightPlus + 'px)');
                    jQuery('.sticky-product-specs-footer').css('top', '-' + height + 'px');
                    jQuery('.sticky-product-specs-footer').css('transform', 'translateY(' + height + 'px)');
                    jQuery('.sticky-product-specs-footer').css('z-index', 1);
                } else {
                    let bannerHeight = jQuery('#shopify-section-secondary-top-banner').height();
                    jQuery('#shopify-section-header').css('transform', 'translateY(-' + bannerHeight + 'px)');
                    jQuery('.sticky-product-specs-footer').css('top', '-' + height + 'px');
                    jQuery('.sticky-product-specs-footer').css('transform', 'translateY(' + (height - bannerHeight + heightPlus - 2) + 'px)');
                    jQuery('.sticky-product-specs-footer').css('z-index', 1);
                }

                //jQuery('.sticky-product-specs-footer').css('top', '0px');
                //jQuery('.sticky-header').css('position', 'absolute');

            } else {
                //jQuery('.sticky-product-specs-footer').css('top', '+' + heightPlus + 'px');
                jQuery('#shopify-section-header').css('transform', 'translateY(0px)');
                jQuery('.sticky-product-specs-footer').css('transform', 'translateY(-' + height + 'px)');
                //jQuery('.sticky-product-specs-footer').css('position', 'relative');
                //jQuery('.sticky-product-specs-footer').css('top', '-' + height + 'px');
                //jQuery('.sticky-product-specs-footer').hide();
                jQuery('.sticky-product-specs-footer').css('z-index', 1);
            }
            lastScrollPosition = jQuery(document).scrollTop();
        }
    });
}
jQuery('.sticky-product-specs-footer .collection-detail-product-link').click(function () {
    jQuery(window).scrollTop(0);
});


jQuery('#shops-state').change(function () {
    var state = jQuery(this).val();
    jQuery('#shops-city option').each(function () {
        if (!jQuery(this).attr('disabled')) {
            jQuery(this).remove();
        } else {
            jQuery("#shops-city").val(jQuery(this).attr('value'));
        }

    });
    jQuery('.shops-cities-options option').each(function () {
        if (jQuery(this).attr('data-state') == state) {
            jQuery('#shops-city').append(jQuery(this).clone(true, true));
        }
    })
})

jQuery('.faq-menu-link .specs-plus').click(function () {
    jQuery(this).hide();
    jQuery(this).parent().find('.specs-minus').show();
    jQuery(this).parents('.faq-specs-section').find('.faq-menu-excerpt').show();
});


jQuery('.faq-menu-link .specs-minus').click(function () {
    jQuery(this).hide();
    jQuery(this).parent().find('.specs-plus').show();
    jQuery(this).parents('.faq-specs-section').find('.faq-menu-excerpt').hide();
});
jQuery('.bed-feel-popup[data-feel-index="5"]').css('visibility', 'visible');
jQuery('.bed-feel-popup-zone').click(function () {
    jQuery('.bed-feel-popup').css('visibility', 'hidden');
    jQuery('.bed-feel-popup[data-feel-index="' + jQuery(this).attr('data-feel-index') + '"]').css('visibility', 'visible');
});
jQuery('.bed-feel-popup-zone').hover(function () {
    jQuery(this).parents('.mattress-firmness-diagram').find('svg circle').attr('r', '29.5');
    if (jQuery(this).attr('data-feel-index') == 10) {
        jQuery(this).parents('.mattress-firmness-diagram').find('svg circle:nth-last-of-type(1)').attr('r', '40.5');
    } else if (jQuery(this).attr('data-feel-index') == 5) {
        jQuery(this).parents('.mattress-firmness-diagram').find('svg circle:nth-last-of-type(2)').attr('r', '40.5');
    } else if (jQuery(this).attr('data-feel-index') == 1) {
        jQuery(this).parents('.mattress-firmness-diagram').find('svg circle:nth-last-of-type(3)').attr('r', '40.5');
    }
}, function () {
    jQuery(this).parents('.mattress-firmness-diagram').find('svg circle').attr('r', '29.5');
});

jQuery('.product-specs-section').first().find('.specs-minus').css('display', 'inline');
jQuery('.product-specs-section').first().find('.specs-plus').css('display', 'none');
jQuery('.product-specs-section').first().find('.product-specs-section-content').css('display', 'block');

jQuery('.mobile-menu-section-header').click(function () {
    if (jQuery(this).parents('.mobile-menu-section').find('.mobile-menu-section-menu:visible').length > 0) {
        jQuery(this).parents('.mobile-menu-section').find('.mobile-menu-section-menu').hide();
        jQuery(this).removeClass('opened');
    } else {
        jQuery(this).parents('.mobile-menu-section').find('.mobile-menu-section-menu').show();
        jQuery(this).addClass('opened');
    }
});

jQuery(document).on('input', '#firmnessSlider', function () {

    jQuery('.collection-detail-product-card').show();
    jQuery('.no-items').hide();
    jQuery('.collection-detail-product-cards').css('display', 'grid');

    var firmness = "Medium";
    if (jQuery('#firmnessSlider').val() > 30 && jQuery('#firmnessSlider').val() <= 70) {
        firmness = "Medium";
        chosen.push("Medium/Firm"); //Alexander Signature Flippable case
    } else if (jQuery('#firmnessSlider').val() >= 0 && jQuery('#firmnessSlider').val() <= 30) {
        firmness = "Plush";
    } else if (jQuery('#firmnessSlider').val() > 70 && jQuery('#firmnessSlider').val() <= 100) {
        firmness = "Firm";
        chosen.push("Medium/Firm"); //Alexander Signature Flippable case
    }

    var chosen = [];

    chosen.push(firmness);

    jQuery('.collection-detail-product-card').each(function () {
        let available = (jQuery(this).attr('data-filters'));
        available = available.split(';');
        for (let i = 0; i < available.length; i++) {
            available[i] = available[i].trim();
        }
        let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
        if (intersection.length == 0) {
            jQuery(this).hide();
        }
    });


    if (jQuery(window).width() <= 1020) {
        jQuery('.nest-builder-section').each(function () {
            var chosen = [];

            jQuery(this).find('.nest-builder-mobile-filter.active').each(function () {
                chosen.push(jQuery(this).text());

            });
            if (chosen.length > 0) {
                jQuery('.collection-detail-product-card').each(function () {
                    let available = (jQuery(this).attr('data-filters'));
                    available = available.split(';');
                    for (let i = 0; i < available.length; i++) {
                        available[i] = available[i].trim();
                    }
                    let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                    if (intersection.length == 0) {
                        jQuery(this).hide();
                    }
                });
            }
        });

    } else {

        jQuery('.nest-builder-section-options').each(function () {
            var chosen = [];

            jQuery(this).find('input').each(function () {
                if (jQuery(this).parent().find('.checkmark').hasClass('checked')) {
                    chosen.push(jQuery(this).val());
                }
            });
            if (chosen.length > 0) {
                jQuery('.collection-detail-product-card').each(function () {
                    let available = (jQuery(this).attr('data-filters'));
                    available = available.split(';');
                    for (let i = 0; i < available.length; i++) {
                        available[i] = available[i].trim();
                    }
                    let intersection = available.filter(function (n) { return chosen.indexOf(n) !== -1; });
                    if (intersection.length == 0) {
                        jQuery(this).hide();
                    }
                });
            }
        });

    }
    if (jQuery('.collection-detail-product-card:visible').length == 0) {
        jQuery('.no-items').show();
        jQuery('.collection-detail-product-cards').css('display', 'none');
    }

});


jQuery('.footer-menu-section-header').click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    if (jQuery(this).hasClass('opened')) {
        jQuery(this).removeClass('opened');
        jQuery(this).next().hide();
    } else {
        jQuery(this).addClass('opened');
        jQuery(this).next().show();
    }
});


setInterval(function () {
    if (jQuery('.product-reviews').length > 0 && jQuery('.template-product').length == 1 && jQuery('.review-customization:visible').length == 0 && jQuery('.filtered-out').length == 0) {
        jQuery('.yotpo-reviews').each(function () {
            var i = 0;
            jQuery(this).find('.yotpo-review').each(function () {
                var userFields = '<div class="user-fields">';
                jQuery(this).find('.yotpo-review-stars .yotpo-user-related-fields .yotpo-user-field').each(function () {
                    userFields += '<div class="user-field" data-question="' + jQuery(this).find('.yotpo-user-field-description').html() + '"><div class="user-field-title">' + jQuery(this).find('.yotpo-user-field-description').html()
                        + '</div><div class="user-field-answer">' + jQuery(this).find('.yotpo-user-field-answer').html() + '</div></div>';
                });
                userFields += '</div>';
                var options = { year: 'numeric', month: 'long', day: 'numeric' };
                var reviewDate = new Date(jQuery(this).find('.yotpo-header-element .yotpo-review-date').first().text());

                var review_id = jQuery(this).attr('data-review-id');
                var thisReview = jQuery(this);
                if (jQuery(this).find('.review-customization').length == 0) {
                    jQuery(this).append('<div class="review-customization">' +
                        jQuery('#icon-real-review-' + (i % 5 + 1)).html() +
                        '<div class="review-customization-col1">' +
                        '<h4>' + jQuery(this).find('.yotpo-user-name').html() + '</h4>'

                        + '<span class="review-location">' + userFields + '</span>'
                        + '</div>' +
                        '<div class="review-customization-col2">' +
                        '<div class="rating">' + " " + '</div>'
                        + '<div class="review-date">' + jQuery(this).find('.yotpo-header .yotpo-review-stars').html()
                        + '<span class="review-date-date">'
                        + reviewDate.toLocaleDateString("en-US", options) + '</span></div>'
                        + '<h5 class="review-header">' + jQuery(this).find('.content-title').html() + '</h5>'
                        + '<div class="review-body">' + jQuery(this).find('.content-review').html() + '</div>'
                        + '<div class="report">'
                        + " "
                        + jQuery('.yotpo-helpful').clone(true, true).html() + '<span class="report-review">Report</span></div>'
                        + '</div>' + '</div>'
                    );
                    if (jQuery(this).find('.yotpo-comments-box')) {
                        jQuery(this).append(jQuery(this).find('.yotpo-comments-box'));
                    }
                    jQuery.ajax({
                        url: 'https://api.yotpo.com/reviews/' + review_id,
                        crossDomain: true,
                        type: "GET",
                        contentType: "application/json",
                        success: function (result) {
                            //console.log(result);
                            thisReview.find('.review-customization .yotpo-sum.vote-sum[data-type="up"]').text(result['response']['review']['votes_up']);
                            thisReview.find('.review-customization .yotpo-sum.vote-sum[data-type="down"]').text(result['response']['review']['votes_down']);
                        }
                    }).fail(function (status) {
                        //console.log(status);
                    });
                    i++;
                }
            });
        });

        jQuery('.yotpo-questions').each(function () {

            var i = 0;
            jQuery(this).find('.yotpo-question').each(function () {
                if (!jQuery(this).hasClass('.customized-photo')) {
                    jQuery(this).find('.yotpo-icon-profile').first().html(jQuery('#icon-real-review-' + (i % 5 + 1)).html());
                    jQuery(this).addClass('.customized-photo');
                }
                i++;
            });
        });
        jQuery('.review-customization .yotpo-icon-thumbs-up').click(function () {
            if (!jQuery(this).parents('.yotpo-review').hasClass('voted')) {
                jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="up"]').text(
                    parseInt(jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="up"]').last().text()) + 1);
                jQuery(this).parents('.yotpo-review').addClass('voted');
                var review_id = jQuery(this).parents('.yotpo-review').attr('data-review-id');

                jQuery.ajax({
                    url: 'https://api.yotpo.com/reviews/' + review_id + '/vote/up',
                    crossDomain: true,
                    type: "POST",
                    contentType: "application/json",
                    data: JSON.stringify({
                        "appkey": "CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x"
                    }),
                    success: function (result) {
                        //console.log(result);
                    }
                }).fail(function (status) {
                    //console.log(status);
                });
            }
        });
        jQuery('.review-customization .yotpo-icon-thumbs-down').click(function () {
            if (!jQuery(this).parents('.yotpo-review').hasClass('voted')) {
                jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="down"]').text(
                    parseInt(jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="down"]').last().text()) - 1);
                jQuery(this).parents('.yotpo-review').addClass('voted');
                var review_id = jQuery(this).parents('.yotpo-review').attr('data-review-id');
                jQuery.ajax({
                    url: 'https://api.yotpo.com/reviews/' + review_id + '/vote/down',
                    crossDomain: true,
                    type: "POST",
                    contentType: "application/json",
                    success: function (result) {
                        //console.log(result);
                    }
                }).fail(function (status) {
                    //console.log(status);
                });
            }
        });
        jQuery('.review-customization .report-review').click(function () {
            jQuery(this).parents('.yotpo-review').hide();

        });
        if (jQuery('.bottom-line-items .title').length == 0) {
            jQuery('.bottom-line-items').prepend('<h5 class="title">Reviews</h5>');
        }
        if (jQuery('.bottom-line-items .note').length == 0) {
            jQuery('.bottom-line-items').append('<div class="note">Rated ' + jQuery('.bottom-line-items .avg-score').text()
                + ' out of 5 stars overall by ' + jQuery('.bottom-line-items .reviews-qa-label').text().replace(/ .*/, '') + ' reviews</div>');
        }
        if (jQuery('.yotpo-messages .filters').length == 0) {
            var toAppend = '';
            if (jQuery('#all-real-reviews').length == 0) {
                var search =
                    jQuery('.free-text-search');
                jQuery('.yotpo-messages').first().prepend('<div class="search-container"></div>');
                if (jQuery(window).width() < 768) {
                    jQuery('.yotpo-messages').first().find('.search-container').prepend(search);
                } else {
                    jQuery('.yotpo-messages').first().find('.search-container').prepend(search);
                }
                toAppend = '<div><span class="filter-additional" ' +
                    'data-filter-option="Back Sleeper">Back Sleeper</span>'

                    + '<span class="filter-additional" ' +
                    'data-filter-option="Stomach Sleeper">Stomach Sleeper</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Side Sleeper">Side Sleeper</span>'
                    + '<span class="filter-additional hide-mobile" ' +
                    'data-filter-option="Combination Sleeper">Combination</span></div>'
                    + '<div><span class="filter-additional" ' +
                    'data-filter-option="Plush">Soft/Plush</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Normal">Medium</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Firm">Firm</span>'
                    + '<span class="filter-additional hide-mobile" ' +
                    'data-filter-option="Very Firm">Very Firm</span></div>';
            }
            jQuery('.yotpo-messages').first().prepend('<span class="filters-heading hide-desktop">filter:</span>'
                + '<div class="filters">' +
                '<span class="filters-heading hide-mobile">filter:</span>'
                + toAppend
                + '<div><span class="filters-1">Most Helpful</span><span class="filters-2">Most Recent</span><span class="filters-3">Highest Rated</span><span class="filters-4">Lowest Rated</span></div>'
                + '</div>');
            if (jQuery(window).width() >= 768) {

                jQuery('.filters').append(jQuery('.yotpo-messages').first().find('.search-container'));
            }


        }

    }
}, 1000);



function repaginateCustomReviews() {
    var j = 0;
    jQuery('#all-real-reviews .review-customization').each(function () {
        jQuery(this).attr('data-page', 1 + Math.floor(j / 5));
        j++;
    });
    var lastPage = 1 + Math.floor(j / 5);

    var currentPage = parseInt(jQuery('#all-real-reviews').attr('data-current-page'));

    jQuery('#all-real-reviews .review-customization').hide();
    jQuery('#all-real-reviews .review-customization[data-page="' + currentPage + '"]').show();

    jQuery('#all-real-reviews .all-reviews-pagination .all-reviews-page-link').remove();

    if (currentPage > 1) {
        jQuery('#all-real-reviews .all-reviews-pagination').append('<a class="all-reviews-page-link" data-page="1"><<</a>');
        jQuery('#all-real-reviews .all-reviews-pagination').append('<a class="all-reviews-page-link" data-page="'
            + (currentPage - 1) + '"><</a>');
    }
    let beginPage = 1;
    let endPage = 10;
    if (currentPage >= lastPage - 5) {
        beginPage = lastPage - 9;
        endPage = lastPage;
    }
    else if (currentPage > 5) {
        beginPage = currentPage - 4;
        endPage = currentPage + 4;
    }
    if (beginPage < 1) {
        beginPage = 1
    }
    for (let i = beginPage; i <= endPage; i++) {

        jQuery('#all-real-reviews .all-reviews-pagination').append('<a class="all-reviews-page-link" data-page="' + i + '">' + i + '</a>');
    }
    if (currentPage < lastPage) {
        jQuery('#all-real-reviews .all-reviews-pagination').append('<a class="all-reviews-page-link" data-page="'
            + (currentPage + 1) + '">></a>');
        jQuery('#all-real-reviews .all-reviews-pagination').append('<a class="all-reviews-page-link" data-page="'
            + lastPage + '">>></a>');
    }
    jQuery('#all-real-reviews .all-reviews-pagination .all-reviews-page-link').click(function () {
        jQuery('#all-real-reviews').attr('data-current-page', jQuery(this).attr('data-page'));
    });
    jQuery('#all-real-reviews .all-reviews-pagination .all-reviews-page-link').removeClass('current');
    jQuery('#all-real-reviews .all-reviews-pagination .all-reviews-page-link[data-page="' +
        currentPage + '"]').addClass('current');
}

setInterval(function () {
    if (jQuery('.yotpo-main-widget').length > 0 && jQuery('.template-product').length == 0 && jQuery('.review-customization:visible').length == 0 && jQuery('.filtered-out').length == 0) {
        jQuery('#y-embedded-widget').each(function () {
            var i = 0;
            jQuery(this).find('.embedded_widget_list_item').each(function () {
                var userFields = '';

                var options = { year: 'numeric', month: 'long', day: 'numeric' };

                var reviewDate = new Date(jQuery(this).find('.embedded_widget_timeStamp').first().text());

                if (jQuery('.review-customization[data-href="' + jQuery(this).find('.embedded-item-link').attr('href') + '"]').length == 0) {
                    jQuery('.yotpo-reviews').append('<div data-href="' + jQuery(this).find('.embedded-item-link').attr('href') + '" class="review-customization">' +
                        jQuery('#icon-real-review-' + (i % 5 + 1)).html() +
                        '<div class="review-customization-col1">' +
                        '<h4>' + ' ' + '</h4>'

                        + '<span class="review-location">' + userFields + '</span>'
                        + '</div>' +
                        '<div class="review-customization-col2">' +
                        '<div class="rating">' + " " + '</div>'
                        + '<div class="review-date"><span class="review-date-rank">' + jQuery(this).find('.embedded_widget_product_rank').html()
                        + '</span><span class="review-date-date">'
                        + reviewDate.toLocaleDateString("en-US", options) + '</span></div>'
                        + '<h5 class="review-header">' + jQuery(this).find('.embedded_widget_review_title strong').html() + '</h5>'
                        + '<div class="review-body">' + jQuery(this).find('.embedded_widget_review').html() + '</div>'
                        + '<div class="report">'
                        + " " +
                        " " + '</div>'
                        + '</div>' + '</div>'
                    );

                    i++;
                }
            });
        });




        if (jQuery('.bottom-line-items .title').length == 0) {
            jQuery('.bottom-line-items').prepend('<h5 class="title">Reviews</h5>');
        }
        if (jQuery('.bottom-line-items .note').length == 0) {
            jQuery('.bottom-line-items').append('<div class="note">Rated ' + jQuery('.bottom-line-items .avg-score').text()
                + ' out of 5 stars overall by ' + jQuery('.bottom-line-items .reviews-qa-label').text().replace(/ .*/, '') + ' reviews</div>');
        }
        if (jQuery('.yotpo-messages .filters').length == 0) {

            var toAppend = '';
            if (jQuery('#all-real-reviews').length == 0) {
                var search =
                    jQuery('.free-text-search');
                jQuery('.yotpo-messages').first().prepend('<div class="search-container"></div>');
                if (jQuery(window).width() < 768) {
                    jQuery('.yotpo-messages').first().find('.search-container').prepend(search);
                } else {
                    jQuery('.yotpo-messages').first().find('.search-container').prepend(search);
                }


                toAppend = '<div><span class="filter-additional" ' +
                    'data-filter-option="Back Sleeper">Back Sleeper</span>'

                    + '<span class="filter-additional" ' +
                    'data-filter-option="Stomach Sleeper">Stomach Sleeper</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Side Sleeper">Side Sleeper</span>'
                    + '<span class="filter-additional hide-mobile" ' +
                    'data-filter-option="Combination Sleeper">Combination</span>'
                    + '</div><div><span class="filter-additional" ' +
                    'data-filter-option="Plush">Soft/Plush</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Normal">Medium</span>'
                    + '<span class="filter-additional" ' +
                    'data-filter-option="Firm">Firm</span>'
                    + '<span class="filter-additional hide-mobile" ' +
                    'data-filter-option="Very Firm">Very Firm</span></div>';
            }
            jQuery('.yotpo-messages').first().prepend('<span class="filters-heading hide-desktop">filter:</span>'
                + '<div class="filters">' +
                '<span class="filters-heading hide-mobile">filter:</span>'
                + toAppend
                + '<div><span class="filters-1">Most Helpful</span><span class="filters-2">Most Recent</span><span class="filters-3">Highest Rated</span><span class="filters-4">Lowest Rated</span></div>'
                + '</div>');

            if (jQuery(window).width() >= 768) {

                jQuery('.filters').append(jQuery('.yotpo-messages').first().find('.search-container'));
            }



        }

    }
    repaginateCustomReviews();
}, 1000);












window.addEventListener('blur', function () {
    if (document.activeElement.id == 'industry-reviews-bottom-iframe') {
        jQuery('.industry-reviews-bottom-left .iframe-wrapper').css('background-image', 'none');
        jQuery('.industry-reviews-bottom-left iframe').css('opacity', '1');
        jQuery('.industry-reviews-bottom-left .iframe-hover-icon').hide();

    }
});

jQuery('.quotes-slider__video').each(function () {
    var that = jQuery(this);
    window.addEventListener('blur', function () {
        if (document.activeElement.id == that.find('iframe').attr('id')) {
            that.find('.iframe-wrapper').css('background-image', 'none');
            that.find('iframe').css('opacity', '1');
        }
    });
});


jQuery('.collapse-icons .specs-plus').click(function () {
    jQuery(this).hide();
    jQuery(this).parent().find('.specs-minus').show();
    jQuery(this).parents('.nest-builder-section').find('.nest-builder-section-options').css('display', 'grid');
});



jQuery('.collapse-icons .specs-minus').click(function () {
    jQuery(this).hide();
    jQuery(this).parent().find('.specs-plus').show();
    jQuery(this).parents('.nest-builder-section').find('.nest-builder-section-options').hide();
});
jQuery('.nest-builder-section-title h5').click(function () {
    let title = jQuery(this).parents('.nest-builder-section-title');
    if (title.find('.specs-minus:visible').length > 0) {
        title.find('.specs-minus').hide();
        title.find('.specs-plus').show();
        title.parents('.nest-builder-section').find('.nest-builder-section-options').hide();
    } else if (title.find('.specs-plus:visible').length > 0) {
        title.find('.specs-plus').hide();
        title.find('.specs-minus').show();
        title.parents('.nest-builder-section').find('.nest-builder-section-options').css('display', 'grid');
    }
});


/*
if(jQuery(window).width() <= 1020){
  jQuery('.template-collection .large-tile-right').each(function(){
    let cloned = jQuery(this).clone(true, true);
    let next = jQuery(this).next();
    jQuery(this).remove();
    cloned.insertAfter(next);
  });
  setTimeout(function(){
    jQuery('.template-product .large-tile-left').each(function(){
        let cloned = jQuery(this).clone(true, true);
        let next = jQuery(this).next();
        jQuery(this).remove();
        cloned.insertAfter(next);
    });
    jQuery('.template-product .large-tile-right').each(function(){
        let cloned = jQuery(this).clone(true, true);
        let prev = jQuery(this).prev();
        jQuery(this).remove();
        cloned.insertBefore(prev);
    });
  }, 1000);
}
*/



jQuery('.product-slider').slick({
    infinite: true,
    slidesToShow: 2,
    adaptiveHeight: false,
    variableWidth: true,
    autoplay: false,
    vertical: false,
    speed: 500,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    swipeToSlide: true
});

jQuery('.review-customization .yotpo-icon-thumbs-up').click(function () {
    jQuery(this).parents('.yotpo-review').find('.yotpo-header .yotpo-icon-thumbs-up').click();
    jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="up"]').text(
        parseInt(jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="up"]').last().text()));
    var review_id = jQuery(this).parents('.yotpo-review').attr('data-review-id');
    jQuery.ajax({
        url: 'https://api.yotpo.com/reviews/' + review_id + '/vote/up',
        crossDomain: true,
        type: "POST",

        contentType: "application/json",
        success: function (result) {
            //console.log(result);
        }
    }).fail(function (status) {
        //console.log(status);
    });
});
jQuery('.review-customization .yotpo-icon-thumbs-down').click(function () {
    jQuery(this).parents('.yotpo-review').find('.yotpo-header .yotpo-icon-thumbs-down').click();
    jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="down"]').text(
        parseInt(jQuery(this).parents('.yotpo-review').find('.yotpo-sum.vote-sum[data-type="down"]').last().text()));
    var review_id = jQuery(this).parents('.yotpo-review').attr('data-review-id');
    jQuery.ajax({
        url: 'https://api.yotpo.com/reviews/' + review_id + '/vote/down',
        crossDomain: true,
        type: "POST",
        contentType: "application/json",
        success: function (result) {
            //console.log(result);
        }
    }).fail(function (status) {
        //console.log(status);
    });
});

if (jQuery(window).width() < 1020) {
    jQuery('.active-filter-tiles').slick({
        infinite: false,
        slidesToShow: 2,
        adaptiveHeight: false,
        variableWidth: true,
        autoplay: false,
        vertical: false,
        speed: 500,
        autoplaySpeed: 0,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        swipeToSlide: true
    });
}
jQuery('.blog-tags').slick({
    infinite: false,
    slidesToShow: 2,
    adaptiveHeight: false,
    variableWidth: true,
    autoplay: false,
    vertical: false,
    speed: 500,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    swipeToSlide: true
});

jQuery('p').each(function () {
    if (jQuery(this).find('img').length == 0 && jQuery(this).text().trim() == "") {
        jQuery(this).remove();
    }
});
//Trims empty space from svg
jQuery(function () {

    var svg = document.getElementById(jQuery('.mattress-firmness-diagram > svg').first().attr('id'));
    if (svg) {
        var bbox = svg.getBBox();
        var viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(" ");
        svg.setAttribute("viewBox", viewBox);
    }

    jQuery('.large-tile h2').each(function () {
        jQuery(this).html(jQuery(this).html().replace('-', '&#8209;'));
    });
});


jQuery('.quickbuy-product-photos-switcher').click(function () {
    jQuery(this).parents('.quickbuy-product-photos-switchers').find('.active').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).parents('.quickbuy-product-photos').find('.quickbuy-product-photo').hide();
    jQuery(this).parents('.quickbuy-product-photos').find('.quickbuy-product-photo[data-quickbuy-product-image-index="'
        + jQuery(this).attr('data-quickbuy-product-image-index') + '"]').show();
});


if (jQuery(window).width() < 721) {
    let announcement = jQuery('.template-index .announcement-bar-content');
    if (announcement) {
        announcement.append('<div class="announcement-bar-content-mobile-left"></div>');
        announcement.append('<div class="announcement-bar-content-mobile-right"></div>');
        jQuery('.announcement-bar-content-mobile-left').append(jQuery('.announcement-bar-content .announcement-bar__link'));
        jQuery('.announcement-bar-content-mobile-right').append(jQuery('.announcement-bar-content .announcement-bar__before_enddate'));
        jQuery('.announcement-bar-content-mobile-right').append(jQuery('.announcement-bar-content .enddate'));
    }
}

jQuery('.comparison_section_text_plus').click(function () {
    jQuery(this).hide();
    jQuery(this).parents('.comparison-section-content-text').find('.comparison_section_text_minus').show();
    jQuery(this).parents('.comparison-section-content-text').find('.comparison_section_text_excerpt').hide();
    jQuery(this).parents('.comparison-section-content-text').find('.comparison_section_text_all').show();
});
jQuery('.comparison_section_text_minus').click(function () {
    jQuery(this).hide();
    jQuery(this).parents('.comparison-section-content-text').find('.comparison_section_text_plus').show();
    jQuery(this).parents('.comparison-section-content-text').find('.comparison_section_text_excerpt').show();
    jQuery(this).parents('.comparison-section-content-text').find('.comparison_section_text_all').hide();
});
setInterval(function () {
    jQuery('.yotpo-read-more').click(function (e) {
        e.preventDefault();
        jQuery(this).hide();
        jQuery(this).parents('.review-body').find('.rest-content-collapsed').css('display', 'inline');
    });
    jQuery('.rest-content-collapsed .yotpo-read-more').click(function (e) {
        e.preventDefault();
        jQuery(this).parents('.review-body').find('.yotpo-read-more').show();
        jQuery(this).parents('.review-body').find('.rest-content-collapsed').hide();
    });
}, 1000);

if (jQuery(window).width() < 1021) {
    jQuery(".site-footer__item-inner--newsletter .search-form").focusin(function () {
        jQuery('#search-modal').show();
        jQuery(".site-footer__item-inner--newsletter .search-form").css('z-index', jQuery('#search-modal').css('z-index') + 1);
    });
    jQuery(".site-footer__item-inner--newsletter .search-form").focusout(function () {
        jQuery('#search-modal').hide();
        jQuery(".site-footer__item-inner--newsletter .search-form").css('z-index', 1);
    });
}
jQuery('.search-results-pagination-right').click(function () {
    var container = jQuery(this).parents('.search-results');
    var currentPage = parseInt(container.find('.search-results-pagination-page').text().trim());
    var nextPage = currentPage + 1;
    if (container.find('.search-results-page[data-page="' + (nextPage) + '"]').length > 0) {
        container.find('.search-results-page[data-page="' + currentPage + '"]').hide();
        container.find('.search-results-page[data-page="' + (nextPage) + '"]').show();
        container.find('.search-results-pagination-page').text(nextPage);
        jQuery('html, body').animate({
            scrollTop: container.find('.search-results-header').offset().top - 150
        }, 0);
    }
});
jQuery('.search-results-pagination-left').click(function () {
    var container = jQuery(this).parents('.search-results');
    var currentPage = parseInt(container.find('.search-results-pagination-page').text().trim());
    if (currentPage > 1) {
        let previousPage = currentPage - 1;
        container.find('.search-results-page[data-page="' + currentPage + '"]').hide();
        container.find('.search-results-page[data-page="' + (previousPage) + '"]').show();
        container.find('.search-results-pagination-page').text(previousPage);

        jQuery('html, body').animate({
            scrollTop: container.find('.search-results-header').offset().top - 150
        }, 0);
    }
});
jQuery('.search-popup-activator *').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    jQuery('.search-popup-activator').hide();
    jQuery('.mobile-menu-search').show();
    jQuery('.mobile-menu-search .search-form__input').focus();
    jQuery('.accessibility-wrap').css('z-index', 1);
});
jQuery(".mobile-menu-close").click(function () {
    jQuery('.search-popup-activator').show();
    jQuery('.mobile-menu-search').hide();
    jQuery('.accessibility-wrap').css('z-index', 2147483647);
});

jQuery('#ouibounce-popup .newsletter__submit').click(function () {
    jQuery('.newsletter-country-phone .smsb-subscribe-button').click();
});

jQuery('.newsletter-close-link').click(function () {
    jQuery(this).parents('#ouibounce-popup').find('#ouibounce-popup-close-icon').click();
});

if (jQuery(window).width() >= 720 && jQuery('.product-badges-slide').length <= 4) {
    jQuery('.product-badge-slider-prev').css('visibility', 'hidden');
    jQuery('.product-badge-slider-next').css('visibility', 'hidden');
}
if (jQuery(window).width() < 720 && jQuery('.product-badges-slide').length <= 2) {
    jQuery('.product-badge-slider-prev').css('visibility', 'hidden');
    jQuery('.product-badge-slider-next').css('visibility', 'hidden');
}
jQuery('.product-badges-slider-inner').slick({
    infinite: true,
    slidesToShow: (jQuery(window).width() >= 720) ? 4 : 2,
    adaptiveHeight: false,
    variableWidth: false,
    autoplay: false,
    vertical: false,
    speed: 500,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    prevArrow: true,
    nextArrow: true,
    swipeToSlide: true
});
jQuery('.product-badge-slider-prev').click(function () {
    jQuery('.product-badges-slider-inner').slick('slickPrev');
});
jQuery('.product-badge-slider-next').click(function () {
    jQuery('.product-badges-slider-inner').slick('slickNext');
});
jQuery('.awards-popup-activator').click(function () {
    jQuery('#awards-modal .collection-awards-section.firmness-popup-section').hide();
    jQuery('#awards-modal .collection-awards-section.firmness-popup-section[data-product="' +
        jQuery(this).attr('data-product') + '"]').show();
    jQuery('#awards-modal').show();
    jQuery('html').css('overflow', 'hidden');
    jQuery('html').css('touch-action', 'none');
    jQuery('html').css('-ms-touch-action', 'none');
    //jQuery('.page-container').css('position', 'fixed');
});
/*
if(jQuery('#shopify-section-badges').length > 0){
  jQuery('#shopify-section-large-tiles-product .large-tile:nth-last-child(2)').css('background-color', '#EEF1E4');
  jQuery('#shopify-section-large-tiles-product .large-tile:nth-last-child(2) h2').css('color', '#384f3b');
  jQuery('#shopify-section-large-tiles-product .large-tile:nth-last-child(2) .large-tile-text p').css('color', '#384f3b');
  jQuery('#shopify-section-large-tiles-product .large-tile:last-child').css('background-color', '#EEF1E4');
  jQuery('#shopify-section-large-tiles-product .large-tile:last-child h2').css('color', '#384f3b');
  jQuery('#shopify-section-large-tiles-product .large-tile:last-child .large-tile-text p').css('color', '#384f3b');

}*/

if (jQuery('.template-product .breadcrumb-collection').length > 0) {
    let found = false;
    jQuery('.template-product .breadcrumb-collection').each(function () {
        if (!found && document.referrer.includes(jQuery(this).attr('data-collection-url'))) {
            jQuery(this).show();
            found = true;
        }
    });
}

/*
Alt text for svg
*/

var selectID = 0;
jQuery('select').each(function () {
    if (jQuery(this).attr('id') == "product-detail-size-chooser") {
        jQuery(this).attr('id', 'product-detail-size-chooser-' + selectID);
        selectID++;
    }
    if (jQuery(this).attr('id') == "product-detail-feel-chooser") {
        jQuery(this).attr('id', 'product-detail-feel-chooser-' + selectID);
        selectID++;
    }
    if (!jQuery(this).attr('title')) {
        jQuery(this).attr('title', 'Select');
    }
});

setInterval(function () {
    var pageTitle = document.title;

    jQuery('svg').each(function () {
        if (jQuery(this).children('title').length == 0) {
            jQuery(this).prepend('<title>' + pageTitle + '</title>');
        }
    });

    jQuery('.label-helpful, .sr-only, svg, g, path, line, circle, text, .product-card__image-wrapper, form[action="/cart/add"]').each(function () {
        if (jQuery(this).parents('.showrooms').length == 0 && jQuery(this).parents('.review-customization') == 0) {

            jQuery(this).removeAttr('id');
        }
    });
    jQuery('a[href="https://www.onthemapmarketing.com/accessibly/"]').attr('tabindex', '-1');
    jQuery('.top-banner-slide').attr('tabindex', '-1');
    jQuery('a[target="_blank"]').each(function () {
        if (jQuery(this).hasClass('social-icons__link')
            || jQuery(this).hasClass('messengermessageus--fixed')
            || jQuery(this).attr('title') == 'On the Map Marketing'
            || jQuery(this).hasClass('accessibly-read-ignore')) {
            jQuery(this).removeAttr('target');
        }
    });
    jQuery('area').each(function () {

        if (!jQuery(this).attr('alt')) {
            jQuery(this).remove();
        }
    });
    jQuery('iframe').each(function () {
        if (!jQuery(this).attr('title')) {
            jQuery(this).attr('title', pageTitle);
        }
    });
    jQuery('.quotes-slide, .vote-btn, .yotpo-read-more').each(function () {
        jQuery(this).removeAttr('aria-describedby');
        jQuery(this).removeAttr('aria-labelledby');
    });

}, 200);
jQuery('.cart__qty-input').attr('title', jQuery('.cart__qty-input').attr('id'));
jQuery("#mattresses-menu-opener a").focus(function (e) {
    setTimeout(function () {
        if (!jQuery('.mattresses-megamenu').hasClass('opened')) {

            jQuery('#bedding-menu-opener').removeClass('opened');
            jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.bedding-megamenu').removeClass('opened');
            });
            jQuery('#furniture-menu-opener').removeClass('opened');
            jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.furniture-megamenu').removeClass('opened');
            });
            jQuery('#home-menu-opener').removeClass('opened');
            jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.home-megamenu').removeClass('opened');
            });
            jQuery('.mattresses-megamenu').css('opacity', '0');
            jQuery('#mattresses-menu-opener .megamenu-opened-icon').css('opacity', '0');
            jQuery('#mattresses-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
            jQuery('.mattresses-megamenu').animate({ opacity: 1 }, 200);
            jQuery('.mattresses-megamenu').addClass('opened');
            jQuery('#mattresses-menu-opener').addClass('opened');
        }
    }, 10);

});
jQuery("#bedding-menu-opener a").focus(function (e) {
    setTimeout(function () {
        if (!jQuery('.bedding-megamenu').hasClass('opened')) {
            jQuery('#mattresses-menu-opener').removeClass('opened');
            jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.mattresses-megamenu').removeClass('opened');
            });
            jQuery('#furniture-menu-opener').removeClass('opened');
            jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.furniture-megamenu').removeClass('opened');
            });
            jQuery('#home-menu-opener').removeClass('opened');
            jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.home-megamenu').removeClass('opened');
            });

            jQuery('.bedding-megamenu').css('opacity', '0');
            jQuery('#bedding-menu-opener .megamenu-opened-icon').css('opacity', '0');
            jQuery('#bedding-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
            jQuery('.bedding-megamenu').animate({ opacity: 1 }, 200);
            jQuery('.bedding-megamenu').addClass('opened');
            jQuery('#bedding-menu-opener').addClass('opened');
        }
    }, 10);

});
jQuery("#furniture-menu-opener a").focus(function (e) {
    setTimeout(function () {
        if (!jQuery('.furniture-megamenu').hasClass('opened')) {
            jQuery('#mattresses-menu-opener').removeClass('opened');
            jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.mattresses-megamenu').removeClass('opened');
            });
            jQuery('#bedding-menu-opener').removeClass('opened');
            jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.bedding-megamenu').removeClass('opened');
            });
            jQuery('#home-menu-opener').removeClass('opened');
            jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.home-megamenu').removeClass('opened');
            });
            jQuery('.furniture-megamenu').css('opacity', '0');
            jQuery('#furniture-menu-opener .megamenu-opened-icon').css('opacity', '0');
            jQuery('#furniture-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
            jQuery('.furniture-megamenu').animate({ opacity: 1 }, 200);
            jQuery('.furniture-megamenu').addClass('opened');
            jQuery('#furniture-menu-opener').addClass('opened');
        }
    }, 10);

});
jQuery("#home-menu-opener a").focus(function (e) {
    setTimeout(function () {
        if (!jQuery('.home-megamenu').hasClass('opened')) {
            jQuery('#mattresses-menu-opener').removeClass('opened');
            jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.mattresses-megamenu').removeClass('opened');
            });
            jQuery('#bedding-menu-opener').removeClass('opened');
            jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.bedding-megamenu').removeClass('opened');
            });
            jQuery('#furniture-menu-opener').removeClass('opened');
            jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.furniture-megamenu').removeClass('opened');
            });
            jQuery('.home-megamenu').css('opacity', '0');
            jQuery('#home-menu-opener .megamenu-opened-icon').css('opacity', '0');
            jQuery('#home-menu-opener .megamenu-opened-icon').animate({ opacity: 1 }, 200);
            jQuery('.home-megamenu').animate({ opacity: 1 }, 200);
            jQuery('.home-megamenu').addClass('opened');
            jQuery('#home-menu-opener').addClass('opened');
        }
    }, 10);
});
jQuery('.collections-row-cell-upper').click(function () {
    jQuery(this).parents('.collections-row-cell').find('.comparison-collection-link').click();
});

if (jQuery(window).width() >= 720) {
    if (jQuery('.slideshow-new').length > 0) {

        jQuery('.slideshow-new-slide').css('-moz-transition', 'all 1s ease');
        jQuery('.slideshow-new-slide').css('-webkit-transition', 'all 1s ease');
        jQuery('.slideshow-new-slide').css('-o-transition', 'all 1s ease');
        jQuery('.slideshow-new-slide').css('transition', 'all 1s ease');



        homeSlideFirst();
        setInterval(function () {
            homeSlide();
        }, 12000);


    }
}
else {

    jQuery('.slideshow-new-slide').each(function () {
        jQuery(this).css('background-image',
            'url(' + jQuery(this).attr('data-mobile-image') + ')');
    });

    if (jQuery('.slideshow-new').length > 0) {

        jQuery('.slideshow-new-slide').css('-moz-transition', 'all 1s ease');
        jQuery('.slideshow-new-slide').css('-webkit-transition', 'all 1s ease');
        jQuery('.slideshow-new-slide').css('-o-transition', 'all 1s ease');
        jQuery('.slideshow-new-slide').css('transition', 'all 1s ease');


        homeSlideMobileFirst();
        setInterval(function () {
            homeSlideMobile();
        }, 5000);


    }

}
function homeSlide() {
    current = parseInt(jQuery('.slideshow-new').attr('data-active-slide'));
    next = (2 + current);
    if (next > jQuery('.slideshow-new-slide').length) {
        next = 1;
    }
    let currentSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + current + '"]');
    let currentSlide2 = jQuery('.slideshow-new-slide[data-slidenumber="' + (1 + current) + '"]');
    let nextSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + next + '"]');
    let nextSlide2 = jQuery('.slideshow-new-slide[data-slidenumber="' + (1 + next) + '"]');
    setTimeout(function () {
        currentSlide1.find('.slideshow-new-inner').addClass('passive');
    }, 0);
    setTimeout(function () {
        currentSlide2.find('.slideshow-new-inner').addClass('passive');
    }, 800);
    setTimeout(function () {
        currentSlide1.removeClass('active');
        currentSlide1.find('img').addClass('passive');
    }, 1600);
    setTimeout(function () {
        currentSlide2.removeClass('active');
        currentSlide2.find('img').addClass('passive');
    }, 2400);
    setTimeout(function () {
        nextSlide1.addClass('active');
        nextSlide1.find('img').removeClass('passive');

    }, 3200);
    setTimeout(function () {
        nextSlide2.addClass('active');
        nextSlide2.find('img').removeClass('passive');

    }, 4000);
    setTimeout(function () {
        nextSlide1.find('.slideshow-new-inner').removeClass('passive');
    }, 4800);
    setTimeout(function () {
        nextSlide2.find('.slideshow-new-inner').removeClass('passive');
    }, 5600);
    jQuery('.slideshow-new').attr('data-active-slide', (next));
}
function homeSlideFirst() {
    current = parseInt(jQuery('.slideshow-new').attr('data-active-slide'));
    next = (2 + current);
    if (next > jQuery('.slideshow-new-slide').length) {
        next = 1;
    }
    let currentSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + current + '"]');
    let currentSlide2 = jQuery('.slideshow-new-slide[data-slidenumber="' + (1 + current) + '"]');
    let nextSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + next + '"]');
    let nextSlide2 = jQuery('.slideshow-new-slide[data-slidenumber="' + (1 + next) + '"]');
    setTimeout(function () {
        nextSlide1.addClass('active');
        nextSlide1.find('img').removeClass('passive');
    }, 0);
    setTimeout(function () {
        nextSlide2.addClass('active');
        nextSlide2.find('img').removeClass('passive');
    }, 800);
    setTimeout(function () {
        nextSlide1.find('.slideshow-new-inner').removeClass('passive');
    }, 1600);
    setTimeout(function () {
        nextSlide2.find('.slideshow-new-inner').removeClass('passive');
    }, 2400);
    jQuery('.slideshow-new').attr('data-active-slide', (next));
}
function homeSlideMobile() {
    current = parseInt(jQuery('.slideshow-new').attr('data-active-slide'));
    next = (1 + current);
    if (next > jQuery('.slideshow-new-slide').length) {
        next = 1;
    }
    let currentSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + current + '"]');
    let nextSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + next + '"]');
    setTimeout(function () {
        currentSlide1.find('.slideshow-new-inner').addClass('passive');
    }, 0);

    setTimeout(function () {
        currentSlide1.removeClass('active');
    }, 800);

    setTimeout(function () {
        nextSlide1.addClass('active');
    }, 1600);

    setTimeout(function () {
        nextSlide1.find('.slideshow-new-inner').removeClass('passive');
    }, 2400);

    jQuery('.slideshow-new').attr('data-active-slide', (next));
}
function homeSlideMobileFirst() {
    current = parseInt(jQuery('.slideshow-new').attr('data-active-slide'));
    next = (1 + current);
    if (next > jQuery('.slideshow-new-slide').length) {
        next = 1;
    }
    if (next == 0) {
        next = 1;
    }
    let currentSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + current + '"]');
    let nextSlide1 = jQuery('.slideshow-new-slide[data-slidenumber="' + next + '"]');


    nextSlide1.addClass('active');


    setTimeout(function () {
        nextSlide1.find('.slideshow-new-inner').removeClass('passive');
    }, 800);

    jQuery('.slideshow-new').attr('data-active-slide', (next));
}

if (jQuery(window).width() >= 720) {
    jQuery('.top-banner-slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        jQuery('.top-banner-slides-prev').animate({ left: ((jQuery(window).width() - jQuery('.top-banner-slides .slick-slide[data-slick-index="' + nextSlide + '"] span').width()) / 2 - 40) + "px" }, 700);
        jQuery('.top-banner-slides-next').animate({ right: ((jQuery(window).width() - jQuery('.top-banner-slides .slick-slide[data-slick-index="' + nextSlide + '"] span').width()) / 2 - 40) + "px" }, 700);
    });

}

var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
if (isChrome) {
    jQuery('body').addClass('chrome');
}


setTimeout(function () {
    jQuery('.review-customization img, .real-review-header img').each(function () {
        jQuery(this).attr('src', jQuery(this).attr('data-src'));
    });
}, 1000);
/*
if(jQuery(window).width() < 1020){
  jQuery('.template-product .large-tile-left').each(function(){
    jQuery(this).prev().insertAfter(jQuery(this));
  });
}
*/
setInterval(function () {
    jQuery('.header-content meta').each(function () {
        if (jQuery(this).attr('name') == "google-site-verification") {
            //console.log(jQuery(this).attr('name'));
            //console.log(jQuery(this).attr('name', 'removed'));
            //console.log(jQuery(this).attr('name'));
        }
    });

}, 1000);

jQuery('.popup-container').height(jQuery(document).height());


if (jQuery(window).width() < 2200) {
    jQuery('#shopify-section-header').prepend(jQuery('.cart-modal'));
}

jQuery('.cart-close-icon').click(function (e) {
    e.preventDefault();
    jQuery('.cart-modal').hide();
    jQuery('.page-container').css('position', 'inherit');
    jQuery('html').css('overflow-y', 'auto');
    jQuery('html').css('touch-action', 'auto');
    jQuery('html').css('-ms-touch-action', 'auto');
});

$(function () {
    $("#sale-popup").click(function (e) {
        e.stopPropagation();
    });


    jQuery('body').on('click', '.open-discount-detail', function (e) {
        e.preventDefault();
        jQuery('#sale-modal').show();
        jQuery('html').css('overflow', 'hidden');
        jQuery('html').css('touch-action', 'none');
        jQuery('html').css('-ms-touch-action', 'none');
    });

    jQuery('body').on('click', '#sale-modal', function (e) {
        e.preventDefault();
        jQuery('#sale-modal').hide();
        jQuery('html').css('overflow-y', 'auto');
        jQuery('html').css('touch-action', 'auto');
        jQuery('html').css('-ms-touch-action', 'auto');
    });


});

$(function () {
    var badges_container = jQuery('.cart-badges-js');
    var cart_badges = jQuery('.cart-badges-section');
    if (badges_container.length && cart_badges.length) {
        cart_badges.appendTo(badges_container);
    }
});

/*
Product feel help
*/
if (jQuery('.feel-help').length > 0) {
    setInterval(function () {
        jQuery('.feel-help-unit').each(function () {
            var variant = jQuery(this).find('.feel-help-feel').text().trim();
            var headline = jQuery(this).find('.feel-help-headline').text().trim();
            var description = jQuery(this).find('.feel-help-description').html();
            jQuery('.product-detail-description-right, .quickbuy-popup-content-right').find('.option-flex').each(function () {
                if (jQuery(this).find('.feel-help-icon').length == 0
                    && jQuery(this).find('span').first().text() == variant) {
                    var whereAppend = jQuery(this);
                    if (jQuery(this).find('.video-popup-button').length != 0) {
                        whereAppend.append('<span class="append-place"></span>');
                        whereAppend.find('.append-place').append(whereAppend.find('.video-popup-button'));
                        whereAppend = whereAppend.find('.append-place');
                    }
                    whereAppend.append('<span class="feel-help-icon-popup"><svg class="feel-help-icon" id="medium-rollover" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">' +
                        '<g transform="translate(0 2)" fill="none" stroke="#384f3b" stroke-width="1">' +
                        '<circle cx="9" cy="9" r="9" stroke="none"/>' +
                        '<circle cx="9" cy="9" r="8.5" fill="none"/>' +
                        '</g>' +
                        '<text id="_" data-name="?" transform="translate(9 16)" fill="#384f3b" font-size="14" font-family="SegoeUI-Bold, Segoe UI" font-weight="700" letter-spacing="0.05em"><tspan x="-3.066" y="0">?</tspan></text></svg>' +
                        '<div class="feel-help-popup"><span class="feel-help-popup-headline">' + headline +
                        '</span><span class="feel-help-popup-text">' + description +
                        '</span></div>' +
                        '</span>');
                }
            });
        });

        if (jQuery(window).width() < 700) {
            jQuery('.feel-help-icon-popup svg').click(function (e) {
                jQuery('.feel-help-popup').hide();
                jQuery(this).parents('.feel-help-icon-popup').find('.feel-help-popup').show();
                e.preventDefault();
                e.stopPropagation();
            });
            jQuery('.feel-help-popup').click(function (e) {
                jQuery(this).hide();
                e.preventDefault();
                e.stopPropagation();
            });
        } else {
            jQuery('.feel-help-icon-popup').mouseenter(function () {
                jQuery(this).find('.feel-help-popup').show();
            });
            jQuery('.feel-help-icon-popup').mouseleave(function () {
                jQuery(this).find('.feel-help-popup').hide();
            });
        }


        if (jQuery(window).width() < 700) {
            jQuery('.feel-help-popup').css('right', '70px');
            jQuery('.feel-help-popup').css('top', '0px');
        } else {
            jQuery('.feel-help-popup').css('right', '75px');
        }

    }, 1000);
}

jQuery('.tile-video-wrapper').each(function () {
    let id = jQuery(this).find('video').attr('id');
    if (jQuery(document).scrollTop() + jQuery(window).height() > jQuery(this).offset().top) {
        jQuery(this).find('svg').hide();
        jQuery(this).find('video').css('opacity', 1);
        var vid = document.getElementById(id);
        vid.play();
        jQuery(this).addClass('played');
    }

    jQuery(this).find('video').on('ended', function () {
        jQuery(this).css('opacity', 0);
        jQuery(this).parents('.tile-video-wrapper').find('.repeat-play').show();
    });


});
jQuery(document).scroll(function () {
    jQuery('.tile-video-wrapper').each(function () {
        if (!jQuery(this).hasClass('played')) {
            if (jQuery(document).scrollTop() + jQuery(window).height() > jQuery(this).offset().top) {
                jQuery(this).find('svg').hide();
                jQuery(this).find('video').css('opacity', 1);
                let id = jQuery(this).find('video').attr('id');
                var vid = document.getElementById(id);
                vid.play();
                jQuery(this).addClass('played');
            }
        }
    });


});

jQuery('.tile-video-wrapper svg').click(function () {
    jQuery(this).hide();
    jQuery(this).parents('.tile-video-wrapper').find('video').css('opacity', 1);
    let id = jQuery(this).parents('.tile-video-wrapper').find('video').attr('id');
    var vid = document.getElementById(id);
    vid.play();
});



/*
Sustainability page
*/

if (jQuery('.sustainable').length > 0) {
    jQuery('.main-content').css('padding-top', '55px');
}
jQuery('.the-certification__list .item').click(function () {
    let id = jQuery(this).attr('id');
    jQuery('.certif-popup').hide();
    jQuery('.certif-popup[data-certificate="' + id + '"]').show();
});
jQuery('.cert-popup-close').click(function () {
    jQuery(this).parent().hide();
});

jQuery('.read-more-link').click(function (e) {
    e.preventDefault();
    jQuery(this).hide();
    jQuery(this).parent().find('.read-more-text').show();
});

jQuery('.product-large-tiles').each(function () {
    let lastTile = jQuery(this).find('.large-tile-container').last();
    lastTile.find('.large-tile-left').css('background-color', '#71695E');
    lastTile.find('.large-tile-text p').css('color', 'white');
    lastTile.find('h2').css('color', 'white');

});

function closePopup() {
    const stateList = document.querySelectorAll('.state');
    for (let i = 0; i < stateList.length; i++) {
        let currentState = stateList[i];
        if (!currentState.classList.contains('hide')) {
            currentState.classList.add('hide');
        }
    }
}

function popup(state) {
    closePopup();
    document.querySelector(`.state.${state.id}`).classList.remove('hide');
}

jQuery('.weekday').click(function () {
    let weekday = jQuery(this).attr('data-weekday');
    jQuery('.weekday').removeClass('active');
    jQuery('.weekday[data-weekday="' + weekday + '"]').addClass('active');
    jQuery('.popular-times-day').removeClass('active');
    jQuery('.popular-times-day[data-weekday="' + weekday + '"]').addClass('active');
});

function tableToogle() {
    document.querySelector('#hours-arrow').style.display = 'none';
    document.querySelector('#more-hours').style.display = 'block';
}

// Floating Menu Mock for showroom page

if (jQuery('.showroom__content').length > 0) {
    var lastScrollPosition = 0;
    var heightPlus = jQuery('.sticky-header').outerHeight();

    jQuery(document).scroll(function () {
        let height = jQuery('.store-fixed__content').outerHeight();
        jQuery('#shopify-section-header').css('transition', 'transform 1s ease');
        jQuery('#shopify-section-header').css('position', 'fixed');
        jQuery('#shopify-section-header').css('z-index', '2');
        jQuery('#shopify-section-header').css('width', '100vw');
        if (jQuery(document).scrollTop() >= jQuery('.product-specs').offset().top) {
            jQuery('.store-fixed-background').css('position', 'fixed');
            jQuery('.store-fixed-background').show();
            jQuery('.store-fixed__content').show();
            jQuery('.store-fixed-background').css('top', '-' + height + 'px');
            jQuery('.store-fixed-background').css('transition', 'transform 1s ease');
            if (!lastScrollPosition || lastScrollPosition < jQuery(document).scrollTop()) {
                jQuery('#shopify-section-header').css('transform', 'translateY(-' + heightPlus + 'px)');
                jQuery('.store-fixed-background').css('top', '-' + height + 'px');
                jQuery('.store-fixed-background').css('transform', 'translateY(' + height + 'px)');
                jQuery('.store-fixed-background').css('z-index', 2);
            }
            else {
                jQuery('#shopify-section-header').css('transform', 'translateY(0px)');
                jQuery('.store-fixed-background').css('transform', 'translateY(' + (height + heightPlus - 2) + 'px)');
                jQuery('.store-fixed-background').css('z-index', 1);
            }


        } else {
            jQuery('#shopify-section-header').css('transform', 'translateY(0px)');
            jQuery('.store-fixed-background').css('transform', 'translateY(-' + height + 'px)');
            jQuery('.store-fixed-background').css('z-index', 1);

        }
        lastScrollPosition = jQuery(document).scrollTop();
    });
}

jQuery('.sticky-product-specs-footer .collection-detail-product-link').click(function () {
    jQuery(window).scrollTop(0);
});

// End Floating menu mock



/*
Scroll from floating menu to Google reviews
*/
jQuery('.google-place-rating, .stars-reviews').click(function () {
    let top = jQuery('#google-review-header').offset().top;
    window.scrollTo(0, top - 150);
});

if (jQuery(window).width() > 1020) {

    jQuery('.stores-menu').click(function (e) {
        // e.preventDefault();
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    });
    jQuery('.stores-menu').focus(function (e) {
        jQuery('#mattresses-menu-opener').removeClass('opened');
        jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.mattresses-megamenu').removeClass('opened');
        });
        jQuery('#bedding-menu-opener').removeClass('opened');
        jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.bedding-megamenu').removeClass('opened');
        });
        jQuery('#furniture-menu-opener').removeClass('opened');
        jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.furniture-megamenu').removeClass('opened');
        });
        jQuery('#home-menu-opener').removeClass('opened');
        jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
            jQuery('.home-megamenu').removeClass('opened');
        });
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    });
    jQuery('a').focusin(function (e) {
        if (jQuery(this).parents('.stores-dropdown').length == 0 && !jQuery(this).hasClass('stores-menu')) {
            jQuery('.stores-dropdown').css('display', 'none');
            jQuery('.stores-dropdown-arrow').css('display', 'none');
        }
        if (jQuery(this).parents('.help-dropdown').length == 0 && !jQuery(this).hasClass('help-menu')) {
            jQuery('.help-dropdown').css('display', 'none');
            jQuery('.help-dropdown-arrow').css('display', 'none');
        }
        if (jQuery(this).parents('.reviews-dropdown').length == 0 && !jQuery(this).hasClass('reviews-menu')) {
            jQuery('.reviews-dropdown').css('display', 'none');
            jQuery('.reviews-dropdown-arrow').css('display', 'none');
        }
        if (jQuery(this).parents('#mattresses-menu-opener').length == 0
            && jQuery(this).parents('#bedding-menu-opener').length == 0
            && jQuery(this).parents('#furniture-menu-opener').length == 0
            && jQuery(this).parents('#home-menu-opener').length == 0) {
            jQuery('#mattresses-menu-opener').removeClass('opened');
            jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.mattresses-megamenu').removeClass('opened');
            });
            jQuery('#bedding-menu-opener').removeClass('opened');
            jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.bedding-megamenu').removeClass('opened');
            });
            jQuery('#furniture-menu-opener').removeClass('opened');
            jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.furniture-megamenu').removeClass('opened');
            });
            jQuery('#home-menu-opener').removeClass('opened');
            jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.home-megamenu').removeClass('opened');
            });
        }
    });
    jQuery('.stores-menu').hover(function (e) {
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.stores-dropdown').css('display', 'none');
        jQuery('.stores-dropdown-arrow').css('display', 'none');
    });
    jQuery('.stores-dropdown').hover(function (e) {
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.stores-dropdown').css('display', 'none');
        jQuery('.stores-dropdown-arrow').css('display', 'none');
    });
    jQuery('.stores-dropdown-arrow').hover(function (e) {
        jQuery('.stores-dropdown').css('display', 'grid');
        jQuery('.stores-dropdown-arrow').css('display', 'block');
    }, function () {
        jQuery('.stores-dropdown').css('display', 'none');
        jQuery('.stores-dropdown-arrow').css('display', 'none');
    });
}

let largeTiles = document.querySelectorAll('.product-large-tiles .large-tile-left');
if (largeTiles.length == 1) {

    largeTiles[0].style.background = '#384f3b'

}

if (largeTiles.length == 2) {

    largeTiles[1].style.background = '#eef1e4'
    largeTiles[1].children[1].style.color = '#384f3b';
    //console.log(largeTiles[1].children)
    //console.log(largeTiles[1].children.length)

    for (let i = 0; i < largeTiles[1].children.length; i++) {
        largeTiles[1].children[i].style.color = '#384f3b'
    }

    for (let j = 0; j < largeTiles[1].children[1].children.length; j++) {
        largeTiles[1].children[1].children[j].style.color = '#384f3b';
    }

    //     largeTiles[1].children[2].children[0].style.color = '#384f3b';
    //     largeTiles[1].children[2].children[1].style.color = '#384f3b';
    //console.log(largeTiles[1].children[2])


}

// if(largeTiles.length == 3){

// 	largeTiles[2].style.background = '#71695e'
//       //console.log(largeTiles[2].style.background + "Style Background")
// }

jQuery('.comparison-competitors tr').each(function () {
    //console.log(jQuery(this).find('th').height());
    jQuery(this).find('td').height(jQuery(this).find('th').height());
});

jQuery('#sms-consent-checkbox').change(function () {
    if (jQuery(this).is(":checked")) {
        jQuery('.account-phone').show();
    } else {
        jQuery('.account-phone').hide();
        jQuery('.account-phone input').val('');

    }
});

jQuery('.signup-part input[type="submit"], .sms-popup-submit').click(function () {
    jQuery('.newsletter-country-phone .smsb-subscribe-button').click();
});


jQuery('.sms-popup-submit').click(function () {
    if (jQuery(this).find('.newsletter__submit-text--large').text() == 'CLOSE') {
        jQuery('body').removeClass('sms-submitted');
        jQuery('#sms-popup').find('.popup-close-icon').click();
        jQuery('#sms-popup .newsletter-country-phone').remove();
        jQuery('#sms-popup .newsletter__submit-text--large').text('SUBMIT');
        jQuery('<div class="newsletter-country-phone" style="width: 100%; max-width: 1200px; margin-left: -15px; margin-right: -15px; padding-top: 15px; padding-bottom: 15px; margin: 0 auto;"><div><script type="text/javascript" src="https://dhv2ziothpgrr.cloudfront.net/196352/form_32746.js?ver=1612290931"></script></div></div>').insertBefore('#sms-popup .popup-footer');
        setTimeout(function () {
            jQuery('.newsletter-country-phone .phone-field').attr('type', 'text');
            jQuery('.newsletter-country-phone .phone-field').attr('placeholder', 'Phone +1');

            jQuery('.newsletter-country-phone select').hide();
            jQuery('.newsletter-country-phone select').val('US');
        }, 1000);
    } else {

        jQuery('body').addClass('sms-submitted');
    }
});

setInterval(function () {
    if (jQuery('.success-container').length != 0 && jQuery('body').hasClass('sms-submitted')) {
        jQuery('#sms-popup .newsletter__submit-text--large').text('CLOSE');
    }
}, 100);


jQuery('.sms-submit').click(function () {
    jQuery('#sms-modal').show();
    jQuery('html').css('overflow', 'hidden');
    jQuery('html').css('touch-action', 'none');
    jQuery('html').css('-ms-touch-action', 'none');
});

jQuery('#geolocation-popup-close-icon').click(function () {
    jQuery('.geolocation-popup').hide();
    Cookies.set('shops-click', 'true', { expires: 1 });
});


if (jQuery('.classic-quotes').length > 0) {
    setInterval(function () {
        if (jQuery(window).width() <= 1020) {
            jQuery('.classic-quotes').each(function () {
                if (jQuery(this).find('.quotes-slide').length - jQuery(this).find('.hidden-slide').length > 2) {
                    jQuery(this).find('.quotes-slide').addClass('hidden-slide');
                    jQuery(this).find('.quotes-slide').first().removeClass('hidden-slide');
                }
            });

        } else {
            jQuery('.classic-quotes').each(function () {
                if (jQuery(this).find('.quotes-slide').length - jQuery(this).find('.hidden-slide').length <= 2) {
                    jQuery(this).find('.quotes-slide').addClass('hidden-slide');
                    jQuery(this).find('.quotes-slide').first().removeClass('hidden-slide');
                    jQuery(this).find('.quotes-slide').eq(1).removeClass('hidden-slide');
                    jQuery(this).find('.quotes-slide').eq(2).removeClass('hidden-slide');
                }
            });
        }

    }, 1000);
}

jQuery('.comparison-section-icon').click(function () {
    if (jQuery(this).hasClass('opened')) {
        jQuery(this).find('.comparison-section-icon-plus').show();
        jQuery(this).find('.comparison-section-icon-minus').hide();
        jQuery(this).parents('.comparison-section-content').find('.comparison-section-text-excerpt').show();
        jQuery(this).parents('.comparison-section-content').find('.comparison-section-text-full').hide();
        jQuery(this).removeClass('opened');
    } else {
        jQuery(this).find('.comparison-section-icon-plus').hide();
        jQuery(this).find('.comparison-section-icon-minus').show();
        jQuery(this).parents('.comparison-section-content').find('.comparison-section-text-excerpt').hide();
        jQuery(this).parents('.comparison-section-content').find('.comparison-section-text-full').show();
        jQuery(this).addClass('opened');
    }

});

if (jQuery('.inner-product-table').length > 0 && jQuery('.inner-product-table tr').first().find('td').length < 3) {
    jQuery('.inner-product-table').addClass('small-table');
}

if (jQuery(window).width() < 700) {
    jQuery('.faq-reference-section').css('background-image', 'url(' + jQuery('.faq-reference-section').attr('data-mobile-background') + ')');
}

jQuery('.mobile-more-open').click(function () {
    jQuery(this).parents('.mattresses-block-description').find('.mobile-more-close').show();
    jQuery(this).parents('.mattresses-block-description').find('.mobile-more').show();
    jQuery(this).hide();
});
jQuery('.mobile-more-close').click(function () {
    jQuery(this).parents('.mattresses-block-description').find('.mobile-more-open').show();
    jQuery(this).parents('.mattresses-block-description').find('.mobile-more').hide();
    jQuery(this).hide();
});

jQuery('.specs-header').click(function () {
    jQuery(this).parents('.mattresses-block-detail').find('.specs-header').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).parents('.mattresses-block-detail').find('.specs-item').removeClass('active');
    jQuery(this).parents('.mattresses-block-detail').find('.specs-item[data-specs="' + jQuery(this).attr('data-specs') + '"]').addClass('active');
});

jQuery('.specs-item-headline').click(function () {
    if (jQuery(this).parents('.specs-item').find('.specs-item-text.active').length == 0) {
        jQuery(this).parents('.specs-item').find('.specs-item-text').addClass('active');
        jQuery(this).parents('.specs-item').find('.specs-minus').show();
        jQuery(this).parents('.specs-item').find('.specs-plus').hide();
    } else {
        jQuery(this).parents('.specs-item').find('.specs-item-text').removeClass('active');
        jQuery(this).parents('.specs-item').find('.specs-minus').hide();
        jQuery(this).parents('.specs-item').find('.specs-plus').show();
    }
});

jQuery('.sleeper-icons').each(function () {
    var columnCount = jQuery(this).attr('data-column-count');
    if (columnCount == '1') {
        jQuery(this).css('grid-template-columns', 'auto');
    } else if (columnCount == '2') {
        jQuery(this).css('grid-template-columns', 'auto auto');
    } else if (columnCount == '3') {
        jQuery(this).css('grid-template-columns', 'auto auto auto');
    }
});
/*
if(jQuery('.collection-detail-product-card-image').length > 0){
  setTimeout(function(){
  var imageHeight = jQuery('.collection-detail-product-card-image').first().height();
    jQuery('.collection-detail-product-card-image').each(function(){
      if(imageHeight < jQuery('.collection-detail-product-card-image').height()){
          imageHeight = jQuery('.collection-detail-product-card-image').height();
      }
    });
    //console.log("height:" + imageHeight);
    jQuery('.collection-detail-product-card-image').height(imageHeight + 'px');
  }, 1000);
}
*/


function slideProductReferencesOnMobile() {
    var currentIndex = parseInt(jQuery('.product-reference-tiles').attr('data-current-index'));
    jQuery('.product-reference-wrapper').hide();
    jQuery('.product-reference-wrapper[data-index="' + currentIndex + '"]').show();
}
if (jQuery('.product-reference-tiles').length > 0 && jQuery(window).width() <= 720) {
    slideProductReferencesOnMobile();
    jQuery('.product-reference-arrow-prev').click(function () {
        var currentIndex = parseInt(jQuery('.product-reference-tiles').attr('data-current-index'));
        if (currentIndex == 1) {
            currentIndex = jQuery('.product-reference-wrapper').last().attr('data-index');
        } else {
            currentIndex--;
        }
        jQuery('.product-reference-tiles').attr('data-current-index', currentIndex);
        slideProductReferencesOnMobile();

    });
    jQuery('.product-reference-arrow-next').click(function () {
        var currentIndex = parseInt(jQuery('.product-reference-tiles').attr('data-current-index'));
        var maxIndex = parseInt(jQuery('.product-reference-wrapper').last().attr('data-index'));
        if (currentIndex == maxIndex) {
            currentIndex = 1;
        } else {
            currentIndex++;
        }
        jQuery('.product-reference-tiles').attr('data-current-index', currentIndex);
        slideProductReferencesOnMobile();
    });
}

if (jQuery(window).width() <= 720) {
    if (jQuery('.header-image').length > 0 && jQuery('.header-image').last().attr('data-mobile-image') != '') {
        jQuery('.header-image').last().css('background-image',
            'url(' + jQuery('.header-image').last().attr('data-mobile-image') + ')');
    }
}

jQuery('#klaviyo-phone').click(function () {
    //console.log('klaviyo');
});

if (jQuery('.variant .unavailable').length > 0 && false) {
    setInterval(function () {
        jQuery('.variant .unavailable').each(function () {

            var options = jQuery(this).attr('data-unavailable-options').split(',');
            var name = jQuery(this).parent().find('.variant-option').text();

            jQuery(this).parents('.product-detail-description-right, .quickbuy-popup-content-right')
                .find('.option-flex').each(function () {
                    var container = jQuery(this).parents('.product-detail-description-right, .quickbuy-popup-content-right');
                    if (jQuery(this).find('.unavailable-link').length == 0
                        && jQuery(this).find('span').first().text() == name) {
                        var valid = true;
                        var first = true;
                        container.find('.styledSelect .option-flex').each(function () {
                            if (!first) {
                                if (!options.includes(jQuery(this).find('span').first().text())
                                    &&
                                    !(container.hasClass('product-detail-description-right')
                                        && jQuery(this).parents('.quickbuy-popup-content-right').length > 0)
                                ) {
                                    valid = false;
                                }
                            } else {
                                first = false;
                            }

                        });


                        if (valid) {
                            console.log(valid);
                            if (jQuery(this).find('.option-sale:visible').length == 0
                                || jQuery(this).find('.option-sale').text() == '$0.00'
                            ) {
                                jQuery(this).parents('.styledSelect').css('pointer-events', 'all');
                                jQuery(this).find('.option-second').html('<a href="#" class="unavailable-link">Notify Me</a><s style="margin-right:15px;display:none;">$0.00</s><span style="display:none;" class="option-sale">$0.00</span>');
                                jQuery(this).addClass('klaviyo-bis-trigger');
                            }
                        }

                    }
                });
        });
        jQuery('.unavailable-link').click(function (e) {


            /*e.preventDefault();
            e.stopPropagation();*/
            let rel = jQuery(this).parents('.option-flex').attr('rel');

            if (!rel) {

                rel = jQuery(this).parents('.option-flex').find('span:first-child()').text().trim();

            }
            e.preventDefault();
            e.stopPropagation();

            jQuery('html').attr('data-klaviyo', rel);


            //jQuery('.options li[rel="' + rel + '"]').click();


            if (jQuery('.btn.klaviyo-bis-trigger').length)
                jQuery('.btn.klaviyo-bis-trigger')[0].click();
            if (jQuery(this).closest('li').length) {

                jQuery(this).closest('li').click();
            }

            jQuery('html').css('overflow', 'hidden');
            jQuery('html').css('touch-action', 'none');
            jQuery('html').css('-ms-touch-action', 'none');
            jQuery('html').css('-webkit-touch-action', 'none');
            jQuery('html').addClass('klaviyo-shown');
            jQuery('#klaviyo-bis-iframe').css('visibility', 'hidden');
            setTimeout(function () {
                jQuery('#klaviyo-bis-iframe').css('visibility', 'visible');
            }, 1000);

        });
        setInterval(function () {
            if (jQuery('#klaviyo-bis-iframe').css('display') == 'none' && jQuery('html').hasClass('klaviyo-shown')) {
                jQuery('html').removeClass('klaviyo-shown');
                jQuery('html').css('overflow-y', 'auto');
                jQuery('html').css('touch-action', 'auto');
                jQuery('html').css('-webkit-touch-action', 'auto');
                jQuery('html').css('-ms-touch-action', 'auto');
            }
        }, 500);
        jQuery('.quickbuy-popup-content-right').each(function () {
            if (jQuery(this).find('.styledSelect .option-flex .unavailable-link').length > 0) {
                jQuery(this).find('.product-form__cart-submit').attr('aria-disabled', 'true');
                jQuery(this).find('.product-form__cart-submit').attr('aria-label', 'Sold out');
                jQuery(this).find('.addtocart-text').text(' Sold out ');
            }

            else
                if (jQuery(this).find('.styledSelect .option-flex').length > 0
                    && jQuery(this).find('.product-form__cart-submit[aria-disabled="true"]').length > 0) {
                    jQuery(this).find('.product-form__cart-submit').removeAttr('aria-disabled');
                    jQuery(this).find('.product-form__cart-submit').attr('aria-label', 'Add to cart');
                    jQuery(this).find('.addtocart-text').text(' Add to cart ');
                }

        });
        jQuery('.product-detail-description-right .product-form-main').each(function () {
            if (jQuery(this).find('.styledSelect .option-flex .unavailable-link').length > 0) {
                jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').attr('aria-disabled', 'true');
                jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').attr('aria-label', 'Sold out');
                jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-text').text(' Sold out ');
                jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-subtext').hide();
            }

            else

                if (jQuery(this).find('.styledSelect .option-flex').length > 0
                    && jQuery(this).parents('.product-detail-description-right').find('.main-product-btn[aria-disabled="true"]').length > 0) {
                    jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').removeAttr('aria-disabled');
                    jQuery(this).parents('.product-detail-description-right').find('.main-product-btn').attr('aria-label', 'Add to cart');
                    jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-text').text(' Add to cart ');
                    jQuery(this).parents('.product-detail-description-right').find('.main-product-btn .addtocart-subtext').show();
                }

        });

    }, 1000);
}

//Yotpo Reviews via API
function loadYotpoReviews(productGrid, productID, page, customCount, container, search, filter) {
    jQuery('.no-reviews').hide();


    var url = 'https://api-cdn.yotpo.com/v1/widget/CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x/products/'
        + productID + '/reviews.json?page=' + page;
    var url2 = 'https://api-cdn.yotpo.com/v1/reviews/CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x/filter.json?page=' + page;


    if (search || productID == 'yotpo_site_reviews') {
        url += '&per_page=150';
        url2 += '&per_page=150';
        url = url.replace('?page=' + page, '?page=1');
    }


    var customFilter = false;
    var scores = [];
    if (filter) {
        if (filter == 'star5') {
            url += '&star=5';
            scores.push(5);
        } else if (filter == 'star1') {
            url += '&star=1';
            scores.push(1);
        } else {
            customFilter = true;
        }
    }

    if (customFilter || (search && !customFilter)) {
        jQuery('.yotpo.new-yotpo-small-box.reviews')
            .prepend('<svg  class="loader" style="position:absolute;z-index:1000;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(252, 252, 252); display: block; shape-rendering: auto;" width="160px" height="160px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">' +
                '<path fill="none" stroke="#384F3B" stroke-width="8" stroke-dasharray="42.76482137044271 42.76482137044271" d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z" stroke-linecap="round" style="transform:scale(0.8);transform-origin:50px 50px">' +
                '<animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0;256.58892822265625"></animate>' +
                '</path>' +
                '<!-- [ldio] generated by https://loading.io/ --></svg>');
        jQuery('.yotpo.new-yotpo-small-box.reviews').css('position', 'relative');
        jQuery('.loader').offset({ left: jQuery('.loader').offset().left - 100 + jQuery('.yotpo.new-yotpo-small-box.reviews').width() / 2 });
        if (jQuery(window).width() > 1020) {
            jQuery('.loader').offset({ top: jQuery('.yotpo.new-yotpo-small-box.reviews').offset().top + 15 });
        } else {
            jQuery('.loader').offset({ top: jQuery('.yotpo.new-yotpo-small-box.reviews').offset().top });
        }
    }
    jQuery.ajax({
        url: url, success: function (reviews) {

            var pagesCount = Math.ceil(reviews.response.pagination.total / reviews.response.pagination.per_page);

            if (!search) {

                var realCount = reviews.response.bottomline.total_review;
                if (!customCount) {
                    customCount = 0;
                }
                var averageScore = reviews.response.bottomline.average_score;
                container.find('.total-grade').text(parseFloat(averageScore).toFixed(1));
                container.find('.total-reviews').text(parseInt(customCount) + realCount);

                container.find('.rating-stars-container').each(function () {
                    if (averageScore < 4.75) {
                        jQuery(this).find('.rating-star:nth-child(5)').removeClass('yotpo-icon-star');
                        jQuery(this).find('.rating-star:nth-child(5)').addClass('yotpo-icon-half-star');
                    }
                    if (averageScore < 4.25) {
                        jQuery(this).find('.rating-star:nth-child(5)').removeClass('yotpo-icon-half-star');
                        jQuery(this).find('.rating-star:nth-child(5)').addClass('yotpo-icon-empty-star');
                    }
                    if (averageScore < 3.75) {
                        jQuery(this).find('.rating-star:nth-child(4)').removeClass('yotpo-icon-star');
                        jQuery(this).find('.rating-star:nth-child(4)').addClass('yotpo-icon-half-star');
                    }
                    if (averageScore < 3.25) {
                        jQuery(this).find('.rating-star:nth-child(4)').removeClass('yotpo-icon-half-star');
                        jQuery(this).find('.rating-star:nth-child(4)').addClass('yotpo-icon-empty-star');
                    }
                    if (averageScore < 2.75) {
                        jQuery(this).find('.rating-star:nth-child(3)').removeClass('yotpo-icon-star');
                        jQuery(this).find('.rating-star:nth-child(3)').addClass('yotpo-icon-half-star');
                    }
                    if (averageScore < 2.25) {
                        jQuery(this).find('.rating-star:nth-child(3)').removeClass('yotpo-icon-half-star');
                        jQuery(this).find('.rating-star:nth-child(3)').addClass('yotpo-icon-empty-star');
                    }
                    if (averageScore < 1.75) {
                        jQuery(this).find('.rating-star:nth-child(2)').removeClass('yotpo-icon-star');
                        jQuery(this).find('.rating-star:nth-child(2)').addClass('yotpo-icon-half-star');
                    }
                    if (averageScore < 1.25) {
                        jQuery(this).find('.rating-star:nth-child(2)').removeClass('yotpo-icon-half-star');
                        jQuery(this).find('.rating-star:nth-child(2)').addClass('yotpo-icon-empty-star');
                    }
                    if (averageScore < 0.75) {
                        jQuery(this).find('.rating-star:nth-child(1)').removeClass('yotpo-icon-star');
                        jQuery(this).find('.rating-star:nth-child(1)').addClass('yotpo-icon-half-star');
                    }
                    if (averageScore < 0.25) {
                        jQuery(this).find('.rating-star:nth-child(1)').removeClass('yotpo-icon-half-star');
                        jQuery(this).find('.rating-star:nth-child(1)').addClass('yotpo-icon-empty-star');
                    }
                });
            }
            if (productGrid && productID != 'yotpo_site_reviews') {
                if (page == 1) {
                    jQuery('.reviews-list .review-customization').remove();
                    jQuery('.reviews-list .yotpo-comments-box').remove();
                }




                jQuery(reviews.response.reviews).each(function (index, review) {
                    //console.log(review);
                    let show = true;
                    if (search && search !== true) {
                        if (!review.content.includes(search) && !review.title.includes(search)) {
                            show = false;
                        }
                    }
                    var answers = '';
                    var customValues = [];
                    for (fieldID in review.custom_fields) {
                        const field = review.custom_fields[fieldID];
                        customValues.push(field.value);
                        answers += '<div class="user-field" data-question="' + field.title + ':"><div class="user-field-title">' + field.title + ':</div><div class="user-field-answer">' + field.value + '</div></div>';
                    }
                    if (customFilter && !customValues.includes(filter) && !review.content.includes(filter)) {
                        show = false;
                    }
                    if (show) {

                        var stars = '';
                        for (let j = 1; j <= review.score; j++) {
                            stars += '<span class="yotpo-icon yotpo-icon-star rating-star pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="19.434" height="19.434" viewBox="0 0 19.434 19.434"><path id="Контур_486" data-name="Контур 486" d="M353.172,409.653l3,6.4,6.714,1.026-4.859,4.98,1.147,7.031-6.006-3.32-6.005,3.32,1.147-7.031-4.859-4.98,6.714-1.026Z" transform="translate(-343.455 -409.653)" fill="#384f3b"/></svg></span>';
                        }
                        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                        let reviewDate = Date.parse(review.created_at);
                        reviewDate = new Date(reviewDate);
                        var comment = '';

                        if (review.comment) {
                            let commentDate = Date.parse(review.comment.created_at);
                            commentDate = new Date(commentDate);
                            comment += '<div class="no-border yotpo-comments-box" style="display: block; visibility: visible;">  <div class="yotpo-comment-box yotpo-comment" data-comment-id="' + review.comment.id + '"> <div class="yotpo-header yotpo-store-owner"> <span class="yotpo-icon-profile yotpo-header-element pull-left yotpo-store-avatar">  <div class="yopto-avatar-wrapper"> <img class="yotpo-store-avatar" src="https://cdn.shopify.com/s/files/1/0074/7582/files/NEST_icon_customer_service.svg?v=1645695350" alt=""> </div>  <span class="yotpo-icon yotpo-icon-circle-checkmark yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip"></span> </span> <div class="yotpo-header-element"> <div class="stars-and-name"> <span class="y-label yotpo-user-name yotpo-font-bold">Nest Bedding</span> </div> <div><span class="y-label"></span></div> </div> <div class="yotpo-header-element yotpo-header-actions">  </div> </div> <div class="yotpo-main"> <div class="content-title yotpo-font-bold"> </div> <div class="content-review"> ' + review.comment.content + ' </div> </div> <div class="yotpo-footer"> <div class="footer-additional-actions"> <span class="y-label yotpo-review-date">' + months[commentDate.getMonth()] + ' ' + commentDate.getDate() + ', ' + commentDate.getFullYear() + '</span> </div> </div> </div> </div>';
                        }
                        let iconID = parseInt(productGrid.attr('data-icon-id'));
                        productGrid.append('<div class="review-customization yotpo-review yotpo-regular-box" data-review-id="' + review.id + '" data-votes-up="' + review.votes_up + '" data-votes-down="' + review.votes_down + '">'
                            + jQuery('#icon-real-review-' + (1 + (iconID % 13))).html()
                            + '<div class="review-customization-col1">'
                            + '<h4>'
                            + review.user.display_name
                            + '</h4>'
                            + '<span class="review-location"><div class="user-fields">' + answers
                            + '</div></span></div><div class="review-customization-col2">'
                            + '<div class="rating">' + stars + '</div><div class="review-date"><div class="yotpo-clr"></div> <div class="yotpo-user-related-fields"></div><span class="review-date-date">' + months[reviewDate.getMonth()] + ' ' + reviewDate.getDate() + ', ' + reviewDate.getFullYear() + '</span></div><h5 class="review-header">' + review.title + '</h5><div class="review-body">' + review.content + '</div><div class="report">  <span class="y-label label-helpful">Was this review helpful?</span>  <div class="yotpo yotpo-icon-btn-small transparent-color-btn vote-btn" data-type="up" role="button" aria-label="vote up Review by Anonymous User " tabindex="0"><span class="yotpo-icon yotpo-icon-thumbs-up"></span>  </div> <span class="y-label yotpo-sum vote-sum" aria-live="polite" aria-atomic="false" data-type="up">' +
                            review.votes_up + '</span> <div class="yotpo yotpo-icon-btn-small transparent-color-btn vote-btn" data-type="down" role="button" aria-label="vote down Review by Anonymous User " tabindex="0"> <span class="yotpo-icon yotpo-icon-thumbs-down"></span>  </div> <span class="y-label yotpo-sum vote-sum" aria-live="polite" aria-atomic="false" data-type="down">' +
                            review.votes_down + '</span> <span class="report-review">Report</span></div>'
                            + '</div>'
                            + '</div>' + comment);
                        productGrid.attr('data-icon-id', iconID + 1);
                    }
                });
                let nextPage = parseInt(productGrid.parents('.product-reviews-api').find('.more-reviews').attr('data-current-page')) + 1;
                productGrid.parents('.product-reviews-api').find('.more-reviews').attr('data-current-page', nextPage);
                productGrid.parents('.product-reviews-api').find('.more-reviews').hide();
                if (!search && nextPage <= pagesCount) {
                    productGrid.parents('.product-reviews-api').find('.more-reviews').show();
                }
                //vote up/down & report
                jQuery('.vote-btn').click(function () {
                    var type = jQuery(this).attr('data-type');
                    var votes = parseInt(jQuery(this).parents('.review-customization').attr('data-votes-' + type));
                    votes++;
                    jQuery(this).parents('.review-customization').attr('data-votes-' + type, votes);
                    jQuery(this).parents('.review-customization').find('.vote-sum[data-type="' + type + '"]').text(votes);
                    var id = jQuery(this).parents('.review-customization').attr('data-review-id');
                    //console.log('https://api.yotpo.com/reviews/' + id + '/vote/' + type);
                    jQuery.ajax({
                        url: 'https://api.yotpo.com/reviews/' + id + '/vote/' + type,
                        method: 'post',
                        success: function (result) {
                            //console.log(result);
                        },
                        error: function (xhr, status, error) {
                        }
                    });
                });
                jQuery('.report-review').click(function () {
                    jQuery(this).parents('.review-customization').hide();
                    jQuery(this).parents('.review-customization').next('.yotpo-comments-box').hide();
                });
                jQuery('.yotpo.new-yotpo-small-box.reviews .loader').fadeOut("slow", function () {
                    jQuery('.yotpo.new-yotpo-small-box.reviews .loader').remove();
                });
                if (productGrid.find('.review-customization').length == 0) {
                    jQuery('.no-reviews').show();
                }
            } else if (productGrid && productID == 'yotpo_site_reviews') {
                if (page == 1) {
                    jQuery('.reviews-list .review-customization').remove();
                    jQuery('.reviews-list .yotpo-comments-box').remove();
                }
                var data = new Object();
                data['scores'] = scores;
                if (search && search !== true) {
                    data['free_text_search'] = search;
                }


                if (customFilter && (filter == 'Normal' || filter == 'Plush' ||
                    filter == 'Very Firm' || filter == 'Back Sleeper')) {
                    data['domain_key'] = '4739110895697';
                }



                jQuery.ajax({
                    url: url2, data: data,
                    type: "POST",
                    dataType: 'json',
                    success: function (reviews2) {
                        var products = reviews2.response.products;

                        var site_reviews = reviews.response.reviews;
                        var product_reviews = reviews2.response.reviews;

                        var total_reviews = site_reviews.concat(product_reviews);


                        total_reviews.sort((a, b) => {
                            return -1 * a.created_at.localeCompare(b.created_at);
                        });
                        if (!search) {
                            total_reviews = total_reviews.slice((page - 1) * 10, (page - 1) * 10 + 10);
                        }



                        jQuery(total_reviews).each(function (index, review) {
                            //console.log(review);
                            let show = true;
                            if (search && search !== true) {
                                if (!review.content.includes(search) && !review.title.includes(search)) {
                                    show = false;
                                }
                            }
                            var answers = '';
                            var customValues = [];
                            for (fieldID in review.custom_fields) {
                                const field = review.custom_fields[fieldID];
                                customValues.push(field.value);
                                answers += '<div class="user-field" data-question="' + field.title + ':"><div class="user-field-title">' + field.title + ':</div><div class="user-field-answer">' + field.value + '</div></div>';
                            }

                            if (filter && filter == 'Normal') {
                                filter = 'Medium';
                            }/*
                                     		if(filter && filter == 'Back Sleeper'){
                                              filter = 'Back';
                                     		}*/
                            var productid = review.product_id;

                            if (customFilter && !customValues.includes(filter) && !review.content.includes(filter)) {
                                show = false;
                                /*
                                jQuery(products).each(function(j, product){
                                  if(product.id == productid){
                                    productid = product.domain_key;
                                  }
                                });
                                var filters = jQuery('.product-tag[data-id="' + productid + '"]').attr('data-filters');

                                if(filters && filters.includes(filter)){
                                  show = true;
                                }
                                */
                            }
                            if (show) {

                                var stars = '';
                                for (let j = 1; j <= review.score; j++) {
                                    stars += '<span class="yotpo-icon yotpo-icon-star rating-star pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="19.434" height="19.434" viewBox="0 0 19.434 19.434"><path id="Контур_486" data-name="Контур 486" d="M353.172,409.653l3,6.4,6.714,1.026-4.859,4.98,1.147,7.031-6.006-3.32-6.005,3.32,1.147-7.031-4.859-4.98,6.714-1.026Z" transform="translate(-343.455 -409.653)" fill="#384f3b"/></svg></span>';
                                }
                                var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                                let reviewDate = Date.parse(review.created_at);
                                reviewDate = new Date(reviewDate);
                                var comment = '';

                                if (review.comment) {
                                    let commentDate = Date.parse(review.comment.created_at);
                                    commentDate = new Date(commentDate);
                                    comment += '<div class="no-border yotpo-comments-box" style="display: block; visibility: visible;">  <div class="yotpo-comment-box yotpo-comment" data-comment-id="' + review.comment.id + '"> <div class="yotpo-header yotpo-store-owner"> <span class="yotpo-icon-profile yotpo-header-element pull-left yotpo-store-avatar">  <div class="yopto-avatar-wrapper"> <img class="yotpo-store-avatar" src="https://cdn.shopify.com/s/files/1/0074/7582/files/NEST_icon_customer_service.svg?v=1645695350" alt=""> </div>  <span class="yotpo-icon yotpo-icon-circle-checkmark yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip"></span> </span> <div class="yotpo-header-element"> <div class="stars-and-name"> <span class="y-label yotpo-user-name yotpo-font-bold">Nest Bedding</span> </div> <div><span class="y-label"></span></div> </div> <div class="yotpo-header-element yotpo-header-actions">  </div> </div> <div class="yotpo-main"> <div class="content-title yotpo-font-bold"> </div> <div class="content-review"> ' + review.comment.content + ' </div> </div> <div class="yotpo-footer"> <div class="footer-additional-actions"> <span class="y-label yotpo-review-date">' + months[commentDate.getMonth()] + ' ' + commentDate.getDate() + ', ' + commentDate.getFullYear() + '</span> </div> </div> </div> </div>';
                                }
                                let iconID = parseInt(productGrid.attr('data-icon-id'));
                                productGrid.append('<div data-productid="' + productid + '" class="review-customization yotpo-review yotpo-regular-box" data-review-id="' + review.id + '" data-votes-up="' + review.votes_up + '" data-votes-down="' + review.votes_down + '">'
                                    + jQuery('#icon-real-review-' + (1 + (iconID % 13))).html()
                                    + '<div class="review-customization-col1">'
                                    + '<h4>'
                                    + review.user.display_name
                                    + '</h4>'
                                    + '<span class="review-location"><div class="user-fields">' + answers
                                    + '</div></span></div><div class="review-customization-col2">'
                                    + '<div class="rating">' + stars + '</div><div class="review-date"><div class="yotpo-clr"></div> <div class="yotpo-user-related-fields"></div><span class="review-date-date">' + months[reviewDate.getMonth()] + ' ' + reviewDate.getDate() + ', ' + reviewDate.getFullYear() + '</span></div><h5 class="review-header">' + review.title + '</h5><div class="review-body">' + review.content + '</div><div class="report">  <span class="y-label label-helpful">Was this review helpful?</span>  <div class="yotpo yotpo-icon-btn-small transparent-color-btn vote-btn" data-type="up" role="button" aria-label="vote up Review by Anonymous User " tabindex="0"><span class="yotpo-icon yotpo-icon-thumbs-up"></span>  </div> <span class="y-label yotpo-sum vote-sum" aria-live="polite" aria-atomic="false" data-type="up">' +
                                    review.votes_up + '</span> <div class="yotpo yotpo-icon-btn-small transparent-color-btn vote-btn" data-type="down" role="button" aria-label="vote down Review by Anonymous User " tabindex="0"> <span class="yotpo-icon yotpo-icon-thumbs-down"></span>  </div> <span class="y-label yotpo-sum vote-sum" aria-live="polite" aria-atomic="false" data-type="down">' +
                                    review.votes_down + '</span> <span class="report-review">Report</span></div>'
                                    + '</div>'
                                    + '</div>' + comment);
                                productGrid.attr('data-icon-id', iconID + 1);
                            }
                        });
                        let nextPage = parseInt(productGrid.parents('.product-reviews-api').find('.more-reviews').attr('data-current-page')) + 1;
                        productGrid.parents('.product-reviews-api').find('.more-reviews').attr('data-current-page', nextPage);
                        productGrid.parents('.product-reviews-api').find('.more-reviews').hide();
                        if (!search && nextPage <= pagesCount) {
                            productGrid.parents('.product-reviews-api').find('.more-reviews').show();
                        }
                        //vote up/down & report
                        jQuery('.vote-btn').click(function () {
                            var type = jQuery(this).attr('data-type');
                            var votes = parseInt(jQuery(this).parents('.review-customization').attr('data-votes-' + type));
                            votes++;
                            jQuery(this).parents('.review-customization').attr('data-votes-' + type, votes);
                            jQuery(this).parents('.review-customization').find('.vote-sum[data-type="' + type + '"]').text(votes);
                            var id = jQuery(this).parents('.review-customization').attr('data-review-id');
                            //console.log('https://api.yotpo.com/reviews/' + id + '/vote/' + type);
                            jQuery.ajax({
                                url: 'https://api.yotpo.com/reviews/' + id + '/vote/' + type,
                                method: 'post',
                                success: function (result) {
                                    //console.log(result);
                                },
                                error: function (xhr, status, error) {
                                }
                            });
                        });
                        jQuery('.report-review').click(function () {
                            jQuery(this).parents('.review-customization').hide();
                            jQuery(this).parents('.review-customization').next('.yotpo-comments-box').hide();
                        });
                        jQuery('.yotpo.new-yotpo-small-box.reviews .loader').fadeOut("slow", function () {
                            jQuery('.yotpo.new-yotpo-small-box.reviews .loader').remove();
                        });
                        if (productGrid.find('.review-customization').length == 0) {
                            jQuery('.no-reviews').show();
                        }
                    }
                });

            }

        }
    });
}

//Yotpo Questions via API
function loadYotpoQuestions(productGrid, sku) {
    jQuery('.no-questions').hide();
    var url = 'https://api.yotpo.com/products/CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x/'
        + sku + '/questions?per_page=100';
    jQuery.ajax({
        url: url, success: function (reviews) {
            if (productGrid) {

                jQuery(reviews.response.questions).each(function (index, review) {
                    //console.log(review);
                    let show = true;

                    if (show) {
                        var answers = '';

                        var stars = '';

                        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                        let reviewDate = Date.parse(review.created_at);
                        reviewDate = new Date(reviewDate);
                        var comment = '';

                        if (review.sorted_public_answers && review.sorted_public_answers[0]) {
                            let commentDate = Date.parse(review.sorted_public_answers[0].created_at);
                            commentDate = new Date(commentDate);
                            comment += '<div class="no-border yotpo-comments-box" style="display: block; visibility: visible;">  <div class="yotpo-comment-box yotpo-comment" data-comment-id="' + review.sorted_public_answers[0].id + '"> <div class="yotpo-header yotpo-store-owner"> <span class="yotpo-icon-profile yotpo-header-element pull-left yotpo-store-avatar">  <div class="yopto-avatar-wrapper"> <img class="yotpo-store-avatar" src="https://cdn.shopify.com/s/files/1/0074/7582/files/NEST_icon_customer_service.svg?v=1645695350" alt=""> </div>  <span class="yotpo-icon yotpo-icon-circle-checkmark yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip"></span> </span> <div class="yotpo-header-element"> <div class="stars-and-name"> <span class="y-label yotpo-user-name yotpo-font-bold">Nest Bedding</span> </div> <div><span class="y-label"></span></div> </div> <div class="yotpo-header-element yotpo-header-actions">  </div> </div> <div class="yotpo-main"> <div class="content-title yotpo-font-bold"> </div> <div class="content-review"> ' + review.sorted_public_answers[0].content + ' </div> </div> <div class="yotpo-footer"> <div class="footer-additional-actions"> <span class="y-label yotpo-review-date">' + months[commentDate.getMonth()] + ' ' + commentDate.getDate() + ', ' + commentDate.getFullYear() + '</span> </div> </div> </div> </div>';
                        }
                        let iconID = parseInt(productGrid.attr('data-icon-id'));
                        productGrid.append('<div class="review-customization yotpo-review yotpo-regular-box" data-review-id="' + review.id + '">'
                            + jQuery('#icon-real-review-' + (1 + (iconID % 13))).html()
                            + '<div class="review-customization-col1">'
                            + '<h4>'
                            + review.asker.display_name
                            + '</h4>'
                            + '<span class="review-location"><div class="user-fields">' + answers
                            + '</div></span></div><div class="review-customization-col2">'
                            + '<div class="review-date"><div class="yotpo-clr"></div> <div class="yotpo-user-related-fields"></div><span class="review-date-date">' + months[reviewDate.getMonth()] + ' ' + reviewDate.getDate() + ', ' + reviewDate.getFullYear() + '</span></div><h5 class="review-header">' + review.content + '</h5>'
                            + '</div>'
                            + '</div>' + comment);
                        productGrid.attr('data-icon-id', iconID + 1);
                    }
                    if (productGrid.find('.review-customization').length == 0) {
                        jQuery('.no-questions').show();
                    }
                });

            }
        }
    });
}


jQuery('.product-reviews-api').each(function () {
    var productGrid = jQuery(this).find('.reviews-grid');
    var productID = jQuery('.product-reviews-api').attr('data-product-id');
    loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
        jQuery('body'), false);
    var loadReviews = jQuery(this).find('.more-reviews');
    loadReviews.click(function (e) {
        e.preventDefault();
        loadYotpoReviews(productGrid, productID, loadReviews.attr('data-current-page'),
            jQuery('.product-template__container').attr('data-review-count'),
            jQuery('body'), false);
    });
    loadYotpoQuestions(jQuery(this).find('.questions-grid'), jQuery('.product-reviews-api').attr('data-product-id'));



});

jQuery('.mattresses-block-detail, .quickbuy-popup').each(function () {
    var productID = jQuery(this).attr('data-product-id');
    loadYotpoReviews(false, productID, 1, jQuery(this).attr('data-review-count'), jQuery(this), false);
});

jQuery('.free-text-search-input').keypress(function (e) {
    if (e.which == '13') {
        jQuery('.filter-additional, .filters-1, .filters-2, .filters-3, .filters-4').removeClass('active');
        let search = jQuery('.free-text-search-input').val();
        var productGrid = jQuery('.reviews-grid');
        var productID = jQuery('.product-reviews-api').attr('data-product-id');
        if (search) {

            loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
                jQuery('body'), search);
        } else {
            loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
                jQuery('body'), false);
        }
    }
});

jQuery('.yotpo-icon-clear-text-search').click(function () {
    jQuery('.free-text-search-input').val('');
});
jQuery('.filter-additional, .filters-1, .filters-2, .filters-3, .filters-4').click(function (e) {
    e.preventDefault();
    if (!jQuery(this).hasClass('active')) {
        jQuery('.filter-additional, .filters-1, .filters-2, .filters-3, .filters-4').removeClass('active');
        jQuery(this).addClass('active');
        var productGrid = jQuery('.reviews-grid');
        var productID = jQuery('.product-reviews-api').attr('data-product-id');
        if (jQuery(this).hasClass('filters-2')) {
            loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
                jQuery('body'), true);
        } else if (jQuery(this).hasClass('filters-3')) {
            loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
                jQuery('body'), true, 'star5');
        } else if (jQuery(this).hasClass('filters-4')) {
            loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
                jQuery('body'), true, 'star1');
        } else if (jQuery(this).hasClass('filter-additional')) {
            loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
                jQuery('body'), true, jQuery(this).attr('data-filter-option'));
        }
    } else {
        e.stopPropagation();
        jQuery(this).removeClass('active');
        var productGrid = jQuery('.reviews-grid');
        var productID = jQuery('.product-reviews-api').attr('data-product-id');
        loadYotpoReviews(productGrid, productID, 1, jQuery('.product-template__container').attr('data-review-count'),
            jQuery('body'), true);
        //console.log(jQuery(this).hasClass('active'));
    }
});

jQuery('.yotpo-nav-tab[data-type="questions"]').click(function () {
    jQuery('.yotpo-nav-tab').removeClass('yotpo-active');
    jQuery(this).addClass('yotpo-active');
    jQuery('.reviews-list').hide();
    jQuery('.questions-list').show();
    jQuery('.reviews-heading-bottom').css('visibility', 'hidden');
});
jQuery('.yotpo-nav-tab[data-type="reviews"]').click(function () {
    jQuery('.yotpo-nav-tab').removeClass('yotpo-active');
    jQuery(this).addClass('yotpo-active');
    jQuery('.questions-list').hide();
    jQuery('.reviews-list').show();
    jQuery('.reviews-heading-bottom').css('visibility', 'visible');
});

jQuery('.btn.write-review').click(function (e) {
    e.preventDefault();
    jQuery('.yotpo.write-question').hide();
    jQuery('.yotpo.write-review').show();
});
jQuery('.btn.write-question').click(function (e) {
    e.preventDefault();
    jQuery('.yotpo.write-review').hide();
    jQuery('.yotpo.write-question').show();
});

jQuery('.yotpo.write-question .yotpo-submit').click(function () {
    var url = 'https://api.yotpo.com/questions/send_confirmation_mail';
    var data = {
        review_content: jQuery('#yotpo_input_question_content').val(),
        display_name: jQuery('#yotpo_input_question_username').val(),
        email: jQuery('#yotpo_input_question_email').val(),
        appkey: 'CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x',
        sku: jQuery('.product-reviews-api').attr('data-product-id'),
        product_title: jQuery('.product-template__container h1').first().text().trim(),
        product_url: window.location.href
    };

    jQuery.ajax({
        url: url, method: 'post',
        data: data,
        success: function (result) {
            //console.log(result);
        }
    });

    jQuery('.yotpo.write-question').hide();
});
jQuery('.yotpo.write-review .stars-wrapper .review-star').click(function () {
    var score = parseInt(jQuery(this).attr('data-score'));
    jQuery('.yotpo.write-review .stars-wrapper .review-star').each(function () {
        if (parseInt(jQuery(this).attr('data-score')) <= score) {
            jQuery(this).addClass('yotpo-icon-star');
            jQuery(this).removeClass('yotpo-icon-empty-star');
        } else {
            jQuery(this).removeClass('yotpo-icon-star');
            jQuery(this).addClass('yotpo-icon-empty-star');
        }
    });
});
jQuery('.yotpo.write-review .yotpo-submit').click(function () {
    var url = 'https://api.yotpo.com/v1/widget/reviews';

    var sku = jQuery('.product-reviews-api').attr('data-product-id');
    var product_title = jQuery('.product-template__container h1').first().text().trim();
    var product_url = window.location.href;
    if (sku == 'yotpo_site_reviews') {
        sku = 6811349909585;
        product_title = "Site reviews";
        product_url = window.location.hostname;
    }
    var data = {
        appkey: 'CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x',
        domain: window.location.hostname,
        sku: sku,
        product_title: product_title,
        product_url: product_url,
        display_name: jQuery('.yotpo.write-review .name-input input').val(),
        email: jQuery('.yotpo.write-review .email-input input').val(),
        review_content: jQuery('.yotpo.write-review .review-content').val(),
        review_title: jQuery('.yotpo.write-review .review-title').val(),
        review_score: jQuery('.yotpo.write-review .stars-wrapper .review-star.yotpo-icon-star').length
    };
    jQuery.ajax({
        url: url, method: 'post',
        data: data,
        success: function (result) {
            //console.log(result);
        }
    });

    jQuery('.yotpo.write-review').hide();
});

function revisedRandId() {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
}

jQuery('.product-specs-section').each(function () {
    let id = revisedRandId();
    jQuery(this).find('.product-specs-section-content').attr('role', 'region');

    jQuery(this).find('.product-specs-section-content').attr('id', id);
    jQuery(this).find('.specs-plus').attr('role', 'button').attr('aria-expanded', 'false');
    jQuery(this).find('.specs-minus').attr('role', 'button').attr('aria-expanded', 'true');
    jQuery(this).find('.specs-plus').attr('aria-controls', id);
    jQuery(this).find('.specs-minus').attr('aria-controls', id);
});

jQuery('.lifetime-faq').each(function () {
    let id = revisedRandId();
    jQuery(this).find('p').attr('role', 'region');
    jQuery(this).find('p').attr('tabindex', '-1');
    jQuery(this).find('p').attr('id', id);
    jQuery(this).find('.specs-plus').attr('role', 'button').attr('aria-expanded', 'false');
    jQuery(this).find('.specs-minus').attr('role', 'button').attr('aria-expanded', 'true');
    jQuery(this).find('.specs-plus').attr('aria-controls', id);
    jQuery(this).find('.specs-minus').attr('aria-controls', id);
});

jQuery('.specs-item').each(function () {
    let id = revisedRandId();
    jQuery(this).find('.specs-item-text').attr('role', 'region');
    jQuery(this).find('.specs-item-text').attr('tabindex', '-1');
    jQuery(this).find('.specs-item-text').attr('id', id);
    jQuery(this).find('.specs-plus').attr('role', 'button').attr('aria-expanded', 'false');
    jQuery(this).find('.specs-minus').attr('role', 'button').attr('aria-expanded', 'true');
    jQuery(this).find('.specs-plus').attr('aria-controls', id);
    jQuery(this).find('.specs-minus').attr('aria-controls', id);
});

jQuery('.footer-menu-section-header').each(function () {
    let id = revisedRandId();
    jQuery(this).next().attr('role', 'region');
    jQuery(this).next().attr('tabindex', '-1');
    jQuery(this).next().attr('id', id);
    //jQuery(this).find('svg').last().attr('aria-expanded', 'true');
    //jQuery(this).find('svg').first().attr('aria-expanded', 'false');
    //jQuery(this).find('svg').last().attr('aria-controls', id);
    //jQuery(this).find('svg').first().attr('aria-controls', id);
});

jQuery('.mobile-menu-section').each(function () {
    let id = revisedRandId();
    jQuery(this).find('.mobile-menu-section-menu').attr('role', 'region');
    jQuery(this).find('.mobile-menu-section-menu').attr('tabindex', '-1');
    jQuery(this).find('.mobile-menu-section-menu').attr('id', id);
    jQuery(this).find('.mobile-menu-section-header svg').last().attr('aria-expanded', 'true');
    jQuery(this).find('.mobile-menu-section-header svg').first().attr('aria-expanded', 'false');
    jQuery(this).find('.mobile-menu-section-header svg').last().attr('aria-controls', id);
    jQuery(this).find('.mobile-menu-section-header svg').first().attr('aria-controls', id);
});


$(document).keydown(function (e) {
    if (jQuery('.bedding-megamenu').hasClass('opened')
        || jQuery('.mattresses-megamenu').hasClass('opened')
        || jQuery('.furniture-megamenu').hasClass('opened')
        || jQuery('.home-megamenu').hasClass('opened')
        || jQuery('.stores-dropdown').css('display') == 'grid'
        || jQuery('.help-dropdown').css('display') == 'grid'
        || jQuery('.reviews-dropdown').css('display') == 'grid') {
        if (event.shiftKey && event.keyCode == 9) {
            e.preventDefault();
            if (jQuery('.mattresses-megamenu').hasClass('opened')) {
                jQuery('.logo-align--left a').focus();
            } else if (jQuery('.bedding-megamenu').hasClass('opened')) {
                jQuery('#mattresses-menu-opener a').first().focus();
            } else if (jQuery('.furniture-megamenu').hasClass('opened')) {
                jQuery('#bedding-menu-opener a').first().focus();
            } else if (jQuery('.reviews-dropdown').css('display') == 'grid') {
                jQuery('#collections-menu li').last().find('a').focus();
            } else if (jQuery('.help-dropdown').css('display') == 'grid') {
                jQuery('.reviews-menu').focus();
            } else {
                jQuery('.help-menu').focus();
            }
            e.stopPropagation();
        }
        else if (e.keyCode == 9) {
            e.preventDefault();
            if (jQuery('.mattresses-megamenu').hasClass('opened')) {
                jQuery('#bedding-menu-opener a').first().focus();
            } else if (jQuery('.bedding-megamenu').hasClass('opened')) {
                jQuery('#furniture-menu-opener a').first().focus();
            } else if (jQuery('.furniture-megamenu').hasClass('opened')) {
                jQuery('#home-menu-opener a').first().focus();

            } else if (jQuery('.home-megamenu').hasClass('opened')) {
                jQuery('#collections-menu li').last().find('a').focus();

            } else if (jQuery('.reviews-dropdown').css('display') == 'grid') {
                jQuery('.help-menu').focus();
            } else if (jQuery('.help-dropdown').css('display') == 'grid') {
                jQuery('.stores-menu').focus();
            } else {
                jQuery('.site-header__account').focus();
            }
            e.stopPropagation();
        } else if (e.keyCode == 27) {
            jQuery('.stores-dropdown').css('display', 'none');
            jQuery('.stores-dropdown-arrow').css('display', 'none');
            jQuery('.help-dropdown').css('display', 'none');
            jQuery('.help-dropdown-arrow').css('display', 'none');
            jQuery('.reviews-dropdown').css('display', 'none');
            jQuery('.reviews-dropdown-arrow').css('display', 'none');
            jQuery('#mattresses-menu-opener').removeClass('opened');
            jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.mattresses-megamenu').removeClass('opened');
            });
            jQuery('#bedding-menu-opener').removeClass('opened');
            jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.bedding-megamenu').removeClass('opened');
            });
            jQuery('#furniture-menu-opener').removeClass('opened');
            jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
                jQuery('.furniture-megamenu').removeClass('opened');
            });
        } else if (e.keyCode == 38) {
            e.preventDefault();
            if (jQuery('.mattresses-megamenu').hasClass('opened')) {
                var nextIndex = jQuery('.mattresses-megamenu a').length - 1;
                if (jQuery('.mattresses-megamenu').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.mattresses-megamenu').attr('data-index')) - 1;
                }
                if (nextIndex >= 0) {
                    jQuery('.mattresses-megamenu a').eq(nextIndex).focus();
                    jQuery('.mattresses-megamenu').attr('data-index', nextIndex);
                }
            } else if (jQuery('.bedding-megamenu').hasClass('opened')) {
                var nextIndex = jQuery('.bedding-megamenu a').length - 1;
                if (jQuery('.bedding-megamenu').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.bedding-megamenu').attr('data-index')) - 1;
                }
                if (nextIndex >= 0) {
                    jQuery('.bedding-megamenu a').eq(nextIndex).focus();
                    jQuery('.bedding-megamenu').attr('data-index', nextIndex);
                }
            } else if (jQuery('.furniture-megamenu').hasClass('opened')) {
                var nextIndex = jQuery('.furniture-megamenu a').length - 1;
                if (jQuery('.furniture-megamenu').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.furniture-megamenu').attr('data-index')) - 1;
                }
                if (nextIndex >= 0) {
                    jQuery('.furniture-megamenu a').eq(nextIndex).focus();
                    jQuery('.furniture-megamenu').attr('data-index', nextIndex);
                }
            } else if (jQuery('.reviews-dropdown').css('display') == 'grid') {
                var nextIndex = jQuery('.reviews-dropdown a').length - 1;
                if (jQuery('.reviews-dropdown').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.reviews-dropdown').attr('data-index')) - 1;
                }
                if (nextIndex >= 0) {
                    jQuery('.reviews-dropdown a').eq(nextIndex).focus();
                    jQuery('.reviews-dropdown').attr('data-index', nextIndex);
                }
            } else if (jQuery('.help-dropdown').css('display') == 'grid') {
                var nextIndex = jQuery('.help-dropdown a').length - 1;
                if (jQuery('.help-dropdown').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.help-dropdown').attr('data-index')) - 1;
                }
                if (nextIndex >= 0) {
                    jQuery('.help-dropdown a').eq(nextIndex).focus();
                    jQuery('.help-dropdown').attr('data-index', nextIndex);
                }
            } else {
                var nextIndex = jQuery('.stores-dropdown a').length - 1;
                if (jQuery('.stores-dropdown').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.stores-dropdown').attr('data-index')) - 1;
                }
                if (nextIndex >= 0) {
                    jQuery('.stores-dropdown a').eq(nextIndex).focus();
                    jQuery('.stores-dropdown').attr('data-index', nextIndex);
                }
            }
            e.stopPropagation();
        } else if (e.keyCode == 40) {
            e.preventDefault();
            if (jQuery('.mattresses-megamenu').hasClass('opened')) {
                var nextIndex = 0;
                if (jQuery('.mattresses-megamenu').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.mattresses-megamenu').attr('data-index')) + 1;
                }
                if (nextIndex < jQuery('.mattresses-megamenu a').length) {
                    jQuery('.mattresses-megamenu a').eq(nextIndex).focus();
                    jQuery('.mattresses-megamenu').attr('data-index', nextIndex);
                }
            } else if (jQuery('.bedding-megamenu').hasClass('opened')) {
                var nextIndex = 0;
                if (jQuery('.bedding-megamenu').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.bedding-megamenu').attr('data-index')) + 1;
                }
                if (nextIndex < jQuery('.bedding-megamenu a').length) {
                    jQuery('.bedding-megamenu a').eq(nextIndex).focus();
                    jQuery('.bedding-megamenu').attr('data-index', nextIndex);
                }
            } else if (jQuery('.furniture-megamenu').hasClass('opened')) {
                var nextIndex = jQuery('.furniture-megamenu a').length - 1;
                if (jQuery('.furniture-megamenu').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.furniture-megamenu').attr('data-index')) + 1;
                }
                if (nextIndex < jQuery('.furniture-megamenu a').length) {
                    jQuery('.furniture-megamenu a').eq(nextIndex).focus();
                    jQuery('.furniture-megamenu').attr('data-index', nextIndex);
                }
            } else if (jQuery('.reviews-dropdown').css('display') == 'grid') {
                var nextIndex = 0;
                if (jQuery('.reviews-dropdown').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.reviews-dropdown').attr('data-index')) + 1;
                }
                if (nextIndex < jQuery('.reviews-dropdown a').length) {
                    jQuery('.reviews-dropdown a').eq(nextIndex).focus();
                    jQuery('.reviews-dropdown').attr('data-index', nextIndex);
                }
            } else if (jQuery('.help-dropdown').css('display') == 'grid') {
                var nextIndex = 0;
                if (jQuery('.help-dropdown').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.help-dropdown').attr('data-index')) + 1;
                }
                if (nextIndex < jQuery('.help-dropdown a').length) {
                    jQuery('.help-dropdown a').eq(nextIndex).focus();
                    jQuery('.help-dropdown').attr('data-index', nextIndex);
                }
            } else {
                var nextIndex = 0;
                if (jQuery('.stores-dropdown').attr('data-index')) {
                    nextIndex = parseInt(jQuery('.stores-dropdown').attr('data-index')) + 1;
                }
                if (nextIndex < jQuery('.stores-dropdown a').length) {
                    jQuery('.stores-dropdown a').eq(nextIndex).focus();
                    jQuery('.stores-dropdown').attr('data-index', nextIndex);
                }
            }
            e.stopPropagation();
        }
    }
});

jQuery('.lifetime-faq-header').click(function (e) {
    e.preventDefault();
    if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
        jQuery(this).parents('.lifetime-faq').find('p').hide();
        jQuery(this).find('.specs-minus').hide();
        jQuery(this).find('.specs-plus').show();
    } else {
        jQuery(this).addClass('active');
        jQuery(this).parents('.lifetime-faq').find('p').show();
        jQuery(this).find('.specs-minus').show();
        jQuery(this).find('.specs-plus').hide();
    }
});


jQuery('.reviews-menu').focusin(function (e) {
    jQuery('#mattresses-menu-opener').removeClass('opened');
    jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.mattresses-megamenu').removeClass('opened');
    });
    jQuery('#bedding-menu-opener').removeClass('opened');
    jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.bedding-megamenu').removeClass('opened');
    });
    jQuery('#furniture-menu-opener').removeClass('opened');
    jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.furniture-megamenu').removeClass('opened');
    });
    jQuery('#home-menu-opener').removeClass('opened');
    jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.home-megamenu').removeClass('opened');
    });

    jQuery('.reviews-dropdown').css('display', 'grid');
    jQuery('.reviews-dropdown-arrow').css('display', 'block');
});
jQuery('.help-menu').focusin(function (e) {
    jQuery('#mattresses-menu-opener').removeClass('opened');
    jQuery('.mattresses-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.mattresses-megamenu').removeClass('opened');
    });
    jQuery('#bedding-menu-opener').removeClass('opened');
    jQuery('.bedding-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.bedding-megamenu').removeClass('opened');
    });
    jQuery('#furniture-menu-opener').removeClass('opened');
    jQuery('.furniture-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.furniture-megamenu').removeClass('opened');
    });
    jQuery('#home-menu-opener').removeClass('opened');
    jQuery('.home-megamenu').animate({ opacity: 0 }, 200, function () {
        jQuery('.home-megamenu').removeClass('opened');
    });
    jQuery('.help-dropdown').css('display', 'grid');
    jQuery('.help-dropdown-arrow').css('display', 'block');
});

jQuery('.template-product .bottom-line-yotpo').click(function () {
    jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery(".product-reviews-api").offset().top - 100
    }, 500);
});

if (jQuery(window).width() < 720) {
    jQuery('.firmness-popup-sections').overlayScrollbars({
        className: "os-theme-dark"
    });
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const variant = urlParams.get('variant');
if (variant) {
    jQuery('.product-form-inner > .variants-codes .variant-code').each(function () {
        if (jQuery(this).find('.variant-code-code').text() == variant) {
            var options = jQuery(this).find('.variant-code-options').text().split('__');
            var i = 0;
            jQuery('.product-form-inner .select').each(function () {
                var option = options[i].replaceAll('_', '').trim();
                jQuery(this).find('.option-flex').each(function () {
                    if (jQuery(this).find('.option-size').text() == option) {
                        jQuery(this).click();
                    }
                });
                i++;
            });
        }
    });
}

if (jQuery('shopify-payment-terms').length > 0) {
    jQuery('.shoppay-popup-wrapper shopify-payment-terms').attr('shopify-meta',
        jQuery('.shoppay-meta shopify-payment-terms').attr('shopify-meta'));
    setInterval(function () {
        var options = "";
        jQuery('.product-detail-description-right .styledSelect .option-flex').each(function () {
            options += jQuery(this).find('span').first().text() + "-";
        });
        if (!jQuery('.shoppay-popup-wrapper[data-options="' + options + '"] shopify-payment-terms')[0]) {

            return false;
        }
        jQuery('html').css('overflow', 'hidden');
        jQuery('html').css('touch-action', 'none');
        jQuery('html').css('-ms-touch-action', 'none');
        var shadowRoot = jQuery('.shoppay-popup-wrapper[data-options="' + options + '"] shopify-payment-terms')[0].shadowRoot;
        jQuery('.monthly-payments.shoppay-callout > span').text(jQuery(shadowRoot).find('.shopify-installments__content').text());
        jQuery('.shoppay-popup-activate').click(function (e) {
            e.preventDefault();
            var options = "";
            jQuery('.product-detail-description-right .styledSelect .option-flex').each(function () {
                options += jQuery(this).find('span').first().text() + "-";
            });
            var shadowRoot = jQuery('.shoppay-popup-wrapper[data-options="' + options + '"] shopify-payment-terms')[0].shadowRoot;
            jQuery(shadowRoot).find('button').click();

            setTimeout(function () {
                jQuery('#shopify-payment-terms-modal').css('height', '700px');
                var shadowModal = jQuery('shopify-installments-modal')[0].shadowRoot
                jQuery('shopify-installments-modal').each(function () {
                    shadowModal = jQuery(this)[0].shadowRoot;
                    jQuery(shadowModal).find('header .btn__close').css('right', '-30px');
                    jQuery(shadowModal).find('header .btn__close').css('top', '-30px');
                    jQuery(shadowModal).find('svg path').css('stroke', '#384F3B');
                    //jQuery(shadowModal).find('svg path').css('fill', 'transparent');
                    jQuery(shadowModal).find('svg path').each(function () {
                        if (jQuery(this).css('fill') != 'none' && jQuery(this).css('fill') != 'rgb(255, 255, 255)') {
                            jQuery(this).css('fill', '#384F3B');
                        }
                    });
                    jQuery(shadowModal).find('*').css('color', '#384F3B');
                    jQuery(shadowModal).find('header .btn__close').html('<svg xmlns="http://www.w3.org/2000/svg" width="19.168" height="19.169" viewBox="0 0 19.168 19.169"><title>Sale – NestDNG</title><g data-name="Group 1187" transform="translate(-1758.94 -190.398)"><line data-name="Line 159" x1="1.19" y2="21.704" transform="translate(1775.776 191.889) rotate(45)" fill="none" stroke="#71695e" stroke-linecap="round" stroke-width="2"></line>    <line data-name="Line 160" x1="1.189" y1="21.705" transform="translate(1776.618 207.235) rotate(135)" fill="none" stroke="#71695e" stroke-linecap="round" stroke-width="2"></line></g></svg>');
                    jQuery(shadowModal).find('header .btn__close line').css('stroke', '#384F3B');
                    jQuery(shadowModal).find('h1').css('font-family', 'NotoSansJPBold');
                    jQuery(shadowModal).find('h1').css('color', '#384F3B');
                    jQuery(shadowModal).find('p').css('font-family', 'NotoSansJPRegular');
                    jQuery(shadowModal).find('p').css('color', '#384F3B');
                    jQuery(shadowModal).find('.list-item__heading').css('font-family', 'NotoSansJPRegular');
                    jQuery(shadowModal).find('.list-item__heading').css('color', '#384F3B');
                    jQuery(shadowModal).find('.list-item__subheading').css('font-family', 'NotoSansJPRegular');
                    jQuery(shadowModal).find('.list-item__subheading').css('color', '#384F3B');
                    jQuery(shadowModal).find('.price').css('color', '#384F3B');
                    jQuery(shadowModal).find('.btn__close--primary').css('background-color', '#384F3B');
                    jQuery(shadowModal).find('.btn__close--primary').css('color', 'white');
                    jQuery(shadowModal).find('.affirm-text').css('font-family', 'NotoSansJPRegular');
                    var logo = jQuery(shadowModal).find('shop-pay-logo')[0].shadowRoot;
                    jQuery(logo).find('*').css('fill', '#384F3B');
                    jQuery(shadowModal).find('header .btn__close').css('background-color', 'transparent');
                    jQuery(shadowModal).find('header .btn__close').blur();
                    jQuery(shadowModal).find('header .btn__close').hover(function () {
                        jQuery(this).css('background-color', 'transparent');
                    });
                });

            }, 100);
        });


    }, 3000);
}

jQuery('.sale-mobile-link').click(function (e) {
    jQuery('.home-header-sale').removeClass('initial');
    if (jQuery(this).parents('.home-header-content').find('p').css('display') == 'none') {
        e.preventDefault();
        jQuery(this).parents('.home-header-content').find('p').show();
        jQuery('.sale-mobile-close').show();
    }
});
jQuery('.sale-mobile-close').click(function (e) {
    jQuery('.home-header-sale').removeClass('initial');
    if (jQuery('.home-header-content').find('p').css('display') == 'block') {
        e.preventDefault();
        jQuery('.home-header-content').find('p').hide();
        jQuery('.sale-mobile-close').hide();
    }
});

jQuery('.klaviyo-container .sms-popup-submit').click(function () {
    jQuery('.newsletter-country-phone button').click();
    jQuery('#sale-popup #completed_message').show();
    jQuery('.klaviyo-container .newsletter-country-phone').remove();
    jQuery('.klaviyo-container .popup-footer').remove();
    jQuery('.klaviyo-container .sms-popup-submit').remove();
});

if (jQuery('.template-index .feature-columns').length > 0 && jQuery(window).width() <= 720) {
    var featuredSlide = jQuery('.template-index .feature-columns');
    featuredSlide.find('.grid__item').hide();
    featuredSlide.find('.grid__item').first().addClass('active');
    featuredSlide.find('.grid__item').first().show();
    featuredSlide.find('.featured-slide-prev').click(function () {
        if (featuredSlide.find('.grid__item.active').prev().hasClass('grid__item')) {
            featuredSlide.find('.grid__item.active').prev().show();
            featuredSlide.find('.grid__item.active').last().hide();
            featuredSlide.find('.grid__item.active').prev().addClass('active');
            featuredSlide.find('.grid__item.active').last().removeClass('active');

        } else {
            featuredSlide.find('.grid__item').last().show();
            featuredSlide.find('.grid__item.active').first().hide();
            featuredSlide.find('.grid__item').last().addClass('active');
            featuredSlide.find('.grid__item.active').first().removeClass('active');

        }
    });
    featuredSlide.find('.featured-slide-next').click(function () {
        if (featuredSlide.find('.grid__item.active').next().hasClass('grid__item')) {
            featuredSlide.find('.grid__item.active').next().show();
            featuredSlide.find('.grid__item.active').first().hide();
            featuredSlide.find('.grid__item.active').next().addClass('active');
            featuredSlide.find('.grid__item.active').first().removeClass('active');

        } else {
            featuredSlide.find('.grid__item').first().show();
            featuredSlide.find('.grid__item.active').last().hide();
            featuredSlide.find('.grid__item').first().addClass('active');
            featuredSlide.find('.grid__item.active').last().removeClass('active');

        }
    });
}




jQuery('.cart__submit').click(function (e) {
    if (jQuery(this).parents('.ajax-active').length != 0) {
        e.preventDefault();
    }
    /*
    if(!jQuery('.cart-modal').hasClass('lre-checked')){
      setTimeout(function(){
      }, 2000);
    }
     */


});

/*
setInterval(function(){
  if(!jQuery('.cart-modal').hasClass('lre-checked')){
        jQuery.ajax({
          url: '/cart.js',
          dataType: 'json',
          success: function (result) {
              var handles = [];
              var sizes = [];
              var qties = [];
              let lreIDs = [];
              let hasLRE = false;
              for(let i = 0; i < result['items'].length; i++){
                handles.push(result['items'][i]['handle']);
                sizes.push(result['items'][i]['variant_options'][0]);
                if(result['items'][i]['product_type'] == 'Renewal Exchange'){
                  hasLRE = true;
                  qties.push(0);
                } else{
                      qties.push(result['items'][i]['quantity']);
                }
              }
                if(!hasLRE){
                  jQuery('.cart-modal').addClass('lre-checked');
                }
              if(hasLRE && !jQuery('.cart-modal').hasClass('ajax-active')){
                //console.log(qties);
                            jQuery.ajax({
                              url: '/cart/update.js',
                              data: {updates: qties},
                              dataType: 'json',
                                success: function (complete_result) {
                                  var toadd = [];
                                  for(i = 0; i < handles.length; i++){
                                    jQuery('.renewal-exchange-product').each(function(){
                                      if(jQuery(this).attr('data-product') == handles[i]
                                         && jQuery(this).attr('data-size') == sizes[i]){
                                        //console.log("Add " + qties[i]);
                                        toadd.push({
                                          id: jQuery(this).attr('data-renewal-variant-id'),
                                          quantity: qties[i]
                                        });

                                      }
                                    });
                                  }
                                  jQuery.ajax({
                                                    url: '/cart/add.js',
                                                    dataType: 'json',
                                    data: {items: toadd},
                                                    success: function (result) {
                                                    //console.log(toadd);
                                                    //console.log(result);
                                                      jQuery('.cart-modal').addClass('lre-checked');
                                                    },
                                                    always: function() {
                                                    }
                                                });

                                },
                              error: function() {//jQuery('.cart-modal').removeClass('ajax-active');
                              }
                              });

              }
          }
        });
        }
}, 4000);
*/

if (jQuery('.furniture-product-reviews .real-reviews-slider').length > 0) {

    var productID = jQuery('.furniture-product-reviews').attr('data-product-ids');
    productID = productID.split(',')[1];
    var url = 'https://api-cdn.yotpo.com/v1/widget/CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x/products/'
        + productID + '/reviews.json&per_page=40';

    var slidesCount = 3;
    if (jQuery(window).width() < 800) {
        slidesCount = 1;
    }
    jQuery.ajax({
        url: url, success: function (reviews) {

            var fi = 0;
            reviews = JSON.parse(reviews);
            jQuery(reviews.response.reviews).each(function (index, review) {
                if (review.content.length <= 400) {
                    var stars = '';
                    for (let j = 1; j <= review.score; j++) {
                        stars += '<span class="yotpo-icon yotpo-icon-star rating-star pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="19.434" height="19.434" viewBox="0 0 19.434 19.434"><path id="Контур_486" data-name="Контур 486" d="M353.172,409.653l3,6.4,6.714,1.026-4.859,4.98,1.147,7.031-6.006-3.32-6.005,3.32,1.147-7.031-4.859-4.98,6.714-1.026Z" transform="translate(-343.455 -409.653)" fill="#384f3b"/></svg></span>';
                    }
                    let iconID = parseInt(jQuery('.furniture-product-reviews').attr('data-icon-id'));

                    if (fi < slidesCount) {
                        jQuery('.furniture-product-reviews .real-reviews-slider').append('<div data-index="' + fi + '" class="real-review"><div class="real-review-header">' +
                            jQuery('#icon-real-review-' + (1 + (iconID % 13))).html() +
                            '<h4>' + review.title + '</h4></div>' +
                            '<div class="review-body"><p>' + review.content + '</div>' +
                            '</p><div class="rating yotpo">' + stars
                            + '</div>' +
                            '</div>'
                        );
                    } else {
                        jQuery('.furniture-product-reviews .real-reviews-slider').append('<div style="display:none;" data-index="' + fi + '" class="real-review"><div class="real-review-header">' +
                            jQuery('#icon-real-review-' + (1 + (iconID % 13))).html() +
                            '<h4>' + review.title + '</h4></div>' +
                            '<div class="review-body"><p>' + review.content + '</div>' +
                            '</p><div class="rating yotpo">' + stars
                            + '</div>' +
                            '</div>'
                        );
                    }
                    jQuery('.furniture-product-reviews').attr('data-icon-id', iconID + 1);
                    fi++;

                }
            });


            if (jQuery('.furniture-product-reviews .real-reviews-slider .real-review').length > 3) {
                jQuery('.furniture-product-reviews .real-reviews-slider-left-arrow').show();
                jQuery('.furniture-product-reviews .real-reviews-slider-right-arrow').show();
            }


            jQuery('.furniture-product-reviews .real-reviews-slider-left-arrow').click(function () {
                let last = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').last().attr('data-index'));
                let first = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').first().attr('data-index'));
                if (first != 0) {
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + (first - 1) + ']').show();
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + last + ']').hide();
                }
            });
            jQuery('.furniture-product-reviews .real-reviews-slider-right-arrow').click(function () {
                let last = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').last().attr('data-index'));
                let first = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').first().attr('data-index'));
                if (last != jQuery(this).parents('.real-product-reviews').find('.real-review').length - 1) {
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + first + ']').hide();
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + (last + 1) + ']').show();
                }
            });






        }
    });





}

if (jQuery('.mattresses-product-reviews .real-reviews-slider').length > 0) {

    var productID = jQuery('.mattresses-product-reviews').attr('data-product-ids');
    productID = productID.split(',')[1];
    var url = 'https://api-cdn.yotpo.com/v1/widget/CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x/products/'
        + productID + '/reviews.json&per_page=40';

    var slidesCount = 3;
    if (jQuery(window).width() < 800) {
        slidesCount = 1;
    }
    jQuery.ajax({
        url: url, success: function (reviews) {

            var fi = 0;
            reviews = JSON.parse(reviews);
            jQuery(reviews.response.reviews).each(function (index, review) {
                if (review.content.length <= 400) {
                    var stars = '';
                    for (let j = 1; j <= review.score; j++) {
                        stars += '<span class="yotpo-icon yotpo-icon-star rating-star pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="19.434" height="19.434" viewBox="0 0 19.434 19.434"><path id="Контур_486" data-name="Контур 486" d="M353.172,409.653l3,6.4,6.714,1.026-4.859,4.98,1.147,7.031-6.006-3.32-6.005,3.32,1.147-7.031-4.859-4.98,6.714-1.026Z" transform="translate(-343.455 -409.653)" fill="#384f3b"/></svg></span>';
                    }
                    let iconID = parseInt(jQuery('.mattresses-product-reviews').attr('data-icon-id'));

                    if (fi < slidesCount) {
                        jQuery('.mattresses-product-reviews .real-reviews-slider').append('<div data-index="' + fi + '" class="real-review"><div class="real-review-header">' +
                            jQuery('#icon-real-review-' + (1 + (iconID % 13))).html() +
                            '<h4>' + review.title + '</h4></div>' +
                            '<div class="review-body"><p>' + review.content + '</div>' +
                            '</p><div class="rating yotpo">' + stars
                            + '</div>' +
                            '</div>'
                        );
                    } else {
                        jQuery('.mattresses-product-reviews .real-reviews-slider').append('<div style="display:none;" data-index="' + fi + '" class="real-review"><div class="real-review-header">' +
                            jQuery('#icon-real-review-' + (1 + (iconID % 13))).html() +
                            '<h4>' + review.title + '</h4></div>' +
                            '<div class="review-body"><p>' + review.content + '</div>' +
                            '</p><div class="rating yotpo">' + stars
                            + '</div>' +
                            '</div>'
                        );
                    }
                    jQuery('.mattresses-product-reviews').attr('data-icon-id', iconID + 1);
                    fi++;

                }
            });


            if (jQuery('.mattresses-product-reviews .real-reviews-slider .real-review').length > 3) {
                jQuery('.mattresses-product-reviews .real-reviews-slider-left-arrow').show();
                jQuery('.mattresses-product-reviews .real-reviews-slider-right-arrow').show();
            }


            jQuery('.mattresses-product-reviews .real-reviews-slider-left-arrow').click(function () {
                let last = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').last().attr('data-index'));
                let first = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').first().attr('data-index'));
                if (first != 0) {
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + (first - 1) + ']').show();
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + last + ']').hide();
                }
            });
            jQuery('.mattresses-product-reviews .real-reviews-slider-right-arrow').click(function () {
                let last = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').last().attr('data-index'));
                let first = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').first().attr('data-index'));
                if (last != jQuery(this).parents('.real-product-reviews').find('.real-review').length - 1) {
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + first + ']').hide();
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + (last + 1) + ']').show();
                }
            });






        }
    });





}


if (jQuery('.bedding-product-reviews .real-reviews-slider').length > 0) {

    var productID = jQuery('.bedding-product-reviews').attr('data-product-ids');
    productID = productID.split(',')[1];
    var url = 'https://api-cdn.yotpo.com/v1/widget/CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x/products/'
        + productID + '/reviews.json&per_page=40';

    var slidesCount = 3;
    if (jQuery(window).width() < 800) {
        slidesCount = 1;
    }
    jQuery.ajax({
        url: url, success: function (reviews) {

            var fi = 0;
            reviews = JSON.parse(reviews);
            jQuery(reviews.response.reviews).each(function (index, review) {
                if (review.content.length <= 400) {
                    var stars = '';
                    for (let j = 1; j <= review.score; j++) {
                        stars += '<span class="yotpo-icon yotpo-icon-star rating-star pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="19.434" height="19.434" viewBox="0 0 19.434 19.434"><path id="Контур_486" data-name="Контур 486" d="M353.172,409.653l3,6.4,6.714,1.026-4.859,4.98,1.147,7.031-6.006-3.32-6.005,3.32,1.147-7.031-4.859-4.98,6.714-1.026Z" transform="translate(-343.455 -409.653)" fill="#384f3b"/></svg></span>';
                    }
                    let iconID = parseInt(jQuery('.bedding-product-reviews').attr('data-icon-id'));

                    if (fi < slidesCount) {
                        jQuery('.bedding-product-reviews .real-reviews-slider').append('<div data-index="' + fi + '" class="real-review"><div class="real-review-header">' +
                            jQuery('#icon-real-review-' + (1 + (iconID % 13))).html() +
                            '<h4>' + review.title + '</h4></div>' +
                            '<div class="review-body"><p>' + review.content + '</div>' +
                            '</p><div class="rating yotpo">' + stars
                            + '</div>' +
                            '</div>'
                        );
                    } else {
                        jQuery('.bedding-product-reviews .real-reviews-slider').append('<div style="display:none;" data-index="' + fi + '" class="real-review"><div class="real-review-header">' +
                            jQuery('#icon-real-review-' + (1 + (iconID % 13))).html() +
                            '<h4>' + review.title + '</h4></div>' +
                            '<div class="review-body"><p>' + review.content + '</div>' +
                            '</p><div class="rating yotpo">' + stars
                            + '</div>' +
                            '</div>'
                        );
                    }
                    jQuery('.bedding-product-reviews').attr('data-icon-id', iconID + 1);
                    fi++;

                }
            });


            if (jQuery('.bedding-product-reviews .real-reviews-slider .real-review').length > 3) {
                jQuery('.bedding-product-reviews .real-reviews-slider-left-arrow').show();
                jQuery('.bedding-product-reviews .real-reviews-slider-right-arrow').show();
            }


            jQuery('.bedding-product-reviews .real-reviews-slider-left-arrow').click(function () {
                let last = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').last().attr('data-index'));
                let first = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').first().attr('data-index'));
                if (first != 0) {
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + (first - 1) + ']').show();
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + last + ']').hide();
                }
            });
            jQuery('.bedding-product-reviews .real-reviews-slider-right-arrow').click(function () {
                let last = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').last().attr('data-index'));
                let first = parseInt(jQuery(this).parents('.real-product-reviews').find('.real-review:visible').first().attr('data-index'));
                if (last != jQuery(this).parents('.real-product-reviews').find('.real-review').length - 1) {
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + first + ']').hide();
                    jQuery(this).parents('.real-product-reviews').find('.real-review[data-index=' + (last + 1) + ']').show();
                }
            });






        }
    });





}

jQuery('.launch-support').click(function () {
    $zopim.livechat.window.show();
});
/*
jQuery('.cart__qty-input').change(function(){
  var index = jQuery(this).parents('.cart__row').attr('data-cart-item-index');
  var cartItem = jQuery('.cart-item[data-line="' + index + '"]');
  if(cartItem.find('.renewal-exchange-card-line-item').length > 0){

  }
});
*/

if (jQuery('.comfort-bundle-lre').length > 0) {
    jQuery(jQuery('.renewal-popup-container').first().html()).insertAfter('.renewal-popup-icon');
    jQuery('.comfort-bundle-lre .renewal-popup-icon').click(function () {
        jQuery(this).parents('.comfort-bundle-lre').find('.renewal-popup').show();
    });
    setInterval(function () {
        let size = jQuery('#product-detail-size-chooser-0').next().find('.option-flex > span').first().text().trim();
        jQuery('.comfort-bundle-lre').hide();
        jQuery('.comfort-bundle-lre[data-size="' + size + '"]').css('display', 'flex');
    }, 1000);
}


setInterval(function () {
    jQuery('.bird-image').each(function () {
        //if(!jQuery(this).attr('data-clipped')){
        jQuery(this).attr('data-clipped', true);
        let id = revisedRandId();
        jQuery(this).find('clipPath').attr('id', jQuery(this).find('clipPath').attr('id') + id);
        jQuery(this).find('clipPath + g').css('clip-path', 'url(#' + jQuery(this).find('clipPath').attr('id') + ')');
        // }
    });
}, 2000);



jQuery('.popup-close-icon').click(function () {
    jQuery(this).parents('.popup-container').hide();
    jQuery('.page-container').css('position', 'inherit');
    jQuery('html').css('overflow-y', 'auto');
    jQuery('html').css('touch-action', 'auto');
    jQuery('html').css('-ms-touch-action', 'auto');
});

jQuery(document).ready(function () {
    jQuery('.shg-fa').removeAttr('aria-label');
});

jQuery(document).ready(function () {
    jQuery('input.rca-product-quantity').attr('aria-label', 'Product quantity');
});

jQuery(document).ready(function () {
    jQuery("#s-9d6f17d5-a42b-4c3c-9489-d93e2c6cd6b8 a.shogun-image-link")
        .attr("aria-label", "Related images of mattresses");
});

jQuery(document).ready(function () {
    jQuery("#s-59c6461e-c613-48c8-99eb-f66337c2fda7 a.shogun-image-link")
        .attr("aria-label", "Related images of sheet sets");
});

jQuery(document).ready(function () {
    jQuery("#s-af76497d-0757-4c4f-8943-f6fb1b5dd16e a.shogun-image-link")
        .attr("aria-label", "Related images of mattresses");
});
jQuery(document).ready(function () {
    jQuery("#s-874f197c-39eb-4b1c-b711-ac9824e139ac a.shogun-image-link")
        .attr("aria-label", "Related images of mattresses");
});

jQuery(document).ready(function () {
    jQuery("#s-a101a4bc-fab1-4e5e-b15b-91eb8868e5bf a.shogun-image-link")
        .attr("aria-label", "Related images of mattresses");
});


jQuery(document).ready(function () {
    jQuery("#s-f74d2227-1a8d-41a3-a51e-258d81f122fd").css("background-color", "#853A00");
});

jQuery(document).ready(function () {
    jQuery("#s-cfb00b4d-3652-4956-96a8-2c67d8bc8a20").css("background-color", "#853A00");
});

jQuery(document).ready(function () {
    jQuery("#s-f118ea14-f572-46e0-a678-a1a6d249cc7c").css("background-color", "#853A00");
});
